
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aUTn5", function(module, exports) {

$parcel$export(module.exports, "IGNORE_SELECTORS", () => $92069b7b1bcb2285$export$c5bc138cfa79c2b2);
$parcel$export(module.exports, "convertSelectionToLegacyFormat", () => $92069b7b1bcb2285$export$4ba66d628a1e5980);
$parcel$export(module.exports, "getMatchTraces", () => $92069b7b1bcb2285$export$b297c7070f7a854);
/* eslint-disable no-restricted-globals */ 
var $2zMIV = parcelRequire("2zMIV");

var $kbVzJ = parcelRequire("kbVzJ");
const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    return $('<div>').append(selectionRange.cloneContents()).html();
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        const $parentElement = $(selectionRange.parentElement());
        const parentOffset = $parentElement.offset();
        if (parentOffset) clientRects = [
            {
                top: parentOffset.top - scrollTop,
                left: parentOffset.left - scrollLeft,
                bottom: parentOffset.top + ($parentElement.height() || 0),
                right: parentOffset.left + ($parentElement.width() || 0)
            }
        ];
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
	 * Calculates Create Issue dialog target area
	 */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
	 * Calculates the action panel target area
	 */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-child"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}

});
parcelRegister("2zMIV", function(module, exports) {

$parcel$export(module.exports, "isHighlightValidForInlineComment", () => $15cdccae323ae129$export$4042f14350dc38e1);
$parcel$export(module.exports, "isHighlightValidForBulkCreateJiraIssues", () => $15cdccae323ae129$export$6c73cedfcc8a18f2);
$parcel$export(module.exports, "getRange", () => $15cdccae323ae129$export$fef151b94550e9f5);
$parcel$export(module.exports, "textNormalize", () => $15cdccae323ae129$export$42b4db950c80743f);
$parcel$export(module.exports, "findStickyHeader", () => $15cdccae323ae129$export$6fc0706fcfa876ec);

var $7W8i8 = parcelRequire("7W8i8");

var $aUTn5 = parcelRequire("aUTn5");
const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};

});

parcelRegister("kbVzJ", function(module, exports) {

$parcel$export(module.exports, "indexTextNodes", () => $567297790b62d2d4$export$2605a3f2b4d7f885);
$parcel$export(module.exports, "findMatches", () => $567297790b62d2d4$export$f4585c00f32d9257);

var $2zMIV = parcelRequire("2zMIV");
const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}

});


parcelRegister("7ZcJJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d081c26badb6644$var$_react = $5d081c26badb6644$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5d081c26badb6644$var$_baseNew = $5d081c26badb6644$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5d081c26badb6644$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d081c26badb6644$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $5d081c26badb6644$var$_react.default.createElement($5d081c26badb6644$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$5d081c26badb6644$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $5d081c26badb6644$var$_default = module.exports.default = $5d081c26badb6644$var$WorkItemsIcon;

});

parcelRegister("kmWRd", function(module, exports) {

$parcel$export(module.exports, "SidePanel", () => $7a88b175622d580e$export$8689d3888980b1f3);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $g9Srd = parcelRequire("g9Srd");
var $h3cbw = parcelRequire("h3cbw");
const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = ({ headerHeight: headerHeight = 0, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, isOpen: isOpen = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g9Srd.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h3cbw.default), {
        enterFrom: "right",
        fade: "inout"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            ...props,
            // `props` has className, so use inline styling to avoid conflicts
            style: {
                backgroundColor: 'elevation.surface',
                position: isFixed ? 'fixed' : 'absolute',
                right: '0',
                top: `${panelTop}px`,
                width: '320px',
                padding: 'space.300',
                borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
                height: `calc(100vh - ${headerHeight}px)`,
                borderTop: displayTopBorder ? `1px solid ${"var(--ds-border, #091E4224)"}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $7a88b175622d580e$var$sidePanelContentStyling
        }, children))));
};

});

parcelRegister("4WZFP", function(module, exports) {

$parcel$export(module.exports, "SidePanelHeader", () => $72d7920b18bf3596$export$70e0922268f2e08b);

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $72d7920b18bf3596$export$70e0922268f2e08b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, children);
};

});

parcelRegister("hAuc5", function(module, exports) {

$parcel$export(module.exports, "convertMarkdownToProsemirror", () => $ce78ef6bb9d33c7d$export$b2bf04f78f72b123);
$parcel$export(module.exports, "backendConvertMarkdownToProsemirrorNode", () => $ce78ef6bb9d33c7d$export$e661a057c2263d64);

var $7KLhS = parcelRequire("7KLhS");

var $8iNK1 = parcelRequire("8iNK1");

var $4xvuZ = parcelRequire("4xvuZ");

var $kviC1 = parcelRequire("kviC1");

var $1D8rU = parcelRequire("1D8rU");

var $aLtij = parcelRequire("aLtij");

var $1MDnJ = parcelRequire("1MDnJ");

var $dpgtc = parcelRequire("dpgtc");

var $2mgEK = parcelRequire("2mgEK");

var $fMMkB = parcelRequire("fMMkB");

var $6dzgm = parcelRequire("6dzgm");

var $locel = parcelRequire("locel");

var $ip5oL = parcelRequire("ip5oL");

var $ifgRb = parcelRequire("ifgRb");

var $2XcI5 = parcelRequire("2XcI5");

var $9tykg = parcelRequire("9tykg");

var $d5C9r = parcelRequire("d5C9r");

var $2OwON = parcelRequire("2OwON");
function $ce78ef6bb9d33c7d$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $ce78ef6bb9d33c7d$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($ce78ef6bb9d33c7d$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $kviC1.Fragment)) children.push(...$ce78ef6bb9d33c7d$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $kviC1.Fragment).fromArray(children);
}
function $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($7KLhS)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key])if (schema[key][idx]) tokenizer.enable((0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $dpgtc.default), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $fMMkB.default), idMap);
        tokenizer.use((0, $2mgEK.default), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $1MDnJ.default), idMap);
    tokenizer.use((0, $9tykg.default));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $locel.default));
    tokenizer.use((0, $ifgRb.default));
    tokenizer.use((0, $6dzgm.default));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $8iNK1.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $2XcI5.default));
        else tokenizer.use((0, $ip5oL.markdownItMedia));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $aLtij.default));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $d5C9r.default));
    const markdownParser = new (0, $4xvuZ.MarkdownParser)(schema, tokenizer, (0, $1D8rU.filterMdToPmSchemaMapping)(schema, (0, $1D8rU.getMdToPmMapping)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $kviC1.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $2OwON.escapeLinks)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $ce78ef6bb9d33c7d$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $ce78ef6bb9d33c7d$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}

});
parcelRegister("1D8rU", function(module, exports) {

$parcel$export(module.exports, "filterMdToPmSchemaMapping", () => $fe15ff31308e86c4$export$a9d25ff08f358d72);
$parcel$export(module.exports, "PM_SCHEMA_TO_MD_MAPPING", () => $fe15ff31308e86c4$export$b535e2638dcce02);
$parcel$export(module.exports, "getMdToPmMapping", () => $fe15ff31308e86c4$export$8f853a1c35ed8bbe);
function $fe15ff31308e86c4$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $fe15ff31308e86c4$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $fe15ff31308e86c4$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });

});

parcelRegister("aLtij", function(module, exports) {

$parcel$export(module.exports, "default", () => $0773845a48a88423$export$2e2bcd8739ae039);
const $0773845a48a88423$var$captionOpen = 'caption_open';
const $0773845a48a88423$var$paragraphOpen = 'paragraph_open';
const $0773845a48a88423$var$paragraphClose = 'paragraph_close';
function $0773845a48a88423$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $0773845a48a88423$var$paragraphOpen && tokens[index + 2]?.type !== $0773845a48a88423$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $0773845a48a88423$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $0773845a48a88423$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $0773845a48a88423$var$captionOpen;
            if (type === $0773845a48a88423$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $0773845a48a88423$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("1MDnJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92fa7dc1daa52ee$export$2e2bcd8739ae039);
function $e92fa7dc1daa52ee$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const citationRegexp = /^\[\^[^\^]+\^]/;
        const match = citationRegexp.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}

});

parcelRegister("dpgtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cab79ce214481e1$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");

var $hqwd7 = parcelRequire("hqwd7");
// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $4cab79ce214481e1$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $4cab79ce214481e1$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$4cab79ce214481e1$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $7MY8y.createToken)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $hqwd7.sanitizeCustomBlocks)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}

});
parcelRegister("7MY8y", function(module, exports) {

$parcel$export(module.exports, "createToken", () => $6d1436b1813e587d$export$c255480b061bd6aa);
function $6d1436b1813e587d$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}

});

parcelRegister("hqwd7", function(module, exports) {

$parcel$export(module.exports, "sanitizeCustomBlocks", () => $bb6e978431b17277$export$e717b161ec14d433);
function $bb6e978431b17277$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}

});


parcelRegister("2mgEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $102908d0f0788df0$export$2e2bcd8739ae039);

var $atveb = parcelRequire("atveb");
function $102908d0f0788df0$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}

});

parcelRegister("fMMkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b85e013b8e2ab0fc$export$2e2bcd8739ae039);
const $b85e013b8e2ab0fc$var$decisionItemOpen = 'decisionItem_open';
const $b85e013b8e2ab0fc$var$paragraphOpen = 'paragraph_open';
const $b85e013b8e2ab0fc$var$paragraphClose = 'paragraph_close';
const $b85e013b8e2ab0fc$var$inline = 'inline';
function $b85e013b8e2ab0fc$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $b85e013b8e2ab0fc$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $b85e013b8e2ab0fc$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $b85e013b8e2ab0fc$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $b85e013b8e2ab0fc$var$paragraphOpen || type === $b85e013b8e2ab0fc$var$paragraphClose) $b85e013b8e2ab0fc$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("6dzgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6de2bb5deb5f668$export$2e2bcd8739ae039);
const $e6de2bb5deb5f668$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $e6de2bb5deb5f668$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $e6de2bb5deb5f668$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $e6de2bb5deb5f668$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $e6de2bb5deb5f668$var$processInlineChildren(token.children);
};
var $e6de2bb5deb5f668$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $e6de2bb5deb5f668$var$brToLineBreak);

});

parcelRegister("locel", function(module, exports) {

$parcel$export(module.exports, "default", () => $866d7fb158c265f1$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $2jzd4 = parcelRequire("2jzd4");

var $4YzAy = parcelRequire("4YzAy");

var $2OwON = parcelRequire("2OwON");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $866d7fb158c265f1$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $866d7fb158c265f1$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2jzd4)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($866d7fb158c265f1$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($866d7fb158c265f1$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $4YzAy.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $2OwON.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $2OwON.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $866d7fb158c265f1$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$866d7fb158c265f1$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $866d7fb158c265f1$var$linkify);

});
parcelRegister("2OwON", function(module, exports) {

$parcel$export(module.exports, "findFilepaths", () => $7715b3c791c155be$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $7715b3c791c155be$export$5e652e74655163e5);
$parcel$export(module.exports, "escapeLinks", () => $7715b3c791c155be$export$8acd10161c5f8b07);
// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7715b3c791c155be$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $7715b3c791c155be$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($7715b3c791c155be$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $7715b3c791c155be$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $7715b3c791c155be$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
    });
}

});


parcelRegister("ip5oL", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $623b0b26b9c81375$export$c8dcbd316b71f8cf);
// File copied from packages/editor/editor-markdown-transformer/src/media.ts
function $623b0b26b9c81375$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes('atlassianinternalmedia')) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $623b0b26b9c81375$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $623b0b26b9c81375$var$createRule());
};

});

parcelRegister("ifgRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $73825321bd2619ae$export$2e2bcd8739ae039);
// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73825321bd2619ae$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$73825321bd2619ae$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $73825321bd2619ae$var$newline);

});

parcelRegister("2XcI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f17de48a6931d92$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");
// eslint-disable-next-line require-unicode-regexp
const $3f17de48a6931d92$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
const $3f17de48a6931d92$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $3f17de48a6931d92$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $3f17de48a6931d92$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $7MY8y.createToken)(state, 'media_single_open');
    const media = (0, $7MY8y.createToken)(state, 'media');
    media.attrs = [
        [
            'url',
            $3f17de48a6931d92$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes('atlassianinternalmedia')) try {
        const urlObject = new URL($3f17de48a6931d92$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $7MY8y.createToken)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $3f17de48a6931d92$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $7MY8y.createToken)(state, 'paragraph_open');
    const inline = (0, $7MY8y.createToken)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $7MY8y.createToken)(state, 'text')
    ];
    const paragraphClose = (0, $7MY8y.createToken)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $3f17de48a6931d92$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $3f17de48a6931d92$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $3f17de48a6931d92$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $3f17de48a6931d92$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $3f17de48a6931d92$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($3f17de48a6931d92$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $3f17de48a6931d92$var$findContent(token);
                content.forEach((item)=>{
                    const doesMatch = /!\[[^\]]*\]\([^)]+\)/u.test(item);
                    if (doesMatch) $3f17de48a6931d92$var$createMediaTokens(item, state, acc);
                    else $3f17de48a6931d92$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$3f17de48a6931d92$var$checkPreviousToken('media_single_close', acc) && !$3f17de48a6931d92$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("9tykg", function(module, exports) {

$parcel$export(module.exports, "default", () => $811470bd95061a4c$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $811470bd95061a4c$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$811470bd95061a4c$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $811470bd95061a4c$var$paragraph);

});

parcelRegister("d5C9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $11bccb76849cfb3f$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");
const $11bccb76849cfb3f$var$bulletListOpen = 'bullet_list_open';
const $11bccb76849cfb3f$var$bulletListClose = 'bullet_list_close';
const $11bccb76849cfb3f$var$listItemOpen = 'list_item_open';
const $11bccb76849cfb3f$var$listItemClose = 'list_item_close';
const $11bccb76849cfb3f$var$taskListOpen = 'task_list_open';
const $11bccb76849cfb3f$var$taskListClose = 'task_list_close';
const $11bccb76849cfb3f$var$taskItemOpen = 'task_item_open';
const $11bccb76849cfb3f$var$taskItemClose = 'task_item_close';
const $11bccb76849cfb3f$var$paragraphOpen = 'paragraph_open';
const $11bccb76849cfb3f$var$paragraphClose = 'paragraph_close';
function $11bccb76849cfb3f$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $11bccb76849cfb3f$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen, $11bccb76849cfb3f$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenListItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$listItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
        }
        newTaskItemOpen.meta = $11bccb76849cfb3f$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $11bccb76849cfb3f$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline') && $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc, -2).level));
    else if (!$11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose)) acc.push(token);
}
function $11bccb76849cfb3f$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.children[0].content);
    token.content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.content);
    token.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $11bccb76849cfb3f$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen) || $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $11bccb76849cfb3f$var$taskItemOpen;
}
function $11bccb76849cfb3f$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $11bccb76849cfb3f$var$removeTodoMarkdown(content) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regex = /(\[x\]\s)|(\[\s\]\s)/;
    return content.replace(regex, '');
}
function $11bccb76849cfb3f$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $11bccb76849cfb3f$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $11bccb76849cfb3f$var$bulletListOpen) $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $11bccb76849cfb3f$var$bulletListClose) $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemOpen) $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index);
            else if ($11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc)) $11bccb76849cfb3f$var$handleInline(token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemClose) $11bccb76849cfb3f$var$handleListItemClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$paragraphOpen || type === $11bccb76849cfb3f$var$paragraphClose) $11bccb76849cfb3f$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});


parcelRegister("6eZqW", function(module, exports) {

$parcel$export(module.exports, "convertProsemirrorToMarkdown", () => $fb0b992a34319cb0$export$cc6cac500a4da966);
$parcel$export(module.exports, "convertProsemirrorNodeToMarkdown", () => $fb0b992a34319cb0$export$3d24004275aefeab);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gWR1e = parcelRequire("gWR1e");

var $8nxxM = parcelRequire("8nxxM");

var $2htg1 = parcelRequire("2htg1");
/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $gWR1e.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $gWR1e.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $gWR1e.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $fb0b992a34319cb0$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $fb0b992a34319cb0$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $fb0b992a34319cb0$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $fb0b992a34319cb0$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $fb0b992a34319cb0$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $2htg1.MarkdownSerializerState)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}

});
parcelRegister("8nxxM", function(module, exports) {

$parcel$export(module.exports, "ProseMirrorContentStatistics", () => $13b081699855d8a3$export$acf14785d7d5b1be);

var $kviC1 = parcelRequire("kviC1");
class $13b081699855d8a3$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $kviC1.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}

});

parcelRegister("2htg1", function(module, exports) {

$parcel$export(module.exports, "MarkdownSerializerState", () => $e985dce6263f3bba$export$61055fa707e69319);
$parcel$export(module.exports, "nodes", () => $e985dce6263f3bba$export$695720b7e7a61533);

var $4xvuZ = parcelRequire("4xvuZ");

var $kviC1 = parcelRequire("kviC1");

var $2xv4m = parcelRequire("2xv4m");

var $50zV1 = parcelRequire("50zV1");

var $8q1Q5 = parcelRequire("8q1Q5");
const $e985dce6263f3bba$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $8q1Q5.stringRepeat)('`', length);
    };
})();
class $e985dce6263f3bba$export$61055fa707e69319 extends (0, $4xvuZ.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return /(^|\n)$/.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/^`/)) text = ' ' + text;
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/`$/)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore-next-line
        super($e985dce6263f3bba$export$695720b7e7a61533, $e985dce6263f3bba$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $e985dce6263f3bba$export$695720b7e7a61533;
        this.marks = $e985dce6263f3bba$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $e985dce6263f3bba$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $50zV1.getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $kviC1.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = 'blob:https://atlassianinternalmedia.com/?';
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $8q1Q5.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $8q1Q5.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $8q1Q5.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$e985dce6263f3bba$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'date',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $e985dce6263f3bba$export$695720b7e7a61533 = {
    ...$e985dce6263f3bba$var$editorNodes,
    ...(0, $2xv4m.default)
};
const $e985dce6263f3bba$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};

});
parcelRegister("2xv4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $deb7030063275628$export$2e2bcd8739ae039);

var $2VvL9 = parcelRequire("2VvL9");
const $deb7030063275628$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $deb7030063275628$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $deb7030063275628$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($deb7030063275628$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $deb7030063275628$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $deb7030063275628$var$renderNode(state, child, i);
    });
};
const $deb7030063275628$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $deb7030063275628$var$renderNode(state, node, 0);
    state.write(' ');
};
const $deb7030063275628$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $deb7030063275628$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($deb7030063275628$var$isHeaderRow(node) || $deb7030063275628$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $deb7030063275628$export$2e2bcd8739ae039 = $deb7030063275628$var$tableNodes;

});
parcelRegister("2VvL9", function(module, exports) {

$parcel$export(module.exports, "attributesMatchDefault", () => $92afea9a8f6a2cee$export$5be26e657c035da4);
const $92afea9a8f6a2cee$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};

});


parcelRegister("50zV1", function(module, exports) {

$parcel$export(module.exports, "getOrderFromMaybeOrderedListNode", () => $6ff1f24202635c31$export$4ea3c6bbdf8f7944);

var $kviC1 = parcelRequire("kviC1");
const $6ff1f24202635c31$export$8ef94ae42a3729bd = 1;
const $6ff1f24202635c31$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $6ff1f24202635c31$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $kviC1.Node))) return $6ff1f24202635c31$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $6ff1f24202635c31$export$d445360e2a3c026b(order) ?? $6ff1f24202635c31$export$8ef94ae42a3729bd;
};

});

parcelRegister("8q1Q5", function(module, exports) {

$parcel$export(module.exports, "stringRepeat", () => $74c7a8487430b8e3$export$345d822805ab3239);
$parcel$export(module.exports, "escapeMarkdown", () => $74c7a8487430b8e3$export$560888d6fe0cfe97);
/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $74c7a8487430b8e3$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $74c7a8487430b8e3$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\+[ ]|[\-*>])/, '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*\d+)\.\s/, '$1\\. ');
    if (insideTable) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $74c7a8487430b8e3$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $74c7a8487430b8e3$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($74c7a8487430b8e3$var$SPECIAL_CHARACTERS, '');
    Array.from(node.childNodes).forEach((child)=>$74c7a8487430b8e3$var$removeSpecialCharacters(child));
}
function $74c7a8487430b8e3$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $74c7a8487430b8e3$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}

});



parcelRegister("b4emg", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $8841f32d2d46ed1f$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");
const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});

parcelRegister("1QMs7", function(module, exports) {

$parcel$export(module.exports, "IssueCreateSidePanel", () => $edeece2624928ccc$export$808956d96594cb81);
$parcel$export(module.exports, "BulkCreateSidePanel", () => $edeece2624928ccc$export$b46ccdf5c201a7ce);
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("1L1jV")).ISSUE_CREATE_SIDE_PANEL_ID);
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_WIDTH", () => (parcelRequire("1L1jV")).ISSUE_CREATE_SIDE_PANEL_WIDTH);
$parcel$export(module.exports, "BULK_ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("3Fkx6")).BULK_ISSUE_CREATE_SIDE_PANEL_ID);
$parcel$export(module.exports, "BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH", () => (parcelRequire("3Fkx6")).BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH);
$parcel$export(module.exports, "getValidRange", () => (parcelRequire("1Q0l6")).getValidRange);
$parcel$export(module.exports, "getPageContentRange", () => (parcelRequire("1Q0l6")).getPageContentRange);
$parcel$export(module.exports, "constructInsertStorageFragmentRequestPayload", () => (parcelRequire("1Q0l6")).constructInsertStorageFragmentRequestPayload);
$parcel$export(module.exports, "constructInsertStorageColumnTableRequestPayload", () => (parcelRequire("1Q0l6")).constructInsertStorageColumnTableRequestPayload);
$parcel$export(module.exports, "getClosestTableFromSelection", () => (parcelRequire("euVTc")).getClosestTableFromSelection);
$parcel$export(module.exports, "useIsAIIssueCreationEnabled", () => (parcelRequire("frJep")).useIsAIIssueCreationEnabled);
$parcel$export(module.exports, "getPageMode", () => (parcelRequire("fz2l1")).getPageMode);
$parcel$export(module.exports, "PageMode", () => (parcelRequire("1mDVg")).PageMode);
$parcel$export(module.exports, "useIssueCreateSidePanelContext", () => (parcelRequire("1mDVg")).useIssueCreateSidePanelContext);
$parcel$export(module.exports, "useSetIsCreatedWithAi", () => (parcelRequire("hq2Sz")).useSetIsCreatedWithAi);
$parcel$export(module.exports, "useSetIsCreatedFromTable", () => (parcelRequire("hq2Sz")).useSetIsCreatedFromTable);
$parcel$export(module.exports, "useSetInsertStorageFragmentRequestPayload", () => (parcelRequire("hq2Sz")).useSetInsertStorageFragmentRequestPayload);
$parcel$export(module.exports, "useSetContentLastModifiedTimestamp", () => (parcelRequire("hq2Sz")).useSetContentLastModifiedTimestamp);
$parcel$export(module.exports, "useGetContentLastModifiedTimestamp", () => (parcelRequire("hq2Sz")).useGetContentLastModifiedTimestamp);
$parcel$export(module.exports, "IssueCreateWarningDialog", () => (parcelRequire("98CLM")).IssueCreateWarningDialog);
$parcel$export(module.exports, "useWarningDialogStateActions", () => (parcelRequire("4aiCO")).useWarningDialogStateActions);
$parcel$export(module.exports, "WarningDialog", () => (parcelRequire("4aiCO")).WarningDialog);
$parcel$export(module.exports, "SingleIssueCreateProvidersWrapper", () => (parcelRequire("eDk57")).SingleIssueCreateProvidersWrapper);

var $jmjWc = parcelRequire("jmjWc");

var $1L1jV = parcelRequire("1L1jV");

var $3Fkx6 = parcelRequire("3Fkx6");

var $1Q0l6 = parcelRequire("1Q0l6");

var $euVTc = parcelRequire("euVTc");

var $frJep = parcelRequire("frJep");

var $fz2l1 = parcelRequire("fz2l1");


var $1mDVg = parcelRequire("1mDVg");

var $hq2Sz = parcelRequire("hq2Sz");

var $98CLM = parcelRequire("98CLM");

var $4aiCO = parcelRequire("4aiCO");

var $eDk57 = parcelRequire("eDk57");


const $edeece2624928ccc$export$808956d96594cb81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "eUHdQ",
    name: "IssueCreateSidePanel",
    loader: async ()=>(await Promise.resolve((parcelRequire("1L1jV")))).IssueCreateSidePanel
});

const $edeece2624928ccc$export$b46ccdf5c201a7ce = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vMHW0",
    name: "BulkCreateSidePanel",
    loader: async ()=>(await Promise.resolve((parcelRequire("3Fkx6")))).BulkCreateSidePanel
});

});
parcelRegister("1L1jV", function(module, exports) {

$parcel$export(module.exports, "sidePanelTestId", () => $7dea7a25aec9b259$export$3318bd9d18742c1e);
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_ID", () => $7dea7a25aec9b259$export$e760a8f02240cc6d);
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_WIDTH", () => $7dea7a25aec9b259$export$d030b92b162b528d);
$parcel$export(module.exports, "IssueCreateSidePanel", () => $7dea7a25aec9b259$export$808956d96594cb81);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $2Rith = parcelRequire("2Rith");
var $fYQcF = parcelRequire("fYQcF");

var $9wGTI = parcelRequire("9wGTI");

var $7aRa9 = parcelRequire("7aRa9");

var $ai7NK = parcelRequire("ai7NK");

var $98CLM = parcelRequire("98CLM");

var $kJYUO = parcelRequire("kJYUO");

var $1mDVg = parcelRequire("1mDVg");

var $eDk57 = parcelRequire("eDk57");

var $5Ew1A = parcelRequire("5Ew1A");

var $jwedr = parcelRequire("jwedr");

var $3AAT8 = parcelRequire("3AAT8");

var $hib1D = parcelRequire("hib1D");

var $6pbwW = parcelRequire("6pbwW");
const $7dea7a25aec9b259$export$3318bd9d18742c1e = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$e760a8f02240cc6d = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$d030b92b162b528d = 320;
const $7dea7a25aec9b259$var$sidePanelStyle = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponent = ({ onClose: onClose, flags: flags })=>{
    const { showSidePanel: showSidePanel, hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { isWarningDialogOpen: isWarningDialogOpen, handleConfirm: handleConfirm, handleCancel: handleCancel } = (0, $jwedr.useGetWarningDialogActions)(onClose);
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { aiState: aiState, isCreatedWithAi: isCreatedWithAi, aiAnalyticsContext: aiAnalyticsContext } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldShowAiFooter = isCreatedWithAi && aiState !== 'error';
    const isAiLoading = aiState === 'loading';
    const handleOnClose = (0, $gwFzn.useCallback)((isCreateSuccess)=>{
        if (isCreatedWithAi && !isCreateSuccess) trackAIInteractionDismiss({
            attributes: aiAnalyticsContext
        });
        if (!isCreateSuccess) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'linkCreate',
                type: 'ui',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    isAiLoading: isAiLoading,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        hideSidePanel();
        onClose();
        actions.setAiState('idle');
    }, [
        isCreatedWithAi,
        hideSidePanel,
        onClose,
        actions,
        trackAIInteractionDismiss,
        aiAnalyticsContext,
        createAnalyticsEvent,
        state.pageMode,
        isAiLoading,
        aiIssueCreationEnablement?.enablement,
        state.hasEditPermission
    ]);
    const handleOnConfirm = (0, $gwFzn.useCallback)(()=>{
        if ((0, $9wGTI.fg)('jira_ai_issue_create_force_idle_state_on_discard')) actions.setAiState('idle');
        handleConfirm();
    }, [
        actions,
        handleConfirm
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_work_item_creation_discard_fix')) showSidePanel();
    }, [
        showSidePanel
    ]);
    if (!(0, $9wGTI.fg)('confluence_work_item_creation_discard_fix')) showSidePanel();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: $7dea7a25aec9b259$export$3318bd9d18742c1e,
        xcss: $7dea7a25aec9b259$var$sidePanelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kJYUO.IssueCreateAiLoadingSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6pbwW.IssueCreateSidePanelHeader), {
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3AAT8.IssueCreateSidePanelBody), {
        onClose: handleOnClose,
        flags: flags
    }), shouldShowAiFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hib1D.IssueCreateSidePanelFooter), null))), isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onCancel: handleCancel,
        onConfirm: handleOnConfirm,
        issuesCount: 1
    }));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider = ({ onClose: onClose, flags: flags })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7dea7a25aec9b259$var$IssueCreateSidePanelComponent, {
        onClose: onClose,
        flags: flags
    })));
};
const $7dea7a25aec9b259$export$808956d96594cb81 = (0, $7aRa9.withFlags)($7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider);

});
parcelRegister("ai7NK", function(module, exports) {

$parcel$export(module.exports, "useSidePanelStateActions", () => $30dd91193859fc54$export$d4bcf572fecd48f5);
$parcel$export(module.exports, "useIsSidePanelOpen", () => $30dd91193859fc54$export$f3f6191f6fee6235);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $4ZoIm.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $iFWZA.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $iFWZA.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});

});

parcelRegister("98CLM", function(module, exports) {

$parcel$export(module.exports, "IssueCreateWarningDialog", () => $e9c533ef122c07a9$export$4385dd64e7fb8e2d);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ccHMk = parcelRequire("ccHMk");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");
const $e9c533ef122c07a9$var$footerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    gap: 'space.050'
});
const $e9c533ef122c07a9$export$4385dd64e7fb8e2d = ({ onConfirm: onConfirm, onCancel: onCancel, issuesCount: issuesCount = 1 })=>{
    const handleConfirm = ()=>{
        onConfirm();
    };
    const handleCancel = ()=>{
        if (onCancel) onCancel();
    };
    const Footer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
            xcss: $e9c533ef122c07a9$var$footerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            testId: "issue-create-warning-cancel-button",
            onClick: handleCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).unsavedActionCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            testId: "issue-create-warning-ok-button",
            appearance: "warning",
            onClick: handleConfirm
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).unsavedActionDiscard))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...(0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).unsavedHeadingIssueTermRefresh : (0, $3E5yu.messages).unsavedHeading,
        values: {
            issuesCount: issuesCount
        }
    }, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), {
            appearance: "warning"
        }, text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...(0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).unsavedContentIssueTermRefresh : (0, $3E5yu.messages).unsavedContent,
            values: {
                issuesCount: issuesCount
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Footer, null)));
};

});
parcelRegister("3E5yu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $340704cf66283bf0$export$defe85febe8b728c);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED", () => $340704cf66283bf0$export$79a7c1ed4f4b06be);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED", () => $340704cf66283bf0$export$4e8bd21788b520a);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_READY", () => $340704cf66283bf0$export$fa02f6b8f65042dd);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_CLOSE", () => $340704cf66283bf0$export$a402043ad8e6699);

var $2nPZH = parcelRequire("2nPZH");

var $jhwJP = parcelRequire("jhwJP");
const $340704cf66283bf0$var$messagesBase = (0, $2nPZH.defineMessages)({
    sidePanelHeader: {
        id: "issue-create-side-panel.header",
        defaultMessage: "Create Jira issue"
    },
    sidePanelFooterSubmit: {
        id: "issue-create-side-panel.footer.submit",
        defaultMessage: "Submit"
    },
    sidePanelFooterCancel: {
        id: "issue-create-side-panel.footer.cancel",
        defaultMessage: "Cancel"
    },
    sidePanelIssueCreateInsertionFailed: {
        id: "issue-create-side-panel.insertion-failed",
        defaultMessage: "We were unable to insert a link for <link>{issueKey} {issueSummary}</link>"
    },
    sidePanelFooterDisclaimerText: {
        id: "issue-create-side-panel.footer.disclaimer-text",
        defaultMessage: "Content quality may vary"
    },
    sidePanelIssueCreateAiToggleLabel: {
        id: "issue-create-side-panel.ai-toggle-label",
        defaultMessage: "Use AI to generate summary and description"
    },
    sidePanelFooterAIText: {
        id: "issue-create-side-panel.footer.ai-text",
        defaultMessage: "Powered by AI"
    },
    sidePanelAiLoading: {
        id: "issue-create-side-panel.body.ai-loading",
        defaultMessage: "Generating issue"
    },
    sidePanelAiLoadingBulk: {
        id: "issue-create-side-panel.bulk-body.ai-loading",
        defaultMessage: "Generating issues"
    },
    jiraSiteHeading: {
        id: "issue-create-side-panel.body.site.heading",
        defaultMessage: "Site:"
    },
    jiraProjectHeading: {
        id: "issue-create-side-panel.body.project.heading",
        defaultMessage: "Project:"
    },
    singleCreateAiErrorDescription: {
        id: "issue-create-side-panel.single-create-ai-error-description",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "Atlassian Intelligence can\u2018t provide a response right now. Try again or create your issue manually."
    },
    issueGenerationErrorDescription: {
        id: "issue-create-side-panel.bulk-create-issue-generation-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Add more content and try again. Or highlight specific text to create manually."
    },
    ethicalViolationErrorDescription: {
        id: "issue-create-side-panel.ethical-violation-ai-error-description",
        defaultMessage: "Your selected content or other content on this page might not comply with our <link>Acceptable Use Policy</link>. You can always create an issue manually."
    },
    rateLimitErrorDescription: {
        id: "issue-create-side-panel.rate-limit-ai-error-description",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create an issue manually."
    },
    exceedingTokenLimitDescription: {
        id: "issue-create-side-panel.exceed-token-limit-description",
        defaultMessage: "Atlassian Intelligence can\u2019t create issues for lengthy Confluence pages right now. You can always create an issue manually."
    },
    noAnswerSuggestedIssues: {
        id: "issue-create-side-panel.no-answer-suggested-issues-ai-error-description",
        defaultMessage: "We can\u2019t understand the content to suggest an issue. Select different content or create an issue manually."
    },
    bulkCreateAiErrorDescription: {
        id: "issue-create-side-panel.bulk-create-ai-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Try again or highlight specific text to create manually."
    },
    connectJiraProjectErrorDescription: {
        id: "issue-create-side-panel.bulk-create-connect-jira-project-error-description",
        defaultMessage: "We weren\u2019t able to connect to your Jira project. Please try again."
    },
    errorTryAgainButton: {
        id: "issue-create-side-panel.error.button.try-again",
        defaultMessage: "Try again"
    },
    errorCreateManuallyButton: {
        id: "issue-create-side-panel.error.button.create-manually",
        defaultMessage: "Create Manually"
    },
    aiUpsellModalTitle: {
        id: "issue-create-side-panel.ai-upsell-modal.title",
        defaultMessage: "Work smart, not hard, with help from AI"
    },
    aiUpsellModalBody: {
        id: "issue-create-side-panel.ai-upsell-modal.body",
        defaultMessage: "Use AI to quickly fill out issue descriptions using info from Confluence pages. Try it with a free trial of Premium."
    },
    aiUpsellModalCancelButton: {
        id: "issue-create-side-panel.ai-upsell-modal.button.cancel",
        defaultMessage: "Not now"
    },
    aiUpsellModalConfirmButton: {
        id: "issue-create-side-panel.ai-upsell-modal.button.confirm",
        defaultMessage: "Try it free"
    },
    sidePanelSingleIssueCreateSuccessFlagTitle: {
        id: "issue-create-side-panel.sucess-flag-title",
        defaultMessage: "You\u2019ve created <link>{issueKey} {issueSummary}</link> issue"
    },
    sidePanelMultipleIssueCreateSuccessFlagTitle: {
        id: "issue-create-side-panel.multiple.sucess-flag-title",
        defaultMessage: "You\u2019ve created {issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    sidePanelSingleIssueInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.insert-link-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert a link for <link>{issueKey} {issueSummary}</link>"
    },
    sidePanelMultipleIssuesInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.multiple.insert-link-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert links for {issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    sidePanelMultipleIssueCreateFlagViewIssue: {
        id: "issue-create-side-panel.multiple.flag-view-issue",
        defaultMessage: "View {issueCount, plural, one {issue} other {issues}} in Jira"
    },
    sidePanelMultipleIssueCreateFlagCopyLink: {
        id: "issue-create-side-panel.multiple.flag-copy-link",
        defaultMessage: "Copy link"
    },
    sidePanelMultipleIssueCreateFlagReloadToSeeLinks: {
        id: "issue-create-side-panel.multiple.flag-reload-to-see-links",
        defaultMessage: "Reload to see links appear"
    },
    sidePanelIssueCreateErrorMessage: {
        id: "issue-create-side-panel.bulk-create.error.message",
        defaultMessage: "We weren\u2019t able to save your {issuesCount, plural, one {issue} other {issues}}. Please try again."
    },
    sidePanelIssueCreatePartialErrorMessage: {
        id: "issue-create-side-panel.bulk-create.partial.error.message",
        defaultMessage: "We couldn\u2019t create some of your issues. Select the checkmark on the remaining issues to create them one at a time."
    },
    sidePanelBetaText: {
        id: "issue-create-side-panel.beta-text",
        defaultMessage: "Beta"
    },
    unsavedHeading: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.heading",
        defaultMessage: "Discard {issuesCount, plural, =0 {issue} one {issue} other {issues}}?"
    },
    unsavedContent: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.content",
        defaultMessage: "Your {issuesCount, plural, =0 {issue} one {issue} other {issues}} will be lost."
    },
    unsavedActionDiscard: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.action.discard",
        defaultMessage: "Discard"
    },
    unsavedActionCancel: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.action.cancel",
        defaultMessage: "Cancel"
    },
    bulkCreateHeaderText: {
        id: "issue-create-side-panel.bulk-create.header",
        defaultMessage: "Create Jira issues"
    },
    bulkCreateCreateAllFooterButton: {
        id: "issue-create-side-panel.bulk-create.footer-button.create-all",
        defaultMessage: "Create all"
    },
    bulkCreateCancelFooterButton: {
        id: "issue-create-side-panel.bulk-create.footer-button.cancel",
        defaultMessage: "Cancel"
    },
    bulkCreateEditHeaderText: {
        id: "issue-create-side-panel.bulk-create-edit.header",
        defaultMessage: "Edit issue"
    },
    bulkCreateConfigureBodyText: {
        id: "issue-create-side-panel.bulk-create.configure.body",
        defaultMessage: "Changing these settings might re-generate the issues list."
    },
    singleWorkCreateFormBodyText: {
        id: "issue-create-side-panel.single-work-create-form.body",
        defaultMessage: "Changing these settings might re-generate the issues list."
    },
    bulkConfigureHeaderText: {
        id: "issue-create-side-panel.bulk-configure.header",
        defaultMessage: "Configure"
    },
    bulkConfigureJiraErrorText: {
        id: "issue-create-side-panel.bulk-configure.jira-error",
        defaultMessage: "There are no available projects in this site."
    },
    singleWorkCreateFormJiraErrorText: {
        id: "issue-create-side-panel.single-work-create-form.jira-error",
        defaultMessage: "There are no available projects in this site."
    },
    bulkConfigureMissingTableCoulumnMappingErrorHeaderText: {
        id: "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-header",
        defaultMessage: "Missing table column mapping"
    },
    bulkConfigureMissingTableCoulumnMappingErrorText: {
        id: "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-text",
        defaultMessage: "Please update and save the mapping of your table columns to work item fields."
    },
    bulkConfigureFormSite: {
        id: "issue-create-side-panel.bulk-configure.form.site",
        defaultMessage: "Site"
    },
    singleWorkCreateFormSite: {
        id: "issue-create-side-panel.single-work-create-form.form.site",
        defaultMessage: "Site"
    },
    bulkConfigureFormProject: {
        id: "issue-create-side-panel.bulk-configure.form.project",
        defaultMessage: "Project"
    },
    singleWorkCreateFormProject: {
        id: "issue-create-side-panel.single-work-create-form.form.project",
        defaultMessage: "Project"
    },
    bulkConfigureFormDefaultIssueType: {
        id: "issue-create-side-panel.bulk-configure.form.default.issue.type",
        defaultMessage: "Default Issue type"
    },
    singleWorkCreateFormDefaultIssueType: {
        id: "issue-create-side-panel.single-work-create-form.form.default.issue.type",
        defaultMessage: "Issue type"
    },
    bulkConfigureFormProjectSelectorProjects: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.projects",
        defaultMessage: "Projects"
    },
    singleWorkCreateFormProjectSelectorProjects: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.projects",
        defaultMessage: "Projects"
    },
    bulkConfigureFormProjectSelectorRecentProjects: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.recent-projects",
        defaultMessage: "Recent Projects"
    },
    singleWorkCreateFormProjectSelectorRecentProjects: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.recent-projects",
        defaultMessage: "Recent Projects"
    },
    bulkConfigureFooterCancel: {
        id: "issue-create-side-panel.bulk-configure.footer.cancel",
        defaultMessage: "Cancel"
    },
    singleCreateIssueFormFooterCancel: {
        id: "issue-create-side-panel.single-create-issue-form.footer.cancel",
        defaultMessage: "Cancel"
    },
    bulkConfigureFooterSave: {
        id: "issue-create-side-panel.bulk-configure.footer.save",
        defaultMessage: "Save"
    },
    singleCreateIssueFormFooterSave: {
        id: "issue-create-side-panel.single-create-issue-form.footer.save",
        defaultMessage: "Create"
    },
    bulkConfigureMapTableToIssueTitle: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.title",
        defaultMessage: "Map table to issue fields"
    },
    bulkConfigureMapTableToIssueDescription: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.description",
        defaultMessage: "You can map your highlighted table\u2019s columns to specific fields in your issues."
    },
    bulkConfigureMapTableToIssueTableColumn: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.table-column",
        defaultMessage: "Table column"
    },
    bulkConfigureMapTableToIssueIssueField: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field",
        defaultMessage: "Issue field"
    },
    bulkConfigureMapTableToIssueAddMapping: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.add-mapping",
        defaultMessage: "Add mapping"
    },
    bulkConfigureMapTableToIssueErrorColumnNotSelected: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.column-not-selected",
        defaultMessage: "Column must be selected."
    },
    bulkConfigureMapTableToIssueErrorFieldNotSelected: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-not-selected",
        defaultMessage: "Field must be selected."
    },
    bulkConfigureMapTableToIssueErrorFieldAlreadyMapped: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-already-mapped",
        defaultMessage: "Another column is already mapped to selected field."
    },
    issueCardDescriptionIconLabel: {
        id: "issue-create-side-panel.bulk-create.card.description-icon",
        defaultMessage: "Description"
    },
    // TODO update objects below with correct fields
    requiredFieldsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-title",
        defaultMessage: "These suggestions have required fields"
    },
    requiredFieldsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-description",
        defaultMessage: "Edit each suggestion and complete the required fields to create the issues"
    },
    bulkCreateIssueInsertionHeading: {
        id: "issue-create-side-panel.bulk-create.issue-insertion-heading",
        defaultMessage: "Linked Jira Issues"
    },
    sidePanelAiLoadingIssueTermRefresh: {
        id: "issue-create-side-panel.body.ai-loading-issue-term-refresh",
        defaultMessage: "Generating"
    },
    sidePanelAiLoadingIssueExperiment: {
        id: "issue-create-side-panel.body.ai-loading-issue-experiment",
        defaultMessage: "Atlassian Intelligence is generating the summary and description, which may take a few moments."
    },
    unsavedHeadingIssueTermRefresh: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.heading-issue-term-refresh",
        defaultMessage: "Discard {issuesCount, plural, =0 {work item} one {work item} other {work items}}?"
    },
    singleCreateAiErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.single-create-ai-error-description-issue-term-refresh",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "Atlassian Intelligence can\u2018t provide a response right now. Try again or create your work item manually."
    },
    sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.sucess-flag-title-issue-term-refresh",
        defaultMessage: "You\u2019ve created <link>{issueKey} {issueSummary}</link> work item"
    },
    sidePanelIssueCreatePartialErrorMessageIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.partial.error.message-issue-term-refresh",
        defaultMessage: "We couldn\u2019t create some of your work items. Select the checkmark on the remaining work items to create them one at a time."
    },
    unsavedContentIssueTermRefresh: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.content-issue-term-refresh",
        defaultMessage: "Your {issuesCount, plural, =0 {work item} one {work item} other {work items}} will be lost."
    },
    sidePanelAiLoadingBulkIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-body.ai-loading-issue-term-refresh",
        defaultMessage: "Generating"
    },
    sidePanelMultipleIssueCreateSuccessFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.multiple.sucess-flag-title-issue-term-refresh",
        defaultMessage: "You\u2019ve created {issueCount} {issueCount, plural, one {work item} other {work items}}"
    },
    sidePanelHeaderIssueTermRefresh: {
        id: "issue-create-side-panel.header-issue-term-refresh",
        defaultMessage: "Create Jira work item"
    },
    aiUpsellModalBodyIssueTermRefresh: {
        id: "issue-create-side-panel.ai-upsell-modal.body-issue-term-refresh",
        defaultMessage: "Use AI to quickly fill out descriptions using info from Confluence pages. Try it with a free trial of Premium."
    },
    noAnswerSuggestedIssuesIssueTermRefresh: {
        id: "issue-create-side-panel.no-answer-suggested-issues-ai-error-description-issue-term-refresh",
        defaultMessage: "We can\u2019t understand the content to suggest a work item. Select different content or create manually."
    },
    ethicalViolationErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.ethical-violation-ai-error-description-issue-term-refresh",
        defaultMessage: "Your selected content or other content on this page might not comply with our <link>Acceptable Use Policy</link>. You can always create a work item manually."
    },
    rateLimitErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.rate-limit-ai-error-description-issue-term-refresh",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create a work item manually."
    },
    exceedingTokenLimitDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.exceed-token-limit-description-issue-term-refresh",
        defaultMessage: "Atlassian Intelligence can\u2019t create work items for lengthy Confluence pages right now. You can always create a work item manually."
    },
    sidePanelMultipleIssuesInsertLinkFailureFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.multiple.insert-link-failure-flag.title-issue-term-refresh",
        defaultMessage: "We couldn\u2019t insert links to the page for {issueCount} {issueCount, plural, one {work item} other {work items}}"
    },
    sidePanelIssueCreateErrorMessageIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.error.message-issue-term-refresh",
        defaultMessage: "We weren\u2019t able to save your {issuesCount, plural, one {work item} other {work items}}. Please try again."
    },
    bulkCreateConfigureBodyTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.configure.body-issue-term-refresh",
        defaultMessage: "Changing these settings might re-generate the list."
    },
    singleWorkCreateFormBodyTextIssueTermRefresh: {
        id: "issue-create-side-panel.single-work-create-form.body-issue-term-refresh",
        defaultMessage: "Changing these settings might re-generate the list."
    },
    requiredFieldsSectionMessageDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-description-issue-term-refresh",
        defaultMessage: "Edit each suggestion and complete the required fields to create the work items"
    },
    moreThanFiftyWorkItemsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.more-than-fifty-work-items-message-title",
        defaultMessage: "There are more than 50 work items"
    },
    moreThanFiftyWorkItemsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.more-than-fifty-work-items-message-description",
        defaultMessage: "We can\u2019t create more than 50 work items at once. Please delete or approve work items from this list, or limit your table to 50 rows."
    },
    bulkConfigureFormDefaultIssueTypeIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.form.default.issue.type-issue-term-refresh",
        defaultMessage: "Default work type"
    },
    singleWorkCreateFormDefaultIssueTypeIssueTermRefresh: {
        id: "issue-create-side-panel.single-work-create-form.form.default.issue.type-issue-term-refresh",
        defaultMessage: "Work type"
    },
    bulkCreateIssueInsertionHeadingIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.issue-insertion-heading-issue-term-refresh",
        defaultMessage: "Linked Jira work items"
    },
    bulkCreateHeaderTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.header-issue-term-refresh",
        defaultMessage: "Create Jira work items"
    },
    bulkConfigureMapTableToIssueTitleIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.title-issue-term-refresh",
        defaultMessage: "Map table to work item fields"
    },
    bulkConfigureMapTableToIssueDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.description-issue-term-refresh",
        defaultMessage: "You can map your highlighted table\u2019s columns to specific fields in your work items."
    },
    bulkConfigureMapTableToIssueIssueFieldIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field-issue-term-refresh",
        defaultMessage: "Work item field"
    },
    bulkCreateEditHeaderTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create-edit.header-issue-term-refresh",
        defaultMessage: "Edit work item"
    },
    workCreateCommonSummaryLabel: {
        id: "issue-create-side-panel.work-create-form-common.text-field-label",
        defaultMessage: "Summary"
    },
    workCreateCommonSummaryError: {
        id: "issue-create-side-panel.work-create-form-common.text-field-error",
        defaultMessage: "Summary is required"
    },
    workCreateCommonDescriptionLabel: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-label",
        defaultMessage: "Description"
    },
    workCreateCommonDescriptionPlaceholder: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-placeholder",
        defaultMessage: "Add a description..."
    }
});
const $340704cf66283bf0$var$messagesLiveDocs = (0, $2nPZH.defineMessages)({
    aiUpsellModalBody: {
        id: "issue-create-side-panel.ai-upsell-modal.body.livedocs",
        defaultMessage: "Use AI to quickly fill out issue descriptions using info from Confluence pages and live docs. Try it with a free trial of Premium."
    }
});
const $340704cf66283bf0$export$defe85febe8b728c = (0, $jhwJP.mergeLiveDocI18n)($340704cf66283bf0$var$messagesBase, $340704cf66283bf0$var$messagesLiveDocs);
const $340704cf66283bf0$export$79a7c1ed4f4b06be = 'jiraEmbedIssueSiteSelected';
const $340704cf66283bf0$export$4e8bd21788b520a = 'jiraEmbedIssueProjectSelected';
const $340704cf66283bf0$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $340704cf66283bf0$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';

});


parcelRegister("kJYUO", function(module, exports) {

$parcel$export(module.exports, "IssueCreateAiLoadingSidebar", () => $e4ab54f04ea47f96$export$dcc317fc4f9228b3);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $1mDVg = parcelRequire("1mDVg");

var $1uJpg = parcelRequire("1uJpg");
const $e4ab54f04ea47f96$export$dcc317fc4f9228b3 = ({ children: children })=>{
    const [{ aiState: aiState, pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiLoading = aiState === 'loading';
    const aiEnablement = aiIssueCreationEnablement?.enablement;
    (0, $gwFzn.useEffect)(()=>{
        if (isAiLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AI loading state',
                source: 'confluenceHighlightIssueCreate',
                attributes: {
                    aiEnablement: aiEnablement,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAiLoading,
        aiEnablement,
        pageMode,
        hasEditPermission
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1uJpg.RainbowLoadingSidebar), {
        isShown: isAiLoading
    }, children);
};

});
parcelRegister("1mDVg", function(module, exports) {

$parcel$export(module.exports, "PageMode", () => $5a132039fb6a1ec6$export$6ea4b0c62affbe44);
$parcel$export(module.exports, "IssueCreateSidePanelContainer", () => $5a132039fb6a1ec6$export$a8290271bb06280a);
$parcel$export(module.exports, "useIssueCreateSidePanelContext", () => $5a132039fb6a1ec6$export$2a12c9775e55a317);
$parcel$export(module.exports, "useIssueCreateSidePanelActions", () => $5a132039fb6a1ec6$export$74cf44ce4ce6c99b);
$parcel$export(module.exports, "useAiIssueCreationEnablementState", () => $5a132039fb6a1ec6$export$daa560916caa4ae4);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $caRYB = parcelRequire("caRYB");
var $2FFuS = parcelRequire("2FFuS");
var $5a132039fb6a1ec6$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["VIEW"] = "view";
    PageMode["EDIT"] = "edit";
    PageMode["LIVE_VIEW"] = "live-view";
    PageMode["LIVE_EDIT"] = "live-edit";
    return PageMode;
}({});
const $5a132039fb6a1ec6$var$initialIssueCreateSidePanelState = {
    contentId: '',
    contentType: 'page',
    summary: '',
    descriptionAdf: (0, $caRYB.doc)((0, $2FFuS.paragraph)('')),
    highlightedText: (0, $caRYB.doc)((0, $2FFuS.paragraph)('')),
    selectedTable: undefined,
    insertStorageFragmentRequestPayload: undefined,
    insertStorageColumnTableRequestPayload: undefined,
    aiState: 'idle',
    isCreatedWithAi: false,
    firstAttempt: true,
    totalRetries: 0,
    aiAnalyticsContext: {
        aiResponseLength: 0,
        pageContextLength: 0,
        highlightedTextLength: 0
    },
    currentSiteSelection: '',
    currentProjectSelection: undefined,
    aiIssueCreationEnablement: {
        isEnabled: false
    },
    isCreateManuallyPressed: false,
    isGicIframeReady: false,
    pageMode: undefined,
    hasEditPermission: false
};
const $5a132039fb6a1ec6$var$issueCreateSidePanelActions = {
    setContentId: (contentId)=>({ setState: setState })=>{
            setState({
                contentId: contentId
            });
        },
    setContentType: (contentType)=>({ setState: setState })=>{
            setState({
                contentType: contentType
            });
        },
    setSummary: (summary)=>({ setState: setState })=>{
            setState({
                summary: summary
            });
        },
    setDescriptionAdf: (descriptionAdf)=>({ setState: setState })=>{
            setState({
                descriptionAdf: descriptionAdf
            });
        },
    setHighlightedText: (highlightedText)=>({ setState: setState })=>{
            setState({
                highlightedText: highlightedText
            });
        },
    setSelectedTable: (selectedTable)=>({ setState: setState })=>{
            setState({
                selectedTable: selectedTable
            });
        },
    setAiState: (aiState)=>({ setState: setState })=>{
            setState({
                aiState: aiState
            });
        },
    setIsCreatedWithAi: (isCreatedWithAi)=>({ setState: setState })=>{
            setState({
                isCreatedWithAi: isCreatedWithAi
            });
        },
    setInsertStorageFragmentRequestPayload: (insertStorageFragmentRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload
            });
        },
    setInsertStorageColumnTableRequestPayload: (insertStorageColumnTableRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload
            });
        },
    setAiAnalyticsContext: (key, value)=>({ setState: setState, getState: getState })=>{
            setState({
                aiAnalyticsContext: {
                    ...getState()['aiAnalyticsContext'],
                    [key]: value
                }
            });
        },
    setFirstAttempt: (firstAttempt)=>({ setState: setState })=>{
            setState({
                firstAttempt: firstAttempt
            });
        },
    setTotalRetries: ()=>({ setState: setState, getState: getState })=>{
            const currentTotalRetries = getState().totalRetries;
            setState({
                totalRetries: currentTotalRetries + 1
            });
        },
    setCurrentSiteSelection: (currentSiteSelection)=>({ setState: setState })=>{
            setState({
                currentSiteSelection: currentSiteSelection
            });
        },
    setCurrentProjectSelection: (currentProjectSelection)=>({ setState: setState })=>{
            setState({
                currentProjectSelection: currentProjectSelection
            });
        },
    setAiIssueCreationEnablement: (aiIssueCreationEnablement)=>({ setState: setState })=>{
            setState({
                aiIssueCreationEnablement: aiIssueCreationEnablement
            });
        },
    setIsCreateManuallyPressed: (isCreateManuallyPressed)=>({ setState: setState })=>{
            setState({
                isCreateManuallyPressed: isCreateManuallyPressed
            });
        },
    setIsGicIframeReady: (isGicIframeReady)=>({ setState: setState })=>{
            setState({
                isGicIframeReady: isGicIframeReady
            });
        },
    setPageMode: (pageMode)=>({ setState: setState })=>{
            setState({
                pageMode: pageMode
            });
        },
    setHasEditPermission: (hasEditPermission)=>({ setState: setState })=>{
            setState({
                hasEditPermission: hasEditPermission
            });
        }
};
const $5a132039fb6a1ec6$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        ...$5a132039fb6a1ec6$var$initialIssueCreateSidePanelState
    },
    actions: $5a132039fb6a1ec6$var$issueCreateSidePanelActions,
    name: 'issueCreateSidePanelContext'
});
const $5a132039fb6a1ec6$export$a8290271bb06280a = (0, $2S0Fz.createContainer)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$2a12c9775e55a317 = (0, $iFWZA.createHook)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$74cf44ce4ce6c99b = (0, $iFWZA.createActionsHook)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$daa560916caa4ae4 = (0, $iFWZA.createStateHook)($5a132039fb6a1ec6$var$Store, {
    selector: (state)=>state.aiIssueCreationEnablement
});

});

parcelRegister("1uJpg", function(module, exports) {

$parcel$export(module.exports, "RainbowLoadingSidebar", () => $0309755d49e5df30$export$b4f1b3140b8717f8);
/* RainbowLoadingSidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $0309755d49e5df30$var$defaultStyles = null;
const $0309755d49e5df30$var$animateBorder = null;
const $0309755d49e5df30$var$gradientBarStyles = null;
const $0309755d49e5df30$var$addAngleStyles = null;
const $0309755d49e5df30$export$b4f1b3140b8717f8 = ({ children: children, isShown: isShown })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testId": "rainbow-loading-sidebar",
        className: (0, $35pXk.default)([
            "_kqswstnw _1bsb1osq _bfhk1ut7 _4t3i1osq _154iidpf _1xi2idpf _1ltvidpf _94n5idpf _1e0c1txw _2lx21bp4",
            isShown && "",
            isShown && "_5pio1ynq _y44vus0d _1kl71axk _1rrh1i1e",
            isShown && ""
        ])
    }, children);
};

});


parcelRegister("eDk57", function(module, exports) {

$parcel$export(module.exports, "SingleIssueCreateProvidersWrapper", () => $45dbb5af31f3f8d0$export$bc90850968906652);

var $gwFzn = parcelRequire("gwFzn");

var $4aiCO = parcelRequire("4aiCO");

var $1mDVg = parcelRequire("1mDVg");
const $45dbb5af31f3f8d0$export$bc90850968906652 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1mDVg.IssueCreateSidePanelContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4aiCO.IssueCreateWarningDialogContainer), null, children));
};

});
parcelRegister("4aiCO", function(module, exports) {

$parcel$export(module.exports, "WarningDialog", () => $b8aa98a6a4a50068$export$83f018e4a62abc64);
$parcel$export(module.exports, "IssueCreateWarningDialogContainer", () => $b8aa98a6a4a50068$export$b306247a3820322e);
$parcel$export(module.exports, "useWarningDialogStateActions", () => $b8aa98a6a4a50068$export$cbed96beb63c6f4b);
$parcel$export(module.exports, "useIsWarningDialogOpen", () => $b8aa98a6a4a50068$export$4516c77130246355);
$parcel$export(module.exports, "useGetWarningDialog", () => $b8aa98a6a4a50068$export$33ce673123557ab7);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");
const $b8aa98a6a4a50068$export$83f018e4a62abc64 = {
    NAV: 'NAV',
    FLOATING: 'FLOATING'
};
const $b8aa98a6a4a50068$export$106572395d8035d = {
    isWarningDialogOpen: false,
    warningDialog: $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV
};
const $b8aa98a6a4a50068$export$e324594224ef24da = {
    showWarningDialog: (warningDialogDisplayType)=>({ setState: setState })=>{
            const warningDialog = warningDialogDisplayType || $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV;
            setState({
                isWarningDialogOpen: true,
                warningDialog: warningDialog
            });
        },
    hideWarningDialog: ()=>({ setState: setState })=>{
            setState({
                isWarningDialogOpen: false,
                warningDialog: $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV
            });
        }
};
const $b8aa98a6a4a50068$var$Store = (0, $4ZoIm.createStore)({
    initialState: $b8aa98a6a4a50068$export$106572395d8035d,
    actions: $b8aa98a6a4a50068$export$e324594224ef24da,
    name: 'WarningDialogState'
});
const $b8aa98a6a4a50068$export$b306247a3820322e = (0, $2S0Fz.createContainer)($b8aa98a6a4a50068$var$Store);
const $b8aa98a6a4a50068$export$cbed96beb63c6f4b = (0, $iFWZA.createActionsHook)($b8aa98a6a4a50068$var$Store);
const $b8aa98a6a4a50068$export$4516c77130246355 = (0, $iFWZA.createStateHook)($b8aa98a6a4a50068$var$Store, {
    selector: (state)=>state.isWarningDialogOpen
});
const $b8aa98a6a4a50068$export$33ce673123557ab7 = (0, $iFWZA.createStateHook)($b8aa98a6a4a50068$var$Store, {
    selector: (state)=>state.warningDialog
});

});


parcelRegister("5Ew1A", function(module, exports) {

$parcel$export(module.exports, "SidePanelWrapper", () => $08d13ac8ef4b9f2b$export$b3a087f936708dae);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $3PXtn = parcelRequire("3PXtn");

var $kmWRd = parcelRequire("kmWRd");
const $08d13ac8ef4b9f2b$export$b3a087f936708dae = ({ children: children, isOpen: isOpen = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const headerHeight = bannerState.getTotalHeight(true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kmWRd.SidePanel), {
            isFixed: true,
            headerHeight: headerHeight,
            panelTop: headerHeight,
            isOpen: isOpen
        }, children);
    });
};

});

parcelRegister("jwedr", function(module, exports) {

$parcel$export(module.exports, "useGetWarningDialogActions", () => $4f64a1a829c0cee2$export$df2a64a911f4558c);

var $4aiCO = parcelRequire("4aiCO");

var $5ZM1F = parcelRequire("5ZM1F");

var $ccRw1 = parcelRequire("ccRw1");
const $4f64a1a829c0cee2$export$df2a64a911f4558c = (onClose)=>{
    const { handleConfirm: navConfirm, handleCancel: navCancel } = (0, $5ZM1F.useCreateWarningDialogNav)(onClose);
    const { handleConfirm: retryConfirm, handleCancel: retryCancel } = (0, $ccRw1.useGetWarningDialogRetry)();
    const isWarningDialogOpen = (0, $4aiCO.useIsWarningDialogOpen)();
    const warningDialog = (0, $4aiCO.useGetWarningDialog)();
    const handleConfirm = warningDialog === (0, $4aiCO.WarningDialog).FLOATING ? retryConfirm : navConfirm;
    const handleCancel = warningDialog === (0, $4aiCO.WarningDialog).FLOATING ? retryCancel : navCancel;
    return {
        isWarningDialogOpen: isWarningDialogOpen,
        handleConfirm: handleConfirm,
        handleCancel: handleCancel
    };
};

});
parcelRegister("5ZM1F", function(module, exports) {

$parcel$export(module.exports, "useCreateWarningDialogNav", () => $279932bbcfc0ae5e$export$238c59c8fdf58e0f);

var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $ai7NK = parcelRequire("ai7NK");

var $4aiCO = parcelRequire("4aiCO");

var $hq2Sz = parcelRequire("hq2Sz");

var $26Yin = parcelRequire("26Yin");
const $279932bbcfc0ae5e$export$238c59c8fdf58e0f = (onClose)=>{
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { showWarningDialog: showWarningDialog, hideWarningDialog: hideWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const [{ bulkIssuesList: bulkIssuesList, aiState: aiState, error: error, isCreatedWithAi: isCreatedWithAi }] = (0, $hq2Sz.useBulkCreateContext)();
    const { logAiInteractionDismissed: logAiInteractionDismissed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const [nextLocation, setNextLocation] = (0, $gwFzn.useState)();
    const history = (0, $4y1GY.useHistory)();
    const isLoading = aiState === (0, $hq2Sz.AiStates).LOADING;
    const isError = error !== (0, $hq2Sz.ErrorStates).EMPTY;
    const handleConfirm = (0, $gwFzn.useCallback)(()=>{
        if (isCreatedWithAi && (isLoading || isError || bulkIssuesList.length === 0)) logAiInteractionDismissed();
        hideWarningDialog();
        if (nextLocation) {
            history.block(()=>{});
            history.push(nextLocation.pathname);
        }
        hideSidePanel();
        onClose();
    }, [
        bulkIssuesList,
        hideSidePanel,
        hideWarningDialog,
        history,
        isCreatedWithAi,
        isError,
        isLoading,
        logAiInteractionDismissed,
        nextLocation,
        onClose
    ]);
    const handleCancel = (0, $gwFzn.useCallback)(()=>{
        hideWarningDialog();
    }, [
        hideWarningDialog
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const unblockNavigation = history.block((location)=>{
            setNextLocation(location);
            showWarningDialog();
            return false;
        });
        return ()=>unblockNavigation && unblockNavigation();
    }, [
        history,
        showWarningDialog
    ]);
    return {
        handleConfirm: handleConfirm,
        handleCancel: handleCancel
    };
};

});
parcelRegister("hq2Sz", function(module, exports) {

$parcel$export(module.exports, "AiStates", () => $9380a12614698ffc$export$298219811dc2c4cb);
$parcel$export(module.exports, "ErrorStates", () => $9380a12614698ffc$export$b6616fff1cd26f39);
$parcel$export(module.exports, "ErrorMessageMap", () => $9380a12614698ffc$export$ed15e8f0bf6a46a2);
$parcel$export(module.exports, "BulkCreateContainer", () => $9380a12614698ffc$export$92252eadd295fb8a);
$parcel$export(module.exports, "useBulkCreateContext", () => $9380a12614698ffc$export$490e4a97d97cfc86);
$parcel$export(module.exports, "useSetIssueTypeFields", () => $9380a12614698ffc$export$1b7cc5c3228e5df3);
$parcel$export(module.exports, "useSetIsCreatedWithAi", () => $9380a12614698ffc$export$870e2a44cedc7bc5);
$parcel$export(module.exports, "useSetIsCreatedFromTable", () => $9380a12614698ffc$export$bbe8b2f72a2f0142);
$parcel$export(module.exports, "useSetCurrentIssueId", () => $9380a12614698ffc$export$855adaee6d0178f6);
$parcel$export(module.exports, "useSetNextIssueToEdit", () => $9380a12614698ffc$export$99381c02a30b0305);
$parcel$export(module.exports, "useSetIssueTypeHasRequiredFields", () => $9380a12614698ffc$export$a4390ab8bce5f04c);
$parcel$export(module.exports, "useSetSingleIssuesCreated", () => $9380a12614698ffc$export$ba3d9bfa5413fe8b);
$parcel$export(module.exports, "useResetSingleIssuesCreated", () => $9380a12614698ffc$export$b51cb542c700486);
$parcel$export(module.exports, "useGetContentLastModifiedTimestamp", () => $9380a12614698ffc$export$de8db8fa7dde89bc);
$parcel$export(module.exports, "useSetContentLastModifiedTimestamp", () => $9380a12614698ffc$export$244e33037af9cd62);
$parcel$export(module.exports, "useSetInsertStorageFragmentRequestPayload", () => $9380a12614698ffc$export$ad6d9721593c93fd);
$parcel$export(module.exports, "useGetIssueType", () => $9380a12614698ffc$export$9a0d9cff0b566e0d);
$parcel$export(module.exports, "useGetIsMissingColumnMappingError", () => $9380a12614698ffc$export$eece47bd38cb4087);
$parcel$export(module.exports, "useSetError", () => $9380a12614698ffc$export$a7b4ff61662e2485);
$parcel$export(module.exports, "useCloseAndAddIssuesToPage", () => $9380a12614698ffc$export$8f38f84afcc073bc);
$parcel$export(module.exports, "useResetCloseAndAddIssuesToPage", () => $9380a12614698ffc$export$8ed14da773b8613e);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $f0BVO = parcelRequire("f0BVO");

var $3E5yu = parcelRequire("3E5yu");

var $aMxFD = parcelRequire("aMxFD");
const $9380a12614698ffc$export$298219811dc2c4cb = {
    ABORT: 'abort',
    LOADING: 'loading',
    ERROR: 'error',
    IDLE: 'idle'
};
const $9380a12614698ffc$export$b6616fff1cd26f39 = {
    BULK_CREATION: 'bulk-issue-creation-failed',
    ISSUE_GENERATION: 'ai-issue-generation-failed',
    SITE_RETRIEVAL: 'jira-site-retreival-failed',
    PROJECT_RETRIEVAL: 'jira-project-retreival-failed',
    ISSUE_TYPE_RETRIEVAL: 'issue-type-retreival-failed',
    EMPTY: ''
};
const $9380a12614698ffc$export$ed15e8f0bf6a46a2 = {
    [$9380a12614698ffc$export$b6616fff1cd26f39.BULK_CREATION]: (0, $3E5yu.messages).bulkCreateAiErrorDescription,
    [$9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION]: (0, $3E5yu.messages).issueGenerationErrorDescription,
    [$9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL]: (0, $3E5yu.messages).connectJiraProjectErrorDescription,
    [$9380a12614698ffc$export$b6616fff1cd26f39.PROJECT_RETRIEVAL]: (0, $3E5yu.messages).connectJiraProjectErrorDescription,
    [$9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_TYPE_RETRIEVAL]: (0, $3E5yu.messages).connectJiraProjectErrorDescription
};
const $9380a12614698ffc$var$initialBulkCreateState = {
    bulkIssuesList: [],
    currentIssueId: '',
    contentLastModifiedTimestamp: undefined,
    insertStorageFragmentRequestPayload: undefined,
    insertStorageColumnTableRequestPayload: undefined,
    aiState: $9380a12614698ffc$export$298219811dc2c4cb.IDLE,
    isCreatedWithAi: false,
    isCreatedFromTable: false,
    currentJiraSite: undefined,
    currentJiraProject: undefined,
    currentDefaultIssueType: undefined,
    issueTypeHasRequiredFields: false,
    singleIssuesCreated: [],
    error: '',
    issueTypeFields: {
        requiredFields: [],
        optionalFields: []
    },
    manualCreateState: 'idle',
    aiResultViewedFiredOnce: false,
    closeAndAddIssuesToPage: false
};
const $9380a12614698ffc$var$bulkCreateActions = {
    setCurrentIssueId: (currentIssueId)=>({ setState: setState })=>{
            setState({
                currentIssueId: currentIssueId
            });
        },
    setBulkIssuesList: (bulkIssuesList)=>({ setState: setState })=>{
            setState({
                bulkIssuesList: bulkIssuesList
            });
        },
    setIssueTypeFields: (issueTypeFields)=>({ setState: setState })=>{
            setState({
                issueTypeFields: issueTypeFields
            });
        },
    setAiState: (aiState)=>({ setState: setState, getState: getState })=>{
            const { error: error } = getState();
            if (error === $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION && aiState == $9380a12614698ffc$export$298219811dc2c4cb.LOADING) setState({
                aiState: aiState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY
            });
            else if (aiState == $9380a12614698ffc$export$298219811dc2c4cb.ERROR) setState({
                aiState: aiState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION
            });
            else setState({
                aiState: aiState
            });
        },
    setIsCreatedWithAi: (isCreatedWithAi)=>({ setState: setState })=>{
            setState({
                isCreatedWithAi: isCreatedWithAi
            });
        },
    setIsCreatedFromTable: (isCreatedFromTable)=>({ setState: setState })=>{
            setState({
                isCreatedFromTable: isCreatedFromTable
            });
        },
    setContentLastModifiedTimestamp: (contentLastModifiedTimestamp)=>({ setState: setState })=>{
            setState({
                contentLastModifiedTimestamp: contentLastModifiedTimestamp
            });
        },
    setInsertStorageFragmentRequestPayload: (insertStorageFragmentRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload
            });
        },
    setInsertStorageColumnTableRequestPayload: (insertStorageColumnTableRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload
            });
        },
    removeBulkIssue: (issueId)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList } = getState();
            const newBulkIssuesList = bulkIssuesList.filter((issue)=>issue.id !== issueId);
            setState({
                bulkIssuesList: newBulkIssuesList,
                closeAndAddIssuesToPage: newBulkIssuesList.length === 0
            });
        },
    removeBulkIssueList: (issueIds)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList } = getState();
            setState({
                bulkIssuesList: bulkIssuesList.filter((issue)=>!issueIds.includes(issue.id))
            });
        },
    setSingleIssuesCreated: (singleIssue)=>({ setState: setState, getState: getState })=>{
            const { singleIssuesCreated: singleIssuesCreated } = getState();
            setState({
                singleIssuesCreated: [
                    ...singleIssuesCreated,
                    singleIssue
                ]
            });
        },
    resetSingleIssuesCreated: ()=>({ setState: setState })=>{
            setState({
                singleIssuesCreated: $9380a12614698ffc$var$initialBulkCreateState.singleIssuesCreated
            });
        },
    setCurrentJiraSite: (currentJiraSite)=>({ setState: setState })=>{
            setState({
                currentJiraSite: currentJiraSite
            });
        },
    setCurrentJiraProject: (currentJiraProject)=>({ setState: setState })=>{
            setState({
                currentJiraProject: currentJiraProject
            });
        },
    setNextIssueToEdit: (goToPage)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList, currentIssueId: currentIssueId } = getState();
            const currentIssueListIndex = bulkIssuesList.findIndex((issue)=>issue?.id === currentIssueId);
            const newBulkIssuesList = bulkIssuesList.filter((issue)=>issue?.id !== currentIssueId);
            if (currentIssueListIndex >= bulkIssuesList.length - 1) {
                setState({
                    bulkIssuesList: newBulkIssuesList,
                    closeAndAddIssuesToPage: newBulkIssuesList.length === 0
                });
                goToPage('default');
                return;
            }
            setState({
                currentIssueId: bulkIssuesList[currentIssueListIndex + 1]?.id,
                bulkIssuesList: newBulkIssuesList,
                closeAndAddIssuesToPage: newBulkIssuesList.length === 0
            });
        },
    setCurrentDefaultIssueType: (currentDefaultIssueType)=>({ setState: setState })=>{
            setState({
                currentDefaultIssueType: currentDefaultIssueType
            });
        },
    setIssueTypeHasRequiredFields: (issueTypeHasRequiredFields)=>({ setState: setState })=>{
            setState({
                issueTypeHasRequiredFields: issueTypeHasRequiredFields
            });
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                error: error
            });
        },
    setManualCreateState: (manualCreateState)=>({ setState: setState, getState: getState })=>{
            if ((0, $9wGTI.fg)('confluence_bulk_issue_creation_panel_state_bug_fix')) {
                const { error: error } = getState();
                const isManualError = error === $9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL || error === $9380a12614698ffc$export$b6616fff1cd26f39.PROJECT_RETRIEVAL || error === $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_TYPE_RETRIEVAL;
                if (isManualError && manualCreateState === 'loading') setState({
                    manualCreateState: manualCreateState,
                    error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY
                });
                else if (manualCreateState === 'error') setState({
                    manualCreateState: manualCreateState,
                    error: $9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL
                }); // Can be site , project or issue type retrieval since they all have the same error message
                else setState({
                    manualCreateState: manualCreateState
                });
            } else setState({
                manualCreateState: manualCreateState
            });
        },
    resetManualBulkCreateState: ()=>({ setState: setState })=>{
            setState({
                manualCreateState: 'idle',
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY,
                bulkIssuesList: []
            });
        },
    resetAIBulkCreateState: ()=>({ setState: setState })=>{
            setState({
                bulkIssuesList: [],
                aiResultViewedFiredOnce: false
            });
        },
    setAiResultViewedFiredOnce: (aiResultViewedFiredOnce)=>({ setState: setState })=>{
            setState({
                aiResultViewedFiredOnce: aiResultViewedFiredOnce
            });
        },
    resetCloseAndAddIssuesToPage: ()=>({ setState: setState })=>{
            setState({
                closeAndAddIssuesToPage: false
            });
        }
};
const $9380a12614698ffc$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        ...$9380a12614698ffc$var$initialBulkCreateState
    },
    actions: $9380a12614698ffc$var$bulkCreateActions,
    name: 'bulkCreateContext'
});
const $9380a12614698ffc$export$92252eadd295fb8a = (0, $2S0Fz.createContainer)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$export$490e4a97d97cfc86 = (0, $iFWZA.createHook)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$var$useActions = (0, $iFWZA.createActionsHook)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$export$1b7cc5c3228e5df3 = ()=>{
    const { setIssueTypeFields: setIssueTypeFields } = $9380a12614698ffc$var$useActions();
    return setIssueTypeFields;
};
const $9380a12614698ffc$export$870e2a44cedc7bc5 = ()=>{
    const { setIsCreatedWithAi: setIsCreatedWithAi } = $9380a12614698ffc$var$useActions();
    return setIsCreatedWithAi;
};
const $9380a12614698ffc$export$bbe8b2f72a2f0142 = ()=>{
    const { setIsCreatedFromTable: setIsCreatedFromTable } = $9380a12614698ffc$var$useActions();
    return setIsCreatedFromTable;
};
const $9380a12614698ffc$export$855adaee6d0178f6 = ()=>{
    const { setCurrentIssueId: setCurrentIssueId } = $9380a12614698ffc$var$useActions();
    return setCurrentIssueId;
};
const $9380a12614698ffc$export$99381c02a30b0305 = ()=>{
    const { setNextIssueToEdit: setNextIssueToEdit } = $9380a12614698ffc$var$useActions();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    return (0, $gwFzn.useCallback)(()=>void setNextIssueToEdit(goToPage), [
        goToPage,
        setNextIssueToEdit
    ]);
};
const $9380a12614698ffc$export$a4390ab8bce5f04c = ()=>{
    const { setIssueTypeHasRequiredFields: setIssueTypeHasRequiredFields } = $9380a12614698ffc$var$useActions();
    return setIssueTypeHasRequiredFields;
};
const $9380a12614698ffc$export$ba3d9bfa5413fe8b = ()=>{
    const { setSingleIssuesCreated: setSingleIssuesCreated } = $9380a12614698ffc$var$useActions();
    return setSingleIssuesCreated;
};
const $9380a12614698ffc$export$b51cb542c700486 = ()=>{
    const { resetSingleIssuesCreated: resetSingleIssuesCreated } = $9380a12614698ffc$var$useActions();
    return resetSingleIssuesCreated;
};
const $9380a12614698ffc$export$de8db8fa7dde89bc = (0, $iFWZA.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.contentLastModifiedTimestamp
});
const $9380a12614698ffc$export$244e33037af9cd62 = ()=>{
    const { setContentLastModifiedTimestamp: setContentLastModifiedTimestamp } = $9380a12614698ffc$var$useActions();
    return setContentLastModifiedTimestamp;
};
const $9380a12614698ffc$export$ad6d9721593c93fd = ()=>{
    const { setInsertStorageFragmentRequestPayload: setInsertStorageFragmentRequestPayload } = $9380a12614698ffc$var$useActions();
    return setInsertStorageFragmentRequestPayload;
};
const $9380a12614698ffc$export$9a0d9cff0b566e0d = (0, $iFWZA.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>({
            iconUrl: (0, $f0BVO.transformStargateUrl)(state.currentDefaultIssueType?.iconUrl || ''),
            name: state.currentDefaultIssueType?.name || '',
            id: state.currentDefaultIssueType?.id || ''
        })
});
const $9380a12614698ffc$export$eece47bd38cb4087 = (0, $iFWZA.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>!state.isCreatedWithAi && state.bulkIssuesList.length === 0 && (0, $9wGTI.fg)('confluence_bulk_issue_creation_loading_fix')
});
const $9380a12614698ffc$export$a7b4ff61662e2485 = ()=>{
    const { setError: setError } = $9380a12614698ffc$var$useActions();
    return setError;
};
const $9380a12614698ffc$export$8f38f84afcc073bc = (0, $iFWZA.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.closeAndAddIssuesToPage
});
const $9380a12614698ffc$export$8ed14da773b8613e = ()=>{
    const { resetCloseAndAddIssuesToPage: resetCloseAndAddIssuesToPage } = $9380a12614698ffc$var$useActions();
    return resetCloseAndAddIssuesToPage;
};

});
parcelRegister("f0BVO", function(module, exports) {

$parcel$export(module.exports, "transformStargateUrl", () => $09059fa00e602c45$export$96f8b7181eacc12a);
// Projects and Issue Types aratar URLs are returned wrongly for Stargate requests.
// This function corrects the URLs.
// This can be removed once the Stargate issue is fixed. Ticket: https://donut-world-dogfood.atlassian.net/browse/MCRTB-1099
const $09059fa00e602c45$export$96f8b7181eacc12a = (url)=>{
    try {
        if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
            const urlObject = new URL(url);
            let urlPathArray = urlObject.pathname.split('/');
            urlPathArray = [
                'gateway',
                'api',
                ...urlPathArray.slice(1)
            ];
            return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
        }
    } catch (e) {
        return url;
    }
    return url;
};

});

parcelRegister("aMxFD", function(module, exports) {

$parcel$export(module.exports, "AiBulkNavigationContextContainer", () => $8e2cb5cf70790964$export$a334843fa0c1b332);
$parcel$export(module.exports, "useAiBulkNavigationGotoPage", () => $8e2cb5cf70790964$export$26ede1f3a8b75971);
$parcel$export(module.exports, "useAiBulkNavigationCurrentPage", () => $8e2cb5cf70790964$export$c38ef97487898e66);
$parcel$export(module.exports, "useSetBulkCreateFlagsContainer", () => $8e2cb5cf70790964$export$94387769fbc3c2a7);
$parcel$export(module.exports, "useBulkCreateFlagsContainer", () => $8e2cb5cf70790964$export$9800018acb54c42);
$parcel$export(module.exports, "useSetErrorMessage", () => $8e2cb5cf70790964$export$bf8137e7995f9734);
$parcel$export(module.exports, "useErrorMessage", () => $8e2cb5cf70790964$export$23759efdd2d2dae9);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");
const $8e2cb5cf70790964$var$initialState = {
    currentPage: 'default',
    errorMessage: null
};
const $8e2cb5cf70790964$var$actions = {
    goToPage: (page)=>({ setState: setState })=>{
            setState({
                currentPage: page
            });
        },
    setFlags: (flags)=>({ setState: setState })=>{
            setState({
                flags: flags
            });
        },
    setErrorMessage: (errorMessage)=>({ setState: setState })=>{
            setState({
                errorMessage: errorMessage
            });
        }
};
const $8e2cb5cf70790964$var$Store = (0, $4ZoIm.createStore)({
    initialState: $8e2cb5cf70790964$var$initialState,
    actions: $8e2cb5cf70790964$var$actions,
    name: 'AiBulkNavigationState'
});
const $8e2cb5cf70790964$export$a334843fa0c1b332 = (0, $2S0Fz.createContainer)($8e2cb5cf70790964$var$Store);
const $8e2cb5cf70790964$var$useActions = (0, $iFWZA.createActionsHook)($8e2cb5cf70790964$var$Store);
const $8e2cb5cf70790964$export$26ede1f3a8b75971 = ()=>{
    const { goToPage: goToPage } = $8e2cb5cf70790964$var$useActions();
    return goToPage;
};
const $8e2cb5cf70790964$export$c38ef97487898e66 = (0, $iFWZA.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.currentPage
});
const $8e2cb5cf70790964$export$94387769fbc3c2a7 = ()=>{
    const { setFlags: setFlags } = $8e2cb5cf70790964$var$useActions();
    return setFlags;
};
const $8e2cb5cf70790964$export$9800018acb54c42 = (0, $iFWZA.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.flags
});
const $8e2cb5cf70790964$export$bf8137e7995f9734 = ()=>{
    const { setErrorMessage: setErrorMessage } = $8e2cb5cf70790964$var$useActions();
    return setErrorMessage;
};
const $8e2cb5cf70790964$export$23759efdd2d2dae9 = (0, $iFWZA.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.errorMessage
});

});


parcelRegister("26Yin", function(module, exports) {

$parcel$export(module.exports, "BULK_ISSUE_CREATE_SOURCE", () => $33398e36495db1d3$export$73d72a8adb795478);
$parcel$export(module.exports, "AI_BULK_ISSUE_CREATE_FEATURE_NAME", () => $33398e36495db1d3$export$90c28b8de76b4f83);
$parcel$export(module.exports, "getSource", () => $33398e36495db1d3$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "useBulkCreateLoggingEvents", () => $33398e36495db1d3$export$ba0927ab3d0d491f);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $fYQcF = parcelRequire("fYQcF");

var $9wGTI = parcelRequire("9wGTI");

var $hq2Sz = parcelRequire("hq2Sz");

var $1mDVg = parcelRequire("1mDVg");

var $CbMiC = parcelRequire("CbMiC");
const $33398e36495db1d3$export$44cbec570ea812dc = 'confluenceHighlightIssueCreate';
const $33398e36495db1d3$export$73d72a8adb795478 = 'confluenceBulkIssueCreate';
const $33398e36495db1d3$export$90c28b8de76b4f83 = 'aiIssueCreateConfluenceBulk';
const $33398e36495db1d3$var$buildAttributes = (baseAttributes, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode)=>{
    baseAttributes.isCreatedFromTable = isCreatedFromTable;
    baseAttributes.isCreatedWithAi = isCreatedWithAi;
    baseAttributes.hasEditPermission = hasEditPermission;
    if (pageMode) baseAttributes.pageMode = pageMode;
    if (isCreatedWithAi) return {
        ...baseAttributes,
        aiFeatureName: $33398e36495db1d3$export$90c28b8de76b4f83
    };
    return baseAttributes;
};
const $33398e36495db1d3$export$dd2b6e807fb37ba3 = (isCreatedFromTable)=>{
    return isCreatedFromTable ? $33398e36495db1d3$export$44cbec570ea812dc : $33398e36495db1d3$export$73d72a8adb795478;
};
const $33398e36495db1d3$var$getErrorMessage = (error)=>{
    if (error instanceof Error) return error.message;
    return String(error);
};
const $33398e36495db1d3$export$7e3e9ba2bdd512ee = ()=>{
    const { columnToFieldMappings: columnToFieldMappings } = (0, $CbMiC.useMappingsState)();
    const numMappings = columnToFieldMappings && (0, $9wGTI.fg)('confluence_bulk_issue_create_additional_mappings') ? columnToFieldMappings.length : undefined;
    return {
        numMappings: numMappings
    };
};
const $33398e36495db1d3$export$ba0927ab3d0d491f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackAIResultError: trackAIResultError, trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [{ isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { numMappings: numMappings } = $33398e36495db1d3$export$7e3e9ba2bdd512ee();
    const logMultipleIssueCreateSuccess = (0, $gwFzn.useCallback)((numIssues)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            numIssues: numIssues,
            ...numMappings && {
                numMappings: numMappings
            }
        }, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'created',
                actionSubject: 'issue',
                attributes: attributes
            }
        }).fire();
    }, [
        numMappings,
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    const logMultipleIssueCreateFailure = (0, $gwFzn.useCallback)((numIssues, error)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            error: $33398e36495db1d3$var$getErrorMessage(error),
            numIssues: numIssues
        }, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'failed',
                actionSubject: 'issueCreation',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    const logSingleIssueCreateSuccess = (0, $gwFzn.useCallback)(()=>{
        logMultipleIssueCreateSuccess(1);
    }, [
        logMultipleIssueCreateSuccess
    ]);
    const logSingleIssueCreateFailure = (0, $gwFzn.useCallback)((error)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            error: $33398e36495db1d3$var$getErrorMessage(error)
        }, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'error',
                actionSubject: 'globalIssueCreate',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    const logCancelAiPanel = (0, $gwFzn.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'cancelled',
                actionSubject: 'aiPanel',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    const logAiResultViewed = (0, $gwFzn.useCallback)((issuesGenerated)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            issuesGenerated: issuesGenerated
        }, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        trackAIResultView({
            attributes: attributes
        });
    }, [
        trackAIResultView,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    const logAiResultActioned = (0, $gwFzn.useCallback)((aiResultAction, issueId)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        trackAIResultAction(aiResultAction, {
            attributes: {
                ...attributes,
                issueId: issueId
            }
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        trackAIResultAction,
        hasEditPermission
    ]);
    const logAiResultRemoved = (0, $gwFzn.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'removed',
                actionSubject: 'aiResult',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        hasEditPermission
    ]);
    const logRequestFailed = (0, $gwFzn.useCallback)(({ requestName: requestName, errorMessage: errorMessage })=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            errorMessage: errorMessage
        }, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'failed',
                actionSubject: requestName,
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        hasEditPermission
    ]);
    const logSidePanelIssueRemoved = (0, $gwFzn.useCallback)(()=>{
        if (isCreatedWithAi) logAiResultRemoved();
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'removed',
                actionSubject: 'sidePanelIssue',
                attributes: attributes
            }
        }).fire();
    }, [
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        createAnalyticsEvent,
        logAiResultRemoved,
        hasEditPermission
    ]);
    const logSidePanelIssueApproved = (0, $gwFzn.useCallback)((issueAction)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            issueAction: issueAction
        }, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'approved',
                actionSubject: 'sidePanelIssue',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    const logCreateAllClick = (0, $gwFzn.useCallback)(()=>{
        if (isCreatedWithAi) logAiResultActioned('createAll');
        logSidePanelIssueApproved('createAll');
    }, [
        isCreatedWithAi,
        logAiResultActioned,
        logSidePanelIssueApproved
    ]);
    const logCreateSingleIssueClick = (0, $gwFzn.useCallback)((issueId)=>{
        if (isCreatedWithAi) logAiResultActioned('createSingleIssue', issueId);
        logSidePanelIssueApproved('createSingleIssue');
    }, [
        isCreatedWithAi,
        logAiResultActioned,
        logSidePanelIssueApproved
    ]);
    const logAiIssueCreationFailed = (0, $gwFzn.useCallback)((numIssues, error = '')=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            errorMessage: $33398e36495db1d3$var$getErrorMessage(error),
            numIssues: numIssues
        }, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'failed',
                actionSubject: 'aiIssueCreation',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    const logAiInteractionDismissed = (0, $gwFzn.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        trackAIInteractionDismiss({
            attributes: attributes
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        trackAIInteractionDismiss,
        hasEditPermission
    ]);
    const logAiNoResultsGenerated = (0, $gwFzn.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'generated',
                actionSubject: 'aiNoResults',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        hasEditPermission
    ]);
    const logAiInteractionInitiated = (0, $gwFzn.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        trackAIInteractionInit({
            attributes: attributes
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        trackAIInteractionInit,
        hasEditPermission
    ]);
    const logAiStreamingBackendFailed = (0, $gwFzn.useCallback)((error = '')=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        trackAIResultError({
            aiErrorMessage: $33398e36495db1d3$var$getErrorMessage(error)
        }, {
            attributes: attributes
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        trackAIResultError,
        hasEditPermission
    ]);
    const logIssueCreationFailed = (0, $gwFzn.useCallback)((numIssues, error = '')=>{
        if (isCreatedWithAi) logAiIssueCreationFailed(numIssues, error);
        logMultipleIssueCreateFailure(numIssues, error);
    }, [
        isCreatedWithAi,
        logAiIssueCreationFailed,
        logMultipleIssueCreateFailure
    ]);
    const logSidePanelClosed = (0, $gwFzn.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({}, isCreatedWithAi, isCreatedFromTable, hasEditPermission, pageMode);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable),
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'linkCreate',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        pageMode,
        hasEditPermission
    ]);
    return {
        logSingleIssueCreateSuccess: logSingleIssueCreateSuccess,
        logMultipleIssueCreateSuccess: logMultipleIssueCreateSuccess,
        logSingleIssueCreateFailure: logSingleIssueCreateFailure,
        logCancelAiPanel: logCancelAiPanel,
        logCreateAllClick: logCreateAllClick,
        logCreateSingleIssueClick: logCreateSingleIssueClick,
        logAiInteractionInitiated: logAiInteractionInitiated,
        logAiResultViewed: logAiResultViewed,
        logAiResultRemoved: logAiResultRemoved,
        logAiInteractionDismissed: logAiInteractionDismissed,
        logAiNoResultsGenerated: logAiNoResultsGenerated,
        logRequestFailed: logRequestFailed,
        logAiStreamingBackendFailed: logAiStreamingBackendFailed,
        logSidePanelIssueRemoved: logSidePanelIssueRemoved,
        logSidePanelIssueApproved: logSidePanelIssueApproved,
        logIssueCreationFailed: logIssueCreationFailed,
        logSidePanelClosed: logSidePanelClosed
    };
};

});
parcelRegister("CbMiC", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $bb8ecfce0aa3278d$export$ed12481c953b8653);
$parcel$export(module.exports, "BulkConfigureContextContainer", () => $bb8ecfce0aa3278d$export$f3c254ba6f87ce6c);
$parcel$export(module.exports, "useAvailableSitesActions", () => $bb8ecfce0aa3278d$export$34f182b55b8247e5);
$parcel$export(module.exports, "useAvailableSitesState", () => $bb8ecfce0aa3278d$export$b6149499a5c58797);
$parcel$export(module.exports, "useProjectsActions", () => $bb8ecfce0aa3278d$export$af9c52e036827f6);
$parcel$export(module.exports, "useProjectsState", () => $bb8ecfce0aa3278d$export$f7f81cde1f4d14dd);
$parcel$export(module.exports, "useIssueTypesActions", () => $bb8ecfce0aa3278d$export$8748a77548356db8);
$parcel$export(module.exports, "useIssueTypesState", () => $bb8ecfce0aa3278d$export$5c76c054e4b1d9b1);
$parcel$export(module.exports, "useIsConfigureLoading", () => $bb8ecfce0aa3278d$export$fd383356e1d8436d);
$parcel$export(module.exports, "useMappingsActions", () => $bb8ecfce0aa3278d$export$d70d2e57670622a8);
$parcel$export(module.exports, "useMappingsState", () => $bb8ecfce0aa3278d$export$c8eb692d6965a0dd);
$parcel$export(module.exports, "useResetConfigureState", () => $bb8ecfce0aa3278d$export$2577d7c75421da7d);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");
var $bb8ecfce0aa3278d$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType[FieldType["PARAGRAPH"] = 0] = "PARAGRAPH";
    FieldType[FieldType["SHORT_TEXT"] = 1] = "SHORT_TEXT";
    FieldType[FieldType["NUMBER"] = 2] = "NUMBER";
    FieldType[FieldType["DATE"] = 3] = "DATE";
    FieldType[FieldType["TIMESTAMP"] = 4] = "TIMESTAMP";
    FieldType[FieldType["USER"] = 5] = "USER";
    FieldType[FieldType["PEOPLE"] = 6] = "PEOPLE";
    FieldType[FieldType["TEAM"] = 7] = "TEAM";
    FieldType[FieldType["PRIORITY"] = 8] = "PRIORITY";
    FieldType[FieldType["LABELS"] = 9] = "LABELS";
    FieldType[FieldType["UNSUPPORTED"] = 10] = "UNSUPPORTED";
    return FieldType;
}({});
const $bb8ecfce0aa3278d$var$initialState = {
    optionsAvailableSites: null,
    optionsRecentProjects: null,
    optionsAllProjects: null,
    optionsIssueTypes: null,
    optionsIssueTypeFields: null,
    optionsColumns: null,
    selectedAvailableSite: null,
    selectedProject: null,
    selectedIssueType: null,
    loadingProjects: false,
    loadingIssueType: false,
    loadingIssueTypeFields: false,
    projectSelectorQuery: '',
    isJiraError: false,
    columnToFieldMappings: null,
    unsavedColumnToFieldMappings: null,
    columnOffset: null
};
const $bb8ecfce0aa3278d$var$actions = {
    setOptionsAvailableSites: (optionsAvailableSites)=>({ setState: setState })=>{
            setState({
                optionsAvailableSites: optionsAvailableSites
            });
        },
    setOptionsRecentProjects: (optionsRecentProjects)=>({ setState: setState })=>{
            setState({
                optionsRecentProjects: optionsRecentProjects
            });
        },
    setOptionsAllProjects: (optionsAllProjects)=>({ setState: setState })=>{
            setState({
                optionsAllProjects: optionsAllProjects
            });
        },
    setOptionsIssueTypes: (optionsIssueTypes)=>({ setState: setState })=>{
            setState({
                optionsIssueTypes: optionsIssueTypes
            });
        },
    setOptionsIssueTypeFields: (optionsIssueTypeFields)=>({ setState: setState })=>{
            setState({
                optionsIssueTypeFields: optionsIssueTypeFields
            });
        },
    setOptionsColumns: (optionsColumns)=>({ setState: setState })=>{
            setState({
                optionsColumns: optionsColumns
            });
        },
    setSelectedAvailableSite: (selectedAvailableSite)=>({ setState: setState })=>{
            setState({
                selectedAvailableSite: selectedAvailableSite,
                selectedProject: null,
                selectedIssueType: null,
                optionsRecentProjects: null,
                optionsAllProjects: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null,
                isJiraError: false
            });
        },
    setSelectedProject: (selectedProject)=>({ setState: setState })=>{
            setState({
                selectedProject: selectedProject,
                selectedIssueType: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null
            });
        },
    setSelectedProjectIfEmpty: (newSelectedProject)=>({ getState: getState, setState: setState })=>{
            const { selectedProject: selectedProject } = getState();
            if (!selectedProject) setState({
                selectedProject: newSelectedProject,
                selectedIssueType: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null
            });
        },
    setSelectedIssueType: (selectedIssueType)=>({ setState: setState })=>{
            setState({
                selectedIssueType: selectedIssueType,
                optionsIssueTypeFields: null
            });
        },
    setSelectedIssueTypeIfEmpty: (newSelectedIssueType)=>({ getState: getState, setState: setState })=>{
            const { selectedIssueType: selectedIssueType } = getState();
            if (!selectedIssueType) setState({
                selectedIssueType: newSelectedIssueType,
                optionsIssueTypeFields: null
            });
        },
    setLoadingProjects: (loadingProjects)=>({ setState: setState })=>{
            setState({
                loadingProjects: loadingProjects
            });
        },
    setLoadingIssueType: (loadingIssueType)=>({ setState: setState })=>{
            setState({
                loadingIssueType: loadingIssueType
            });
        },
    setLoadingIssueTypeFields: (loadingIssueTypeFields)=>({ setState: setState })=>{
            setState({
                loadingIssueTypeFields: loadingIssueTypeFields
            });
        },
    setProjectSelectorQuery: (projectSelectorQuery)=>({ setState: setState })=>{
            setState({
                projectSelectorQuery: projectSelectorQuery
            });
        },
    setIsJiraError: (isJiraError)=>({ setState: setState })=>{
            setState({
                isJiraError: isJiraError
            });
        },
    setColumnToFieldMappings: (columnToFieldMappings)=>({ setState: setState })=>{
            setState({
                columnToFieldMappings: columnToFieldMappings
            });
        },
    setUnsavedColumnToFieldMappings: (unsavedColumnToFieldMappings)=>({ setState: setState })=>{
            setState({
                unsavedColumnToFieldMappings: unsavedColumnToFieldMappings
            });
        },
    initUnsavedColumnToFieldMappings: ()=>({ setState: setState, getState: getState })=>{
            const { columnToFieldMappings: columnToFieldMappings, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, optionsIssueTypeFields: optionsIssueTypeFields } = getState();
            // When the issue type chenges, the issue type fields will need to be reloaded.
            // With the existing mapping:
            // If the field is not available in the newly selected issue type, we remove the mapping.
            // If the field is available, we keep the mapping and update the reference to the field.
            if (unsavedColumnToFieldMappings && optionsIssueTypeFields) {
                const fieldIdMap = new Map(optionsIssueTypeFields.map((field)=>[
                        field.fieldId,
                        field
                    ]));
                const updatedMappings = unsavedColumnToFieldMappings.reduce((acc, mapping)=>{
                    const currentFieldId = mapping.field?.fieldId;
                    if (currentFieldId === undefined || fieldIdMap.has(currentFieldId)) acc.push({
                        ...mapping,
                        field: currentFieldId ? fieldIdMap.get(currentFieldId) : undefined,
                        errors: {}
                    });
                    return acc;
                }, []);
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            } else if (columnToFieldMappings) {
                const updatedMappings = columnToFieldMappings.map((mapping)=>({
                        ...mapping,
                        isDefaultMapping: mapping.field?.fieldId === 'summary' || mapping.field?.fieldId === 'description',
                        errors: {}
                    }));
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            }
        },
    addUnsavedColumnToFieldMapping: (mapping)=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) setState({
                unsavedColumnToFieldMappings: [
                    ...unsavedColumnToFieldMappings,
                    mapping
                ]
            });
        },
    deleteUnsavedColumnToFieldMapping: (index)=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) {
                const updatedMappings = unsavedColumnToFieldMappings.filter((_, idx)=>idx !== index);
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            }
        },
    saveUnsavedColumnToFieldMapping: ()=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) {
                const updatedMappings = unsavedColumnToFieldMappings.map(({ errors: errors, isDefaultMapping: isDefaultMapping, ...rest })=>rest);
                setState({
                    columnToFieldMappings: updatedMappings
                });
            }
        },
    setColumnOffset: (columnOffset)=>({ setState: setState })=>{
            setState({
                columnOffset: columnOffset
            });
        },
    resetAll: (selectedAvailableSite, selectedProject, selectedIssueType)=>({ setState: setState })=>{
            setState({
                selectedAvailableSite: selectedAvailableSite,
                selectedProject: selectedProject,
                selectedIssueType: selectedIssueType
            });
        }
};
const $bb8ecfce0aa3278d$var$Store = (0, $4ZoIm.createStore)({
    initialState: $bb8ecfce0aa3278d$var$initialState,
    actions: $bb8ecfce0aa3278d$var$actions,
    name: 'BulkConfigureState'
});
const $bb8ecfce0aa3278d$export$f3c254ba6f87ce6c = (0, $2S0Fz.createContainer)($bb8ecfce0aa3278d$var$Store);
const $bb8ecfce0aa3278d$var$useActions = (0, $iFWZA.createActionsHook)($bb8ecfce0aa3278d$var$Store);
const $bb8ecfce0aa3278d$export$34f182b55b8247e5 = ()=>{
    const { setOptionsAvailableSites: setOptionsAvailableSites, setSelectedAvailableSite: setSelectedAvailableSite } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsAvailableSites: setOptionsAvailableSites,
        setSelectedAvailableSite: setSelectedAvailableSite
    };
};
const $bb8ecfce0aa3278d$export$b6149499a5c58797 = (0, $iFWZA.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsAvailableSites: optionsAvailableSites, selectedAvailableSite: selectedAvailableSite })=>({
            optionsAvailableSites: optionsAvailableSites,
            selectedAvailableSite: selectedAvailableSite
        })
});
const $bb8ecfce0aa3278d$export$af9c52e036827f6 = ()=>{
    const { setOptionsRecentProjects: setOptionsRecentProjects, setOptionsAllProjects: setOptionsAllProjects, setSelectedProject: setSelectedProject, setSelectedProjectIfEmpty: setSelectedProjectIfEmpty, setLoadingProjects: setLoadingProjects, setProjectSelectorQuery: setProjectSelectorQuery, setIsJiraError: setIsJiraError } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsRecentProjects: setOptionsRecentProjects,
        setOptionsAllProjects: setOptionsAllProjects,
        setSelectedProject: setSelectedProject,
        setSelectedProjectIfEmpty: setSelectedProjectIfEmpty,
        setLoadingProjects: setLoadingProjects,
        setProjectSelectorQuery: setProjectSelectorQuery,
        setIsJiraError: setIsJiraError
    };
};
const $bb8ecfce0aa3278d$export$f7f81cde1f4d14dd = (0, $iFWZA.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsRecentProjects: optionsRecentProjects, optionsAllProjects: optionsAllProjects, selectedProject: selectedProject, projectSelectorQuery: projectSelectorQuery })=>({
            optionsRecentProjects: optionsRecentProjects,
            optionsAllProjects: optionsAllProjects,
            selectedProject: selectedProject,
            projectSelectorQuery: projectSelectorQuery
        })
});
const $bb8ecfce0aa3278d$export$8748a77548356db8 = ()=>{
    const { setOptionsIssueTypes: setOptionsIssueTypes, setSelectedIssueType: setSelectedIssueType, setLoadingIssueType: setLoadingIssueType, setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsIssueTypes: setOptionsIssueTypes,
        setSelectedIssueType: setSelectedIssueType,
        setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty,
        setLoadingIssueType: setLoadingIssueType
    };
};
const $bb8ecfce0aa3278d$export$5c76c054e4b1d9b1 = (0, $iFWZA.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsIssueTypes: optionsIssueTypes, selectedIssueType: selectedIssueType })=>({
            optionsIssueTypes: optionsIssueTypes,
            selectedIssueType: selectedIssueType
        })
});
const $bb8ecfce0aa3278d$export$fd383356e1d8436d = (0, $iFWZA.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ selectedAvailableSite: selectedAvailableSite, loadingProjects: loadingProjects, loadingIssueType: loadingIssueType, isJiraError: isJiraError })=>({
            isLoading: selectedAvailableSite == null || loadingProjects || loadingIssueType,
            isJiraError: isJiraError
        })
});
const $bb8ecfce0aa3278d$export$d70d2e57670622a8 = ()=>{
    const { setOptionsColumns: setOptionsColumns, setOptionsIssueTypeFields: setOptionsIssueTypeFields, setLoadingIssueTypeFields: setLoadingIssueTypeFields, setColumnToFieldMappings: setColumnToFieldMappings, setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings, initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings, addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping, deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping, saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping, setColumnOffset: setColumnOffset } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsColumns: setOptionsColumns,
        setOptionsIssueTypeFields: setOptionsIssueTypeFields,
        setLoadingIssueTypeFields: setLoadingIssueTypeFields,
        setColumnToFieldMappings: setColumnToFieldMappings,
        initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings,
        setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings,
        addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping,
        deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping,
        saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping,
        setColumnOffset: setColumnOffset
    };
};
const $bb8ecfce0aa3278d$export$c8eb692d6965a0dd = (0, $iFWZA.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsColumns: optionsColumns, optionsIssueTypeFields: optionsIssueTypeFields, loadingIssueTypeFields: loadingIssueTypeFields, columnToFieldMappings: columnToFieldMappings, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, columnOffset: columnOffset })=>({
            optionsColumns: optionsColumns,
            optionsIssueTypeFields: optionsIssueTypeFields,
            loadingIssueTypeFields: loadingIssueTypeFields,
            columnToFieldMappings: columnToFieldMappings,
            unsavedColumnToFieldMappings: unsavedColumnToFieldMappings,
            columnOffset: columnOffset
        })
});
const $bb8ecfce0aa3278d$export$2577d7c75421da7d = ()=>{
    const { resetAll: resetAll } = $bb8ecfce0aa3278d$var$useActions();
    return resetAll;
};

});



parcelRegister("ccRw1", function(module, exports) {

$parcel$export(module.exports, "useGetWarningDialogRetry", () => $a9a03e018614f316$export$c93f6c362a2b52d9);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $4aiCO = parcelRequire("4aiCO");
const $a9a03e018614f316$export$c93f6c362a2b52d9 = ()=>{
    const { hideWarningDialog: hideWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const handleConfirm = (0, $gwFzn.useCallback)(async ()=>{
        // This logic will be replaced by a refetch call to the AI API which will render new AI issues
        await setIsCreatedWithAi(false);
        await setIsCreatedWithAi(true);
        hideWarningDialog();
    }, [
        hideWarningDialog,
        setIsCreatedWithAi
    ]);
    const handleCancel = (0, $gwFzn.useCallback)(()=>{
        hideWarningDialog();
    }, [
        hideWarningDialog
    ]);
    return {
        handleConfirm: handleConfirm,
        handleCancel: handleCancel
    };
};

});


parcelRegister("3AAT8", function(module, exports) {

$parcel$export(module.exports, "IssueCreateSidePanelBody", () => $889e5fc4cfbacead$export$b5988d25d9f45521);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $cfwlu = parcelRequire("cfwlu");

var $fYQcF = parcelRequire("fYQcF");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");

var $1mDVg = parcelRequire("1mDVg");

var $5FJ5W = parcelRequire("5FJ5W");

var $3E5yu = parcelRequire("3E5yu");

var $1Q0l6 = parcelRequire("1Q0l6");

var $9K9na = parcelRequire("9K9na");

var $2ay9q = parcelRequire("2ay9q");

var $bImpr = parcelRequire("bImpr");

var $kcLnq = parcelRequire("kcLnq");

var $dAg4H = parcelRequire("dAg4H");

var $bZC8A = parcelRequire("bZC8A");

var $jE0Gg = parcelRequire("jE0Gg");

var $aXkRG = parcelRequire("aXkRG");

var $7aGmI = parcelRequire("7aGmI");
const $889e5fc4cfbacead$var$aiContentWrapperBaseStyles = (0, $ecnYn.xcss)({
    display: 'inherit',
    flexGrow: 1
});
const $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $889e5fc4cfbacead$export$b5988d25d9f45521 = ({ onClose: onClose, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { contentId: contentId, contentType: contentType, summary: summary, descriptionAdf: descriptionAdf, aiState: aiState, isCreatedWithAi: isCreatedWithAi, highlightedText: highlightedText, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, totalRetries: totalRetries, firstAttempt: firstAttempt, aiAnalyticsContext: aiAnalyticsContext, currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isGicIframeReady: isGicIframeReady } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const aiError = aiState === 'error';
    // no need to override if it's the same site
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const [overrideCloudIdForSitePicker, setOverrideCloudIdForSitePicker] = (0, $gwFzn.useState)(persistedOverrideCloudId !== cloudId ? persistedOverrideCloudId : undefined);
    const [overrideProjectId, setOverrideProjectId] = (0, $gwFzn.useState)(undefined);
    const [showCreateWithAiToggle, setShowCreateWithAiToggle] = (0, $gwFzn.useState)(false);
    const defaultErrorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).singleCreateAiErrorDescription;
    const [errorMessage, setErrorMessage] = (0, $gwFzn.useState)(defaultErrorMessage);
    const [errorMessageValues, setErrorMessageValues] = (0, $gwFzn.useState)();
    const [hideTryAgain, setHideTryAgain] = (0, $gwFzn.useState)(false);
    (0, $jE0Gg.useMessageListener)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId
    });
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'linkCreateScreen',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                },
                source: 'confluenceHighlightIssueCreate'
            }
        }).fire();
    }, [
        isCreatedWithAi,
        createAnalyticsEvent,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        state.hasEditPermission
    ]);
    const isAiLoading = aiState === 'loading';
    const triggerFlag = (0, $9K9na.useTriggerFlagIssueCreated)(flags);
    const handleTryAgain = (0, $gwFzn.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setAiState('idle');
        // trigger a new AI interaction init event retries
        trackAIInteractionInit({
            attributes: {
                pageMode: state.pageMode,
                totalRetries: totalRetries + 1,
                firstAttempt: false,
                aiEnablement: aiIssueCreationEnablement?.enablement
            }
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: !isCreatedWithAi,
                    tryAgainWithAi: isCreatedWithAi,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
    }, [
        actions,
        trackAIInteractionInit,
        totalRetries,
        aiIssueCreationEnablement?.enablement,
        createAnalyticsEvent,
        state.pageMode,
        isCreatedWithAi,
        aiAnalyticsContext,
        state.hasEditPermission
    ]);
    const handleCreateManually = (0, $gwFzn.useCallback)(()=>{
        actions.setIsCreatedWithAi(false);
        actions.setAiState('idle');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateWithAi = (0, $gwFzn.useCallback)(()=>{
        actions.setIsCreatedWithAi(true);
        actions.setAiState('loading');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateManuallyAfterError = (0, $gwFzn.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setIsCreateManuallyPressed(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: true,
                    tryAgainWithAi: false,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
        handleCreateManually();
    }, [
        actions,
        createAnalyticsEvent,
        state.pageMode,
        state.hasEditPermission,
        totalRetries,
        aiAnalyticsContext,
        handleCreateManually
    ]);
    const onIssueCreateInit = (0, $gwFzn.useCallback)(()=>{
        setShowCreateWithAiToggle(aiIssueCreationEnablement?.isEnabled ?? false);
        /*
		 * When ConfluenceAI=OFF & JiraAI=ON this component will manually create the issue first until
		 * selected site & project info is available to check Jira's AI enablement.  If JiraAI=ON then
		 * we can setIsCreatedWithAi to what the user's personal AI enablement to trigger a rerender.
		 */ if (aiIssueCreationEnablement?.isEnabled) actions.setIsCreatedWithAi((0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)());
        else actions.setIsCreatedWithAi(false);
        if (!(0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)() || !(0, $9wGTI.fg)('jira_side_panel_aiwc_jira_ai_enablement')) return;
        /*
		 * requiresComponentChange is important since we are switching between manaul create (GicAnywhere) and
		 * ConfluenceAiIssueCreate (which uses GicAnywhere under the hood).  The GicAnywhere has limitations where
		 * changes to overrideCloudId after initial load can cause iframe rendering issues.  A component swap happens only when
		 * the isCreatedWithAi state is changed so we can bundle these prop updates together.
		 */ const requiresComponentChange = aiIssueCreationEnablement?.isEnabled !== isCreatedWithAi;
        if (requiresComponentChange) {
            setOverrideCloudIdForSitePicker(currentSiteSelection);
            setOverrideProjectId(currentProjectSelection?.selectedProjectId);
            // During component switch the iframe will be replaced and there is no event for this.
            // We need to reset it here manually.
            actions.setIsGicIframeReady(false);
        }
        if (currentSiteSelection && currentSiteSelection !== overrideCloudIdForSitePicker) setOverrideProjectId(currentProjectSelection?.selectedProjectId);
    }, [
        actions,
        aiIssueCreationEnablement,
        currentSiteSelection,
        currentProjectSelection?.selectedProjectId,
        overrideCloudIdForSitePicker,
        setOverrideProjectId,
        isCreatedWithAi
    ]);
    const onAiIssueCreateInit = (0, $gwFzn.useCallback)(()=>{
        onIssueCreateInit();
        const analyticAttributes = {
            attributes: {
                ...aiAnalyticsContext,
                aiEnablement: aiIssueCreationEnablement?.enablement,
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission
            }
        };
        trackAIResultView({
            actionSubjectId: 'aiIssueCreatOnInitComplete',
            ...analyticAttributes
        });
    }, [
        onIssueCreateInit,
        aiAnalyticsContext,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        trackAIResultView,
        state.hasEditPermission
    ]);
    const isSuggestedIssuesErrorMessage = (error)=>{
        return error && typeof error === 'object' && 'message_template' in error;
    };
    const onFailure = (0, $gwFzn.useCallback)((error)=>{
        // reset
        if (hideTryAgain) {
            setHideTryAgain(false);
            setErrorMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).singleCreateAiErrorDescription);
            setErrorMessageValues({});
        }
        if (isSuggestedIssuesErrorMessage(error)) {
            const aiIssueCreateError = (0, $bZC8A.handleAiIssueCreateError)(error);
            if (aiIssueCreateError !== undefined) {
                setErrorMessage(aiIssueCreateError.errorMessage);
                setErrorMessageValues(aiIssueCreateError.errorMessageValues);
                setHideTryAgain(aiIssueCreateError.hideTryAgain);
            }
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'error',
                actionSubject: 'globalIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    error: error,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultError({
            aiErrorMessage: error.message
        }, {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                ...aiAnalyticsContext
            }
        });
    }, [
        hideTryAgain,
        createAnalyticsEvent,
        isCreatedWithAi,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        trackAIResultError,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const onSuccess = (0, $gwFzn.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'created',
                actionSubject: 'issue',
                actionSubjectId: 'confluenceIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    isCreatedFromTable: false,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultAction('issue created', {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                issueId: payload?.issueId || '',
                aiEnablement: aiIssueCreationEnablement?.enablement,
                ...aiAnalyticsContext
            }
        });
        triggerFlag(payload, 'success-circle', (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitle);
        // Save the cloud id in localStorage if an issue is created
        (0, $2ay9q.saveCloudIdToLocalStorage)(payload);
        if (insertStorageFragmentRequestPayload && (state.hasEditPermission || !(0, $9wGTI.fg)('jira-work-create-from-connie-without-edit-perms'))) {
            insertStorageFragmentRequestPayload.xmlModification = (0, $1Q0l6.constructSmartlinkTag)(payload.link);
            (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(insertStorageFragmentRequestPayload, state.pageMode);
            (0, $1Q0l6.insertContentAtSelectionEnd)(insertStorageFragmentRequestPayload).then((data)=>{
                // There is a case where the API response is OK, but the response data is false.
                // When this happens, the backend has trouble inserting the ticket to the page and we should show an error toast.
                if (data === false) throw new Error('Failed to insert storage fragment');
                return createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'created',
                        actionSubject: 'link',
                        actionSubjectId: 'confluenceIssueCreate',
                        attributes: {
                            isManuallyCreated: !isCreatedWithAi,
                            isCreatedWithAi: isCreatedWithAi,
                            pageMode: state.pageMode,
                            hasEditPermission: state.hasEditPermission
                        }
                    }
                }).fire();
            }).then(()=>{
                // Refresh the page only if the current mode is VIEW, as other modes receive live updates.
                if (state.pageMode === (0, $1mDVg.PageMode).VIEW) (0, $1Q0l6.refreshPageWithTimeout)();
            }).catch((_error)=>triggerFlag(payload, 'error', (0, $3E5yu.messages).sidePanelIssueCreateInsertionFailed));
        }
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        triggerFlag,
        insertStorageFragmentRequestPayload,
        trackAIResultAction,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const handleStateChange = (0, $gwFzn.useCallback)((aiFetchState)=>{
        actions.setAiState(aiFetchState);
    }, [
        actions
    ]);
    const onAiToggleChange = (0, $gwFzn.useCallback)((enabled)=>{
        if (enabled) {
            trackAIInteractionInit({
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            });
            handleCreateWithAi();
        } else handleCreateManually();
    }, [
        trackAIInteractionInit,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        handleCreateWithAi,
        handleCreateManually
    ]);
    if (aiError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: "confluenceHighlightIssueCreate",
        errorMessage: errorMessage,
        errorMessageValues: hideTryAgain ? errorMessageValues : undefined,
        onTryAgain: hideTryAgain ? undefined : handleTryAgain,
        onCreateManually: handleCreateManuallyAfterError,
        isCreatedWithAi: true
    });
    const aiToggle = (0, $9wGTI.fg)('jira_ai_single_issue_create_panel_form') ? !isAiLoading && showCreateWithAiToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
        onChange: onAiToggleChange
    }) : !isAiLoading && isGicIframeReady && showCreateWithAiToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
        onChange: onAiToggleChange
    });
    const formRenderer = (0, $9wGTI.fg)('jira_ai_single_issue_create_panel_form') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7aGmI.SingleWorkCreateForm), {
        summary: summary,
        descriptionAdf: descriptionAdf,
        closePanel: onClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: cloudId,
        consumer: "confluence-highlight-issue-create",
        onInit: onIssueCreateInit,
        onSuccess: onSuccess,
        onClose: onClose,
        onFailure: onFailure,
        summary: summary,
        descriptionAdf: descriptionAdf,
        overrideCloudId: overrideCloudIdForSitePicker,
        isPayloadReady: true,
        projectId: overrideProjectId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, aiToggle, isCreatedWithAi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isAiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5FJ5W.IssueCreateAiLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $889e5fc4cfbacead$var$aiContentWrapperBaseStyles,
            isAiLoading && $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kcLnq.ConfluenceAiIssueCreate), {
        cloudId: cloudId,
        contentType: contentType,
        pageId: contentId,
        highlightedTextAdf: highlightedText,
        consumer: "confluence-highlight-issue-create-ai",
        onInit: onAiIssueCreateInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onStateChange: handleStateChange,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectId,
        setAiAnalyticsContext: actions.setAiAnalyticsContext,
        aIIssueCreationEnablement: aiIssueCreationEnablement
    }))) : formRenderer);
};

});
parcelRegister("cfwlu", function(module, exports) {

$parcel$export(module.exports, "GicAnywhere", () => $0e7ff5291d49736a$export$9af19a1ca8685214);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $RUXAI = parcelRequire("RUXAI");

var $b4emg = parcelRequire("b4emg");

var $inPa6 = parcelRequire("inPa6");

var $7p4As = parcelRequire("7p4As");

var $1Whri = parcelRequire("1Whri");

var $abC4X = parcelRequire("abC4X");

var $dh538 = parcelRequire("dh538");

var $bedQP = parcelRequire("bedQP");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $fwDOR = parcelRequire("fwDOR");

var $9hlns = parcelRequire("9hlns");

var $cOrQJ = parcelRequire("cOrQJ");

var $fVTNs = parcelRequire("fVTNs");
var $3C50A = parcelRequire("3C50A");
var $bHD89 = parcelRequire("bHD89");

var $btlx6 = parcelRequire("btlx6");

var $4KAVh = parcelRequire("4KAVh");

var $0XxK1 = parcelRequire("0XxK1");

var $g5o3i = parcelRequire("g5o3i");

var $7u9UW = parcelRequire("7u9UW");

var $4SDuV = parcelRequire("4SDuV");
const $0e7ff5291d49736a$var$phases = {
    loading: 'loading',
    timeout: 'timeout',
    error: 'error',
    idle: 'idle'
};
const $0e7ff5291d49736a$export$9af19a1ca8685214 = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $0XxK1.AnalyticsProvider), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVTNs.ContextWrapper), {
            sourceType: (0, $bHD89.MODAL),
            sourceName: "gicAnywhere",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($0e7ff5291d49736a$export$c43a9e8a05acb520, {
                ...props
            })
        })
    });
};
const $0e7ff5291d49736a$var$styles = {
    hiddenDisplay: "_1e0cglyw",
    gicAnywhere: "_1bsb1osq _4t3i1osq",
    loadingScreen: "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o"
};
const $0e7ff5291d49736a$export$9aacb40c302bf6f7 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, configuration: configuration, summary: summary, assignee: assignee, descriptionAdf: descriptionAdf, consumer: consumer, timeoutMs: timeoutMs = (0, $7u9UW.DEFAULT_TIMEOUT), onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, projectId: projectId, issueTypeId: issueTypeId, issueTypes: issueTypes, isPayloadReady: isPayloadReady = false })=>{
    (0, $RUXAI.di)((0, $g5o3i.useGetFirstAvailableSiteDomain));
    const { domain: domainName, availableSites: availableSites } = (0, $g5o3i.useGetFirstAvailableSiteDomain)({
        preferredCloudId: cloudId
    });
    const { domain: isOverrideSiteAvailable } = (0, $g5o3i.useGetFirstAvailableSiteDomain)({
        preferredCloudId: overrideCloudId
    });
    const displaySitePicker = availableSites && availableSites.length > 1;
    const [phase, setPhase] = (0, $gwFzn.useState)($0e7ff5291d49736a$var$phases.loading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        const timeout = (()=>{
            switch(phase){
                case $0e7ff5291d49736a$var$phases.loading:
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed timedOut', {
                            consumer: consumer,
                            timeoutMs: timeoutMs
                        });
                        setPhase($0e7ff5291d49736a$var$phases.timeout);
                        onTimeout?.();
                    }, timeoutMs);
                case $0e7ff5291d49736a$var$phases.timeout:
                    // if timeoutMs passes again after initial timeout, assume GIC is not loading and set to error state
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed error', {
                            consumer: consumer,
                            timeoutMs: timeoutMs * 2
                        });
                        setPhase($0e7ff5291d49736a$var$phases.error);
                        onFailure(new Error('GIC has timed out'));
                    }, timeoutMs);
            }
        })(); // set Timeout for loading, reset for any other state.
        return ()=>timeout && clearTimeout(timeout);
    }, [
        consumer,
        createAnalyticsEvent,
        onFailure,
        onTimeout,
        phase,
        timeoutMs
    ]); // we mimic "external callback" for our needs
    const onGICReady = (0, $gwFzn.useCallback)(()=>{
        setPhase($0e7ff5291d49736a$var$phases.idle);
        return {
            summary: summary || 'No summary provided' /* this is impossible case */ ,
            descriptionAdf: descriptionAdf || (0, $b4emg.getEmptyADF)(),
            projectId: projectId,
            issueTypeId: issueTypeId,
            issueTypes: issueTypes?.join(','),
            assignee: assignee
        };
    }, [
        summary,
        descriptionAdf,
        projectId,
        issueTypeId,
        issueTypes,
        assignee
    ]);
    const renderPhaseInformation = (0, $gwFzn.useMemo)(()=>{
        switch(phase){
            case $0e7ff5291d49736a$var$phases.timeout:
            case $0e7ff5291d49736a$var$phases.loading:
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-loading",
                    xcss: (0, $1Whri.cx)($0e7ff5291d49736a$var$styles.gicAnywhere, $0e7ff5291d49736a$var$styles.loadingScreen),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                            children: formatMessage(phase === $0e7ff5291d49736a$var$phases.timeout ? (0, $4SDuV.messages).iFrameSlowLoading : (0, $4SDuV.messages).iFrameLoading, {
                                br: /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
                            })
                        })
                    ]
                });
            case $0e7ff5291d49736a$var$phases.error:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-error",
                    xcss: $0e7ff5291d49736a$var$styles.gicAnywhere,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $abC4X.default), {
                        header: formatMessage((0, $4SDuV.messages).errorHeader),
                        description: formatMessage((0, $4SDuV.messages).errorBody),
                        primaryAction: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                            onClick: ()=>{
                                onClose();
                            },
                            href: domainName || '/',
                            target: "_blank",
                            appearance: "primary",
                            children: formatMessage((0, $4SDuV.messages).openInJiraButton)
                        }),
                        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($btlx6))),
                        imageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageHeight: (0, $7u9UW.MAX_ERROR_IMAGE_HEIGHT)
                    })
                });
            default:
                return undefined;
        }
    }, [
        phase,
        formatMessage,
        domainName,
        onClose
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            renderPhaseInformation,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwDOR.default), {
                name: "gic-anywhere-iframe-loading",
                hold: phase === $0e7ff5291d49736a$var$phases.loading
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: phase !== $0e7ff5291d49736a$var$phases.idle ? $0e7ff5291d49736a$var$styles.hiddenDisplay : $0e7ff5291d49736a$var$styles.gicAnywhere,
                children: domainName !== undefined && /*#__PURE__*/ (0, $7UHDa.jsx)($0e7ff5291d49736a$export$ae3b6dcb03669e81, {
                    domainName: domainName,
                    consumer: consumer,
                    onGICReady: onGICReady,
                    onInit: onInit,
                    onSuccess: onSuccess,
                    onFailure: onFailure,
                    onClose: onClose,
                    configuration: configuration,
                    displaySitePicker: displaySitePicker,
                    isPayloadReady: isPayloadReady,
                    overrideCloudId: isOverrideSiteAvailable ? overrideCloudId : undefined
                })
            })
        ]
    });
};
const $0e7ff5291d49736a$export$2e5634b60d5a8196 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, configuration: configuration, summary: summary, assignee: assignee, descriptionAdf: descriptionAdf, consumer: consumer, timeoutMs: timeoutMs = (0, $7u9UW.DEFAULT_TIMEOUT), onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, projectId: projectId, issueTypeId: issueTypeId, issueTypes: issueTypes, isPayloadReady: isPayloadReady = false })=>{
    const { availableSites: availableSites, domainName: domainName, isOverrideSiteAvailable: isOverrideSiteAvailable } = (0, $g5o3i.useGetDomainAndAvailableSites)({
        cloudId: cloudId,
        overrideCloudId: overrideCloudId
    });
    const displaySitePicker = availableSites && availableSites.length > 1;
    const [phase, setPhase] = (0, $gwFzn.useState)($0e7ff5291d49736a$var$phases.loading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        const timeout = (()=>{
            switch(phase){
                case $0e7ff5291d49736a$var$phases.loading:
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed timedOut', {
                            consumer: consumer,
                            timeoutMs: timeoutMs
                        });
                        setPhase($0e7ff5291d49736a$var$phases.timeout);
                        onTimeout?.();
                    }, timeoutMs);
                case $0e7ff5291d49736a$var$phases.timeout:
                    // if timeoutMs passes again after initial timeout, assume GIC is not loading and set to error state
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed error', {
                            consumer: consumer,
                            timeoutMs: timeoutMs * 2
                        });
                        setPhase($0e7ff5291d49736a$var$phases.error);
                        onFailure(new Error('GIC has timed out'));
                    }, timeoutMs);
            }
        })(); // set Timeout for loading, reset for any other state.
        return ()=>timeout && clearTimeout(timeout);
    }, [
        consumer,
        createAnalyticsEvent,
        onFailure,
        onTimeout,
        phase,
        timeoutMs
    ]); // we mimic "external callback" for our needs
    const onGICReady = (0, $gwFzn.useCallback)(()=>{
        setPhase($0e7ff5291d49736a$var$phases.idle);
        return {
            summary: summary || 'No summary provided' /* this is impossible case */ ,
            descriptionAdf: descriptionAdf || (0, $b4emg.getEmptyADF)(),
            projectId: projectId,
            issueTypeId: issueTypeId,
            issueTypes: issueTypes?.join(','),
            assignee: assignee
        };
    }, [
        summary,
        descriptionAdf,
        projectId,
        issueTypeId,
        issueTypes,
        assignee
    ]);
    const renderPhaseInformation = (0, $gwFzn.useMemo)(()=>{
        switch(phase){
            case $0e7ff5291d49736a$var$phases.timeout:
            case $0e7ff5291d49736a$var$phases.loading:
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-loading",
                    xcss: (0, $1Whri.cx)($0e7ff5291d49736a$var$styles.gicAnywhere, $0e7ff5291d49736a$var$styles.loadingScreen),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                            children: formatMessage(phase === $0e7ff5291d49736a$var$phases.timeout ? (0, $4SDuV.messages).iFrameSlowLoading : (0, $4SDuV.messages).iFrameLoading, {
                                br: /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
                            })
                        })
                    ]
                });
            case $0e7ff5291d49736a$var$phases.error:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-error",
                    xcss: $0e7ff5291d49736a$var$styles.gicAnywhere,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $abC4X.default), {
                        header: formatMessage((0, $4SDuV.messages).errorHeader),
                        description: formatMessage((0, $4SDuV.messages).errorBody),
                        primaryAction: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                            onClick: ()=>{
                                onClose();
                            },
                            href: domainName || '/',
                            target: "_blank",
                            appearance: "primary",
                            children: formatMessage((0, $4SDuV.messages).openInJiraButton)
                        }),
                        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($btlx6))),
                        imageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageHeight: (0, $7u9UW.MAX_ERROR_IMAGE_HEIGHT)
                    })
                });
            default:
                return undefined;
        }
    }, [
        phase,
        formatMessage,
        domainName,
        onClose
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            renderPhaseInformation,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwDOR.default), {
                name: "gic-anywhere-iframe-loading",
                hold: phase === $0e7ff5291d49736a$var$phases.loading
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: phase !== $0e7ff5291d49736a$var$phases.idle ? $0e7ff5291d49736a$var$styles.hiddenDisplay : $0e7ff5291d49736a$var$styles.gicAnywhere,
                children: domainName !== undefined && /*#__PURE__*/ (0, $7UHDa.jsx)($0e7ff5291d49736a$export$ae3b6dcb03669e81, {
                    domainName: domainName,
                    consumer: consumer,
                    onGICReady: onGICReady,
                    onInit: onInit,
                    onSuccess: onSuccess,
                    onFailure: onFailure,
                    onClose: onClose,
                    configuration: configuration,
                    displaySitePicker: displaySitePicker,
                    isPayloadReady: isPayloadReady,
                    overrideCloudId: isOverrideSiteAvailable ? overrideCloudId : undefined
                })
            })
        ]
    });
};
const $0e7ff5291d49736a$export$c43a9e8a05acb520 = (0, $bedQP.componentWithFG)('fix_duplicated_available_sites_call_gic_anywhere', $0e7ff5291d49736a$export$2e5634b60d5a8196, $0e7ff5291d49736a$export$9aacb40c302bf6f7);
const $0e7ff5291d49736a$export$ae3b6dcb03669e81 = ({ onGICReady: onGICReady, consumer: consumer, domainName: domainName, overrideCloudId: overrideCloudId, onClose: onClose, onFailure: onFailure, onSuccess: onSuccess, onInit: onInit, configuration: configuration, displaySitePicker: displaySitePicker = true, isPayloadReady: isPayloadReady = false })=>{
    (0, $RUXAI.di)($0e7ff5291d49736a$export$b32b5f1ee4493319);
    const iframeRef = (0, $gwFzn.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const [isCreateSuccess, setIsCreateSuccess] = (0, $gwFzn.useState)(false);
    const [isGicReady, setIsGicReady] = (0, $gwFzn.useState)(false);
    const isGicReadyRef = (0, $gwFzn.useRef)(isGicReady); // we will react on this event only once
    // we dont want to reattach handlers on every render
    const onGICReadyRef = (0, $gwFzn.useRef)(onGICReady);
    onGICReadyRef.current = onGICReady;
    const params = (0, $gwFzn.useMemo)(()=>({
            product: consumer,
            actionSource: 'issue-create-anywhere-embed'
        }), [
        consumer
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const messageHandler = async (message)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (!iframe) return;
            const eventName = message?.data?.event;
            const event = createAnalyticsEvent({});
            switch(eventName){
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_READY:
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed initialised', {
                        consumer: consumer
                    });
                    setIsGicReady(true);
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_SUCCESS:
                    setIsCreateSuccess(true);
                    onSuccess(message.data.payload);
                    (0, $3C50A.fireTrackAnalytics)(event, 'globalIssueCreateEmbed succeeded', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_FAILURE:
                    onFailure(new Error('issueCreate failed to save'));
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed failed', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    onClose(isCreateSuccess); // GIC sends a closeEvent even when created succesfully. Hence
                    // checking if no issue was created
                    if (!isCreateSuccess) (0, $3C50A.fireUIAnalytics)(event, 'globalIssueCreateEmbed closed', {
                        consumer: consumer
                    });
                    break;
                default:
            }
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('message', messageHandler);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('message', messageHandler);
        };
    }, [
        iframeRef,
        consumer,
        createAnalyticsEvent,
        onInit,
        onClose,
        onFailure,
        onSuccess,
        isCreateSuccess,
        setIsCreateSuccess,
        setIsGicReady
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isPayloadReady && isGicReady) // Only resolve the Promise if isPayloadReady is true, and the message has been received
        Promise.resolve(onGICReadyRef.current()).then((issuePayload)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (iframe) {
                // Send GIC data used for initialization
                iframe.postMessage({
                    event: (0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_INIT),
                    payload: {
                        defaultValues: issuePayload
                    }
                }, // Broadcast this message to all listeners for now
                '*');
                onInit?.();
            }
        });
    }, [
        isPayloadReady,
        isGicReady,
        onGICReadyRef,
        onInit
    ]);
    const iframeSrc = (0, $0XxK1.getIframeSrc)({
        colorMode: colorMode,
        domainName: domainName,
        params: params,
        displaySitePicker: (0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout') ? displaySitePicker : (0, $dh538.fg)('inconsistent_iframe_src_site_picker_fix') ? true : displaySitePicker,
        ...configuration,
        overrideCloudId: overrideCloudId
    });
    (0, $gwFzn.useEffect)(()=>{
        if (!(0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout')) return;
        isGicReadyRef.current = isGicReady;
    }, [
        isGicReady
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!(0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout')) return;
         // We need to reset the isGicReady state to avoid sending another postMessage to the GIC iframe window
        setIsGicReady(false);
    }, [
        iframeSrc
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!(0, $dh538.fg)('jira_ai_gic_embed_exception_on_timeout')) return;
        const TIMEOUT_30_SECONDS = 30000;
        const timeout = setTimeout(()=>{
            // We need to use a ref to check if GIC is ready because the isGicReady state is updated asynchronously
            if (!isGicReadyRef.current) // This is a fallback for the case when the GIC iframe window is not initialized
            throw new Error('jira-ai/gic-anywhere: The latest GIC iframe window was not initialized');
        }, TIMEOUT_30_SECONDS);
        return ()=>clearTimeout(timeout);
    }, [
        iframeSrc
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0e7ff5291d49736a$export$b32b5f1ee4493319, {
        name: "gic-anywhere-iframe",
        sandbox: undefined,
        ref: iframeRef,
        height: "100%",
        width: "100%",
        frameBorder: 0,
        // onError={}
        src: iframeSrc,
        "data-testid": "gic-anywhere"
    });
};
const $0e7ff5291d49736a$export$b32b5f1ee4493319 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("iframe", {
        title: "Jira Embed Global Issue Create",
        ref: ref,
        ...props
    });
});

});
parcelRegister("fVTNs", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $c32683c3f1554789$export$34282a1f95511a11);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $f0hBp = parcelRequire("f0hBp");

var $dKXPX = parcelRequire("dKXPX");

var $bYRk6 = parcelRequire("bYRk6");
const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dKXPX)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f0hBp))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: props.children
        })
    });
};

});
parcelRegister("f0hBp", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $aec48297aff07090$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $aec48297aff07090$var$isUndefined;

});


parcelRegister("3C50A", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $24a3efb1cf8e29fc$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $24a3efb1cf8e29fc$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $24a3efb1cf8e29fc$export$79f423cc3fd39762);

var $5XKHf = parcelRequire("5XKHf");

var $bHD89 = parcelRequire("bHD89");

var $1J0ov = parcelRequire("1J0ov");
const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};

});
parcelRegister("bHD89", function(module, exports) {

$parcel$export(module.exports, "MODAL", () => $f220a889fcad0dca$export$1171103ea9083ffa);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $f220a889fcad0dca$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $f220a889fcad0dca$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $f220a889fcad0dca$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $f220a889fcad0dca$export$12346a674644c156);
$parcel$export(module.exports, "ANALYTICS_BRIDGE_CHANNEL", () => $f220a889fcad0dca$export$2ceccf177fae277c);
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';

});

parcelRegister("1J0ov", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $9c601e99598456fc$export$e6baab532ef8c6bf);
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});


parcelRegister("btlx6", function(module, exports) {
module.exports = new URL("error.5fbc7fe9.png", import.meta.url).toString();

});

parcelRegister("4KAVh", function(module, exports) {

$parcel$export(module.exports, "ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED", () => $2ad7ca53e97d3c24$export$bdb28edf034fd38);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_INIT", () => $2ad7ca53e97d3c24$export$b342b407e829290);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_READY", () => $2ad7ca53e97d3c24$export$fa02f6b8f65042dd);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_SUCCESS", () => $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_FAILURE", () => $2ad7ca53e97d3c24$export$c1caf9536ed579cc);
$parcel$export(module.exports, "JIRA_EMBED_ISSUE_CREATE_CLOSE", () => $2ad7ca53e97d3c24$export$a402043ad8e6699);
// Error messages
const $2ad7ca53e97d3c24$export$bdb28edf034fd38 = 'Jira GIC Anywhere - Iframe Source character limit exceeded';
const $2ad7ca53e97d3c24$export$b342b407e829290 = 'jiraEmbedIssueCreateInit';
const $2ad7ca53e97d3c24$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9 = 'jiraEmbedIssueCreateSuccess';
const $2ad7ca53e97d3c24$export$c1caf9536ed579cc = 'jiraEmbedIssueCreateAppFailed';
const $2ad7ca53e97d3c24$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';

});

parcelRegister("0XxK1", function(module, exports) {

$parcel$export(module.exports, "getIframeSrc", () => $5588f1d8fd0b9255$export$584bd4ae64a8d7e2);
$parcel$export(module.exports, "getAvailableJiraSites", () => $5588f1d8fd0b9255$export$5e195155111b6846);
$parcel$export(module.exports, "AnalyticsProvider", () => $5588f1d8fd0b9255$export$1b581a2ec13e37f1);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a9sR2 = parcelRequire("a9sR2");

var $kDuN4 = parcelRequire("kDuN4");

var $bHD89 = parcelRequire("bHD89");
var $hzZxz = parcelRequire("hzZxz");

var $4KAVh = parcelRequire("4KAVh");
const $5588f1d8fd0b9255$var$analyticsClientInfo = {
    env: 'prod',
    product: 'jira'
};
const $5588f1d8fd0b9255$var$LIGHT_MODE = 'light';
const $5588f1d8fd0b9255$var$DARK_MODE = 'dark';
const $5588f1d8fd0b9255$var$AUTO = 'auto';
const $5588f1d8fd0b9255$export$a31dd10290664cf6 = 2048;
const $5588f1d8fd0b9255$export$584bd4ae64a8d7e2 = ({ colorMode: colorMode = $5588f1d8fd0b9255$var$AUTO, domainName: domainName = '', overrideCloudId: overrideCloudId, params: params, onFailure: onFailure, displaySitePicker: displaySitePicker, disableProjectDropdown: disableProjectDropdown, displayOnlyRequiredFields: displayOnlyRequiredFields })=>{
    const iframeParams = new URLSearchParams(params);
    iframeParams.append('postMessageInit', '1');
    if (displaySitePicker === false) iframeParams.append('displaySitePicker', 'false');
    if (disableProjectDropdown) iframeParams.append('disableProjectDropdown', 'true');
    if (displayOnlyRequiredFields) iframeParams.append('displayOnlyRequiredFields', 'true');
    if (colorMode) iframeParams.append('themeMode', colorMode);
    if (overrideCloudId) iframeParams.append('overrideCloudId', overrideCloudId);
    /**
	 * We want to use the postMessageInit param to instruct the Jira embed iframe
	 * to wait before mounting Issue Create.
	 * It will send a message back to us when it's ready to receive the init message
	 */ const srcUrl = `${domainName}/jira/issues/create/embed?${iframeParams}`;
    if (srcUrl.length > $5588f1d8fd0b9255$export$a31dd10290664cf6) onFailure?.(new Error((0, $4KAVh.ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED)));
    return srcUrl;
};
const $5588f1d8fd0b9255$export$61874183278c256e = [
    'jira-software.ondemand',
    'jira-core.ondemand',
    'jira-servicedesk.ondemand',
    'jira-product-discovery'
];
async function $5588f1d8fd0b9255$export$5e195155111b6846() {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: $5588f1d8fd0b9255$export$61874183278c256e
        })
    };
    const response = await fetch('/gateway/api/available-sites', requestConfig);
    if (response.ok) return response.json();
    throw response;
}
const $5588f1d8fd0b9255$export$1b581a2ec13e37f1 = (props)=>{
    const analyticsClient = (0, $gwFzn.useRef)(new (0, $a9sR2.default)($5588f1d8fd0b9255$var$analyticsClientInfo, {}));
    const sendEvent = (0, $gwFzn.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $bHD89.UI_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendUIEvent(payload);
                break;
            case 0, $bHD89.TRACK_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendTrackEvent(payload);
                break;
            case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendOperationalEvent(payload);
                break;
            case 0, $bHD89.SCREEN_EVENT_TYPE:
                analyticsClient.current.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
        channel: (0, $bHD89.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, $hzZxz.extractAWCDataFromEvent)(event)),
        children: props.children
    });
};

});
parcelRegister("hzZxz", function(module, exports) {

$parcel$export(module.exports, "extractAWCDataFromEvent", () => $50a1a1624abaf5e4$export$1c850cf68c053906);

var $f0hBp = parcelRequire("f0hBp");

var $dKXPX = parcelRequire("dKXPX");

var $bHD89 = parcelRequire("bHD89");

var $01od0 = parcelRequire("01od0");
const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($dKXPX)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($f0hBp))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("01od0", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsType", () => $4b9739432bab74fb$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $4b9739432bab74fb$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $4b9739432bab74fb$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $4b9739432bab74fb$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $4b9739432bab74fb$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $4b9739432bab74fb$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $4b9739432bab74fb$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $4b9739432bab74fb$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $4b9739432bab74fb$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $4b9739432bab74fb$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $4b9739432bab74fb$export$af63d7414243dad3);

var $hz0AL = parcelRequire("hz0AL");

var $f0hBp = parcelRequire("f0hBp");

var $5XKHf = parcelRequire("5XKHf");

var $ewFdA = parcelRequire("ewFdA");

var $dKXPX = parcelRequire("dKXPX");

var $jIQq0 = parcelRequire("jIQq0");
const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($ewFdA)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($dKXPX)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($f0hBp))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($5XKHf)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($jIQq0)))((0, (/*@__PURE__*/$parcel$interopDefault($hz0AL)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});



parcelRegister("g5o3i", function(module, exports) {

$parcel$export(module.exports, "useGetFirstAvailableSiteDomain", () => $5909ab59f28be203$export$930bddfd3ad23bb7);
$parcel$export(module.exports, "useGetDomainAndAvailableSites", () => $5909ab59f28be203$export$48ca77029c1208c2);

var $gwFzn = parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $dh538 = parcelRequire("dh538");

var $0XxK1 = parcelRequire("0XxK1");
const $5909ab59f28be203$export$930bddfd3ad23bb7 = ({ preferredCloudId: preferredCloudId, onComplete: onComplete, onError: onError })=>{
    (0, $RUXAI.di)((0, $0XxK1.getAvailableJiraSites));
    const [domain, setDomain] = (0, $gwFzn.useState)(undefined);
    const [availableSites, setAvailableSites] = (0, $gwFzn.useState)([]);
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(undefined);
    (0, $gwFzn.useEffect)(()=>{
        const fetchAvailableJiraSites = async ()=>{
            setLoading(true);
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)();
                setAvailableSites(sites ?? []);
                const computedDomain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
                setDomain(computedDomain);
                onComplete?.({
                    domain: computedDomain,
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
    }, [
        preferredCloudId,
        onComplete,
        onError
    ]);
    return {
        domain: domain,
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$7872bb66f9195035 = ({ onComplete: onComplete, onError: onError })=>{
    (0, $RUXAI.di)((0, $0XxK1.getAvailableJiraSites));
    const [availableSites, setAvailableSites] = (0, $gwFzn.useState)([]);
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(undefined);
    const hasMount = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (hasMount.current) return;
        setLoading(true);
        const fetchAvailableJiraSites = async ()=>{
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)();
                setAvailableSites(sites ?? []);
                onComplete?.({
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
        hasMount.current = true;
    }, [
        onComplete,
        onError
    ]);
    return {
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$60b2cad7400d36b3 = ({ sites: sites, preferredCloudId: preferredCloudId })=>{
    const domain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
    return {
        domain: domain
    };
};
const $5909ab59f28be203$export$48ca77029c1208c2 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId })=>{
    const { availableSites: availableSites, loading: loading, error: error } = $5909ab59f28be203$export$7872bb66f9195035({});
    const { domain: domainName } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: cloudId
    });
    const { domain: isOverrideSiteAvailable } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: overrideCloudId
    });
    if ((0, $dh538.fg)('inconsistent_iframe_src_site_picker_fix')) {
        if (error) throw new Error('Failed to fetch available sites');
        return loading ? {
            availableSites: [],
            domainName: undefined,
            isOverrideSiteAvailable: undefined
        } : {
            availableSites: availableSites,
            domainName: domainName,
            isOverrideSiteAvailable: isOverrideSiteAvailable
        };
    }
    return {
        availableSites: availableSites,
        domainName: domainName,
        isOverrideSiteAvailable: isOverrideSiteAvailable
    };
};

});

parcelRegister("7u9UW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $f25a4ef78ed97248$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "MAX_ERROR_IMAGE_WIDTH", () => $f25a4ef78ed97248$export$6dfc55fc5e2544ae);
$parcel$export(module.exports, "MAX_ERROR_IMAGE_HEIGHT", () => $f25a4ef78ed97248$export$85d8afb0902718e2);
const $f25a4ef78ed97248$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $f25a4ef78ed97248$export$6dfc55fc5e2544ae = 188;
const $f25a4ef78ed97248$export$85d8afb0902718e2 = 250;

});

parcelRegister("4SDuV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2b8c8c7153d4d991$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $2b8c8c7153d4d991$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    iFrameLoading: {
        id: "jira-ai.gic-anywhere.iframe-loading",
        defaultMessage: "Loading issue details, this might take a few seconds."
    },
    iFrameSlowLoading: {
        id: "jira-ai.gic-anywhere.iframe-slow-loading",
        defaultMessage: "It is taking longer than usual to load your issue.{br}Give it a few more seconds, or try again later."
    },
    openInJiraButton: {
        id: "jira-ai.gic-anywhere.open-in-jira-button",
        defaultMessage: "Log in to Jira to view"
    },
    errorHeader: {
        id: "jira-ai.gic-anywhere.error-header",
        defaultMessage: "Something's gone wrong"
    },
    errorBody: {
        id: "jira-ai.gic-anywhere.error-body",
        defaultMessage: "Try opening this in Jira. If the problem persists, please contact Atlassian support."
    }
});

});


parcelRegister("5FJ5W", function(module, exports) {

$parcel$export(module.exports, "IssueCreateAiLoading", () => $b386c1485ada9c1f$export$a1eba8f1cc91eb04);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $3E5yu = parcelRequire("3E5yu");
const $b386c1485ada9c1f$var$GeneratingAnimation = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
const $b386c1485ada9c1f$var$loadingContainerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    padding: 'space.300'
});
const $b386c1485ada9c1f$var$loadingIconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px'
});
const $b386c1485ada9c1f$export$a1eba8f1cc91eb04 = ({ loadingType: loadingType = 'single' })=>{
    const loadingMessage = (0, $gwFzn.useMemo)(()=>{
        if ((0, $9wGTI.fg)('confluence-issue-terminology-refresh')) {
            const loadingSingleMessageRefresh = (0, $6mKj3.expVal)('aiwc_confluence_update_loading_message', 'isEnabled', false) ? (0, $3E5yu.messages).sidePanelAiLoadingIssueExperiment : (0, $3E5yu.messages).sidePanelAiLoadingIssueTermRefresh;
            return loadingType === 'bulk' ? (0, $3E5yu.messages).sidePanelAiLoadingBulkIssueTermRefresh : loadingSingleMessageRefresh;
        }
        const loadingSingleMessage = (0, $6mKj3.expVal)('aiwc_confluence_update_loading_message', 'isEnabled', false) ? (0, $3E5yu.messages).sidePanelAiLoadingIssueExperiment : (0, $3E5yu.messages).sidePanelAiLoading;
        return loadingType === 'bulk' ? (0, $3E5yu.messages).sidePanelAiLoadingBulk : loadingSingleMessage;
    }, [
        loadingType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b386c1485ada9c1f$var$loadingContainerStyles,
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b386c1485ada9c1f$var$loadingIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b386c1485ada9c1f$var$GeneratingAnimation, {
        alt: "Generating"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "large",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), loadingMessage))));
};

});

parcelRegister("1Q0l6", function(module, exports) {

$parcel$export(module.exports, "constructJiraIssueUrl", () => $d1908e0af5aa886c$export$78fd671954584729);
$parcel$export(module.exports, "constructSmartlinkTag", () => $d1908e0af5aa886c$export$abe60dca128cf840);
$parcel$export(module.exports, "bulkConstructSmartlinkTags", () => $d1908e0af5aa886c$export$44af636f2297de15);
$parcel$export(module.exports, "constructHeading", () => $d1908e0af5aa886c$export$8f3860761b656032);
$parcel$export(module.exports, "constructInsertStorageFragmentRequestPayload", () => $d1908e0af5aa886c$export$3135b2526beb9ea6);
$parcel$export(module.exports, "constructInsertStorageColumnTableRequestPayload", () => $d1908e0af5aa886c$export$703688cefc28164e);
$parcel$export(module.exports, "updateLastFetchTimeIfNotViewMode", () => $d1908e0af5aa886c$export$af14e9631e8de173);
$parcel$export(module.exports, "insertContentAtSelectionEnd", () => $d1908e0af5aa886c$export$57c9f61b323299ee);
$parcel$export(module.exports, "insertContentAtColumn", () => $d1908e0af5aa886c$export$1f11e8d398d7ee36);
$parcel$export(module.exports, "refreshPageWithTimeout", () => $d1908e0af5aa886c$export$63b770721cbd3eed);
$parcel$export(module.exports, "getValidRange", () => $d1908e0af5aa886c$export$61726a905a82cbc1);
$parcel$export(module.exports, "getPageContentRange", () => $d1908e0af5aa886c$export$6884d917093a4918);

var $f7B1p = parcelRequire("f7B1p");

var $1mDVg = parcelRequire("1mDVg");
const $d1908e0af5aa886c$var$REFRESH_TIMEOUT = 3000;
const $d1908e0af5aa886c$export$78fd671954584729 = (jiraSiteUrl, issueKey)=>{
    return `${jiraSiteUrl}/browse/${issueKey}`;
};
const $d1908e0af5aa886c$export$abe60dca128cf840 = (url)=>{
    return `<a href="${url}" data-card-appearance="inline">${url}</a>`;
};
const $d1908e0af5aa886c$export$44af636f2297de15 = (urls)=>{
    return urls.map((url)=>$d1908e0af5aa886c$export$abe60dca128cf840(url)).join(' ');
};
const $d1908e0af5aa886c$export$8f3860761b656032 = (text)=>{
    return `<h2>${text}</h2>`;
};
const $d1908e0af5aa886c$var$getLastFetchTimeFromMetaTag = ()=>{
    const metaTag = document.querySelector(`meta[name="confluence-request-time"]`);
    return metaTag ? Number(metaTag.getAttribute('content')) : null;
};
const $d1908e0af5aa886c$var$constructBasePayload = (contentId, result, lastModified)=>{
    // This happens when the page is completely empty.
    if (!result || !result.searchText || result.searchText.numMatches === undefined) return {
        pageId: contentId,
        selectedText: '',
        index: -1,
        numMatches: 0,
        lastFetchTime: lastModified ? new Date(lastModified).getTime() : $d1908e0af5aa886c$var$getLastFetchTimeFromMetaTag()
    };
    const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = result;
    return {
        pageId: contentId,
        selectedText: selectedText,
        index: matchIndex,
        numMatches: numMatches,
        // Get last fetch time of current page.
        // This used to be the request time, but this caused problems due to time drift between the server and database.
        // So now try to use the content last modification date on load if that exists, then fallback onto the
        // request time if it's not available.
        lastFetchTime: lastModified ? new Date(lastModified).getTime() : $d1908e0af5aa886c$var$getLastFetchTimeFromMetaTag()
    };
};
const $d1908e0af5aa886c$export$3135b2526beb9ea6 = (contentId, convertSelectionToLegacyFormat, range, contentRef, lastModified)=>{
    const result = convertSelectionToLegacyFormat(contentRef, range, contentId);
    return {
        ...$d1908e0af5aa886c$var$constructBasePayload(contentId, result, lastModified),
        xmlModification: undefined
    };
};
const $d1908e0af5aa886c$export$703688cefc28164e = (contentId, convertSelectionToLegacyFormat, range, contentRef, lastModified, tableColumnIndex)=>{
    const result = convertSelectionToLegacyFormat(contentRef, range, contentId);
    return {
        ...$d1908e0af5aa886c$var$constructBasePayload(contentId, result, lastModified),
        tableColumnIndex: tableColumnIndex ?? 0,
        cellModifications: []
    };
};
const $d1908e0af5aa886c$export$af14e9631e8de173 = (payload, pageMode)=>{
    if (pageMode && pageMode !== (0, $1mDVg.PageMode).VIEW) payload.lastFetchTime = Date.now();
};
const $d1908e0af5aa886c$export$57c9f61b323299ee = async (insertStorageFragmentRequestPayload)=>{
    try {
        const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-fragment';
        const response = await (0, $f7B1p.cfetch)(restUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(insertStorageFragmentRequestPayload)
        });
        if (!response.ok) throw new Error('Insert storage fragment request failed');
        return await response.json();
    } catch (error) {
        throw error;
    }
};
const $d1908e0af5aa886c$export$1f11e8d398d7ee36 = async (insertStorageColumnTableRequestPayload)=>{
    const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-column-table';
    const response = await (0, $f7B1p.cfetch)(restUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(insertStorageColumnTableRequestPayload)
    });
    if (!response.ok) throw new Error('Insert storage column table request failed');
    return response.json();
};
const $d1908e0af5aa886c$export$63b770721cbd3eed = ()=>{
    setTimeout(()=>{
        window.location.reload();
    }, $d1908e0af5aa886c$var$REFRESH_TIMEOUT);
};
const $d1908e0af5aa886c$export$61726a905a82cbc1 = (originalRange)=>{
    if (!originalRange) return undefined;
    const newRange = document.createRange();
    let lastTextNode = null;
    let lastTextNodeStartOffset = 0;
    let lastTextNodeEndOffset = 0;
    const INVALID_NODE_SELECTORS = [
        // Status macro
        'span[data-node-type="status"]',
        // Inline Smart Card/Jira issue link
        '[data-inline-card="true"]',
        '.inlineCardView-content-wrap',
        '.smart-link-title-wrapper'
    ].join(',');
    const isInvalidNode = (node)=>{
        return node.nodeType === Node.ELEMENT_NODE && node.matches(INVALID_NODE_SELECTORS);
    };
    const hasInvalidAncestor = (node, ancestorLimit)=>{
        let currentNode = node;
        while(currentNode && currentNode !== ancestorLimit){
            if (isInvalidNode(currentNode)) return true;
            currentNode = currentNode.parentNode;
        }
        return false;
    };
    const previousNode = (node, range)=>{
        if (node.previousSibling) {
            node = node.previousSibling;
            while(node.hasChildNodes() && !isInvalidNode(node))node = node.lastChild;
            return node;
        }
        return node.parentNode && node.parentNode !== range.commonAncestorContainer ? node.parentNode : null;
    };
    let currentNode = originalRange.endContainer;
    while(currentNode){
        // If the current node is a text node and it is not empty, and it does not have an invalid ancestor, then it is a valid node.
        if (currentNode.nodeType === Node.TEXT_NODE && currentNode.textContent && currentNode.textContent.trim() !== '' && !hasInvalidAncestor(currentNode, originalRange.commonAncestorContainer)) {
            lastTextNode = currentNode;
            if (originalRange.endContainer === currentNode) lastTextNodeEndOffset = originalRange.endOffset;
            else lastTextNodeEndOffset = currentNode.textContent.length;
            if (originalRange.startContainer === currentNode) lastTextNodeStartOffset = originalRange.startOffset;
            else lastTextNodeStartOffset = 0;
            break; // Early termination as soon as we find the last valid text node.
        }
        // Terminate when we reach the start of the original range.
        if (currentNode === originalRange.startContainer) break;
        currentNode = previousNode(currentNode, originalRange);
    }
    if (lastTextNode) {
        newRange.setStart(lastTextNode, lastTextNodeStartOffset);
        newRange.setEnd(lastTextNode, lastTextNodeEndOffset);
        return newRange;
    }
    return originalRange;
};
const $d1908e0af5aa886c$export$6884d917093a4918 = ()=>{
    const contentElement = document.getElementById('main-content');
    if (contentElement) {
        const range = document.createRange();
        range.selectNodeContents(contentElement);
        const findDeepestChild = (node)=>{
            let current = node;
            while(current.hasChildNodes())current = current.lastChild;
            return current;
        };
        const endContainer = findDeepestChild(range.endContainer);
        let endOffset = 0;
        if (endContainer.nodeType === Node.TEXT_NODE) endOffset = endContainer.textContent?.length || 0;
        else if (endContainer.nodeType === Node.ELEMENT_NODE) endOffset = endContainer.childNodes.length;
        range.setEnd(endContainer, endOffset);
        return range;
    }
    return undefined;
};

});

parcelRegister("9K9na", function(module, exports) {

$parcel$export(module.exports, "useTriggerFlagIssueCreated", () => $c2473cc34e5c9c56$export$8ecee5edd581c23a);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $auNCB = parcelRequire("auNCB");
const $c2473cc34e5c9c56$export$8ecee5edd581c23a = (flags)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return (0, $gwFzn.useCallback)((payload, flagType, message)=>{
        flags.showFlag({
            type: flagType,
            title: formatMessage(message, {
                issueKey: payload?.issueKey,
                issueSummary: payload?.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $auNCB.default), {
                        href: payload?.link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage
    ]);
};

});

parcelRegister("2ay9q", function(module, exports) {

$parcel$export(module.exports, "saveCloudIdToLocalStorage", () => $d14147b5d5932d8b$export$1a5b3977e2178dad);
$parcel$export(module.exports, "getPersistedOverrideCloudId", () => $d14147b5d5932d8b$export$330363aaebcbbac2);
$parcel$export(module.exports, "getIsCreateIssueWithAiEnabledByUser", () => $d14147b5d5932d8b$export$a35ab74c98615456);
$parcel$export(module.exports, "setCreateIssueWithAiEnabledByUser", () => $d14147b5d5932d8b$export$14465c2df74f62aa);
$parcel$export(module.exports, "saveJiraConfigDetailsToLocalStorage", () => $d14147b5d5932d8b$export$e1a5fce8e4916b90);

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
var $d14147b5d5932d8b$export$f06d63e9178daac8 = /*#__PURE__*/ function(ISSUE_CREATE_WITH_AI) {
    ISSUE_CREATE_WITH_AI["enabled"] = "enabled";
    ISSUE_CREATE_WITH_AI["disabled"] = "disabled";
    return ISSUE_CREATE_WITH_AI;
}({});
const $d14147b5d5932d8b$export$1a5b3977e2178dad = (payload)=>{
    if (payload?.selectedCloudId) try {
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE, payload.selectedCloudId);
    } catch (error) {
        throw new Error('Unable to fetch cloudId');
    }
};
const $d14147b5d5932d8b$export$330363aaebcbbac2 = ()=>(0, $e9zUf.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE);
const $d14147b5d5932d8b$export$a35ab74c98615456 = ()=>{
    const isCreateIssueAiEnabled = (0, $e9zUf.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).ISSUE_CREATE_WITH_AI);
    // If the value is not set true should be returned by default
    return isCreateIssueAiEnabled !== "disabled";
};
const $d14147b5d5932d8b$export$14465c2df74f62aa = (enabled)=>{
    (0, $e9zUf.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).ISSUE_CREATE_WITH_AI, enabled ? "enabled" : "disabled");
};
const $d14147b5d5932d8b$export$e1a5fce8e4916b90 = ({ selectedSite: selectedSite, selectedProject: selectedProject, selectedIssueType: selectedIssueType })=>{
    try {
        if (selectedSite && selectedProject && selectedIssueType) (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER, {
            selectedSite: selectedSite,
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to set bulk create Jira config: ${error instanceof Error ? error.message : String(error)}`);
    }
};

});

parcelRegister("bImpr", function(module, exports) {

$parcel$export(module.exports, "IssueCreateWithAiToggle", () => $7bb6117a579cf01b$export$47f423704ba03667);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $82gXq = parcelRequire("82gXq");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $3E5yu = parcelRequire("3E5yu");

var $2ay9q = parcelRequire("2ay9q");

var $1mDVg = parcelRequire("1mDVg");
const $7bb6117a579cf01b$var$aiToggleContainerStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.250',
    paddingBlockStart: 'space.250'
});
const $7bb6117a579cf01b$var$toggleWrapperStyle = (0, $ecnYn.xcss)({
    flexShrink: 0
});
const $7bb6117a579cf01b$export$47f423704ba03667 = ({ onChange: onChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const id = 'issue-create-with-ai-toggle';
    const [isChecked, setIsChecked] = (0, $gwFzn.useState)((0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)());
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $gwFzn.useEffect)(()=>{
        (0, $2ay9q.setCreateIssueWithAiEnabledByUser)(isChecked);
    });
    const onToggleChange = (0, $gwFzn.useCallback)(async ()=>{
        const newIsChecked = !isChecked;
        setIsChecked(newIsChecked);
        (0, $2ay9q.setCreateIssueWithAiEnabledByUser)(newIsChecked);
        // Wait for the toggle to finish animating before continuing
        await new Promise((resolve)=>setTimeout(resolve, 250));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'issueCreateSidePanel',
                action: 'toggled',
                actionSubject: 'toggle',
                actionSubjectId: 'issueCreateAiToggle',
                type: 'ui',
                attributes: {
                    newState: newIsChecked ? 'enabled' : 'disabled',
                    aiEnablement: aiIssueCreationEnablement?.enablement,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission
                }
            }
        }).fire();
        onChange(newIsChecked);
    }, [
        isChecked,
        createAnalyticsEvent,
        aiIssueCreationEnablement?.enablement,
        pageMode,
        onChange,
        hasEditPermission
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $7bb6117a579cf01b$var$aiToggleContainerStyle,
        alignBlock: "start",
        testId: "issue-create-side-panel.with-ai"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $7bb6117a579cf01b$var$toggleWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $82gXq.default), {
        id: id,
        testId: "issue-create-side-panel.with-ai.toggle",
        isChecked: isChecked,
        onChange: onToggleChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("label", {
        htmlFor: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).sidePanelIssueCreateAiToggleLabel)));
};

});

parcelRegister("kcLnq", function(module, exports) {

$parcel$export(module.exports, "ConfluenceAiIssueCreate", () => $0aab3fed706492b4$export$56bb8aafd9fb646e);
/* ConfluenceAiIssueCreate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $caRYB = parcelRequire("caRYB");
var $2FFuS = parcelRequire("2FFuS");

var $gdv5Z = parcelRequire("gdv5Z");

var $fwDOR = parcelRequire("fwDOR");

var $7pE6f = parcelRequire("7pE6f");
var $4sbrV = parcelRequire("4sbrV");

var $2Rith = parcelRequire("2Rith");

var $jJf3a = parcelRequire("jJf3a");

var $cfwlu = parcelRequire("cfwlu");

var $gXmdm = parcelRequire("gXmdm");
var $bYQI0 = parcelRequire("bYQI0");
var $1umsb = parcelRequire("1umsb");

var $cLj22 = parcelRequire("cLj22");

var $1ASvP = parcelRequire("1ASvP");

var $6mKj3 = parcelRequire("6mKj3");

var $9wGTI = parcelRequire("9wGTI");

var $kfViO = parcelRequire("kfViO");

var $9BGuq = parcelRequire("9BGuq");

var $arvSz = parcelRequire("arvSz");

var $7aGmI = parcelRequire("7aGmI");
const $0aab3fed706492b4$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $0aab3fed706492b4$var$style = {
    aiIssueCreateWrapper: "_16jlkb7n"
};
const $0aab3fed706492b4$export$92b36e2bd44453a3 = ({ cloudId: cloudId, confluencePage: confluencePage, highlightedText: highlightedText, handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange, isReady: isReady, overrideXProduct: overrideXProduct })=>{
    const result = (0, $bYQI0.useFetchAiSuggestedFields)({
        cloudId: cloudId,
        confluencePage: confluencePage,
        experienceId: 'ai-issue-create-confluence-single',
        highlightedText: highlightedText,
        product: 'confluence',
        onStateChange: handleAiSuggestedFieldsStateChange,
        overrideXProduct: overrideXProduct
    });
    if (!isReady) return {
        state: 'loading',
        fields: null
    };
    return {
        state: result.state,
        fields: result.fields || null
    };
};
const $0aab3fed706492b4$export$fbdfb25d3cad524a = ({ confluencePage: confluencePage, highlightedText: highlightedText, isReady: isReady, overrideXProduct: overrideXProduct, handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange })=>{
    const streamingHookProps = (0, $arvSz.useStreamingHookProps)({
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        overrideXProduct: overrideXProduct
    });
    const { suggestions: suggestions, isStreaming: isStreaming, error: error, onAIResultView: onAIResultView } = (0, $cLj22.useAiWorkSuggestionStreaming)(streamingHookProps);
    // Transform streaming suggestions to match the expected fields format
    const transformedFields = (0, $gwFzn.useMemo)(()=>{
        // Only use suggestions when streaming is complete
        if (isStreaming) return {
            summary: '',
            description: ''
        };
        return {
            summary: suggestions?.[0]?.field_values?.Summary || '',
            description: suggestions?.[0]?.field_values?.Description || ''
        };
    }, [
        suggestions,
        isStreaming
    ]);
    const getServiceState = ()=>{
        if (error) return 'error';
        if (isStreaming) return 'loading';
        return 'idle';
    };
    (0, $gwFzn.useEffect)(()=>{
        if (error) handleAiSuggestedFieldsStateChange({
            state: 'error',
            error: $0aab3fed706492b4$export$98d40c5fd23ef716(error)
        });
        else if (isStreaming) handleAiSuggestedFieldsStateChange({
            state: 'loading',
            fields: transformedFields
        });
        else handleAiSuggestedFieldsStateChange({
            state: 'idle',
            fields: transformedFields
        });
    }, [
        error,
        isStreaming,
        transformedFields,
        handleAiSuggestedFieldsStateChange
    ]);
    if (!isReady) return {
        state: 'loading',
        fields: null
    };
    return {
        state: getServiceState(),
        fields: transformedFields,
        onAIResultView: onAIResultView,
        suggestions: suggestions,
        isStreaming: isStreaming
    };
};
const $0aab3fed706492b4$export$98d40c5fd23ef716 = (error)=>{
    return {
        message_template: error?.message?.message_template,
        statusCode: error?.message?.status_code,
        message: error?.message?.content,
        content: error?.message?.content
    };
};
const $0aab3fed706492b4$export$a653b3ac3dd182f4 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, contentType: contentType, pageId: pageId, highlightedTextAdf: highlightedTextAdf, timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const [confluencePage, setConfluencePage] = (0, $gwFzn.useState)('');
    const [idMap, setIdMap] = (0, $gwFzn.useState)({});
    const [isIdMapReady, setIsIdMapReady] = (0, $gwFzn.useState)(false);
    // Custom handler to wrap multiple onStateChange calls
    const handleStateChange = (0, $gwFzn.useCallback)((source, state)=>{
        // trigger error if any state is errored
        if (onFailure && state?.state === 'error') {
            onFailure(state.error, state.message_template);
            fireTrack(`${source} failed`);
        }
        if (onStateChange) {
            onStateChange(state.state, source);
            fireTrack(`${source} updated`, {
                state: state.state
            });
        }
    }, [
        onFailure,
        onStateChange,
        fireTrack
    ]);
    const handleConfluencePageStateChange = (0, $gwFzn.useCallback)((newState)=>handleStateChange('aiIssueCreateGetConfluencePageState', newState), [
        handleStateChange
    ]);
    // Fetch confluence page
    const { state: confluencePageState, confluencePage: confluencePageAsAdf } = (0, $1umsb.useGetConfluencePage)({
        cloudId: cloudId,
        contentType: contentType,
        experienceId: 'ai-issue-create-confluence-single',
        pageId: pageId,
        onStateChange: handleConfluencePageStateChange
    });
    // Effect to transform confluence page ADF to markdown after fetching
    (0, $gwFzn.useEffect)(()=>{
        if (confluencePageState === 'idle' && confluencePageAsAdf) {
            const { markdown: markdown, idMap: newIdMap } = (0, $7pE6f.adfToMarkdownPlus)(confluencePageAsAdf);
            setAiAnalyticsContext && setAiAnalyticsContext('pageContextLength', (0, $kfViO.countADFChars)(confluencePageAsAdf));
            setConfluencePage(markdown);
            setIdMap(newIdMap);
            setIsIdMapReady(true); // Set idMap ready when it's set
        }
    }, [
        confluencePageState,
        confluencePageAsAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        xcss: $0aab3fed706492b4$var$style.aiIssueCreateWrapper,
        testId: testId ?? 'default-confluence-ai-issue-create'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.adf-to-markdown-plus",
        hold: confluencePageState !== 'loading' && !isIdMapReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.confluence-page-loading",
        hold: confluencePageState === 'loading'
    }), isIdMapReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0aab3fed706492b4$var$WrappedConfluenceAiIssueCreateComponent, {
        handleStateChange: handleStateChange,
        confluencePageState: confluencePageState,
        confluencePage: confluencePage,
        idMap: idMap,
        useService: (0, $6mKj3.expVal)('aiwc_migrate_to_convo_ai_from_assistance_service', 'isEnabled', false) ? $0aab3fed706492b4$export$fbdfb25d3cad524a : $0aab3fed706492b4$export$92b36e2bd44453a3,
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        onStateChange: onStateChange,
        consumer: consumer,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker
    }) : null);
};
const $0aab3fed706492b4$var$WrappedConfluenceAiIssueCreateComponent = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, highlightedTextAdf: highlightedTextAdf = (0, $caRYB.doc)((0, $2FFuS.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, idMap: idMap, confluencePage: confluencePage, confluencePageState: confluencePageState, handleStateChange: handleStateChange, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, useService: useService, aIIssueCreationEnablement: aIIssueCreationEnablement, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker })=>{
    const handleAiSuggestedFieldsStateChange = (0, $gwFzn.useCallback)((newState)=>handleStateChange('aiIssueCreateFetchSuggestedFieldsState', newState), [
        handleStateChange
    ]);
    const highlightedText = (0, $gwFzn.useMemo)(()=>{
        return (0, $7pE6f.adfToMarkdownPlus)(highlightedTextAdf, undefined, idMap).markdown;
    }, [
        highlightedTextAdf,
        idMap
    ]);
    // Only call SuggestionComponent when highlightedText is ready
    const { state: suggestedFieldsState, fields: fields, onAIResultView: onAIResultView, isStreaming: isStreaming, suggestions: suggestions } = useService({
        cloudId: cloudId,
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange,
        isReady: highlightedText !== '',
        overrideXProduct: aIIssueCreationEnablement?.enablement
    });
    const isLoading = confluencePageState === 'loading' || suggestedFieldsState === 'loading';
    const isErrored = confluencePageState === 'error' || suggestedFieldsState === 'error';
    const isPayloadReady = confluencePageState === 'idle' && suggestedFieldsState === 'idle';
    const descriptionADF = (0, $gwFzn.useMemo)(()=>{
        if (isLoading || isErrored || !fields?.description) return (0, $caRYB.doc)((0, $2FFuS.paragraph)(''));
        return (0, $4sbrV.markdownPlusToAdf)({
            markdown: fields.description,
            idMap: idMap
        });
    }, [
        isLoading,
        isErrored,
        fields,
        idMap
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('aiResponseLength', (0, $kfViO.countADFChars)(descriptionADF));
    }, [
        descriptionADF,
        setAiAnalyticsContext
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('highlightedTextLength', (0, $kfViO.countADFChars)(highlightedTextAdf));
    }, [
        highlightedTextAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.suggested-fields-loading",
        hold: suggestedFieldsState === 'loading'
    }), !isErrored && (0, $9wGTI.fg)('jira_ai_single_issue_create_panel_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7aGmI.SingleWorkCreateForm), {
        closePanel: onClose
    }), !isErrored && !(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: cloudId,
        summary: fields?.summary || '',
        descriptionAdf: descriptionADF,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        consumer: consumer,
        isPayloadReady: isPayloadReady,
        overrideCloudId: overrideCloudIdForSitePicker,
        projectId: overrideProjectIdForProjectPicker
    }), !isStreaming && Boolean(suggestions?.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1ASvP.MountEvent), {
        onMount: onAIResultView
    }));
};
const $0aab3fed706492b4$export$56bb8aafd9fb646e = ({ cloudId: cloudId, contentType: contentType, pageId: pageId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, highlightedTextAdf: highlightedTextAdf = (0, $caRYB.doc)((0, $2FFuS.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer = 'confluenceHighlight', setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    const experienceTracker = (0, $gXmdm.useAiIssueCreateExperienceTracker)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jJf3a.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0aab3fed706492b4$export$a653b3ac3dd182f4, {
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        testId: testId,
        onStateChange: onStateChange,
        consumer: consumer,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement
    })));
};

});
parcelRegister("7pE6f", function(module, exports) {

$parcel$export(module.exports, "adfToMarkdownPlus", () => $5a51f9da98a84e11$export$bd172d9b9473ac80);
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/adf-to-markdownPlus.ts and slightly modified to work in the browser.
 */ 
var $h9yJL = parcelRequire("h9yJL");

var $6eZqW = parcelRequire("6eZqW");
const $5a51f9da98a84e11$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $5a51f9da98a84e11$export$bd172d9b9473ac80(adf, featureToggles, idMap) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    if (featureToggles?.markdownPlusAvoidDuplicatedIdCounter === undefined) featureToggles.markdownPlusAvoidDuplicatedIdCounter = true;
    // Convert ADF to ProseMirrorNode
    const proseMirrorNode = $5a51f9da98a84e11$var$serializer.parse(adf);
    // Generate the mentionMap required for correctly returning @mention strings in Markdown+
    const mentionMap = $5a51f9da98a84e11$var$getMentionMap($5a51f9da98a84e11$var$serializer.encode(proseMirrorNode));
    // Convert ProseMirrorNode to markdown-plus
    const { markdown: markdown, idMap: newIdMap } = (0, $6eZqW.convertProsemirrorNodeToMarkdown)({
        node: proseMirrorNode,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
    return {
        markdown: markdown,
        idMap: newIdMap
    };
}
function $5a51f9da98a84e11$var$getMentionMap(jsonNode) {
    const mentionMap = {};
    function findMentions(node) {
        if (node.type === 'mention') {
            const userValues = $5a51f9da98a84e11$var$getUserMentionValues(node);
            if (userValues) // Stripping '@' from the mention as Markdown+ automatically adds it back for each map value
            mentionMap[userValues.id] = userValues.text.replace('@', '');
        }
        node.content?.forEach((childNode)=>{
            if (childNode) findMentions(childNode);
        });
    }
    findMentions(jsonNode);
    return mentionMap;
}
function $5a51f9da98a84e11$var$getUserMentionValues(node) {
    if (node.attrs && $5a51f9da98a84e11$var$hasTextAndIdFields(node.attrs)) return {
        text: node.attrs.text,
        id: node.attrs.id
    };
    return null;
}
function $5a51f9da98a84e11$var$hasTextAndIdFields(attrs) {
    return 'text' in attrs && 'id' in attrs && typeof attrs.text === 'string' && typeof attrs.id === 'string';
}

});

parcelRegister("4sbrV", function(module, exports) {

$parcel$export(module.exports, "markdownPlusToAdf", () => $c4325a25ee151966$export$dfca419434f7e5a8);
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $ODlve = parcelRequire("ODlve");

var $h9yJL = parcelRequire("h9yJL");

var $hAuc5 = parcelRequire("hAuc5");
const $c4325a25ee151966$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $c4325a25ee151966$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $hAuc5.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $ODlve.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $c4325a25ee151966$var$serializer.encode(proseMirrorNode);
}

});

parcelRegister("jJf3a", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", () => $519cb1da41ed4097$export$a7b0697657ed8bd0);

var $gwFzn = parcelRequire("gwFzn");
const $519cb1da41ed4097$export$a7b0697657ed8bd0 = (0, $gwFzn.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});

});

parcelRegister("gXmdm", function(module, exports) {

$parcel$export(module.exports, "useAiIssueCreateAnalytics", () => $5432d0f4065c32f5$export$f6ae4d64a1b3fc6e);
$parcel$export(module.exports, "useAiIssueCreateExperienceTracker", () => $5432d0f4065c32f5$export$62af031f97b1cab3);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $dh538 = parcelRequire("dh538");

var $9tntP = parcelRequire("9tntP");
const $5432d0f4065c32f5$export$f6ae4d64a1b3fc6e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const actions = (0, $gwFzn.useMemo)(()=>{
        return {
            fireTrack: (name, attributes)=>{
                const source = 'aiIssueCreate';
                const [actionSubject, action] = name.split(' ');
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: source,
                        action: action,
                        actionSubject: actionSubject,
                        attributes: attributes
                    }
                }).fire();
            }
        };
    }, [
        createAnalyticsEvent
    ]);
    return actions;
};
const $5432d0f4065c32f5$export$62af031f97b1cab3 = ()=>{
    const experienceTracker = (0, $gwFzn.useMemo)(()=>new (0, $9tntP.ExperienceTracker)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('crocs-ai-issue-create-user-experience-tracker')) {
            const unsubscribe = experienceTracker.subscribe((event)=>{
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'ui',
                        action: event.action,
                        actionSubject: 'ui',
                        attributes: {
                            task: event.name,
                            taskId: event.id,
                            startTime: event.startTime,
                            ...'duration' in event && {
                                duration: event.duration
                            },
                            ...event.attributes
                        }
                    }
                }).fire();
            });
            return ()=>unsubscribe();
        }
    }, [
        experienceTracker,
        createAnalyticsEvent
    ]);
    return experienceTracker;
};

});

parcelRegister("bYQI0", function(module, exports) {

$parcel$export(module.exports, "useFetchAiSuggestedFields", () => $61d0bbcdbe428292$export$164d7aa8ab0f3df2);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $jJf3a = parcelRequire("jJf3a");

var $faxqs = parcelRequire("faxqs");

var $gXmdm = parcelRequire("gXmdm");

var $jE5jJ = parcelRequire("jE5jJ");
const $61d0bbcdbe428292$var$experienceName = 'aiIssueCreateFetchSuggestedFieldsRequest';
const $61d0bbcdbe428292$var$TOKEN_LIMITS = 18500;
const $61d0bbcdbe428292$var$CHARS_LIMITS = $61d0bbcdbe428292$var$TOKEN_LIMITS * 4; // We use 1 token ~= 4 chars in English
const $61d0bbcdbe428292$export$164d7aa8ab0f3df2 = ({ cloudId: cloudId, confluencePage: confluencePage, highlightedText: highlightedText, product: product, experienceId: experienceId, onStateChange: onStateChange, overrideXProduct: overrideXProduct })=>{
    const { fireTrack: fireTrack } = (0, $gXmdm.useAiIssueCreateAnalytics)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const [fetchState, setFetchState] = (0, $gwFzn.useState)({
        state: 'loading',
        fields: undefined
    });
    const abortControllerRef = (0, $gwFzn.useRef)(null);
    const fetchAiFields = (0, $gwFzn.useCallback)(async ()=>{
        if (!cloudId || !confluencePage) return;
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        const currentAbortController = abortControllerRef.current;
        setFetchState({
            state: 'loading',
            fields: undefined
        });
        const contentLength = confluencePage.length + highlightedText.length;
        try {
            // CRCS-1048: remove once new events have enough data for validation and swap
            fireTrack('aiIssueCreateFetchSuggestedFieldsRequest start');
            if ((0, $dh538.fg)('crocs-ai-issue-create-user-experience-tracker')) experienceTracker.start({
                name: $61d0bbcdbe428292$var$experienceName,
                id: $61d0bbcdbe428292$var$experienceName
            });
            if (contentLength > $61d0bbcdbe428292$var$CHARS_LIMITS) {
                const message_template = (0, $faxqs.AssistanceServiceMessageTemplate).FE_REQUEST_EXCEEDING_TOKEN_LENGTH;
                const errorMessage = 'Exceeds token length limit';
                const error = new (0, $jE5jJ.FetchSuggestionError)(errorMessage, message_template);
                setFetchState({
                    state: 'error',
                    error: error,
                    message_template: message_template,
                    fields: undefined
                });
                if ((0, $dh538.fg)('crocs-ai-issue-create-user-experience-tracker')) experienceTracker.fail({
                    name: $61d0bbcdbe428292$var$experienceName,
                    error: error,
                    attributes: {
                        errorMessage: errorMessage,
                        message_template: message_template,
                        shouldSlo: false,
                        contentLength: contentLength
                    }
                });
                return;
            }
            const result = await (0, $jE5jJ.fetchAiSuggestedFields)({
                cloudId: cloudId,
                confluencePage: confluencePage,
                experienceId: experienceId,
                highlightedText: highlightedText,
                product: product,
                signal: currentAbortController.signal,
                overrideXProduct: overrideXProduct
            });
            // CRCS-1048: remove once new events have enough data for validation and swap
            fireTrack('aiIssueCreateFetchSuggestedFieldsRequest complete', {
                haveResult: !!result
            });
            if ((0, $dh538.fg)('crocs-ai-issue-create-user-experience-tracker')) experienceTracker.succeed({
                name: $61d0bbcdbe428292$var$experienceName,
                attributes: {
                    haveResult: !!result,
                    contentLength: contentLength,
                    totalUsage: result?.usage?.total_tokens
                }
            });
            if (currentAbortController.signal.aborted) return;
            if (result) setFetchState({
                state: 'idle',
                fields: result.suggestion
            });
            else {
                const message_template = (0, $faxqs.AssistanceServiceMessageTemplate).UNKNOWN_ERROR;
                setFetchState({
                    state: 'error',
                    error: new (0, $jE5jJ.FetchSuggestionError)('Error on suggesting AI Issue Create from Assistance Service', message_template),
                    message_template: message_template,
                    fields: undefined
                });
            }
        } catch (e) {
            let statusCode;
            let errorMessage;
            let message_template = (0, $faxqs.AssistanceServiceMessageTemplate).UNKNOWN_ERROR; // default to unknown
            let shouldSlo = true;
            if (e instanceof (0, $jE5jJ.ConvoAiError)) {
                statusCode = e.statusCode;
                errorMessage = e.errorMessage;
                message_template = e.message_template;
                shouldSlo = (0, $dh538.fg)('jira_ai_issue_create_status_code_whitelist') ? !(0, $jE5jJ.isWhitelistedStatusCode)(statusCode) : e.shouldSlo;
            } else if (e instanceof Error) errorMessage = e.message;
            else errorMessage = `Error occurred when requesting to ${experienceId} agent`;
            if (currentAbortController.signal.aborted) {
                setFetchState({
                    state: 'abort',
                    fields: undefined
                });
                return;
            }
            // CRCS-1048: remove once new events have enough data for validation and swap
            fireTrack('aiIssueCreateFetchSuggestedFieldsRequest fail', {
                errorMessage: errorMessage,
                statusCode: statusCode,
                message_template: message_template,
                shouldSlo: shouldSlo
            });
            if ((0, $dh538.fg)('crocs-ai-issue-create-user-experience-tracker')) experienceTracker.fail({
                name: $61d0bbcdbe428292$var$experienceName,
                error: e instanceof Error ? e : new Error(errorMessage),
                attributes: {
                    errorMessage: errorMessage,
                    statusCode: statusCode,
                    message_template: message_template,
                    shouldSlo: shouldSlo,
                    contentLength: contentLength
                }
            });
            setFetchState({
                state: 'error',
                error: e,
                message_template: message_template,
                fields: undefined
            });
        }
    }, [
        cloudId,
        confluencePage,
        experienceId,
        fireTrack,
        highlightedText,
        product,
        experienceTracker,
        overrideXProduct
    ]);
    (0, $gwFzn.useEffect)(()=>{
        fetchAiFields();
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        fetchAiFields
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (onStateChange) onStateChange(fetchState);
    }, [
        fetchState.state,
        fetchState.fields,
        onStateChange,
        fetchState
    ]);
    const trigger = (0, $gwFzn.useCallback)(()=>{
        return fetchAiFields();
    }, [
        fetchAiFields
    ]);
    return {
        ...fetchState,
        trigger: trigger
    };
};

});
parcelRegister("faxqs", function(module, exports) {

$parcel$export(module.exports, "AssistanceServiceMessageTemplate", () => $ed2f918cf3914cae$export$4f86aad88367b6b3);
const $ed2f918cf3914cae$export$4f86aad88367b6b3 = {
    // https://bitbucket.org/atlassian/assistance-service/src/02087c3b6569f042ec338e08e8e0e152c4563dad/src/schema/message_publisher.py#lines-74
    ACCEPTABLE_USE_VIOLATIONS: 'ACCEPTABLE_USE_VIOLATIONS',
    ACCEPTABLE_USE_EVALUATION_EXCEPTION: 'ACCEPTABLE_USE_EVALUATION_EXCEPTION',
    AI_DISABLED: 'AI_DISABLED',
    ANSWER_UNAVAILABLE_FOR_CONTENT: 'ASWER_UNAVAILABLE_FOR_CONTENT',
    CONVERSATION_CHANNEL_UNAUTHORIZED: 'CONVERSATION_CHANNEL_UNAUTHORIZED',
    EXCEEDING_CONTEXT_LENGTH_ERROR: 'EXCEEDING_CONTEXT_LENGTH_ERROR',
    EXPERIENCE_NOT_ENABLED_FOR_CUSTOMER_ACCOUNT: 'EXPERIENCE_NOT_ENABLED_FOR_CUSTOMER_ACCOUNT',
    FEATURE_DISABLED_ON_SITE: 'FEATURE_DISABLED_ON_SITE',
    FEATURE_DISABLED: 'FEATURE_DISABLED',
    HIPAA_CONTENT_DETECTED: 'HIPAA_CONTENT_DETECTED',
    NETWORK_ERROR: 'NETWORK_ERROR',
    NO_AGENT: 'NO_AGENT',
    NO_ANSWER: 'NO_ANSWER',
    NOT_ENOUGH_CONTENT_ERROR: 'NOT_ENOUGH_CONTENT_ERROR',
    OPENAI_RATE_LIMIT_USER_ABUSE: 'OPENAI_RATE_LIMIT_USER_ABUSE',
    PLUGIN_ERRORED: 'PLUGIN_ERRORED',
    RATE_LIMIT: 'RATE_LIMIT',
    UNEXPECTED: 'UNEXPECTED',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    // Custom
    NO_ANSWER_SUGGESTED_ISSUES: 'NO_ANSWER_SUGGESTED_ISSUES',
    FE_REQUEST_EXCEEDING_TOKEN_LENGTH: 'FE_REQUEST_EXCEEDING_TOKEN_LENGTH',
    BAD_RESPONSE: 'BAD_RESPONSE',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};

});

parcelRegister("jE5jJ", function(module, exports) {

$parcel$export(module.exports, "FetchSuggestionError", () => $6094e53047e3bdb5$export$125d96a340aceb4a);
$parcel$export(module.exports, "ConvoAiError", () => $6094e53047e3bdb5$export$74bf389a710386ac);
$parcel$export(module.exports, "fetchAiSuggestedFields", () => $6094e53047e3bdb5$export$d130e2970045dc7d);
$parcel$export(module.exports, "isWhitelistedStatusCode", () => $6094e53047e3bdb5$export$8b8f8eddc343ddd4);

var $dh538 = parcelRequire("dh538");

var $4U9Cw = parcelRequire("4U9Cw");

var $faxqs = parcelRequire("faxqs");
const $6094e53047e3bdb5$var$capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
class $6094e53047e3bdb5$export$125d96a340aceb4a extends Error {
    constructor(errorMessage, message_template){
        super(errorMessage), this.errorMessage = errorMessage, this.message_template = message_template;
    }
}
class $6094e53047e3bdb5$export$74bf389a710386ac extends Error {
    constructor(statusCode, errorMessage, message_template, shouldSlo = true){
        super(errorMessage), this.statusCode = statusCode, this.errorMessage = errorMessage, this.message_template = message_template, this.shouldSlo = shouldSlo;
    }
}
const $6094e53047e3bdb5$export$d130e2970045dc7d = async ({ cloudId: cloudId, confluencePage: confluencePage, highlightedText: highlightedText, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create-confluence-single', overrideXProduct: overrideXProduct })=>{
    const xProduct = overrideXProduct ?? product;
    const response = await fetch((0, $4U9Cw.AI_MATE_URL), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Experience-Id': experienceId,
            'X-Product': xProduct,
            'Atl-CloudId': cloudId
        },
        body: JSON.stringify({
            recipient_agent_named_id: 'ai_issue_create_agent',
            agent_input_context: {
                application: $6094e53047e3bdb5$var$capitalizeFirstLetter(product),
                context: {
                    confluence_page_markdown_plus: confluencePage,
                    highlighted_text: highlightedText
                },
                suggested_issues_config: {
                    max_issues: 1,
                    suggested_issue_field_types: [
                        {
                            issue_type: 'Task',
                            fields: [
                                {
                                    field_name: 'Summary',
                                    field_type: 'Short-Text'
                                },
                                {
                                    field_name: 'Description',
                                    field_type: 'Paragraph'
                                }
                            ]
                        }
                    ]
                }
            }
        }),
        credentials: 'include',
        signal: signal
    });
    if (!response.ok) {
        const errorPayload = await response.json();
        const error = $6094e53047e3bdb5$export$80c2a90c88f1a57a(response.status, errorPayload);
        throw error;
    }
    const data = await response.json();
    const suggestion = $6094e53047e3bdb5$export$4c0e6fff2d4abe18(data);
    if (!suggestion) throw new Error(`Parsing response from ${experienceId} failed`);
    return suggestion;
};
const $6094e53047e3bdb5$var$NON_SLO_MESSAGE_TEMPLATES = [
    (0, $faxqs.AssistanceServiceMessageTemplate).ACCEPTABLE_USE_VIOLATIONS,
    (0, $faxqs.AssistanceServiceMessageTemplate).ACCEPTABLE_USE_EVALUATION_EXCEPTION,
    (0, $faxqs.AssistanceServiceMessageTemplate).AI_DISABLED,
    (0, $faxqs.AssistanceServiceMessageTemplate).CONVERSATION_CHANNEL_UNAUTHORIZED,
    (0, $faxqs.AssistanceServiceMessageTemplate).EXCEEDING_CONTEXT_LENGTH_ERROR,
    (0, $faxqs.AssistanceServiceMessageTemplate).EXPERIENCE_NOT_ENABLED_FOR_CUSTOMER_ACCOUNT,
    (0, $faxqs.AssistanceServiceMessageTemplate).FEATURE_DISABLED,
    (0, $faxqs.AssistanceServiceMessageTemplate).FEATURE_DISABLED_ON_SITE,
    (0, $faxqs.AssistanceServiceMessageTemplate).HIPAA_CONTENT_DETECTED,
    (0, $faxqs.AssistanceServiceMessageTemplate).OPENAI_RATE_LIMIT_USER_ABUSE,
    (0, $faxqs.AssistanceServiceMessageTemplate).RATE_LIMIT
];
const $6094e53047e3bdb5$var$NON_SLO_STATUS_CODES = [
    403
];
const $6094e53047e3bdb5$export$986d312e2c3e3ee = (messageTemplate)=>$6094e53047e3bdb5$var$NON_SLO_MESSAGE_TEMPLATES.includes(messageTemplate);
const $6094e53047e3bdb5$export$8b8f8eddc343ddd4 = (status_code)=>$6094e53047e3bdb5$var$NON_SLO_STATUS_CODES.includes(status_code);
const $6094e53047e3bdb5$export$4c0e6fff2d4abe18 = (data)=>{
    let shouldSlo = (0, $dh538.fg)('jira_ai_issue_create_status_code_whitelist') ? !$6094e53047e3bdb5$export$8b8f8eddc343ddd4(data.status_code) : true;
    if ('message_template' in data) {
        // only check for whitelisted message templates if status code is not whitelisted
        if (shouldSlo) shouldSlo = !$6094e53047e3bdb5$export$986d312e2c3e3ee(data.message_template);
        throw new $6094e53047e3bdb5$export$74bf389a710386ac(data.status_code, data.content, data.message_template, shouldSlo);
    }
    const content = data?.message?.content;
    if (!content) return undefined;
    try {
        const contentJson = JSON.parse(content);
        if (contentJson.suggested_issues === undefined) throw new $6094e53047e3bdb5$export$74bf389a710386ac(200, `Response suggested_issues is undefined. Key names: ${Object.keys(contentJson).toString()}`, (0, $faxqs.AssistanceServiceMessageTemplate).NO_ANSWER_SUGGESTED_ISSUES, shouldSlo);
        if (contentJson.suggested_issues.length === 0) throw new $6094e53047e3bdb5$export$74bf389a710386ac(200, 'No suggested issues are available for the context provided', (0, $faxqs.AssistanceServiceMessageTemplate).NO_ANSWER_SUGGESTED_ISSUES, shouldSlo);
        const suggestion = {
            summary: contentJson.suggested_issues[0].field_values.Summary,
            description: contentJson.suggested_issues[0].field_values.Description
        };
        const usage = data.usage_data.total;
        return {
            suggestion: suggestion,
            usage: usage
        };
    } catch (error) {
        if (content.startsWith('_')) {
            const fixedJSON = {
                ...data,
                message: {
                    ...data.message,
                    content: content.slice(1)
                }
            };
            return $6094e53047e3bdb5$export$4c0e6fff2d4abe18(fixedJSON);
        }
        if (error instanceof $6094e53047e3bdb5$export$74bf389a710386ac) throw error;
        throw new $6094e53047e3bdb5$export$74bf389a710386ac(200, `Failed to parse JSON: ${error}`, data.message_template ?? (0, $faxqs.AssistanceServiceMessageTemplate).UNKNOWN_ERROR, shouldSlo);
    }
};
const $6094e53047e3bdb5$export$80c2a90c88f1a57a = (statusCode, errorPayload)=>{
    const { content: content, errorMessage: errorMessage, message_template: message_template } = errorPayload;
    // `content` is available when error is from assistance-service
    // `errorMessage` is available when error is from convo-ai (usually only AI enabled errors)
    // `message_template` is available when error is from assistance-service in case content is empty
    const message = content || (errorMessage ?? message_template);
    return new $6094e53047e3bdb5$export$74bf389a710386ac(statusCode, message ?? 'Unknown error', message_template ?? (0, $faxqs.AssistanceServiceMessageTemplate).UNKNOWN_ERROR);
};

});
parcelRegister("4U9Cw", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_URL", () => $c9b235485add8925$export$9fb931e86e17b946);
const $c9b235485add8925$export$9fb931e86e17b946 = '/gateway/api/assist/chat/v1/invoke_agent';

});



parcelRegister("1umsb", function(module, exports) {

$parcel$export(module.exports, "useGetConfluencePage", () => $842dee2fd80dfa2c$export$e411256f856842c7);

var $gwFzn = parcelRequire("gwFzn");

var $gXmdm = parcelRequire("gXmdm");

var $iY4nM = parcelRequire("iY4nM");
const $842dee2fd80dfa2c$export$e411256f856842c7 = ({ cloudId: cloudId, contentType: contentType, experienceId: experienceId, pageId: pageId, product: product, onStateChange: onStateChange })=>{
    const { fireTrack: fireTrack } = (0, $gXmdm.useAiIssueCreateAnalytics)();
    const [fetchState, setGetConfluencePageState] = (0, $gwFzn.useState)({
        state: 'loading',
        confluencePage: undefined
    });
    const abortControllerRef = (0, $gwFzn.useRef)(null);
    const fetchConfluencePage = (0, $gwFzn.useCallback)(async ()=>{
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        const currentAbortController = abortControllerRef.current;
        setGetConfluencePageState({
            state: 'loading',
            confluencePage: undefined
        });
        try {
            fireTrack('aiIssueCreateGetConfluencePageRequest start');
            const confluencePage = await (0, $iY4nM.getConfluencePageAdf)({
                cloudId: cloudId,
                contentType: contentType,
                experienceId: experienceId,
                pageId: pageId,
                product: product,
                signal: currentAbortController.signal
            });
            fireTrack('aiIssueCreateGetConfluencePageRequest complete', {
                haveResult: !!confluencePage
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            if (confluencePage) setGetConfluencePageState({
                state: 'idle',
                confluencePage: confluencePage
            });
            else setGetConfluencePageState({
                state: 'error',
                error: new Error('Error on getting confluence page as ADF'),
                confluencePage: undefined
            });
        } catch (e) {
            fireTrack('aiIssueCreateGetConfluencePageRequest fail', {
                message: e.message
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            setGetConfluencePageState({
                state: 'error',
                error: e,
                confluencePage: undefined
            });
        }
    }, [
        cloudId,
        contentType,
        experienceId,
        pageId,
        product,
        setGetConfluencePageState,
        fireTrack
    ]);
    (0, $gwFzn.useEffect)(()=>{
        fetchConfluencePage();
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        fetchConfluencePage
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (onStateChange) onStateChange(fetchState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchState.state,
        fetchState.confluencePage,
        onStateChange
    ]);
    return {
        ...fetchState,
        trigger: fetchConfluencePage
    };
};

});
parcelRegister("iY4nM", function(module, exports) {

$parcel$export(module.exports, "getConfluencePageAdf", () => $98a3645fea1a46e5$export$d9e18d9f19c35b71);
const $98a3645fea1a46e5$export$d9e18d9f19c35b71 = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create' })=>{
    try {
        const endpointAPI = contentType === 'blogpost' ? `blogposts` : `pages`;
        const response = await fetch(`/wiki/api/v2/${endpointAPI}/${pageId}?body-format=atlas_doc_format`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': experienceId,
                'X-Product': product,
                'Atl-CloudId': cloudId
            },
            credentials: 'include',
            signal: signal
        });
        const data = await response.json();
        if (!data.body?.atlas_doc_format) throw new Error('No atlas doc format found in confluence page');
        return JSON.parse(data.body.atlas_doc_format.value);
    } catch (error) {
        throw new Error('Request to get confluence page failed');
    }
};

});


parcelRegister("cLj22", function(module, exports) {

$parcel$export(module.exports, "useAiWorkSuggestionStreaming", () => $4a7a945da70edda5$export$5fe969aa6ed2f349);

var $gwFzn = parcelRequire("gwFzn");

var $fYQcF = parcelRequire("fYQcF");

var $j1XmT = parcelRequire("j1XmT");

var $9ZanP = parcelRequire("9ZanP");
const $4a7a945da70edda5$export$5fe969aa6ed2f349 = ({ analyticsConfig: analyticsConfig, issueConfig: issueConfig, onCompletion: onCompletion, customExperienceTracker: customExperienceTracker, requestHeaderOverrides: requestHeaderOverrides, ...streamingProps })=>{
    // **** setup ****
    const { updateSuggestions: updateSuggestions, suggestions: suggestions, fullSuggestionList: fullSuggestionList, reset: resetSuggestion, hideSuggestion: hideSuggestion } = (0, $j1XmT.useSuggestions)();
    const [error, setError] = (0, $gwFzn.useState)();
    const analyticsContext = {
        ...analyticsConfig,
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        isAIFeature: 1
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIResultError: trackAIResultError, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)(analyticsContext);
    const onStreamError = (0, $gwFzn.useCallback)((error)=>{
        customExperienceTracker?.fail?.(error);
        trackAIResultError({
            aiErrorCode: error.message.status_code,
            aiErrorMessage: error.message.message_template
        }, !(0, $9ZanP.isWhitelistedSLOError)(error) ? {
            attributes: {
                aiResultErrorCategory: 'server-error'
            }
        } : undefined);
        setError(error);
    }, [
        trackAIResultError,
        customExperienceTracker
    ]);
    const onStreamInit = (0, $gwFzn.useCallback)((retryCount)=>{
        resetSuggestion();
        setError(undefined);
        customExperienceTracker?.start?.();
        trackAIInteractionInit({
            attributes: {
                totalRetries: retryCount
            }
        });
    }, [
        trackAIInteractionInit,
        resetSuggestion,
        customExperienceTracker
    ]);
    const onStreamAborted = (0, $gwFzn.useCallback)(()=>{
        customExperienceTracker?.abort?.();
        trackAIInteractionDismiss();
    }, [
        trackAIInteractionDismiss,
        customExperienceTracker
    ]);
    const { isStreaming: isStreaming, isInitiating: isInitiatingStreaming, reset: resetStreaming, refetch: refetch, getIsStreamingRef: getIsStreamingRef } = (0, $9ZanP.useStreaming)({
        analyticsContext: analyticsContext,
        streamingProps: streamingProps,
        issueConfig: issueConfig,
        requestHeaderOverrides: requestHeaderOverrides,
        onSuggestionStreamUpdated: updateSuggestions,
        onStreamError: onStreamError,
        onStreamInit: onStreamInit,
        onStreamAbortedByInitNew: onStreamAborted
    });
    // **** callbacks ****
    const terminate = (0, $gwFzn.useCallback)(()=>{
        if (isStreaming) // stream aborted by terminating service
        onStreamAborted();
        resetSuggestion();
        resetStreaming();
        setError(undefined);
    // leave for side effect to invoke `onCompletion`
    }, [
        onStreamAborted,
        isStreaming,
        resetSuggestion,
        resetStreaming
    ]);
    const hideSuggestions = (0, $gwFzn.useCallback)((ids, action)=>{
        if (action) ids.forEach((_)=>trackAIResultAction(action));
        ids.forEach((id)=>hideSuggestion(id));
    }, [
        trackAIResultAction,
        hideSuggestion
    ]);
    // **** event handlers ****
    const onAIResultView = (0, $gwFzn.useCallback)(()=>{
        customExperienceTracker?.succeed?.();
        trackAIResultView({
            attributes: {
                suggestedNumber: suggestions.length
            }
        });
    }, [
        trackAIResultView,
        suggestions.length,
        customExperienceTracker
    ]);
    // **** side effects ****
    (0, $gwFzn.useEffect)(()=>{
        // work is considered done, if
        // - no suggestions are available
        // - no error exist
        // - no streaming is active
        if (!isInitiatingStreaming && !isStreaming && !error && suggestions.length === 0) onCompletion();
    }, [
        error,
        suggestions,
        isStreaming,
        onCompletion,
        isInitiatingStreaming
    ]);
    // report aborted on unmount if still streaming
    (0, $gwFzn.useEffect)(()=>()=>{
            if (getIsStreamingRef.current()) onStreamAborted();
        }, [
        onStreamAborted,
        getIsStreamingRef
    ]);
    return {
        suggestions: suggestions,
        fullSuggestionList: fullSuggestionList,
        isStreaming: isStreaming,
        error: error,
        onAIResultView: // event handlers
        onAIResultView,
        onAIFeedbackSubmit: trackAIFeedbackSubmit,
        refetch: // callbacks
        refetch,
        hideSuggestions: hideSuggestions,
        terminate: terminate
    };
};

});
parcelRegister("j1XmT", function(module, exports) {

$parcel$export(module.exports, "useSuggestions", () => $6264d1e35540fc04$export$378f0080e636ce63);

var $gwFzn = parcelRequire("gwFzn");

var $9HkI0 = parcelRequire("9HkI0");
const $6264d1e35540fc04$export$378f0080e636ce63 = ()=>{
    const [hiddenSuggestionIds, setHiddenSuggestionIds] = (0, $gwFzn.useState)(new Set());
    const [fullSuggestionList, setFullSuggestionList] = (0, $gwFzn.useState)([]);
    // used to avoid calling `setSuggestions` too many times during streaming - could break devtools
    const streamedIssueCount = (0, $gwFzn.useRef)(0);
    const suggestions = (0, $gwFzn.useMemo)(()=>fullSuggestionList.filter((suggestion)=>!hiddenSuggestionIds.has(suggestion.localId)), [
        fullSuggestionList,
        hiddenSuggestionIds
    ]);
    const hideSuggestion = (0, $gwFzn.useCallback)((id)=>{
        setHiddenSuggestionIds((set)=>new Set(set).add(id));
    }, []);
    const reset = (0, $gwFzn.useCallback)(()=>{
        setFullSuggestionList([]);
        setHiddenSuggestionIds(new Set());
        streamedIssueCount.current = 0;
    }, []);
    const addSuggestion = (0, $gwFzn.useCallback)((suggestion)=>{
        setFullSuggestionList((suggestions)=>[
                ...suggestions,
                {
                    ...suggestion,
                    localId: (0, $9HkI0.v4)()
                }
            ]);
    }, []);
    const updateSuggestions = (0, $gwFzn.useCallback)((newSuggestionList)=>{
        while(streamedIssueCount.current < newSuggestionList.length){
            addSuggestion(newSuggestionList[streamedIssueCount.current]);
            streamedIssueCount.current++;
        }
    }, [
        addSuggestion
    ]);
    return {
        fullSuggestionList: fullSuggestionList,
        suggestions: suggestions,
        hideSuggestion: hideSuggestion,
        updateSuggestions: updateSuggestions,
        reset: reset
    };
};

});

parcelRegister("9ZanP", function(module, exports) {

$parcel$export(module.exports, "isWhitelistedSLOError", () => $9518a1ee412d4b03$export$4177e9b841c72d1e);
$parcel$export(module.exports, "useStreaming", () => $9518a1ee412d4b03$export$734279c1f8caf5b9);

var $gwFzn = parcelRequire("gwFzn");

var $93WqG = parcelRequire("93WqG");
var $kAaxz = parcelRequire("kAaxz");
var $d3UlG = parcelRequire("d3UlG");
const $9518a1ee412d4b03$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $93WqG.ConvoAIErrorMessage).NOT_FOUND,
        (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $9518a1ee412d4b03$export$734279c1f8caf5b9 = ({ analyticsContext: analyticsContext, issueConfig: issueConfig, streamingProps: streamingProps, requestHeaderOverrides: requestHeaderOverrides, onSuggestionStreamUpdated: onSuggestionStreamUpdated, onStreamError: onStreamError, onStreamInit: onStreamInit, onStreamAbortedByInitNew: onStreamAbortedByInitNew })=>{
    const [isStreaming, setIsStreaming] = (0, $gwFzn.useState)(false);
    const [isInitiating, setIsInitiating] = (0, $gwFzn.useState)(true);
    const prevResponseState = (0, $gwFzn.useRef)(null);
    const streamCountRef = (0, $gwFzn.useRef)(0);
    const getIsStreamingRef = (0, $gwFzn.useRef)(()=>false);
    getIsStreamingRef.current = ()=>isStreaming;
    const streamingRequest = (0, $gwFzn.useMemo)(()=>({
            ai_feature_input: {
                ...streamingProps.input,
                suggested_issues_config: issueConfig
            }
        }), [
        issueConfig,
        streamingProps.input
    ]);
    const streamingConfig = (0, $gwFzn.useMemo)(()=>({
            apiPath: `v2/ai-feature/jira/issue/source-type/${streamingProps.sourceType}/suggestions/stream`,
            enablePartialJson: true,
            enableFollowUp: false,
            headers: {
                'x-experience-id': streamingProps.experienceId,
                'x-product': requestHeaderOverrides?.overrideXProduct ?? analyticsContext.product,
                'x-channel-id': streamingProps?.channelId
            }
        }), [
        analyticsContext.product,
        streamingProps.experienceId,
        streamingProps.sourceType,
        requestHeaderOverrides?.overrideXProduct,
        streamingProps?.channelId
    ]);
    const onStateChange = (0, $gwFzn.useCallback)((state)=>{
        if (prevResponseState.current !== state.responseState) {
            if (state.responseState === (0, $kAaxz.ConvoAIResponseState).Initialization) {
                if (isStreaming) onStreamAbortedByInitNew();
                onStreamInit(streamCountRef.current); // argument is "retryCount", so before self-increment
                setIsStreaming(true);
                if (isInitiating) setIsInitiating(false);
                streamCountRef.current++;
            }
            prevResponseState.current = state.responseState;
        }
        if (!isStreaming) return;
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                {
                    const fullyFormedIssues = state.content?.suggested_issues?.slice?.(0, -1) ?? [];
                    onSuggestionStreamUpdated(fullyFormedIssues);
                    break;
                }
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                setIsStreaming(false);
                // builds kept failing when using ConvoAIErrorMessage.SOME_ERROR
                // fixed by typecasting as ConvoAIErrorMessage
                if (!('suggested_issues' in state.content)) {
                    // if there are are no suggested_issues, it's potentially due to bad json
                    // log as an unexpected error as we are unsure if this pops up in ConvoAI
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'UNEXPECTED',
                            content: `Bad JSON: ${Object.keys(state.content).toString()}`,
                            status_code: 500
                        }
                    });
                    break;
                }
                if (state.content?.suggested_issues.length === 0) {
                    // no child issue information came back from the LLM
                    // we clasify this as a not engouh information error
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'NOT_ENOUGH_CONTENT_ERROR',
                            content: 'Not enough content to generate work items from Confluence link.',
                            status_code: 400
                        }
                    });
                    break;
                }
                onSuggestionStreamUpdated(state.content?.suggested_issues);
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                setIsStreaming(false);
                onStreamError(state.error);
                break;
            default:
        }
    }, [
        onSuggestionStreamUpdated,
        onStreamError,
        isStreaming,
        isInitiating,
        onStreamAbortedByInitNew,
        onStreamInit
    ]);
    const [_, refetch] = (0, $d3UlG.useConvoAIStreaming)(streamingRequest, streamingConfig, onStateChange);
    const reset = (0, $gwFzn.useCallback)(()=>{
        setIsStreaming(false);
    }, []);
    return {
        isInitiating: isInitiating,
        isStreaming: isStreaming,
        getIsStreamingRef: getIsStreamingRef,
        refetch: refetch,
        reset: reset
    };
};

});
parcelRegister("93WqG", function(module, exports) {

$parcel$export(module.exports, "ConvoAIErrorMessage", () => $855f7e526aba7e75$export$cb6667e6b65615);
$parcel$export(module.exports, "CONVOAI_DEFAULT_ERROR_CODE", () => $855f7e526aba7e75$export$26a36d98cab4996b);
var $855f7e526aba7e75$export$cb6667e6b65615 = /*#__PURE__*/ function(ConvoAIErrorMessage) {
    ConvoAIErrorMessage["RATE_LIMIT"] = "RATE_LIMIT";
    ConvoAIErrorMessage["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "ANSWER_UNAVAILABLE_FOR_CONTENT";
    ConvoAIErrorMessage["ACCEPTABLE_USE_VIOLATIONS"] = "ACCEPTABLE_USE_VIOLATIONS";
    ConvoAIErrorMessage["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    ConvoAIErrorMessage["NOT_FOUND"] = "NOT_FOUND";
    ConvoAIErrorMessage["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ConvoAIErrorMessage["BAD_REQUEST"] = "BAD_REQUEST";
    ConvoAIErrorMessage["UNEXPECTED"] = "UNEXPECTED";
    ConvoAIErrorMessage["TIMEOUT"] = "TIMEOUT";
    return ConvoAIErrorMessage;
}({});
const $855f7e526aba7e75$export$26a36d98cab4996b = 0;

});

parcelRegister("kAaxz", function(module, exports) {

$parcel$export(module.exports, "ConvoAIResponseState", () => $a6056237f8f2f3cc$export$5ad15ff4d6b74b3f);
$parcel$export(module.exports, "getDefaultConvoAIStreamingState", () => $a6056237f8f2f3cc$export$c25f824513be9f8a);
var $a6056237f8f2f3cc$export$5ad15ff4d6b74b3f = /*#__PURE__*/ function(ConvoAIResponseState) {
    ConvoAIResponseState["Initialization"] = "Initialization";
    ConvoAIResponseState["ChannelId"] = "ChannelId";
    ConvoAIResponseState["AnswerPart"] = "AnswerPart";
    ConvoAIResponseState["FinalResponse"] = "FinalResponse";
    ConvoAIResponseState["FollowUp"] = "FollowUp";
    ConvoAIResponseState["Error"] = "Error";
    return ConvoAIResponseState;
}({});
function $a6056237f8f2f3cc$export$c25f824513be9f8a() {
    return {
        content: null,
        responseState: "Initialization"
    };
}

});

parcelRegister("d3UlG", function(module, exports) {

$parcel$export(module.exports, "useConvoAIStreaming", () => $d7c3e272b37735b1$export$d6e2ae1e990d7e71);

var $gwFzn = parcelRequire("gwFzn");

var $3CH4j = parcelRequire("3CH4j");

var $iIEgX = parcelRequire("iIEgX");
var $6yCLg = parcelRequire("6yCLg");

var $cPtvM = parcelRequire("cPtvM");

var $kAaxz = parcelRequire("kAaxz");
function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $gwFzn.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $3CH4j.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $gwFzn.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}

});
parcelRegister("iIEgX", function(module, exports) {

$parcel$export(module.exports, "useObservableEffect", () => $5805e7f3f1b14b04$export$42102e336cc49836);

var $gwFzn = parcelRequire("gwFzn");

var $cC77I = parcelRequire("cC77I");
function $5805e7f3f1b14b04$export$42102e336cc49836(onObservableInit, inputs) {
    const [inputSubject$] = (0, $gwFzn.useState)(()=>new (0, $cC77I.Subject)());
    const [observable$] = (0, $gwFzn.useState)(()=>onObservableInit(inputSubject$));
    (0, $gwFzn.useEffect)(()=>{
        const subscription$ = observable$.subscribe();
        return ()=>{
            subscription$.unsubscribe();
        };
    }, [
        observable$
    ]);
    const callback = (0, $gwFzn.useCallback)((nextState)=>inputSubject$.next(nextState), [
        inputSubject$
    ]);
    (0, $gwFzn.useEffect)(()=>{
        inputSubject$.next(inputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        callback
    ];
}

});

parcelRegister("6yCLg", function(module, exports) {

$parcel$export(module.exports, "useStatefulObservableEffect", () => $725c584c19c66c44$export$916f6bbdfa1987d0);

var $gwFzn = parcelRequire("gwFzn");

var $aXpOY = parcelRequire("aXpOY");
function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $gwFzn.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}

});
parcelRegister("aXpOY", function(module, exports) {

$parcel$export(module.exports, "useStatefulObservableLazyEffect", () => $e8269ad00759219d$export$7e63706be514842f);

var $gwFzn = parcelRequire("gwFzn");

var $eH9u1 = parcelRequire("eH9u1");

var $cC77I = parcelRequire("cC77I");
function $e8269ad00759219d$export$7e63706be514842f(onObservableInit, initialState) {
    const [inputSubject$] = (0, $gwFzn.useState)(()=>new (0, $cC77I.Subject)());
    const [observable$] = (0, $gwFzn.useState)(()=>onObservableInit(inputSubject$));
    const stateSnapshot = (0, $gwFzn.useRef)(initialState);
    const subscribe = (0, $gwFzn.useCallback)((handleStoreChange)=>{
        const subscription = observable$.subscribe({
            next: (nextState)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(nextState, stateSnapshot.current)) {
                    stateSnapshot.current = nextState;
                    handleStoreChange();
                }
            },
            // eslint-disable-next-line no-console
            error: (err)=>console.error(err),
            complete: ()=>inputSubject$.complete()
        });
        return ()=>subscription.unsubscribe();
    }, [
        inputSubject$,
        observable$
    ]);
    const getSnapshot = (0, $gwFzn.useCallback)(()=>{
        return stateSnapshot.current;
    }, [
        stateSnapshot
    ]);
    const callback = (0, $gwFzn.useCallback)((nextState)=>{
        inputSubject$.next(nextState);
    }, [
        inputSubject$
    ]);
    const state = (0, $gwFzn.useSyncExternalStore)(subscribe, getSnapshot);
    return [
        state,
        callback
    ];
}

});


parcelRegister("cPtvM", function(module, exports) {

$parcel$export(module.exports, "convoAIStreamingEffect", () => $00c22fcadb546387$export$a0d56a856e9914d2);

var $eH9u1 = parcelRequire("eH9u1");

var $guQFZ = parcelRequire("guQFZ");

var $2C39U = parcelRequire("2C39U");

var $eJ5lO = parcelRequire("eJ5lO");

var $4iZtC = parcelRequire("4iZtC");

var $7CiAC = parcelRequire("7CiAC");

var $2HUA6 = parcelRequire("2HUA6");

var $eByKY = parcelRequire("eByKY");

var $69nRD = parcelRequire("69nRD");

var $kkxph = parcelRequire("kkxph");

var $8EEqM = parcelRequire("8EEqM");

var $bTavj = parcelRequire("bTavj");

var $93WqG = parcelRequire("93WqG");

var $bmfL4 = parcelRequire("bmfL4");

var $i66k0 = parcelRequire("i66k0");

var $LzBwp = parcelRequire("LzBwp");

var $2864f = parcelRequire("2864f");

var $aOfhe = parcelRequire("aOfhe");

var $kAaxz = parcelRequire("kAaxz");
function $00c22fcadb546387$export$a0d56a856e9914d2(input$) {
    return input$.pipe((0, $69nRD.skipWhile)(({ inputs: [_, { skip: skip }] })=>!!skip), (0, $7CiAC.distinctUntilChanged)(({ inputs: [prevRequest, prevConfig, prevRefetchId] }, { inputs: [nextRequest, nextConfig, nextRefetchId] })=>(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(prevRequest, nextRequest) && (0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(prevConfig, nextConfig) && prevRefetchId === nextRefetchId), (0, $eByKY.map)(({ inputs: [request, config] })=>({
            config: (0, $i66k0.getDefaultConvoAIConfigWithUserSettings)(config),
            request: request
        })), (0, $eByKY.map)(({ request: request, config: config })=>({
            requestConfig: (0, $bmfL4.createConvoAIRequestConfig)(request, config),
            config: config
        })), (0, $kkxph.switchMap)(({ requestConfig: requestConfig, config: config })=>{
        (0, $aOfhe.logConvoAIInfo)('pre request data', config, requestConfig);
        let $request = (0, $LzBwp.makeConvoAIStreamRequest)(requestConfig);
        if (config.timeoutDelay) return $request.pipe((0, $bTavj.timeout)(config.timeoutDelay), (0, $eByKY.map)((state)=>({
                config: config,
                state: state
            })));
        return $request.pipe((0, $eByKY.map)((state)=>({
                config: config,
                state: state
            })));
    }))// pipe() has an apparent limit of 9 operators
    // https://github.com/ReactiveX/rxjs/issues/4221#issuecomment-426774631
    .pipe((0, $2HUA6.filter)(({ config: config, state: state })=>!(!config.enableFollowUp && state.responseState === (0, $kAaxz.ConvoAIResponseState).FollowUp)), (0, $eByKY.map)(({ config: config, state: state })=>{
        (0, $aOfhe.logConvoAIInfo)('response data', config, state);
        const nextState = (0, $2864f.parsePartialConvoAIJsonIfNeeded)(state, config);
        (0, $aOfhe.logConvoAIInfo)('post json parsing content', config, state);
        return {
            state: nextState,
            config: config
        };
    }), (0, $8EEqM.timeInterval)(), (0, $eJ5lO.concatMap)(({ value: { state: state, config: config }, interval: interval })=>{
        if (!config.delayChunkUpdate) return (0, $guQFZ.of)(state);
        const { time: time, gap: gap } = config.delayChunkUpdate;
        if (interval < gap) return (0, $guQFZ.of)(state).pipe((0, $4iZtC.delay)(time));
        return (0, $guQFZ.of)(state);
    }), (0, $2C39U.catchError)((error)=>{
        if (error.name === 'TimeoutError') {
            const timeoutErrorState = {
                responseState: (0, $kAaxz.ConvoAIResponseState).Error,
                content: null,
                answerChunkIndex: undefined,
                error: {
                    type: 'ERROR',
                    message: {
                        content: error.message,
                        message_template: (0, $93WqG.ConvoAIErrorMessage).TIMEOUT,
                        status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
                    }
                }
            };
            return (0, $guQFZ.of)(timeoutErrorState);
        }
        const unexpectedErrorState = {
            responseState: (0, $kAaxz.ConvoAIResponseState).Error,
            content: null,
            error: {
                type: 'ERROR',
                message: {
                    content: error.message,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
                }
            }
        };
        return (0, $guQFZ.of)(unexpectedErrorState);
    }));
}

});
parcelRegister("bmfL4", function(module, exports) {

$parcel$export(module.exports, "createConvoAIRequestConfig", () => $616a3b6034357a30$export$39a530c281991f7b);
const $616a3b6034357a30$export$39a530c281991f7b = (request, config)=>{
    const requestInitParams = {
        method: 'POST',
        headers: new Headers({
            ...config.headers
        }),
        body: JSON.stringify(request)
    };
    return {
        requestInitParams: requestInitParams,
        url: `${config.baseUrl}/${config.apiPath}`
    };
};

});

parcelRegister("i66k0", function(module, exports) {

$parcel$export(module.exports, "getDefaultConvoAIConfigWithUserSettings", () => $7087f936648f12b4$export$98f0249d9632eade);

var $iQFRZ = parcelRequire("iQFRZ");

var $gyqrs = parcelRequire("gyqrs");
const $7087f936648f12b4$var$baseUrl = (0, $iQFRZ.Lens).fromNullableProp()('baseUrl', (0, $gyqrs.BASE_STREAM_URL));
const $7087f936648f12b4$var$enablePartialJson = (0, $iQFRZ.Lens).fromNullableProp()('enablePartialJson', false);
const $7087f936648f12b4$var$enableFollowUp = (0, $iQFRZ.Lens).fromNullableProp()('enableFollowUp', false);
const $7087f936648f12b4$var$enableLocalVerboseLogs = (0, $iQFRZ.Lens).fromNullableProp()('enableLocalVerboseLogs', false);
const $7087f936648f12b4$var$skip = (0, $iQFRZ.Lens).fromNullableProp()('skip', false);
const $7087f936648f12b4$var$contentType = (0, $iQFRZ.Lens).fromNullableProp()('content-type', 'application/json;charset=UTF-8');
const $7087f936648f12b4$var$xIssyntheticTraffic = (0, $iQFRZ.Lens).fromNullableProp()('x-issynthetic-traffic', 'false');
function $7087f936648f12b4$var$getHeaders(config) {
    const headers = {
        'content-type': $7087f936648f12b4$var$contentType.get(config.headers),
        'x-product': config.headers['x-product'],
        'x-experience-id': config.headers['x-experience-id'],
        'x-issynthetic-traffic': $7087f936648f12b4$var$xIssyntheticTraffic.get(config.headers)
    };
    if (config.headers['x-channel-id']) headers['x-channel-id'] = config.headers['x-channel-id'];
    return headers;
}
const $7087f936648f12b4$export$98f0249d9632eade = (config)=>({
        baseUrl: $7087f936648f12b4$var$baseUrl.get(config),
        apiPath: config.apiPath,
        enablePartialJson: $7087f936648f12b4$var$enablePartialJson.get(config),
        enableFollowUp: $7087f936648f12b4$var$enableFollowUp.get(config),
        enableLocalVerboseLogs: $7087f936648f12b4$var$enableLocalVerboseLogs.get(config),
        timeoutDelay: config.timeoutDelay,
        skip: $7087f936648f12b4$var$skip.get(config),
        headers: $7087f936648f12b4$var$getHeaders(config)
    });

});
parcelRegister("iQFRZ", function(module, exports) {

$parcel$export(module.exports, "Lens", () => Lens);
/**
 * @since 1.0.0
 */ 
var $cgdoB = parcelRequire("cgdoB");

var $fFgN5 = parcelRequire("fFgN5");

var $72EOc = parcelRequire("72EOc");

var $1Te5W = parcelRequire("1Te5W");

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $4O2fb = parcelRequire("4O2fb");

var $5kHfR = parcelRequire("5kHfR");

var $2oRqE = parcelRequire("2oRqE");

var $40vng = parcelRequire("40vng");

var $43LA8 = parcelRequire("43LA8");

var $ftUJ4 = parcelRequire("ftUJ4");

var $7NEBD = parcelRequire("7NEBD");
//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($5kHfR.reverse(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $5kHfR.modify(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($5kHfR.asLens(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($5kHfR.asPrism(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($5kHfR.asOptional(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($5kHfR.asTraversal(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($5kHfR.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $30crt.pipe)(this, $5kHfR.asLens, $40vng.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $30crt.pipe)(this, $5kHfR.asPrism, $ftUJ4.compose(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $5kHfR.asOptional, $43LA8.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $5kHfR.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $30crt.pipe)($40vng.id(), $40vng.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $30crt.pipe)($40vng.id(), $40vng.props.apply($40vng, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $bxsNd.fromNullable)(s[k]);
                if ((0, $bxsNd.isNone)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $40vng.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($40vng.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($40vng.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($40vng.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $40vng.asOptional, $43LA8.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $40vng.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $30crt.pipe)(this, $40vng.compose((0, $30crt.pipe)(ab, $5kHfR.asLens))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($40vng.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($ftUJ4.fromPredicate(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $bxsNd.isNone)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $bxsNd.option).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($ftUJ4.asOptional(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($ftUJ4.asTraversal(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $bxsNd.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($ftUJ4.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $ftUJ4.asOptional, $43LA8.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $ftUJ4.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $30crt.pipe)(this, $ftUJ4.compose((0, $30crt.pipe)(ab, $5kHfR.asPrism))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($ftUJ4.composeLens(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $72EOc.identity), (0, $bxsNd.some));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $bxsNd.fromNullable)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $43LA8.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $43LA8.modifyOption(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($43LA8.asTraversal(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $bxsNd.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($43LA8.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $43LA8.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $43LA8.compose((0, $30crt.pipe)(ab, $40vng.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $43LA8.compose((0, $30crt.pipe)(ab, $ftUJ4.asOptional))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $43LA8.compose((0, $30crt.pipe)(ab, $5kHfR.asOptional))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $7NEBD.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $7NEBD.set(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($7NEBD.filter(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $fFgN5.getApplicative)(M))(function(a) {
                    return (0, $fFgN5.make)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($7NEBD.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $7NEBD.compose((0, $30crt.pipe)(ab, $40vng.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $7NEBD.compose((0, $30crt.pipe)(ab, $ftUJ4.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $7NEBD.compose((0, $30crt.pipe)(ab, $5kHfR.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($4O2fb.fromIso(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($2oRqE.fromAt(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($2oRqE.fromIso(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($cgdoB.getMonoid())($cgdoB.of);
        this.exist = foldMap((0, $1Te5W.monoidAny));
        this.all = foldMap((0, $1Te5W.monoidAll));
        this.foldMapFirst = foldMap((0, $bxsNd.getFirstMonoid)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $bxsNd.fromPredicate)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $72EOc.constant)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $7NEBD.fromTraversable(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});
parcelRegister("cgdoB", function(module, exports) {

$parcel$export(module.exports, "of", () => $8ed15ecb979cdc0d$export$ba255e9e49e00608);
$parcel$export(module.exports, "getMonoid", () => $8ed15ecb979cdc0d$export$c2a7ef2cc9b32b31);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $96Xjv = parcelRequire("96Xjv");

var $8yI6w = parcelRequire("8yI6w");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");

var $3n81G = parcelRequire("3n81G");
var $8ed15ecb979cdc0d$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $8ed15ecb979cdc0d$export$a978c53b4062a525 = $96Xjv.isNonEmpty;
var $8ed15ecb979cdc0d$export$68159836694e22c1 = $96Xjv.prepend;
var $8ed15ecb979cdc0d$export$c4c4d41eab625797 = $96Xjv.prependW;
var $8ed15ecb979cdc0d$export$10d8903dec122b9d = $96Xjv.append;
var $8ed15ecb979cdc0d$export$19903a1bf1942f6 = $96Xjv.appendW;
var $8ed15ecb979cdc0d$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $96Xjv.makeBy(f)(n);
};
var $8ed15ecb979cdc0d$export$606959e7ccb797f0 = function(n, a) {
    return $8ed15ecb979cdc0d$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $8ed15ecb979cdc0d$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $8ed15ecb979cdc0d$export$172ec0a6ebfeb6fa = function(ma) {
    return $EfnK2.isNone(ma) ? [] : [
        ma.value
    ];
};
var $8ed15ecb979cdc0d$export$80c878c9b1d77917 = function(e) {
    return $EfnK2.isLeft(e) ? [] : [
        e.right
    ];
};
var $8ed15ecb979cdc0d$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $8ed15ecb979cdc0d$export$4659b591c19bdf3d = $8ed15ecb979cdc0d$export$2d55ea551c238330;
var $8ed15ecb979cdc0d$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? onNonEmpty($96Xjv.head(as), $96Xjv.tail(as)) : onEmpty();
    };
};
var $8ed15ecb979cdc0d$export$6280271dfaec4919 = $8ed15ecb979cdc0d$export$ebbe93aa91e3abdc;
var $8ed15ecb979cdc0d$export$f3163a37d0ef5927 = $8ed15ecb979cdc0d$export$6280271dfaec4919;
var $8ed15ecb979cdc0d$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? onNonEmpty($96Xjv.init(as), $96Xjv.last(as)) : onEmpty();
    };
};
var $8ed15ecb979cdc0d$export$b1cacb83a5c6bd02 = $8ed15ecb979cdc0d$export$364f7f2cc8473008;
var $8ed15ecb979cdc0d$export$77fa89c00b331c4c = $8ed15ecb979cdc0d$export$b1cacb83a5c6bd02;
var $8ed15ecb979cdc0d$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $8ed15ecb979cdc0d$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $8ed15ecb979cdc0d$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $8ed15ecb979cdc0d$export$346677f925de839c = function(as) {
    return as.length;
};
var $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9 = $96Xjv.isOutOfBound;
var $8ed15ecb979cdc0d$export$dfc7155ac0343b8 = $8yI6w.lookup;
var $8ed15ecb979cdc0d$export$5fd5031fecdacec3 = $8yI6w.head;
var $8ed15ecb979cdc0d$export$4c7897fafd92b108 = $8yI6w.last;
var $8ed15ecb979cdc0d$export$c01875f616615628 = function(as) {
    return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $EfnK2.some($96Xjv.tail(as)) : $EfnK2.none;
};
var $8ed15ecb979cdc0d$export$2cd8252107eb640b = function(as) {
    return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $EfnK2.some($96Xjv.init(as)) : $EfnK2.none;
};
var $8ed15ecb979cdc0d$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(n, as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $8ed15ecb979cdc0d$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(n, as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $8ed15ecb979cdc0d$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $8ed15ecb979cdc0d$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $8ed15ecb979cdc0d$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $8ed15ecb979cdc0d$export$b0d75975ac0be0e1($8ed15ecb979cdc0d$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $8ed15ecb979cdc0d$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $8ed15ecb979cdc0d$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $8ed15ecb979cdc0d$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($8ed15ecb979cdc0d$var$spanLeftIndex(as, predicate));
    };
}
var $8ed15ecb979cdc0d$export$de3a4d4a0d731119 = $8yI6w.findIndex;
function $8ed15ecb979cdc0d$export$9a2f228bed5035c2(predicate) {
    return $8yI6w.findFirst(predicate);
}
var $8ed15ecb979cdc0d$export$a86c11c94d794a95 = $8yI6w.findFirstMap;
function $8ed15ecb979cdc0d$export$296de88ccac4bedb(predicate) {
    return $8yI6w.findLast(predicate);
}
var $8ed15ecb979cdc0d$export$8b5e6d6ad82284fa = $8yI6w.findLastMap;
var $8ed15ecb979cdc0d$export$8855a8be7bd3e9f8 = $8yI6w.findLastIndex;
var $8ed15ecb979cdc0d$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $8ed15ecb979cdc0d$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($8ed15ecb979cdc0d$export$f4863e1822a1860c(i, a, as));
    };
};
var $8ed15ecb979cdc0d$export$b6d8713d53419d4c = function(i, a) {
    return $8ed15ecb979cdc0d$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $8ed15ecb979cdc0d$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($8ed15ecb979cdc0d$export$4937fde8dfc38dbd(i, as));
    };
};
var $8ed15ecb979cdc0d$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($8ed15ecb979cdc0d$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $8ed15ecb979cdc0d$export$66c1ae025e96b4bc = function(as) {
    return $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $8ed15ecb979cdc0d$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $8ed15ecb979cdc0d$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $8ed15ecb979cdc0d$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $8ed15ecb979cdc0d$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $8ed15ecb979cdc0d$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $8ed15ecb979cdc0d$export$8901015135f2fb22(bs, as);
    };
    return $8ed15ecb979cdc0d$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $8ed15ecb979cdc0d$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $8ed15ecb979cdc0d$export$849c7567cbd62acc = function(middle) {
    var f = $96Xjv.prependAll(middle);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $8ed15ecb979cdc0d$export$af200dcf8b7cb5de = function(middle) {
    var f = $96Xjv.intersperse(middle);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$bb628a54ab399bc9 = function(n) {
    var f = $96Xjv.rotate(n);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$5bf96401662340b7 = $8yI6w.elem;
var $8ed15ecb979cdc0d$export$f70730c3d1fc524e = function(E) {
    var f = $96Xjv.uniq(E);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$b035e44d7bb4278f = function(ords) {
    var f = $96Xjv.sortBy(ords);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$433fe05b12ba833f = function(f) {
    var g = $96Xjv.chop(f);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $8ed15ecb979cdc0d$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $96Xjv.splitAt(n)(as) : $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? [
            $8ed15ecb979cdc0d$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $8ed15ecb979cdc0d$export$784d13d8ee351f07(as)
        ];
    };
};
var $8ed15ecb979cdc0d$export$2f0184d5df52135f = function(n) {
    var f = $96Xjv.chunksOf(n);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $8ed15ecb979cdc0d$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $8ed15ecb979cdc0d$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $8ed15ecb979cdc0d$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(input) ? $8ed15ecb979cdc0d$export$5b8affa63fc6df16($96Xjv.head(input), function(a) {
            return go((0, $72EOc.pipe)(scope, $8ed15ecb979cdc0d$export$10d8903dec122b9d(a)), $96Xjv.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $8ed15ecb979cdc0d$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(first) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(second) : $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(second) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $8ed15ecb979cdc0d$export$ee1b3e54f0441b22 = $8ed15ecb979cdc0d$export$c8c959650bbe80e2;
function $8ed15ecb979cdc0d$export$971dd5b0dfd021b6(E) {
    var unionE = $96Xjv.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $8ed15ecb979cdc0d$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(first) && $8ed15ecb979cdc0d$export$a978c53b4062a525(second) ? unionE(second)(first) : $8ed15ecb979cdc0d$export$a978c53b4062a525(first) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(first) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(second);
    };
}
function $8ed15ecb979cdc0d$export$bc86dfbf7795668c(E) {
    var elemE = $8ed15ecb979cdc0d$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $8ed15ecb979cdc0d$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $8ed15ecb979cdc0d$export$acaf96a27438246b(E) {
    var elemE = $8ed15ecb979cdc0d$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $8ed15ecb979cdc0d$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $8ed15ecb979cdc0d$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$8f07ddce13659f50(f));
};
var $8ed15ecb979cdc0d$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $8ed15ecb979cdc0d$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filter = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filterMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partition = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partitionMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$228be17d80722ab(that));
};
var $8ed15ecb979cdc0d$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_foldMap = function(M) {
    var foldMapM = $8ed15ecb979cdc0d$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $8ed15ecb979cdc0d$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filterMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_extend = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_traverse = function(F) {
    var traverseF = $8ed15ecb979cdc0d$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $8ed15ecb979cdc0d$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $8ed15ecb979cdc0d$var$_chainRecDepthFirst = $8yI6w._chainRecDepthFirst;
var $8ed15ecb979cdc0d$var$_chainRecBreadthFirst = $8yI6w._chainRecBreadthFirst;
var $8ed15ecb979cdc0d$export$ba255e9e49e00608 = $96Xjv.of;
var $8ed15ecb979cdc0d$export$7f9972325ebfd559 = function() {
    return [];
};
var $8ed15ecb979cdc0d$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $8ed15ecb979cdc0d$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $8ed15ecb979cdc0d$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$871de8747c9eaa88(f));
    });
};
var $8ed15ecb979cdc0d$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $8ed15ecb979cdc0d$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $8ed15ecb979cdc0d$export$bffa455ba8c619a6 = /*#__PURE__*/ $8ed15ecb979cdc0d$export$5b8affa63fc6df16((0, $72EOc.identity));
var $8ed15ecb979cdc0d$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $8ed15ecb979cdc0d$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($EfnK2.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $8ed15ecb979cdc0d$export$a04c6c6965dd4709 = function(f) {
    return $8ed15ecb979cdc0d$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $8ed15ecb979cdc0d$export$8e16b83750b44988 = /*#__PURE__*/ $8ed15ecb979cdc0d$export$a04c6c6965dd4709((0, $72EOc.identity));
var $8ed15ecb979cdc0d$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $1HSKK.separated)(left, right);
};
var $8ed15ecb979cdc0d$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $8ed15ecb979cdc0d$export$b29f828819edca8d = function(predicate) {
    return $8ed15ecb979cdc0d$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $8ed15ecb979cdc0d$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $8ed15ecb979cdc0d$export$3117e3f9ececb6bc = function(f) {
    return $8ed15ecb979cdc0d$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $8ed15ecb979cdc0d$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $8ed15ecb979cdc0d$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $8ed15ecb979cdc0d$export$228be17d80722ab = $8ed15ecb979cdc0d$export$1517cca7889d6aaa;
var $8ed15ecb979cdc0d$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $8ed15ecb979cdc0d$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $8ed15ecb979cdc0d$export$ecd5e8ace626722c = /*#__PURE__*/ $8ed15ecb979cdc0d$export$8b58be045bf06082((0, $72EOc.identity));
var $8ed15ecb979cdc0d$export$b66cdc0497d8a99a = $8yI6w.foldMap;
var $8ed15ecb979cdc0d$export$18153bb1181268e5 = $8yI6w.foldMapWithIndex;
var $8ed15ecb979cdc0d$export$533b26079ad0b4b = $8yI6w.reduce;
var $8ed15ecb979cdc0d$export$bbd3ef8720e22369 = $8yI6w.reduceWithIndex;
var $8ed15ecb979cdc0d$export$7fef8bcdbb34f435 = $8yI6w.reduceRight;
var $8ed15ecb979cdc0d$export$ce2b2fe0b88ccd0a = $8yI6w.reduceRightWithIndex;
var $8ed15ecb979cdc0d$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $8ed15ecb979cdc0d$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $8ed15ecb979cdc0d$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $8ed15ecb979cdc0d$var$_reduce(ta, F.of($8ed15ecb979cdc0d$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $72EOc.pipe)(as, $8ed15ecb979cdc0d$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $8ed15ecb979cdc0d$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $8ed15ecb979cdc0d$export$bbd3ef8720e22369(F.of($8ed15ecb979cdc0d$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $8ed15ecb979cdc0d$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $8ed15ecb979cdc0d$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $8ed15ecb979cdc0d$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $8ed15ecb979cdc0d$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $8ed15ecb979cdc0d$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $8ed15ecb979cdc0d$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($EfnK2.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $8ed15ecb979cdc0d$export$9156e739aa33e19f = 'Array';
var $8ed15ecb979cdc0d$export$3cb5cd7f7776c81 = $8yI6w.getShow;
var $8ed15ecb979cdc0d$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $8ed15ecb979cdc0d$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $8ed15ecb979cdc0d$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $8ed15ecb979cdc0d$export$804fed467fde44e4 = $8yI6w.getEq;
var $8ed15ecb979cdc0d$export$1af51209b1b91d07 = $8yI6w.getOrd;
var $8ed15ecb979cdc0d$export$baca17b4aff42f82 = function(E) {
    var unionE = $8ed15ecb979cdc0d$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $8ed15ecb979cdc0d$export$c487aac9f4157837 = function(E) {
    return {
        concat: $8ed15ecb979cdc0d$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $8ed15ecb979cdc0d$export$d379a869a72e4055 = function(E) {
    var intersectionE = $8ed15ecb979cdc0d$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $8ed15ecb979cdc0d$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $8ed15ecb979cdc0d$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map
};
var $8ed15ecb979cdc0d$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61);
var $8ed15ecb979cdc0d$export$59a71046037e6c20 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608
};
var $8ed15ecb979cdc0d$export$9fdffe0fe1e91cad = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex
};
var $8ed15ecb979cdc0d$export$efc21ddc6aeb363d = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap
};
var $8ed15ecb979cdc0d$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($8ed15ecb979cdc0d$export$efc21ddc6aeb363d);
var $8ed15ecb979cdc0d$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($8ed15ecb979cdc0d$export$efc21ddc6aeb363d);
var $8ed15ecb979cdc0d$export$1279d2b7807629fd = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608
};
var $8ed15ecb979cdc0d$export$f18d5acc27d70423 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16
};
var $8ed15ecb979cdc0d$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($8ed15ecb979cdc0d$export$f18d5acc27d70423);
var $8ed15ecb979cdc0d$export$fb641926d034ac7d = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16
};
var $8ed15ecb979cdc0d$export$8fa953f00d3b093 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    unfold: $8ed15ecb979cdc0d$export$c48e357c1a89b78d
};
var $8ed15ecb979cdc0d$export$25ba4469a069167 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    alt: $8ed15ecb979cdc0d$var$_alt
};
var $8ed15ecb979cdc0d$export$aaef8a3eae948f03 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    zero: $8ed15ecb979cdc0d$export$7f9972325ebfd559
};
var $8ed15ecb979cdc0d$export$864d727b48066337 = /*#__PURE__*/ (0, $3n81G.guard)($8ed15ecb979cdc0d$export$aaef8a3eae948f03, $8ed15ecb979cdc0d$export$59a71046037e6c20);
var $8ed15ecb979cdc0d$export$4acb47accde578d2 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608,
    alt: $8ed15ecb979cdc0d$var$_alt,
    zero: $8ed15ecb979cdc0d$export$7f9972325ebfd559
};
var $8ed15ecb979cdc0d$export$5b5dd0e212d2a5bc = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    extend: $8ed15ecb979cdc0d$var$_extend
};
var $8ed15ecb979cdc0d$export$4a21ac48141ac3c9 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408
};
var $8ed15ecb979cdc0d$export$d00e1c48fb621173 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap
};
var $8ed15ecb979cdc0d$export$c29a647071e542ec = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap,
    partitionMapWithIndex: $8ed15ecb979cdc0d$var$_partitionMapWithIndex,
    partitionWithIndex: $8ed15ecb979cdc0d$var$_partitionWithIndex,
    filterMapWithIndex: $8ed15ecb979cdc0d$var$_filterMapWithIndex,
    filterWithIndex: $8ed15ecb979cdc0d$var$_filterWithIndex
};
var $8ed15ecb979cdc0d$export$41404b31838667c9 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight
};
var $8ed15ecb979cdc0d$export$e8f7d17aaff345cb = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    reduceWithIndex: $8ed15ecb979cdc0d$var$_reduceWithIndex,
    foldMapWithIndex: $8ed15ecb979cdc0d$var$_foldMapWithIndex,
    reduceRightWithIndex: $8ed15ecb979cdc0d$var$_reduceRightWithIndex
};
var $8ed15ecb979cdc0d$export$a0202666c3bda011 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039
};
var $8ed15ecb979cdc0d$export$bd7b528d8c36ec41 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    reduceWithIndex: $8ed15ecb979cdc0d$var$_reduceWithIndex,
    foldMapWithIndex: $8ed15ecb979cdc0d$var$_foldMapWithIndex,
    reduceRightWithIndex: $8ed15ecb979cdc0d$var$_reduceRightWithIndex,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039,
    traverseWithIndex: $8ed15ecb979cdc0d$var$_traverseWithIndex
};
var $8ed15ecb979cdc0d$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($8ed15ecb979cdc0d$export$a0202666c3bda011, $8ed15ecb979cdc0d$export$4a21ac48141ac3c9);
var $8ed15ecb979cdc0d$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($8ed15ecb979cdc0d$export$a0202666c3bda011, $8ed15ecb979cdc0d$export$4a21ac48141ac3c9);
var $8ed15ecb979cdc0d$export$748d317b4c426f96 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039,
    wither: $8ed15ecb979cdc0d$var$_wither,
    wilt: $8ed15ecb979cdc0d$var$_wilt
};
var $8ed15ecb979cdc0d$export$f855115a79f70c1a = $8yI6w.chainRecDepthFirst;
var $8ed15ecb979cdc0d$export$7d808dfaa6d54634 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16,
    chainRec: $8ed15ecb979cdc0d$var$_chainRecDepthFirst
};
var $8ed15ecb979cdc0d$export$bffee57bb00a6859 = $8yI6w.chainRecBreadthFirst;
var $8ed15ecb979cdc0d$export$57f3a385c7e59628 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16,
    chainRec: $8ed15ecb979cdc0d$var$_chainRecBreadthFirst
};
var $8ed15ecb979cdc0d$export$c40604f35db61519 = /*#__PURE__*/ (0, $jNYdc.filterE)($8ed15ecb979cdc0d$export$748d317b4c426f96);
var $8ed15ecb979cdc0d$export$825ea6cb6fc48d49 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    fromEither: $8ed15ecb979cdc0d$export$80c878c9b1d77917
};
var $8ed15ecb979cdc0d$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $jFfj2.fromEitherK)($8ed15ecb979cdc0d$export$825ea6cb6fc48d49);
var $8ed15ecb979cdc0d$export$f4863e1822a1860c = $96Xjv.unsafeInsertAt;
var $8ed15ecb979cdc0d$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $96Xjv.unsafeUpdateAt(i, a, as) : [];
};
var $8ed15ecb979cdc0d$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $8ed15ecb979cdc0d$export$7ecc1a3b11b57dab = $8yI6w.every;
var $8ed15ecb979cdc0d$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $8ed15ecb979cdc0d$export$f7e9f41ea797a17 = $8ed15ecb979cdc0d$export$ad14ef4001db2bcd;
var $8ed15ecb979cdc0d$export$739ec22334c44788 = $8yI6w.intercalate;
var $8ed15ecb979cdc0d$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $8ed15ecb979cdc0d$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $8ed15ecb979cdc0d$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61);
var $8ed15ecb979cdc0d$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61);
var $8ed15ecb979cdc0d$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($8ed15ecb979cdc0d$export$f18d5acc27d70423);
var $8ed15ecb979cdc0d$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($8ed15ecb979cdc0d$export$efc21ddc6aeb363d);
var $8ed15ecb979cdc0d$export$e08e3b67e392101e = $8ed15ecb979cdc0d$export$5b8affa63fc6df16;
var $8ed15ecb979cdc0d$export$d02631cccf789723 = $96Xjv.range;
var $8ed15ecb979cdc0d$export$6e22c362a0406a2c = [];
var $8ed15ecb979cdc0d$export$8327ebbef2a0ba76 = $96Xjv.cons;
var $8ed15ecb979cdc0d$export$c40cf5aab899f397 = $96Xjv.snoc;
var $8ed15ecb979cdc0d$export$baeb00bf1e27e233 = $8ed15ecb979cdc0d$export$849c7567cbd62acc;
var $8ed15ecb979cdc0d$export$2f23118c22fb2630 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex,
    partitionMapWithIndex: $8ed15ecb979cdc0d$var$_partitionMapWithIndex,
    partitionWithIndex: $8ed15ecb979cdc0d$var$_partitionWithIndex,
    filterMapWithIndex: $8ed15ecb979cdc0d$var$_filterMapWithIndex,
    filterWithIndex: $8ed15ecb979cdc0d$var$_filterWithIndex,
    alt: $8ed15ecb979cdc0d$var$_alt,
    zero: $8ed15ecb979cdc0d$export$7f9972325ebfd559,
    unfold: $8ed15ecb979cdc0d$export$c48e357c1a89b78d,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039,
    reduceWithIndex: $8ed15ecb979cdc0d$var$_reduceWithIndex,
    foldMapWithIndex: $8ed15ecb979cdc0d$var$_foldMapWithIndex,
    reduceRightWithIndex: $8ed15ecb979cdc0d$var$_reduceRightWithIndex,
    traverseWithIndex: $8ed15ecb979cdc0d$var$_traverseWithIndex,
    extend: $8ed15ecb979cdc0d$var$_extend,
    wither: $8ed15ecb979cdc0d$var$_wither,
    wilt: $8ed15ecb979cdc0d$var$_wilt
};

});
parcelRegister("aYN4d", function(module, exports) {

$parcel$export(module.exports, "ap", () => $7fe591a84c8a55d0$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "apFirst", () => $7fe591a84c8a55d0$export$5f28d9feedcfd46e);
$parcel$export(module.exports, "apSecond", () => $7fe591a84c8a55d0$export$ed01bc59c3d06bf3);
$parcel$export(module.exports, "apS", () => $7fe591a84c8a55d0$export$8cbfc0239f42bb49);
$parcel$export(module.exports, "getApplySemigroup", () => $7fe591a84c8a55d0$export$18979a515d2a828e);
/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ 
var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");
function $7fe591a84c8a55d0$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $7fe591a84c8a55d0$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $7fe591a84c8a55d0$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $7fe591a84c8a55d0$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $7fe591a84c8a55d0$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $7fe591a84c8a55d0$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $7fe591a84c8a55d0$var$curried(f, n - 1, combined);
    };
}
var $7fe591a84c8a55d0$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $7fe591a84c8a55d0$var$getTupleConstructor(len) {
    if (!$EfnK2.has.call($7fe591a84c8a55d0$var$tupleConstructors, len)) $7fe591a84c8a55d0$var$tupleConstructors[len] = $7fe591a84c8a55d0$var$curried((0, $72EOc.tuple), len - 1, []);
    return $7fe591a84c8a55d0$var$tupleConstructors[len];
}
function $7fe591a84c8a55d0$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $7fe591a84c8a55d0$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $7fe591a84c8a55d0$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $7fe591a84c8a55d0$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $7fe591a84c8a55d0$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $7fe591a84c8a55d0$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

});
parcelRegister("72EOc", function(module, exports) {

$parcel$export(module.exports, "getSemigroup", () => $5208601174ca67ff$export$e759a9a7f8d04692);
$parcel$export(module.exports, "getMonoid", () => $5208601174ca67ff$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "identity", () => $5208601174ca67ff$export$f0954fd7d5368655);
$parcel$export(module.exports, "unsafeCoerce", () => $5208601174ca67ff$export$401372c57776dc);
$parcel$export(module.exports, "constant", () => $5208601174ca67ff$export$c983f826f44ff86);
$parcel$export(module.exports, "constTrue", () => $5208601174ca67ff$export$a68382d9631f6c53);
$parcel$export(module.exports, "constFalse", () => $5208601174ca67ff$export$7349232f2648ca80);
$parcel$export(module.exports, "constNull", () => $5208601174ca67ff$export$243c2ee5e7d8b05c);
$parcel$export(module.exports, "constUndefined", () => $5208601174ca67ff$export$3d16a43570087548);
$parcel$export(module.exports, "flow", () => $5208601174ca67ff$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "tuple", () => $5208601174ca67ff$export$65e3907585753458);
$parcel$export(module.exports, "pipe", () => $5208601174ca67ff$export$a4627e546088548d);
$parcel$export(module.exports, "SK", () => $5208601174ca67ff$export$5f584391ee0d99b4);
$parcel$export(module.exports, "dual", () => $5208601174ca67ff$export$d1699a1bbdf17835);
var $5208601174ca67ff$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $5208601174ca67ff$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $5208601174ca67ff$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $5208601174ca67ff$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $5208601174ca67ff$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $5208601174ca67ff$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $5208601174ca67ff$export$575097c1c561f76f = function(R) {
    var S = $5208601174ca67ff$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $5208601174ca67ff$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $5208601174ca67ff$export$f0954fd7d5368655(a) {
    return a;
}
var $5208601174ca67ff$export$401372c57776dc = $5208601174ca67ff$export$f0954fd7d5368655;
function $5208601174ca67ff$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $5208601174ca67ff$export$a68382d9631f6c53 = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(true);
var $5208601174ca67ff$export$7349232f2648ca80 = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(false);
var $5208601174ca67ff$export$243c2ee5e7d8b05c = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(null);
var $5208601174ca67ff$export$3d16a43570087548 = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(undefined);
var $5208601174ca67ff$export$fe2a8306a887c223 = $5208601174ca67ff$export$3d16a43570087548;
function $5208601174ca67ff$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $5208601174ca67ff$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $5208601174ca67ff$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $5208601174ca67ff$export$a2647aa13413c947(n) {
    return n + 1;
}
function $5208601174ca67ff$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $5208601174ca67ff$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $5208601174ca67ff$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $5208601174ca67ff$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $5208601174ca67ff$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $5208601174ca67ff$export$5cc5fd8bb7edf254 = $5208601174ca67ff$export$f172309911142386;
var $5208601174ca67ff$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $5208601174ca67ff$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $5208601174ca67ff$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $5208601174ca67ff$export$ccc7b0636abaffc3(first, second);
        },
        empty: $5208601174ca67ff$export$f0954fd7d5368655
    };
};
var $5208601174ca67ff$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $5208601174ca67ff$var$__spreadArray([
                self
            ], args, false));
        };
    };
};

});

parcelRegister("EfnK2", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $078fab1278725f43$export$e56af863d5645d5f);
$parcel$export(module.exports, "isSome", () => $078fab1278725f43$export$5d7e502287836e58);
$parcel$export(module.exports, "none", () => $078fab1278725f43$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $078fab1278725f43$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "isLeft", () => $078fab1278725f43$export$d649b6842e09f2b);
$parcel$export(module.exports, "isRight", () => $078fab1278725f43$export$a9d71693f0c1a85d);
$parcel$export(module.exports, "left", () => $078fab1278725f43$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $078fab1278725f43$export$79ffe56a765070d2);
$parcel$export(module.exports, "singleton", () => $078fab1278725f43$export$439306a4dcaafbb9);
$parcel$export(module.exports, "isNonEmpty", () => $078fab1278725f43$export$a978c53b4062a525);
$parcel$export(module.exports, "head", () => $078fab1278725f43$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $078fab1278725f43$export$c01875f616615628);
$parcel$export(module.exports, "emptyReadonlyArray", () => $078fab1278725f43$export$6ca726a2417e0f3f);
$parcel$export(module.exports, "emptyRecord", () => $078fab1278725f43$export$4de80339753b012b);
$parcel$export(module.exports, "has", () => $078fab1278725f43$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "fromReadonlyNonEmptyArray", () => $078fab1278725f43$export$7e77326b0f0e268c);
$parcel$export(module.exports, "liftNullable", () => $078fab1278725f43$export$cd139e14432f317b);
$parcel$export(module.exports, "liftOption", () => $078fab1278725f43$export$ea4a22f93200df79);
$parcel$export(module.exports, "flatMapNullable", () => $078fab1278725f43$export$1a0515933c5c84fe);
$parcel$export(module.exports, "flatMapOption", () => $078fab1278725f43$export$b5f02b7beb8ed7d8);

var $72EOc = parcelRequire("72EOc");
var $078fab1278725f43$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $078fab1278725f43$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $078fab1278725f43$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $078fab1278725f43$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $078fab1278725f43$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $078fab1278725f43$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $078fab1278725f43$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $078fab1278725f43$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $078fab1278725f43$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $078fab1278725f43$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $078fab1278725f43$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $078fab1278725f43$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $078fab1278725f43$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $078fab1278725f43$export$6ca726a2417e0f3f = [];
var $078fab1278725f43$export$4de80339753b012b = {};
var $078fab1278725f43$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $078fab1278725f43$export$7e77326b0f0e268c = function(as) {
    return $078fab1278725f43$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $078fab1278725f43$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $078fab1278725f43$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $078fab1278725f43$export$79ffe56a765070d2(o));
        };
    };
};
var $078fab1278725f43$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($078fab1278725f43$export$e56af863d5645d5f(o) ? $078fab1278725f43$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $078fab1278725f43$export$79ffe56a765070d2(o.value));
        };
    };
};
var $078fab1278725f43$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, $078fab1278725f43$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $078fab1278725f43$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, $078fab1278725f43$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $078fab1278725f43$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $078fab1278725f43$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $078fab1278725f43$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $078fab1278725f43$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};

});


parcelRegister("kgj0x", function(module, exports) {

$parcel$export(module.exports, "chainFirst", () => $ec040bc836e1dc38$export$e3821ef4970c339c);
$parcel$export(module.exports, "tap", () => $ec040bc836e1dc38$export$3f23594af5f37336);
$parcel$export(module.exports, "bind", () => $ec040bc836e1dc38$export$2385a24977818dd0);
function $ec040bc836e1dc38$export$e3821ef4970c339c(M) {
    var tapM = $ec040bc836e1dc38$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $ec040bc836e1dc38$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $ec040bc836e1dc38$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

});

parcelRegister("jFfj2", function(module, exports) {

$parcel$export(module.exports, "fromOption", () => $e50db819b062999e$export$172ec0a6ebfeb6fa);
$parcel$export(module.exports, "fromPredicate", () => $e50db819b062999e$export$23f31c55d7162b91);
$parcel$export(module.exports, "fromOptionK", () => $e50db819b062999e$export$a907462f448b49f8);
$parcel$export(module.exports, "chainOptionK", () => $e50db819b062999e$export$12d26179deb6a68a);
$parcel$export(module.exports, "fromEitherK", () => $e50db819b062999e$export$8138b0ae92c9b5d8);
$parcel$export(module.exports, "chainEitherK", () => $e50db819b062999e$export$a3eef2eba9908c3e);
$parcel$export(module.exports, "tapEither", () => $e50db819b062999e$export$be3ff275bb5a8ac9);
$parcel$export(module.exports, "filterOrElse", () => $e50db819b062999e$export$30af8ca9498ddf5b);
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 
var $kgj0x = parcelRequire("kgj0x");

var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");
function $e50db819b062999e$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($EfnK2.isNone(ma) ? $EfnK2.left(onNone()) : $EfnK2.right(ma.value));
        };
    };
}
function $e50db819b062999e$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $EfnK2.right(a) : $EfnK2.left(onFalse(a)));
        };
    };
}
function $e50db819b062999e$export$a907462f448b49f8(F) {
    var fromOptionF = $e50db819b062999e$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $72EOc.flow)(f, from);
        };
    };
}
function $e50db819b062999e$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $e50db819b062999e$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $e50db819b062999e$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $72EOc.flow)(f, F.fromEither);
    };
}
function $e50db819b062999e$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $e50db819b062999e$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $e50db819b062999e$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $e50db819b062999e$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $e50db819b062999e$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $EfnK2.right(a) : $EfnK2.left(onFalse(a)));
            });
        };
    };
}
function $e50db819b062999e$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $e50db819b062999e$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $kgj0x.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

});

parcelRegister("cpwuW", function(module, exports) {

$parcel$export(module.exports, "flap", () => $90910745238aeb40$export$18c957606d8bdf09);
$parcel$export(module.exports, "bindTo", () => $90910745238aeb40$export$7c052ae73f8acff0);
$parcel$export(module.exports, "let", () => $90910745238aeb40$export$5d537b797c421217);
$parcel$export(module.exports, "getFunctorComposition", () => $90910745238aeb40$export$7b0f6fce42e2b480);
$parcel$export(module.exports, "as", () => $90910745238aeb40$export$6554612db691658e);
$parcel$export(module.exports, "asUnit", () => $90910745238aeb40$export$9284b360ca18a0fd);
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
var $72EOc = parcelRequire("72EOc");
function $90910745238aeb40$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $90910745238aeb40$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $90910745238aeb40$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $90910745238aeb40$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $90910745238aeb40$export$7b0f6fce42e2b480(F, G) {
    var _map = $90910745238aeb40$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $72EOc.pipe)(fga, _map(f));
        }
    };
}
function $90910745238aeb40$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $90910745238aeb40$export$9284b360ca18a0fd(F) {
    var asM = $90910745238aeb40$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}

});

parcelRegister("96Xjv", function(module, exports) {

$parcel$export(module.exports, "isNonEmpty", () => $6a22af06192636c3$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $6a22af06192636c3$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $6a22af06192636c3$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $6a22af06192636c3$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $6a22af06192636c3$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $6a22af06192636c3$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $6a22af06192636c3$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $6a22af06192636c3$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $6a22af06192636c3$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $6a22af06192636c3$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $6a22af06192636c3$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $6a22af06192636c3$export$b035e44d7bb4278f);
$parcel$export(module.exports, "union", () => $6a22af06192636c3$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $6a22af06192636c3$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $6a22af06192636c3$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $6a22af06192636c3$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $6a22af06192636c3$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $6a22af06192636c3$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $6a22af06192636c3$export$4c7897fafd92b108);
$parcel$export(module.exports, "of", () => $6a22af06192636c3$export$ba255e9e49e00608);
$parcel$export(module.exports, "prependAll", () => $6a22af06192636c3$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $6a22af06192636c3$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $6a22af06192636c3$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $6a22af06192636c3$export$2f0184d5df52135f);
$parcel$export(module.exports, "cons", () => $6a22af06192636c3$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $6a22af06192636c3$export$c40cf5aab899f397);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $gcR1C = parcelRequire("gcR1C");

var $ecsM6 = parcelRequire("ecsM6");
var $6a22af06192636c3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6a22af06192636c3$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $6a22af06192636c3$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $6a22af06192636c3$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $6a22af06192636c3$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $6a22af06192636c3$export$68159836694e22c1 = $6a22af06192636c3$export$c4c4d41eab625797;
var $6a22af06192636c3$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $6a22af06192636c3$var$__spreadArray($6a22af06192636c3$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $6a22af06192636c3$export$10d8903dec122b9d = $6a22af06192636c3$export$19903a1bf1942f6;
var $6a22af06192636c3$export$f4863e1822a1860c = function(i, a, as) {
    if ($6a22af06192636c3$export$a978c53b4062a525(as)) {
        var xs = $6a22af06192636c3$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $6a22af06192636c3$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $6a22af06192636c3$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $6a22af06192636c3$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $6a22af06192636c3$export$784d13d8ee351f07(as);
        var out = [
            $6a22af06192636c3$export$5fd5031fecdacec3(as)
        ];
        var rest = $6a22af06192636c3$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $6a22af06192636c3$export$b035e44d7bb4278f = function(ords) {
    if ($6a22af06192636c3$export$a978c53b4062a525(ords)) {
        var M = (0, $gcR1C.getMonoid)();
        return $6a22af06192636c3$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $6a22af06192636c3$export$784d13d8ee351f07;
};
var $6a22af06192636c3$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $6a22af06192636c3$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $72EOc.pipe)(first, $6a22af06192636c3$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $6a22af06192636c3$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($6a22af06192636c3$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $6a22af06192636c3$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $6a22af06192636c3$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $72EOc.pipe)(s, $6a22af06192636c3$export$ee1b3e54f0441b22(f));
        } else return $6a22af06192636c3$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $6a22af06192636c3$export$7e77326b0f0e268c = $EfnK2.fromReadonlyNonEmptyArray;
var $6a22af06192636c3$export$571d59b505e6bb4e = function(as) {
    return $6a22af06192636c3$export$a978c53b4062a525(as) ? $EfnK2.some(as) : $EfnK2.none;
};
var $6a22af06192636c3$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $6a22af06192636c3$export$606959e7ccb797f0 = function(a) {
    return $6a22af06192636c3$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $6a22af06192636c3$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $6a22af06192636c3$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $6a22af06192636c3$export$c04edabe9c8d994f = function(as) {
    return [
        $6a22af06192636c3$export$5fd5031fecdacec3(as),
        $6a22af06192636c3$export$c01875f616615628(as)
    ];
};
var $6a22af06192636c3$export$89a97afc72a83708 = function(as) {
    return [
        $6a22af06192636c3$export$2cd8252107eb640b(as),
        $6a22af06192636c3$export$4c7897fafd92b108(as)
    ];
};
function $6a22af06192636c3$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $6a22af06192636c3$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $6a22af06192636c3$export$66c1ae025e96b4bc = function(as) {
    return $6a22af06192636c3$var$__spreadArray([
        $6a22af06192636c3$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $6a22af06192636c3$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $6a22af06192636c3$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($EfnK2.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $6a22af06192636c3$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $6a22af06192636c3$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($6a22af06192636c3$export$f4863e1822a1860c(i, a, as));
    };
};
var $6a22af06192636c3$export$b6d8713d53419d4c = function(i, a) {
    return $6a22af06192636c3$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $6a22af06192636c3$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $6a22af06192636c3$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($6a22af06192636c3$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $6a22af06192636c3$export$784d13d8ee351f07 = $6a22af06192636c3$export$7e77326b0f0e268c;
var $6a22af06192636c3$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $6a22af06192636c3$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $6a22af06192636c3$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $6a22af06192636c3$export$8901015135f2fb22(bs, as);
    };
    return $6a22af06192636c3$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $6a22af06192636c3$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $6a22af06192636c3$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $6a22af06192636c3$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $6a22af06192636c3$export$c01875f616615628(as);
        return $6a22af06192636c3$export$a978c53b4062a525(rest) ? (0, $72EOc.pipe)(rest, $6a22af06192636c3$export$849c7567cbd62acc(middle), $6a22af06192636c3$export$68159836694e22c1($6a22af06192636c3$export$5fd5031fecdacec3(as))) : $6a22af06192636c3$export$784d13d8ee351f07(as);
    };
};
var $6a22af06192636c3$export$18153bb1181268e5 = $ecsM6.foldMapWithIndex;
var $6a22af06192636c3$export$b66cdc0497d8a99a = $ecsM6.foldMap;
var $6a22af06192636c3$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $6a22af06192636c3$export$7e77326b0f0e268c(f(0, $6a22af06192636c3$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $6a22af06192636c3$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($6a22af06192636c3$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $6a22af06192636c3$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $6a22af06192636c3$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $72EOc.pipe)(as.slice(1, m), $6a22af06192636c3$export$68159836694e22c1($6a22af06192636c3$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $6a22af06192636c3$export$2f0184d5df52135f = function(n) {
    return $6a22af06192636c3$export$433fe05b12ba833f($6a22af06192636c3$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $6a22af06192636c3$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $6a22af06192636c3$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_foldMap = function(M) {
    var foldMapM = $6a22af06192636c3$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_traverse = function(F) {
    var traverseF = $6a22af06192636c3$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $6a22af06192636c3$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $6a22af06192636c3$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $6a22af06192636c3$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $72EOc.pipe)(as, $6a22af06192636c3$export$c8c959650bbe80e2(that()));
    };
};
var $6a22af06192636c3$export$228be17d80722ab = $6a22af06192636c3$export$1517cca7889d6aaa;
var $6a22af06192636c3$export$2f6ca3d3b1f80bf5 = function(as) {
    return $6a22af06192636c3$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(as, $6a22af06192636c3$export$871de8747c9eaa88(f));
    });
};
var $6a22af06192636c3$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $6a22af06192636c3$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $6a22af06192636c3$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $6a22af06192636c3$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($6a22af06192636c3$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $6a22af06192636c3$export$c01875f616615628(next);
        }
        return out;
    };
};
var $6a22af06192636c3$export$ecd5e8ace626722c = /*#__PURE__*/ $6a22af06192636c3$export$8b58be045bf06082((0, $72EOc.identity));
var $6a22af06192636c3$export$bffa455ba8c619a6 = /*#__PURE__*/ $6a22af06192636c3$export$5b8affa63fc6df16((0, $72EOc.identity));
var $6a22af06192636c3$export$871de8747c9eaa88 = function(f) {
    return $6a22af06192636c3$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $6a22af06192636c3$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $6a22af06192636c3$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $6a22af06192636c3$export$533b26079ad0b4b = $ecsM6.reduce;
var $6a22af06192636c3$export$bbd3ef8720e22369 = $ecsM6.reduceWithIndex;
var $6a22af06192636c3$export$7fef8bcdbb34f435 = $ecsM6.reduceRight;
var $6a22af06192636c3$export$ce2b2fe0b88ccd0a = $ecsM6.reduceRightWithIndex;
var $6a22af06192636c3$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $6a22af06192636c3$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $6a22af06192636c3$export$49bb65c2ea163039 = function(F) {
    return $6a22af06192636c3$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $6a22af06192636c3$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $6a22af06192636c3$export$5fd5031fecdacec3(as)), $6a22af06192636c3$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $6a22af06192636c3$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $6a22af06192636c3$export$f9380c9a627682d3 = $ecsM6.head;
var $6a22af06192636c3$export$9156e739aa33e19f = 'NonEmptyArray';
var $6a22af06192636c3$export$3cb5cd7f7776c81 = $ecsM6.getShow;
var $6a22af06192636c3$export$e759a9a7f8d04692 = function() {
    return {
        concat: $6a22af06192636c3$export$ee1b3e54f0441b22
    };
};
var $6a22af06192636c3$export$804fed467fde44e4 = $ecsM6.getEq;
var $6a22af06192636c3$export$baca17b4aff42f82 = function(E) {
    var unionE = $6a22af06192636c3$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $6a22af06192636c3$export$bd5b6bfc5fa2ee61 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map
};
var $6a22af06192636c3$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($6a22af06192636c3$export$bd5b6bfc5fa2ee61);
var $6a22af06192636c3$export$59a71046037e6c20 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    of: $6a22af06192636c3$export$ba255e9e49e00608
};
var $6a22af06192636c3$export$9fdffe0fe1e91cad = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    mapWithIndex: $6a22af06192636c3$var$_mapWithIndex
};
var $6a22af06192636c3$export$efc21ddc6aeb363d = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap
};
var $6a22af06192636c3$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($6a22af06192636c3$export$efc21ddc6aeb363d);
var $6a22af06192636c3$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($6a22af06192636c3$export$efc21ddc6aeb363d);
var $6a22af06192636c3$export$1279d2b7807629fd = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap,
    of: $6a22af06192636c3$export$ba255e9e49e00608
};
var $6a22af06192636c3$export$f18d5acc27d70423 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap,
    chain: $6a22af06192636c3$export$5b8affa63fc6df16
};
var $6a22af06192636c3$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($6a22af06192636c3$export$f18d5acc27d70423);
var $6a22af06192636c3$export$fb641926d034ac7d = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap,
    of: $6a22af06192636c3$export$ba255e9e49e00608,
    chain: $6a22af06192636c3$export$5b8affa63fc6df16
};
var $6a22af06192636c3$export$41404b31838667c9 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight
};
var $6a22af06192636c3$export$e8f7d17aaff345cb = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    reduceWithIndex: $6a22af06192636c3$var$_reduceWithIndex,
    foldMapWithIndex: $6a22af06192636c3$var$_foldMapWithIndex,
    reduceRightWithIndex: $6a22af06192636c3$var$_reduceRightWithIndex
};
var $6a22af06192636c3$export$a0202666c3bda011 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    traverse: $6a22af06192636c3$var$_traverse,
    sequence: $6a22af06192636c3$export$49bb65c2ea163039
};
var $6a22af06192636c3$export$bd7b528d8c36ec41 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    mapWithIndex: $6a22af06192636c3$var$_mapWithIndex,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    traverse: $6a22af06192636c3$var$_traverse,
    sequence: $6a22af06192636c3$export$49bb65c2ea163039,
    reduceWithIndex: $6a22af06192636c3$var$_reduceWithIndex,
    foldMapWithIndex: $6a22af06192636c3$var$_foldMapWithIndex,
    reduceRightWithIndex: $6a22af06192636c3$var$_reduceRightWithIndex,
    traverseWithIndex: $6a22af06192636c3$var$_traverseWithIndex
};
var $6a22af06192636c3$export$25ba4469a069167 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    alt: $6a22af06192636c3$var$_alt
};
var $6a22af06192636c3$export$fdd73124b9f1de36 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    extend: $6a22af06192636c3$var$_extend,
    extract: $6a22af06192636c3$export$f9380c9a627682d3
};
var $6a22af06192636c3$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $6a22af06192636c3$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $6a22af06192636c3$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($6a22af06192636c3$export$bd5b6bfc5fa2ee61);
var $6a22af06192636c3$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($6a22af06192636c3$export$bd5b6bfc5fa2ee61);
var $6a22af06192636c3$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($6a22af06192636c3$export$f18d5acc27d70423);
var $6a22af06192636c3$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($6a22af06192636c3$export$efc21ddc6aeb363d);
var $6a22af06192636c3$export$5fd5031fecdacec3 = $ecsM6.head;
var $6a22af06192636c3$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $6a22af06192636c3$export$4c7897fafd92b108 = $ecsM6.last;
var $6a22af06192636c3$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $6a22af06192636c3$export$96ec731ed4dcb222 = $ecsM6.min;
var $6a22af06192636c3$export$8960430cfd85939f = $ecsM6.max;
var $6a22af06192636c3$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $6a22af06192636c3$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($6a22af06192636c3$export$5fd5031fecdacec3(as), $6a22af06192636c3$export$c01875f616615628(as));
    };
};
var $6a22af06192636c3$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($6a22af06192636c3$export$2cd8252107eb640b(as), $6a22af06192636c3$export$4c7897fafd92b108(as));
    };
};
var $6a22af06192636c3$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $6a22af06192636c3$var$__spreadArray([
            f($6a22af06192636c3$export$5fd5031fecdacec3(as))
        ], $6a22af06192636c3$export$c01875f616615628(as), true);
    };
};
var $6a22af06192636c3$export$20ca6ad9f7762931 = function(a) {
    return $6a22af06192636c3$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $6a22af06192636c3$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $72EOc.pipe)($6a22af06192636c3$export$2cd8252107eb640b(as), $6a22af06192636c3$export$10d8903dec122b9d(f($6a22af06192636c3$export$4c7897fafd92b108(as))));
    };
};
var $6a22af06192636c3$export$d3affa0a0a83d946 = function(a) {
    return $6a22af06192636c3$export$302ad361c463800a(function() {
        return a;
    });
};
var $6a22af06192636c3$export$739ec22334c44788 = $ecsM6.intercalate;
var $6a22af06192636c3$export$e08e3b67e392101e = $6a22af06192636c3$export$5b8affa63fc6df16;
function $6a22af06192636c3$export$103ce2c0a67e4e61(O) {
    var sortO = $6a22af06192636c3$export$97db5808d8f88186(O);
    var groupO = $6a22af06192636c3$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $6a22af06192636c3$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $6a22af06192636c3$export$3dea766d36a8935f(predicate) {
    return $6a22af06192636c3$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $6a22af06192636c3$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $6a22af06192636c3$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $6a22af06192636c3$export$b446f6baa3bb1430 = $6a22af06192636c3$export$c04edabe9c8d994f;
var $6a22af06192636c3$export$712962e076096ed4 = $6a22af06192636c3$export$89a97afc72a83708;
function $6a22af06192636c3$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $6a22af06192636c3$export$68159836694e22c1(head) : (0, $72EOc.pipe)(tail, $6a22af06192636c3$export$68159836694e22c1(head));
}
var $6a22af06192636c3$export$c40cf5aab899f397 = function(init, end) {
    return (0, $72EOc.pipe)(init, $6a22af06192636c3$export$10d8903dec122b9d(end));
};
var $6a22af06192636c3$export$baeb00bf1e27e233 = $6a22af06192636c3$export$849c7567cbd62acc;
var $6a22af06192636c3$export$93e2b83da34ff82a = $ecsM6.concatAll;
var $6a22af06192636c3$export$a5383a53b408af94 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    of: $6a22af06192636c3$export$ba255e9e49e00608,
    map: $6a22af06192636c3$var$_map,
    mapWithIndex: $6a22af06192636c3$var$_mapWithIndex,
    ap: $6a22af06192636c3$var$_ap,
    chain: $6a22af06192636c3$export$5b8affa63fc6df16,
    extend: $6a22af06192636c3$var$_extend,
    extract: $6a22af06192636c3$export$f9380c9a627682d3,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    traverse: $6a22af06192636c3$var$_traverse,
    sequence: $6a22af06192636c3$export$49bb65c2ea163039,
    reduceWithIndex: $6a22af06192636c3$var$_reduceWithIndex,
    foldMapWithIndex: $6a22af06192636c3$var$_foldMapWithIndex,
    reduceRightWithIndex: $6a22af06192636c3$var$_reduceRightWithIndex,
    traverseWithIndex: $6a22af06192636c3$var$_traverseWithIndex,
    alt: $6a22af06192636c3$var$_alt
};

});
parcelRegister("gcR1C", function(module, exports) {

$parcel$export(module.exports, "fromCompare", () => $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd);
$parcel$export(module.exports, "getMonoid", () => $bcc6e5fd0afe4f22$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "min", () => $bcc6e5fd0afe4f22$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $bcc6e5fd0afe4f22$export$8960430cfd85939f);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");
var $bcc6e5fd0afe4f22$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $bcc6e5fd0afe4f22$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $bcc6e5fd0afe4f22$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $bcc6e5fd0afe4f22$export$66c1ae025e96b4bc = function(O) {
    return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $bcc6e5fd0afe4f22$var$contramap_ = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $bcc6e5fd0afe4f22$export$53b696d27ecb7ba7(f));
};
var $bcc6e5fd0afe4f22$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $bcc6e5fd0afe4f22$export$9156e739aa33e19f = 'Ord';
var $bcc6e5fd0afe4f22$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $bcc6e5fd0afe4f22$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $bcc6e5fd0afe4f22$export$e759a9a7f8d04692().concat,
        empty: $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $bcc6e5fd0afe4f22$export$def901a57d5539c3 = {
    URI: $bcc6e5fd0afe4f22$export$9156e739aa33e19f,
    contramap: $bcc6e5fd0afe4f22$var$contramap_
};
var $bcc6e5fd0afe4f22$export$e5bb9f0f2dedbef6 = {
    equals: (0, $72EOc.constTrue),
    compare: /*#__PURE__*/ (0, $72EOc.constant)(0)
};
var $bcc6e5fd0afe4f22$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $bcc6e5fd0afe4f22$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $bcc6e5fd0afe4f22$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $bcc6e5fd0afe4f22$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $bcc6e5fd0afe4f22$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $bcc6e5fd0afe4f22$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $bcc6e5fd0afe4f22$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $bcc6e5fd0afe4f22$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $bcc6e5fd0afe4f22$export$96ec731ed4dcb222(O);
    var maxO = $bcc6e5fd0afe4f22$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $bcc6e5fd0afe4f22$export$cf95c51b03f10bae = function(O) {
    var ltO = $bcc6e5fd0afe4f22$export$b961576059b7aeb6(O);
    var gtO = $bcc6e5fd0afe4f22$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $bcc6e5fd0afe4f22$export$c41db498223b95e9 = $bcc6e5fd0afe4f22$export$65e3907585753458;
var $bcc6e5fd0afe4f22$export$35315ebcdff1b05c = $bcc6e5fd0afe4f22$export$66c1ae025e96b4bc;
var $bcc6e5fd0afe4f22$export$ad12338f1fefb50e = $bcc6e5fd0afe4f22$export$def901a57d5539c3;
// default compare for primitive types
function $bcc6e5fd0afe4f22$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $bcc6e5fd0afe4f22$var$strictOrd = {
    equals: (0, $3Md1m.eqStrict).equals,
    compare: $bcc6e5fd0afe4f22$var$compare
};
var $bcc6e5fd0afe4f22$export$ef759d57a4e44836 = $bcc6e5fd0afe4f22$var$strictOrd;
var $bcc6e5fd0afe4f22$export$c5f2758e49b2b86a = $bcc6e5fd0afe4f22$var$strictOrd;
var $bcc6e5fd0afe4f22$export$5ed021ff2336715c = $bcc6e5fd0afe4f22$var$strictOrd;
var $bcc6e5fd0afe4f22$export$722593c82468f9f4 = /*#__PURE__*/ (0, $72EOc.pipe)($bcc6e5fd0afe4f22$export$5ed021ff2336715c, /*#__PURE__*/ $bcc6e5fd0afe4f22$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));

});
parcelRegister("3Md1m", function(module, exports) {

$parcel$export(module.exports, "fromEquals", () => $2bfff480dbab3bcc$export$fec6acd8d60e8568);
$parcel$export(module.exports, "eqStrict", () => $2bfff480dbab3bcc$export$37a88d8211c10fd3);

var $72EOc = parcelRequire("72EOc");
var $2bfff480dbab3bcc$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $2bfff480dbab3bcc$export$8cf3da7c1c9174ea = function(eqs) {
    return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $2bfff480dbab3bcc$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $2bfff480dbab3bcc$var$contramap_ = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $2bfff480dbab3bcc$export$53b696d27ecb7ba7(f));
};
var $2bfff480dbab3bcc$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $2bfff480dbab3bcc$export$9156e739aa33e19f = 'Eq';
var $2bfff480dbab3bcc$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $2bfff480dbab3bcc$var$empty = {
    equals: function() {
        return true;
    }
};
var $2bfff480dbab3bcc$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $2bfff480dbab3bcc$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $2bfff480dbab3bcc$export$e759a9a7f8d04692().concat,
        empty: $2bfff480dbab3bcc$var$empty
    };
};
var $2bfff480dbab3bcc$export$def901a57d5539c3 = {
    URI: $2bfff480dbab3bcc$export$9156e739aa33e19f,
    contramap: $2bfff480dbab3bcc$var$contramap_
};
var $2bfff480dbab3bcc$export$1a50cb133a346493 = $2bfff480dbab3bcc$export$65e3907585753458;
var $2bfff480dbab3bcc$export$b35b2bde1875587a = $2bfff480dbab3bcc$export$8cf3da7c1c9174ea;
var $2bfff480dbab3bcc$export$24d177074f8dc6ef = $2bfff480dbab3bcc$export$37a88d8211c10fd3.equals;
var $2bfff480dbab3bcc$export$9663ddc1cf085b32 = $2bfff480dbab3bcc$export$def901a57d5539c3;
var $2bfff480dbab3bcc$export$d7927e8ffc1afb48 = $2bfff480dbab3bcc$export$37a88d8211c10fd3;
var $2bfff480dbab3bcc$export$fa624555ca2acbc8 = $2bfff480dbab3bcc$export$37a88d8211c10fd3;
var $2bfff480dbab3bcc$export$e24978670be1e4f3 = $2bfff480dbab3bcc$export$37a88d8211c10fd3;
var $2bfff480dbab3bcc$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};

});


parcelRegister("ecsM6", function(module, exports) {

$parcel$export(module.exports, "empty", () => $a56881c4a03fdb98$export$6e22c362a0406a2c);
$parcel$export(module.exports, "isNonEmpty", () => $a56881c4a03fdb98$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $a56881c4a03fdb98$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $a56881c4a03fdb98$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $a56881c4a03fdb98$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $a56881c4a03fdb98$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $a56881c4a03fdb98$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $a56881c4a03fdb98$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $a56881c4a03fdb98$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $a56881c4a03fdb98$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $a56881c4a03fdb98$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $a56881c4a03fdb98$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $a56881c4a03fdb98$export$b035e44d7bb4278f);
$parcel$export(module.exports, "union", () => $a56881c4a03fdb98$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $a56881c4a03fdb98$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $a56881c4a03fdb98$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $a56881c4a03fdb98$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $a56881c4a03fdb98$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $a56881c4a03fdb98$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $a56881c4a03fdb98$export$4c7897fafd92b108);
$parcel$export(module.exports, "prependAll", () => $a56881c4a03fdb98$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $a56881c4a03fdb98$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $a56881c4a03fdb98$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $a56881c4a03fdb98$export$2f0184d5df52135f);
$parcel$export(module.exports, "reduce", () => $a56881c4a03fdb98$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $a56881c4a03fdb98$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $a56881c4a03fdb98$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $a56881c4a03fdb98$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $a56881c4a03fdb98$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "of", () => $a56881c4a03fdb98$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $a56881c4a03fdb98$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getEq", () => $a56881c4a03fdb98$export$804fed467fde44e4);
$parcel$export(module.exports, "min", () => $a56881c4a03fdb98$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $a56881c4a03fdb98$export$8960430cfd85939f);
$parcel$export(module.exports, "concatAll", () => $a56881c4a03fdb98$export$b314777ae20abca9);
$parcel$export(module.exports, "intercalate", () => $a56881c4a03fdb98$export$739ec22334c44788);
$parcel$export(module.exports, "cons", () => $a56881c4a03fdb98$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $a56881c4a03fdb98$export$c40cf5aab899f397);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $gcR1C = parcelRequire("gcR1C");

var $58DQ5 = parcelRequire("58DQ5");
var $a56881c4a03fdb98$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a56881c4a03fdb98$export$6e22c362a0406a2c = $EfnK2.emptyReadonlyArray;
var $a56881c4a03fdb98$export$a978c53b4062a525 = $EfnK2.isNonEmpty;
var $a56881c4a03fdb98$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $a56881c4a03fdb98$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $a56881c4a03fdb98$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $a56881c4a03fdb98$export$68159836694e22c1 = $a56881c4a03fdb98$export$c4c4d41eab625797;
var $a56881c4a03fdb98$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $a56881c4a03fdb98$var$__spreadArray($a56881c4a03fdb98$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $a56881c4a03fdb98$export$10d8903dec122b9d = $a56881c4a03fdb98$export$19903a1bf1942f6;
var $a56881c4a03fdb98$export$f4863e1822a1860c = function(i, a, as) {
    if ($a56881c4a03fdb98$export$a978c53b4062a525(as)) {
        var xs = $EfnK2.fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $a56881c4a03fdb98$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $EfnK2.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
var $a56881c4a03fdb98$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $a56881c4a03fdb98$export$5fd5031fecdacec3(as)
        ];
        var rest = $a56881c4a03fdb98$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$b035e44d7bb4278f = function(ords) {
    if ($a56881c4a03fdb98$export$a978c53b4062a525(ords)) {
        var M = (0, $gcR1C.getMonoid)();
        return $a56881c4a03fdb98$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $72EOc.identity;
};
var $a56881c4a03fdb98$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $a56881c4a03fdb98$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $72EOc.pipe)(first, $a56881c4a03fdb98$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $a56881c4a03fdb98$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($a56881c4a03fdb98$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $a56881c4a03fdb98$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $72EOc.pipe)(s, $a56881c4a03fdb98$export$ee1b3e54f0441b22(f));
        } else return $a56881c4a03fdb98$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $a56881c4a03fdb98$export$9288e031f1846591 = function(as) {
    return $a56881c4a03fdb98$export$a978c53b4062a525(as) ? $EfnK2.some(as) : $EfnK2.none;
};
var $a56881c4a03fdb98$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $a56881c4a03fdb98$export$606959e7ccb797f0 = function(a) {
    return $a56881c4a03fdb98$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $a56881c4a03fdb98$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $a56881c4a03fdb98$export$c04edabe9c8d994f = function(as) {
    return [
        $a56881c4a03fdb98$export$5fd5031fecdacec3(as),
        $a56881c4a03fdb98$export$c01875f616615628(as)
    ];
};
var $a56881c4a03fdb98$export$89a97afc72a83708 = function(as) {
    return [
        $a56881c4a03fdb98$export$2cd8252107eb640b(as),
        $a56881c4a03fdb98$export$4c7897fafd92b108(as)
    ];
};
var $a56881c4a03fdb98$export$571d59b505e6bb4e = function(as) {
    return $a56881c4a03fdb98$export$9288e031f1846591(as.slice());
};
function $a56881c4a03fdb98$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $a56881c4a03fdb98$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $a56881c4a03fdb98$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $a56881c4a03fdb98$var$__spreadArray([
        $a56881c4a03fdb98$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $a56881c4a03fdb98$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $a56881c4a03fdb98$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $a56881c4a03fdb98$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($EfnK2.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $a56881c4a03fdb98$export$b6d8713d53419d4c = function(i, a) {
    return $a56881c4a03fdb98$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $a56881c4a03fdb98$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($a56881c4a03fdb98$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $a56881c4a03fdb98$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $a56881c4a03fdb98$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $a56881c4a03fdb98$export$8901015135f2fb22(bs, as);
    };
    return $a56881c4a03fdb98$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $a56881c4a03fdb98$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $a56881c4a03fdb98$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $a56881c4a03fdb98$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $a56881c4a03fdb98$export$c01875f616615628(as);
        return $a56881c4a03fdb98$export$a978c53b4062a525(rest) ? (0, $72EOc.pipe)(rest, $a56881c4a03fdb98$export$849c7567cbd62acc(middle), $a56881c4a03fdb98$export$68159836694e22c1($a56881c4a03fdb98$export$5fd5031fecdacec3(as))) : as;
    };
};
var $a56881c4a03fdb98$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $EfnK2.fromReadonlyNonEmptyArray(f(0, $a56881c4a03fdb98$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($a56881c4a03fdb98$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $a56881c4a03fdb98$export$6e22c362a0406a2c
        ] : [
            (0, $72EOc.pipe)(as.slice(1, m), $a56881c4a03fdb98$export$68159836694e22c1($a56881c4a03fdb98$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $a56881c4a03fdb98$export$2f0184d5df52135f = function(n) {
    return $a56881c4a03fdb98$export$433fe05b12ba833f($a56881c4a03fdb98$export$b0d75975ac0be0e1(n));
};
var $a56881c4a03fdb98$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$8f07ddce13659f50(f));
};
var $a56881c4a03fdb98$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $a56881c4a03fdb98$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $a56881c4a03fdb98$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_foldMap = function(M) {
    var foldMapM = $a56881c4a03fdb98$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_traverse = function(F) {
    var traverseF = $a56881c4a03fdb98$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $a56881c4a03fdb98$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $a56881c4a03fdb98$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $a56881c4a03fdb98$export$ba255e9e49e00608 = $EfnK2.singleton;
var $a56881c4a03fdb98$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $72EOc.pipe)(as, $a56881c4a03fdb98$export$c8c959650bbe80e2(that()));
    };
};
var $a56881c4a03fdb98$export$228be17d80722ab = $a56881c4a03fdb98$export$1517cca7889d6aaa;
var $a56881c4a03fdb98$export$2f6ca3d3b1f80bf5 = function(as) {
    return $a56881c4a03fdb98$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(as, $a56881c4a03fdb98$export$871de8747c9eaa88(f));
    });
};
var $a56881c4a03fdb98$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $a56881c4a03fdb98$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $a56881c4a03fdb98$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $a56881c4a03fdb98$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($a56881c4a03fdb98$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $a56881c4a03fdb98$export$c01875f616615628(next);
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$ecd5e8ace626722c = /*#__PURE__*/ $a56881c4a03fdb98$export$8b58be045bf06082((0, $72EOc.identity));
var $a56881c4a03fdb98$export$bffa455ba8c619a6 = /*#__PURE__*/ $a56881c4a03fdb98$export$5b8affa63fc6df16((0, $72EOc.identity));
var $a56881c4a03fdb98$export$871de8747c9eaa88 = function(f) {
    return $a56881c4a03fdb98$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $a56881c4a03fdb98$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $a56881c4a03fdb98$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $a56881c4a03fdb98$export$533b26079ad0b4b = function(b, f) {
    return $a56881c4a03fdb98$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $a56881c4a03fdb98$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $a56881c4a03fdb98$export$7fef8bcdbb34f435 = function(b, f) {
    return $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $a56881c4a03fdb98$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $a56881c4a03fdb98$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $a56881c4a03fdb98$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $a56881c4a03fdb98$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $a56881c4a03fdb98$export$49bb65c2ea163039 = function(F) {
    return $a56881c4a03fdb98$export$955fdc0d24efa249(F)((0, $72EOc.SK));
};
var $a56881c4a03fdb98$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $a56881c4a03fdb98$export$5fd5031fecdacec3(as)), $a56881c4a03fdb98$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $a56881c4a03fdb98$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $a56881c4a03fdb98$export$f9380c9a627682d3 = $EfnK2.head;
var $a56881c4a03fdb98$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $a56881c4a03fdb98$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $a56881c4a03fdb98$export$e759a9a7f8d04692 = function() {
    return {
        concat: $a56881c4a03fdb98$export$ee1b3e54f0441b22
    };
};
var $a56881c4a03fdb98$export$804fed467fde44e4 = function(E) {
    return (0, $3Md1m.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $a56881c4a03fdb98$export$baca17b4aff42f82 = function(E) {
    var unionE = $a56881c4a03fdb98$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $a56881c4a03fdb98$export$bd5b6bfc5fa2ee61 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map
};
var $a56881c4a03fdb98$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($a56881c4a03fdb98$export$bd5b6bfc5fa2ee61);
var $a56881c4a03fdb98$export$59a71046037e6c20 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608
};
var $a56881c4a03fdb98$export$9fdffe0fe1e91cad = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    mapWithIndex: $a56881c4a03fdb98$var$_mapWithIndex
};
var $a56881c4a03fdb98$export$efc21ddc6aeb363d = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap
};
var $a56881c4a03fdb98$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($a56881c4a03fdb98$export$efc21ddc6aeb363d);
var $a56881c4a03fdb98$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($a56881c4a03fdb98$export$efc21ddc6aeb363d);
var $a56881c4a03fdb98$export$1279d2b7807629fd = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608
};
var $a56881c4a03fdb98$export$f18d5acc27d70423 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap,
    chain: $a56881c4a03fdb98$export$5b8affa63fc6df16
};
var $a56881c4a03fdb98$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($a56881c4a03fdb98$export$f18d5acc27d70423);
var $a56881c4a03fdb98$export$fb641926d034ac7d = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608,
    chain: $a56881c4a03fdb98$export$5b8affa63fc6df16
};
var $a56881c4a03fdb98$export$41404b31838667c9 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight
};
var $a56881c4a03fdb98$export$e8f7d17aaff345cb = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    reduceWithIndex: $a56881c4a03fdb98$var$_reduceWithIndex,
    foldMapWithIndex: $a56881c4a03fdb98$var$_foldMapWithIndex,
    reduceRightWithIndex: $a56881c4a03fdb98$var$_reduceRightWithIndex
};
var $a56881c4a03fdb98$export$a0202666c3bda011 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    traverse: $a56881c4a03fdb98$var$_traverse,
    sequence: $a56881c4a03fdb98$export$49bb65c2ea163039
};
var $a56881c4a03fdb98$export$bd7b528d8c36ec41 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    mapWithIndex: $a56881c4a03fdb98$var$_mapWithIndex,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    traverse: $a56881c4a03fdb98$var$_traverse,
    sequence: $a56881c4a03fdb98$export$49bb65c2ea163039,
    reduceWithIndex: $a56881c4a03fdb98$var$_reduceWithIndex,
    foldMapWithIndex: $a56881c4a03fdb98$var$_foldMapWithIndex,
    reduceRightWithIndex: $a56881c4a03fdb98$var$_reduceRightWithIndex,
    traverseWithIndex: $a56881c4a03fdb98$var$_traverseWithIndex
};
var $a56881c4a03fdb98$export$25ba4469a069167 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    alt: $a56881c4a03fdb98$var$_alt
};
var $a56881c4a03fdb98$export$fdd73124b9f1de36 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    extend: $a56881c4a03fdb98$var$_extend,
    extract: $a56881c4a03fdb98$export$f9380c9a627682d3
};
var $a56881c4a03fdb98$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $a56881c4a03fdb98$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $a56881c4a03fdb98$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($a56881c4a03fdb98$export$bd5b6bfc5fa2ee61);
var $a56881c4a03fdb98$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($a56881c4a03fdb98$export$bd5b6bfc5fa2ee61);
var $a56881c4a03fdb98$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($a56881c4a03fdb98$export$f18d5acc27d70423);
var $a56881c4a03fdb98$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($a56881c4a03fdb98$export$efc21ddc6aeb363d);
var $a56881c4a03fdb98$export$5fd5031fecdacec3 = $a56881c4a03fdb98$export$f9380c9a627682d3;
var $a56881c4a03fdb98$export$c01875f616615628 = $EfnK2.tail;
var $a56881c4a03fdb98$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $a56881c4a03fdb98$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $a56881c4a03fdb98$export$96ec731ed4dcb222 = function(O) {
    var S = $58DQ5.min(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a56881c4a03fdb98$export$8960430cfd85939f = function(O) {
    var S = $58DQ5.max(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a56881c4a03fdb98$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a56881c4a03fdb98$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($a56881c4a03fdb98$export$5fd5031fecdacec3(as), $a56881c4a03fdb98$export$c01875f616615628(as));
    };
};
var $a56881c4a03fdb98$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($a56881c4a03fdb98$export$2cd8252107eb640b(as), $a56881c4a03fdb98$export$4c7897fafd92b108(as));
    };
};
var $a56881c4a03fdb98$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $a56881c4a03fdb98$var$__spreadArray([
            f($a56881c4a03fdb98$export$5fd5031fecdacec3(as))
        ], $a56881c4a03fdb98$export$c01875f616615628(as), true);
    };
};
var $a56881c4a03fdb98$export$20ca6ad9f7762931 = function(a) {
    return $a56881c4a03fdb98$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $72EOc.pipe)($a56881c4a03fdb98$export$2cd8252107eb640b(as), $a56881c4a03fdb98$export$10d8903dec122b9d(f($a56881c4a03fdb98$export$4c7897fafd92b108(as))));
    };
};
var $a56881c4a03fdb98$export$d3affa0a0a83d946 = function(a) {
    return $a56881c4a03fdb98$export$302ad361c463800a(function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$739ec22334c44788 = function(S) {
    var concatAllS = $a56881c4a03fdb98$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $72EOc.flow)($a56881c4a03fdb98$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $a56881c4a03fdb98$export$e08e3b67e392101e = $a56881c4a03fdb98$export$5b8affa63fc6df16;
function $a56881c4a03fdb98$export$103ce2c0a67e4e61(O) {
    var sortO = $a56881c4a03fdb98$export$97db5808d8f88186(O);
    var groupO = $a56881c4a03fdb98$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $a56881c4a03fdb98$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $a56881c4a03fdb98$export$6e22c362a0406a2c;
    };
}
function $a56881c4a03fdb98$export$3dea766d36a8935f(predicate) {
    return $a56881c4a03fdb98$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $a56881c4a03fdb98$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $a56881c4a03fdb98$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $a56881c4a03fdb98$export$b446f6baa3bb1430 = $a56881c4a03fdb98$export$c04edabe9c8d994f;
var $a56881c4a03fdb98$export$712962e076096ed4 = $a56881c4a03fdb98$export$89a97afc72a83708;
function $a56881c4a03fdb98$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $a56881c4a03fdb98$export$68159836694e22c1(head) : (0, $72EOc.pipe)(tail, $a56881c4a03fdb98$export$68159836694e22c1(head));
}
var $a56881c4a03fdb98$export$c40cf5aab899f397 = function(init, end) {
    return (0, $72EOc.pipe)(init, $a56881c4a03fdb98$export$ee1b3e54f0441b22([
        end
    ]));
};
var $a56881c4a03fdb98$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($a56881c4a03fdb98$export$f4863e1822a1860c(i, a, as));
    };
};
var $a56881c4a03fdb98$export$baeb00bf1e27e233 = $a56881c4a03fdb98$export$849c7567cbd62acc;
var $a56881c4a03fdb98$export$93e2b83da34ff82a = $a56881c4a03fdb98$export$b314777ae20abca9;
var $a56881c4a03fdb98$export$3c6c57333e3dca24 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608,
    map: $a56881c4a03fdb98$var$_map,
    mapWithIndex: $a56881c4a03fdb98$var$_mapWithIndex,
    ap: $a56881c4a03fdb98$var$_ap,
    chain: $a56881c4a03fdb98$export$5b8affa63fc6df16,
    extend: $a56881c4a03fdb98$var$_extend,
    extract: $a56881c4a03fdb98$export$f9380c9a627682d3,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    traverse: $a56881c4a03fdb98$var$_traverse,
    sequence: $a56881c4a03fdb98$export$49bb65c2ea163039,
    reduceWithIndex: $a56881c4a03fdb98$var$_reduceWithIndex,
    foldMapWithIndex: $a56881c4a03fdb98$var$_foldMapWithIndex,
    reduceRightWithIndex: $a56881c4a03fdb98$var$_reduceRightWithIndex,
    traverseWithIndex: $a56881c4a03fdb98$var$_traverseWithIndex,
    alt: $a56881c4a03fdb98$var$_alt
};

});
parcelRegister("58DQ5", function(module, exports) {

$parcel$export(module.exports, "min", () => $3bdc9a4cfa1f6a4e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $3bdc9a4cfa1f6a4e$export$8960430cfd85939f);
$parcel$export(module.exports, "constant", () => $3bdc9a4cfa1f6a4e$export$c983f826f44ff86);
$parcel$export(module.exports, "reverse", () => $3bdc9a4cfa1f6a4e$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "struct", () => $3bdc9a4cfa1f6a4e$export$8cf3da7c1c9174ea);
$parcel$export(module.exports, "tuple", () => $3bdc9a4cfa1f6a4e$export$65e3907585753458);
$parcel$export(module.exports, "intercalate", () => $3bdc9a4cfa1f6a4e$export$739ec22334c44788);
$parcel$export(module.exports, "first", () => $3bdc9a4cfa1f6a4e$export$43128fadae87b74a);
$parcel$export(module.exports, "last", () => $3bdc9a4cfa1f6a4e$export$4c7897fafd92b108);
$parcel$export(module.exports, "concatAll", () => $3bdc9a4cfa1f6a4e$export$b314777ae20abca9);
$parcel$export(module.exports, "semigroupVoid", () => $3bdc9a4cfa1f6a4e$export$36aabcd6b6e45f3b);
$parcel$export(module.exports, "getObjectSemigroup", () => $3bdc9a4cfa1f6a4e$export$2f965793fef2fb8a);
$parcel$export(module.exports, "getLastSemigroup", () => $3bdc9a4cfa1f6a4e$export$edb0acd3f464ffc5);
$parcel$export(module.exports, "getFirstSemigroup", () => $3bdc9a4cfa1f6a4e$export$84a57d7a8bf6c3ea);
$parcel$export(module.exports, "getTupleSemigroup", () => $3bdc9a4cfa1f6a4e$export$bd94daf2735ef9c);
$parcel$export(module.exports, "getStructSemigroup", () => $3bdc9a4cfa1f6a4e$export$98d1814f8ed74e13);
$parcel$export(module.exports, "getDualSemigroup", () => $3bdc9a4cfa1f6a4e$export$e0cea6c43ec66a1);
$parcel$export(module.exports, "getJoinSemigroup", () => $3bdc9a4cfa1f6a4e$export$4278e54cd9769e6d);
$parcel$export(module.exports, "getMeetSemigroup", () => $3bdc9a4cfa1f6a4e$export$7baccd77d16d1a41);
$parcel$export(module.exports, "getIntercalateSemigroup", () => $3bdc9a4cfa1f6a4e$export$fcc2cca196b2daf0);
$parcel$export(module.exports, "fold", () => $3bdc9a4cfa1f6a4e$export$93e2b83da34ff82a);
$parcel$export(module.exports, "semigroupAll", () => $3bdc9a4cfa1f6a4e$export$e8f9875ab703bdff);
$parcel$export(module.exports, "semigroupAny", () => $3bdc9a4cfa1f6a4e$export$9511aba5be5ac81b);
$parcel$export(module.exports, "getFunctionSemigroup", () => $3bdc9a4cfa1f6a4e$export$b2ecf5de014857c2);
$parcel$export(module.exports, "semigroupString", () => $3bdc9a4cfa1f6a4e$export$d9b7100b101f2c5b);
$parcel$export(module.exports, "semigroupSum", () => $3bdc9a4cfa1f6a4e$export$1481126044ad2de0);
$parcel$export(module.exports, "semigroupProduct", () => $3bdc9a4cfa1f6a4e$export$a22a2283cc3aa839);
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 
var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");

var $dvJYF = parcelRequire("dvJYF");

var $gcR1C = parcelRequire("gcR1C");
var $3bdc9a4cfa1f6a4e$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $gcR1C.min(O)
    };
};
var $3bdc9a4cfa1f6a4e$export$8960430cfd85939f = function(O) {
    return {
        concat: $gcR1C.max(O)
    };
};
var $3bdc9a4cfa1f6a4e$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$66c1ae025e96b4bc = $dvJYF.reverse;
var $3bdc9a4cfa1f6a4e$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($EfnK2.has.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $3bdc9a4cfa1f6a4e$export$43128fadae87b74a = function() {
    return {
        concat: (0, $72EOc.identity)
    };
};
var $3bdc9a4cfa1f6a4e$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$b314777ae20abca9 = $dvJYF.concatAll;
var $3bdc9a4cfa1f6a4e$export$36aabcd6b6e45f3b = $3bdc9a4cfa1f6a4e$export$c983f826f44ff86(undefined);
var $3bdc9a4cfa1f6a4e$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$edb0acd3f464ffc5 = $3bdc9a4cfa1f6a4e$export$4c7897fafd92b108;
var $3bdc9a4cfa1f6a4e$export$84a57d7a8bf6c3ea = $3bdc9a4cfa1f6a4e$export$43128fadae87b74a;
var $3bdc9a4cfa1f6a4e$export$bd94daf2735ef9c = $3bdc9a4cfa1f6a4e$export$65e3907585753458;
var $3bdc9a4cfa1f6a4e$export$98d1814f8ed74e13 = $3bdc9a4cfa1f6a4e$export$8cf3da7c1c9174ea;
var $3bdc9a4cfa1f6a4e$export$e0cea6c43ec66a1 = $3bdc9a4cfa1f6a4e$export$66c1ae025e96b4bc;
var $3bdc9a4cfa1f6a4e$export$4278e54cd9769e6d = $3bdc9a4cfa1f6a4e$export$8960430cfd85939f;
var $3bdc9a4cfa1f6a4e$export$7baccd77d16d1a41 = $3bdc9a4cfa1f6a4e$export$96ec731ed4dcb222;
var $3bdc9a4cfa1f6a4e$export$fcc2cca196b2daf0 = $3bdc9a4cfa1f6a4e$export$739ec22334c44788;
function $3bdc9a4cfa1f6a4e$export$93e2b83da34ff82a(S) {
    var concatAllS = $3bdc9a4cfa1f6a4e$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $3bdc9a4cfa1f6a4e$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $3bdc9a4cfa1f6a4e$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $3bdc9a4cfa1f6a4e$export$b2ecf5de014857c2 = (0, $72EOc.getSemigroup);
var $3bdc9a4cfa1f6a4e$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $3bdc9a4cfa1f6a4e$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $3bdc9a4cfa1f6a4e$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};

});
parcelRegister("dvJYF", function(module, exports) {

$parcel$export(module.exports, "reverse", () => $9d61d5c37892c0ce$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "concatAll", () => $9d61d5c37892c0ce$export$b314777ae20abca9);
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $9d61d5c37892c0ce$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $9d61d5c37892c0ce$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $9d61d5c37892c0ce$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $9d61d5c37892c0ce$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $9d61d5c37892c0ce$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};

});




parcelRegister("8yI6w", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $63b3b5db92dfece4$export$dfc7155ac0343b8);
$parcel$export(module.exports, "head", () => $63b3b5db92dfece4$export$5fd5031fecdacec3);
$parcel$export(module.exports, "last", () => $63b3b5db92dfece4$export$4c7897fafd92b108);
$parcel$export(module.exports, "findIndex", () => $63b3b5db92dfece4$export$de3a4d4a0d731119);
$parcel$export(module.exports, "findFirst", () => $63b3b5db92dfece4$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstMap", () => $63b3b5db92dfece4$export$a86c11c94d794a95);
$parcel$export(module.exports, "findLast", () => $63b3b5db92dfece4$export$296de88ccac4bedb);
$parcel$export(module.exports, "findLastMap", () => $63b3b5db92dfece4$export$8b5e6d6ad82284fa);
$parcel$export(module.exports, "findLastIndex", () => $63b3b5db92dfece4$export$8855a8be7bd3e9f8);
$parcel$export(module.exports, "unsafeUpdateAt", () => $63b3b5db92dfece4$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "elem", () => $63b3b5db92dfece4$export$5bf96401662340b7);
$parcel$export(module.exports, "reduce", () => $63b3b5db92dfece4$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $63b3b5db92dfece4$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $63b3b5db92dfece4$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $63b3b5db92dfece4$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $63b3b5db92dfece4$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "_chainRecDepthFirst", () => $63b3b5db92dfece4$export$c5c44f872d8af73);
$parcel$export(module.exports, "chainRecDepthFirst", () => $63b3b5db92dfece4$export$f855115a79f70c1a);
$parcel$export(module.exports, "_chainRecBreadthFirst", () => $63b3b5db92dfece4$export$b9909b62ceeab991);
$parcel$export(module.exports, "chainRecBreadthFirst", () => $63b3b5db92dfece4$export$bffee57bb00a6859);
$parcel$export(module.exports, "of", () => $63b3b5db92dfece4$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $63b3b5db92dfece4$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getMonoid", () => $63b3b5db92dfece4$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "getEq", () => $63b3b5db92dfece4$export$804fed467fde44e4);
$parcel$export(module.exports, "getOrd", () => $63b3b5db92dfece4$export$1af51209b1b91d07);
$parcel$export(module.exports, "every", () => $63b3b5db92dfece4$export$7ecc1a3b11b57dab);
$parcel$export(module.exports, "intercalate", () => $63b3b5db92dfece4$export$739ec22334c44788);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $3Md1m = parcelRequire("3Md1m");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $RoEDj = parcelRequire("RoEDj");

var $gcR1C = parcelRequire("gcR1C");

var $ecsM6 = parcelRequire("ecsM6");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");

var $3n81G = parcelRequire("3n81G");
var $63b3b5db92dfece4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $63b3b5db92dfece4$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $63b3b5db92dfece4$export$a978c53b4062a525 = $ecsM6.isNonEmpty;
var $63b3b5db92dfece4$export$68159836694e22c1 = $ecsM6.prepend;
var $63b3b5db92dfece4$export$c4c4d41eab625797 = $ecsM6.prependW;
var $63b3b5db92dfece4$export$10d8903dec122b9d = $ecsM6.append;
var $63b3b5db92dfece4$export$19903a1bf1942f6 = $ecsM6.appendW;
var $63b3b5db92dfece4$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : $ecsM6.makeBy(f)(n);
};
var $63b3b5db92dfece4$export$606959e7ccb797f0 = function(n, a) {
    return $63b3b5db92dfece4$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $63b3b5db92dfece4$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
}
var $63b3b5db92dfece4$export$172ec0a6ebfeb6fa = function(ma) {
    return $EfnK2.isNone(ma) ? $63b3b5db92dfece4$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $63b3b5db92dfece4$export$80c878c9b1d77917 = function(e) {
    return $EfnK2.isLeft(e) ? $63b3b5db92dfece4$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $63b3b5db92dfece4$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $63b3b5db92dfece4$export$4659b591c19bdf3d = $63b3b5db92dfece4$export$2d55ea551c238330;
var $63b3b5db92dfece4$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? onNonEmpty($ecsM6.head(as), $ecsM6.tail(as)) : onEmpty();
    };
};
var $63b3b5db92dfece4$export$6280271dfaec4919 = $63b3b5db92dfece4$export$ebbe93aa91e3abdc;
var $63b3b5db92dfece4$export$f3163a37d0ef5927 = $63b3b5db92dfece4$export$6280271dfaec4919;
var $63b3b5db92dfece4$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? onNonEmpty($ecsM6.init(as), $ecsM6.last(as)) : onEmpty();
    };
};
var $63b3b5db92dfece4$export$b1cacb83a5c6bd02 = $63b3b5db92dfece4$export$364f7f2cc8473008;
var $63b3b5db92dfece4$export$77fa89c00b331c4c = $63b3b5db92dfece4$export$b1cacb83a5c6bd02;
var $63b3b5db92dfece4$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($63b3b5db92dfece4$export$dd1bc94b04021eeb(as)) return $63b3b5db92dfece4$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $63b3b5db92dfece4$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $63b3b5db92dfece4$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $63b3b5db92dfece4$export$346677f925de839c = function(as) {
    return as.length;
};
var $63b3b5db92dfece4$export$2fde0b1c54fc39b9 = $ecsM6.isOutOfBound;
function $63b3b5db92dfece4$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $63b3b5db92dfece4$export$dfc7155ac0343b8(i, as);
    } : $63b3b5db92dfece4$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some(as[i]);
}
var $63b3b5db92dfece4$export$5fd5031fecdacec3 = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.head(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$4c7897fafd92b108 = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.last(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$c01875f616615628 = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.tail(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$2cd8252107eb640b = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.init(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $63b3b5db92dfece4$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $63b3b5db92dfece4$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : out;
    };
}
var $63b3b5db92dfece4$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $63b3b5db92dfece4$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $63b3b5db92dfece4$export$b0d75975ac0be0e1($63b3b5db92dfece4$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $63b3b5db92dfece4$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $63b3b5db92dfece4$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $63b3b5db92dfece4$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $63b3b5db92dfece4$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $63b3b5db92dfece4$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $EfnK2.some(i);
        }
        return $EfnK2.none;
    };
};
function $63b3b5db92dfece4$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $EfnK2.some(as[i]);
        }
        return $EfnK2.none;
    };
}
var $63b3b5db92dfece4$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($EfnK2.isSome(out)) return out;
        }
        return $EfnK2.none;
    };
};
function $63b3b5db92dfece4$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $EfnK2.some(as[i]);
        }
        return $EfnK2.none;
    };
}
var $63b3b5db92dfece4$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($EfnK2.isSome(out)) return out;
        }
        return $EfnK2.none;
    };
};
var $63b3b5db92dfece4$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $EfnK2.some(i);
        }
        return $EfnK2.none;
    };
};
var $63b3b5db92dfece4$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($ecsM6.unsafeInsertAt(i, a, as));
    };
};
var $63b3b5db92dfece4$export$b6d8713d53419d4c = function(i, a) {
    return $63b3b5db92dfece4$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $63b3b5db92dfece4$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($63b3b5db92dfece4$export$4937fde8dfc38dbd(i, as));
    };
};
var $63b3b5db92dfece4$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($63b3b5db92dfece4$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $63b3b5db92dfece4$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $63b3b5db92dfece4$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $63b3b5db92dfece4$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $63b3b5db92dfece4$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $63b3b5db92dfece4$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $63b3b5db92dfece4$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $63b3b5db92dfece4$export$8901015135f2fb22(bs, as);
    };
    return $63b3b5db92dfece4$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $63b3b5db92dfece4$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $63b3b5db92dfece4$export$849c7567cbd62acc = function(middle) {
    var f = $ecsM6.prependAll(middle);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$af200dcf8b7cb5de = function(middle) {
    var f = $ecsM6.intersperse(middle);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$bb628a54ab399bc9 = function(n) {
    var f = $ecsM6.rotate(n);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $63b3b5db92dfece4$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $63b3b5db92dfece4$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $63b3b5db92dfece4$export$f70730c3d1fc524e = function(E) {
    var f = $ecsM6.uniq(E);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$b035e44d7bb4278f = function(ords) {
    var f = $ecsM6.sortBy(ords);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$433fe05b12ba833f = function(f) {
    var g = $ecsM6.chop(f);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? g(as) : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
};
var $63b3b5db92dfece4$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $ecsM6.splitAt(n)(as) : $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? [
            as,
            $63b3b5db92dfece4$export$6e22c362a0406a2c
        ] : [
            $63b3b5db92dfece4$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $63b3b5db92dfece4$export$2f0184d5df52135f = function(n) {
    var f = $ecsM6.chunksOf(n);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
};
var $63b3b5db92dfece4$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $63b3b5db92dfece4$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $63b3b5db92dfece4$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(input) ? $63b3b5db92dfece4$export$5b8affa63fc6df16($ecsM6.head(input), function(a) {
            return go((0, $72EOc.pipe)(scope, $63b3b5db92dfece4$export$10d8903dec122b9d(a)), $ecsM6.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
    return go($63b3b5db92dfece4$export$6e22c362a0406a2c, input);
}
var $63b3b5db92dfece4$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $63b3b5db92dfece4$export$dd1bc94b04021eeb(first) ? second : $63b3b5db92dfece4$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $63b3b5db92dfece4$export$ee1b3e54f0441b22 = $63b3b5db92dfece4$export$c8c959650bbe80e2;
function $63b3b5db92dfece4$export$971dd5b0dfd021b6(E) {
    var unionE = $ecsM6.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $63b3b5db92dfece4$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $63b3b5db92dfece4$export$a978c53b4062a525(first) && $63b3b5db92dfece4$export$a978c53b4062a525(second) ? unionE(second)(first) : $63b3b5db92dfece4$export$a978c53b4062a525(first) ? first : second;
    };
}
function $63b3b5db92dfece4$export$bc86dfbf7795668c(E) {
    var elemE = $63b3b5db92dfece4$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $63b3b5db92dfece4$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $63b3b5db92dfece4$export$acaf96a27438246b(E) {
    var elemE = $63b3b5db92dfece4$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $63b3b5db92dfece4$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $63b3b5db92dfece4$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$871de8747c9eaa88(f));
};
var $63b3b5db92dfece4$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$8f07ddce13659f50(f));
};
var $63b3b5db92dfece4$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $63b3b5db92dfece4$export$2f6ca3d3b1f80bf5(fa));
};
var $63b3b5db92dfece4$var$_filter = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$3dea766d36a8935f(predicate));
};
var $63b3b5db92dfece4$var$_filterMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$a04c6c6965dd4709(f));
};
var $63b3b5db92dfece4$var$_partition = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$b29f828819edca8d(predicate));
};
var $63b3b5db92dfece4$var$_partitionMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$3117e3f9ececb6bc(f));
};
var $63b3b5db92dfece4$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $63b3b5db92dfece4$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$bc7c0794b9c6f3ba(f));
};
var $63b3b5db92dfece4$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$228be17d80722ab(that));
};
var $63b3b5db92dfece4$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$533b26079ad0b4b(b, f));
};
var $63b3b5db92dfece4$var$_foldMap = function(M) {
    var foldMapM = $63b3b5db92dfece4$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
var $63b3b5db92dfece4$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$7fef8bcdbb34f435(b, f));
};
var $63b3b5db92dfece4$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$bbd3ef8720e22369(b, f));
};
var $63b3b5db92dfece4$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $63b3b5db92dfece4$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
var $63b3b5db92dfece4$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a(b, f));
};
var $63b3b5db92dfece4$var$_filterMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$30c5cbe848021e97(f));
};
var $63b3b5db92dfece4$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$36e42aef19fc7171(predicateWithIndex));
};
var $63b3b5db92dfece4$var$_extend = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$8b58be045bf06082(f));
};
var $63b3b5db92dfece4$var$_traverse = function(F) {
    var traverseF = $63b3b5db92dfece4$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $63b3b5db92dfece4$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $63b3b5db92dfece4$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $63b3b5db92dfece4$export$c5c44f872d8af73 = function(a, f) {
    return (0, $72EOc.pipe)(a, $63b3b5db92dfece4$export$f855115a79f70c1a(f));
};
var $63b3b5db92dfece4$export$b9909b62ceeab991 = function(a, f) {
    return (0, $72EOc.pipe)(a, $63b3b5db92dfece4$export$bffee57bb00a6859(f));
};
var $63b3b5db92dfece4$export$ba255e9e49e00608 = $ecsM6.of;
var $63b3b5db92dfece4$export$7f9972325ebfd559 = function() {
    return $63b3b5db92dfece4$export$6e22c362a0406a2c;
};
var $63b3b5db92dfece4$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $63b3b5db92dfece4$export$228be17d80722ab = $63b3b5db92dfece4$export$1517cca7889d6aaa;
var $63b3b5db92dfece4$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $63b3b5db92dfece4$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$871de8747c9eaa88(f));
    });
};
var $63b3b5db92dfece4$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $63b3b5db92dfece4$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $63b3b5db92dfece4$export$bffa455ba8c619a6 = /*#__PURE__*/ $63b3b5db92dfece4$export$5b8affa63fc6df16((0, $72EOc.identity));
var $63b3b5db92dfece4$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $63b3b5db92dfece4$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $63b3b5db92dfece4$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $1HSKK.separated)(left, right);
};
var $63b3b5db92dfece4$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $63b3b5db92dfece4$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($EfnK2.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $63b3b5db92dfece4$export$a04c6c6965dd4709 = function(f) {
    return $63b3b5db92dfece4$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $63b3b5db92dfece4$export$8e16b83750b44988 = /*#__PURE__*/ $63b3b5db92dfece4$export$a04c6c6965dd4709((0, $72EOc.identity));
var $63b3b5db92dfece4$export$b29f828819edca8d = function(predicate) {
    return $63b3b5db92dfece4$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $63b3b5db92dfece4$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $63b3b5db92dfece4$export$3117e3f9ececb6bc = function(f) {
    return $63b3b5db92dfece4$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $63b3b5db92dfece4$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $63b3b5db92dfece4$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $63b3b5db92dfece4$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $63b3b5db92dfece4$export$ecd5e8ace626722c = /*#__PURE__*/ $63b3b5db92dfece4$export$8b58be045bf06082((0, $72EOc.identity));
var $63b3b5db92dfece4$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $63b3b5db92dfece4$export$533b26079ad0b4b = function(b, f) {
    return $63b3b5db92dfece4$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $63b3b5db92dfece4$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $63b3b5db92dfece4$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $63b3b5db92dfece4$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $63b3b5db92dfece4$export$7fef8bcdbb34f435 = function(b, f) {
    return $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $63b3b5db92dfece4$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $63b3b5db92dfece4$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $63b3b5db92dfece4$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $63b3b5db92dfece4$var$_reduce(ta, F.of($63b3b5db92dfece4$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $72EOc.pipe)(as, $63b3b5db92dfece4$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $63b3b5db92dfece4$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $63b3b5db92dfece4$export$bbd3ef8720e22369(F.of($63b3b5db92dfece4$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $63b3b5db92dfece4$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $63b3b5db92dfece4$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $63b3b5db92dfece4$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $63b3b5db92dfece4$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $63b3b5db92dfece4$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $63b3b5db92dfece4$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($EfnK2.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $63b3b5db92dfece4$export$9156e739aa33e19f = 'ReadonlyArray';
var $63b3b5db92dfece4$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $63b3b5db92dfece4$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $63b3b5db92dfece4$export$dd1bc94b04021eeb(first) ? second : $63b3b5db92dfece4$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $63b3b5db92dfece4$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $63b3b5db92dfece4$export$e759a9a7f8d04692().concat,
        empty: $63b3b5db92dfece4$export$6e22c362a0406a2c
    };
};
var $63b3b5db92dfece4$export$804fed467fde44e4 = function(E) {
    return (0, $3Md1m.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $63b3b5db92dfece4$export$1af51209b1b91d07 = function(O) {
    return (0, $gcR1C.fromCompare)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $RoEDj.Ord.compare(aLen, bLen);
    });
};
var $63b3b5db92dfece4$export$baca17b4aff42f82 = function(E) {
    var unionE = $63b3b5db92dfece4$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $63b3b5db92dfece4$export$c487aac9f4157837 = function(E) {
    return {
        concat: $63b3b5db92dfece4$export$baca17b4aff42f82(E).concat,
        empty: $63b3b5db92dfece4$export$6e22c362a0406a2c
    };
};
var $63b3b5db92dfece4$export$d379a869a72e4055 = function(E) {
    var intersectionE = $63b3b5db92dfece4$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $63b3b5db92dfece4$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $63b3b5db92dfece4$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $63b3b5db92dfece4$export$bd5b6bfc5fa2ee61 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map
};
var $63b3b5db92dfece4$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($63b3b5db92dfece4$export$bd5b6bfc5fa2ee61);
var $63b3b5db92dfece4$export$59a71046037e6c20 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608
};
var $63b3b5db92dfece4$export$9fdffe0fe1e91cad = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex
};
var $63b3b5db92dfece4$export$efc21ddc6aeb363d = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap
};
var $63b3b5db92dfece4$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($63b3b5db92dfece4$export$efc21ddc6aeb363d);
var $63b3b5db92dfece4$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($63b3b5db92dfece4$export$efc21ddc6aeb363d);
var $63b3b5db92dfece4$export$1279d2b7807629fd = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608
};
var $63b3b5db92dfece4$export$f18d5acc27d70423 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16
};
var $63b3b5db92dfece4$export$fb641926d034ac7d = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16
};
var $63b3b5db92dfece4$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($63b3b5db92dfece4$export$f18d5acc27d70423);
var $63b3b5db92dfece4$export$8fa953f00d3b093 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    unfold: $63b3b5db92dfece4$export$c48e357c1a89b78d
};
var $63b3b5db92dfece4$export$25ba4469a069167 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    alt: $63b3b5db92dfece4$var$_alt
};
var $63b3b5db92dfece4$export$aaef8a3eae948f03 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    zero: $63b3b5db92dfece4$export$7f9972325ebfd559
};
var $63b3b5db92dfece4$export$864d727b48066337 = /*#__PURE__*/ (0, $3n81G.guard)($63b3b5db92dfece4$export$aaef8a3eae948f03, $63b3b5db92dfece4$export$59a71046037e6c20);
var $63b3b5db92dfece4$export$4acb47accde578d2 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608,
    alt: $63b3b5db92dfece4$var$_alt,
    zero: $63b3b5db92dfece4$export$7f9972325ebfd559
};
var $63b3b5db92dfece4$export$5b5dd0e212d2a5bc = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    extend: $63b3b5db92dfece4$var$_extend
};
var $63b3b5db92dfece4$export$4a21ac48141ac3c9 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408
};
var $63b3b5db92dfece4$export$d00e1c48fb621173 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap
};
var $63b3b5db92dfece4$export$c29a647071e542ec = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap,
    partitionMapWithIndex: $63b3b5db92dfece4$var$_partitionMapWithIndex,
    partitionWithIndex: $63b3b5db92dfece4$var$_partitionWithIndex,
    filterMapWithIndex: $63b3b5db92dfece4$var$_filterMapWithIndex,
    filterWithIndex: $63b3b5db92dfece4$var$_filterWithIndex
};
var $63b3b5db92dfece4$export$41404b31838667c9 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight
};
var $63b3b5db92dfece4$export$e8f7d17aaff345cb = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    reduceWithIndex: $63b3b5db92dfece4$var$_reduceWithIndex,
    foldMapWithIndex: $63b3b5db92dfece4$var$_foldMapWithIndex,
    reduceRightWithIndex: $63b3b5db92dfece4$var$_reduceRightWithIndex
};
var $63b3b5db92dfece4$export$a0202666c3bda011 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039
};
var $63b3b5db92dfece4$export$bd7b528d8c36ec41 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    reduceWithIndex: $63b3b5db92dfece4$var$_reduceWithIndex,
    foldMapWithIndex: $63b3b5db92dfece4$var$_foldMapWithIndex,
    reduceRightWithIndex: $63b3b5db92dfece4$var$_reduceRightWithIndex,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039,
    traverseWithIndex: $63b3b5db92dfece4$var$_traverseWithIndex
};
var $63b3b5db92dfece4$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $63b3b5db92dfece4$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($EfnK2.isLeft(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $63b3b5db92dfece4$export$7d808dfaa6d54634 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16,
    chainRec: $63b3b5db92dfece4$export$c5c44f872d8af73
};
var $63b3b5db92dfece4$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($EfnK2.isLeft(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $63b3b5db92dfece4$export$57f3a385c7e59628 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16,
    chainRec: $63b3b5db92dfece4$export$b9909b62ceeab991
};
var $63b3b5db92dfece4$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($63b3b5db92dfece4$export$a0202666c3bda011, $63b3b5db92dfece4$export$4a21ac48141ac3c9);
var $63b3b5db92dfece4$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($63b3b5db92dfece4$export$a0202666c3bda011, $63b3b5db92dfece4$export$4a21ac48141ac3c9);
var $63b3b5db92dfece4$export$748d317b4c426f96 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039,
    wither: $63b3b5db92dfece4$var$_wither,
    wilt: $63b3b5db92dfece4$var$_wilt
};
var $63b3b5db92dfece4$export$c40604f35db61519 = /*#__PURE__*/ (0, $jNYdc.filterE)($63b3b5db92dfece4$export$748d317b4c426f96);
var $63b3b5db92dfece4$export$825ea6cb6fc48d49 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    fromEither: $63b3b5db92dfece4$export$80c878c9b1d77917
};
var $63b3b5db92dfece4$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $jFfj2.fromEitherK)($63b3b5db92dfece4$export$825ea6cb6fc48d49);
var $63b3b5db92dfece4$export$f4863e1822a1860c = $ecsM6.unsafeInsertAt;
var $63b3b5db92dfece4$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $ecsM6.unsafeUpdateAt(i, a, as) : as;
};
var $63b3b5db92dfece4$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $63b3b5db92dfece4$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $63b3b5db92dfece4$export$571d59b505e6bb4e = function(as) {
    return $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice();
};
var $63b3b5db92dfece4$export$6e22c362a0406a2c = $ecsM6.empty;
function $63b3b5db92dfece4$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $63b3b5db92dfece4$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $63b3b5db92dfece4$export$f7e9f41ea797a17 = $63b3b5db92dfece4$export$ad14ef4001db2bcd;
var $63b3b5db92dfece4$export$739ec22334c44788 = function(M) {
    var intercalateM = $ecsM6.intercalate(M);
    return function(middle) {
        return $63b3b5db92dfece4$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $63b3b5db92dfece4$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $63b3b5db92dfece4$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $63b3b5db92dfece4$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($63b3b5db92dfece4$export$bd5b6bfc5fa2ee61);
var $63b3b5db92dfece4$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($63b3b5db92dfece4$export$bd5b6bfc5fa2ee61);
var $63b3b5db92dfece4$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($63b3b5db92dfece4$export$f18d5acc27d70423);
var $63b3b5db92dfece4$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($63b3b5db92dfece4$export$efc21ddc6aeb363d);
var $63b3b5db92dfece4$export$e08e3b67e392101e = $63b3b5db92dfece4$export$5b8affa63fc6df16;
var $63b3b5db92dfece4$export$d02631cccf789723 = $ecsM6.range;
var $63b3b5db92dfece4$export$8327ebbef2a0ba76 = $ecsM6.cons;
var $63b3b5db92dfece4$export$c40cf5aab899f397 = $ecsM6.snoc;
var $63b3b5db92dfece4$export$baeb00bf1e27e233 = $63b3b5db92dfece4$export$849c7567cbd62acc;
var $63b3b5db92dfece4$export$95ca155af9fd5713 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex,
    partitionMapWithIndex: $63b3b5db92dfece4$var$_partitionMapWithIndex,
    partitionWithIndex: $63b3b5db92dfece4$var$_partitionWithIndex,
    filterMapWithIndex: $63b3b5db92dfece4$var$_filterMapWithIndex,
    filterWithIndex: $63b3b5db92dfece4$var$_filterWithIndex,
    alt: $63b3b5db92dfece4$var$_alt,
    zero: $63b3b5db92dfece4$export$7f9972325ebfd559,
    unfold: $63b3b5db92dfece4$export$c48e357c1a89b78d,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039,
    reduceWithIndex: $63b3b5db92dfece4$var$_reduceWithIndex,
    foldMapWithIndex: $63b3b5db92dfece4$var$_foldMapWithIndex,
    reduceRightWithIndex: $63b3b5db92dfece4$var$_reduceRightWithIndex,
    traverseWithIndex: $63b3b5db92dfece4$var$_traverseWithIndex,
    extend: $63b3b5db92dfece4$var$_extend,
    wither: $63b3b5db92dfece4$var$_wither,
    wilt: $63b3b5db92dfece4$var$_wilt
};

});
parcelRegister("RoEDj", function(module, exports) {

$parcel$export(module.exports, "Ord", () => $0a08133259714bc1$export$ee8aa95bfab51c5);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $0a08133259714bc1$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $0a08133259714bc1$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $0a08133259714bc1$export$ee8aa95bfab51c5 = {
    equals: $0a08133259714bc1$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $0a08133259714bc1$export$88f31472ebc405c8 = {
    equals: $0a08133259714bc1$export$a2050e5b0c4dcf10.equals,
    compare: $0a08133259714bc1$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $0a08133259714bc1$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $0a08133259714bc1$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $0a08133259714bc1$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $0a08133259714bc1$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $0a08133259714bc1$export$2517c0450e71e789 = {
    concat: $0a08133259714bc1$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $0a08133259714bc1$export$ee1a63590489b690 = {
    concat: $0a08133259714bc1$export$5b0bccec79556292.concat,
    empty: 1
};
var $0a08133259714bc1$export$a455218a85c89869 = {
    add: $0a08133259714bc1$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $0a08133259714bc1$export$5b0bccec79556292.concat,
    one: 1,
    sub: $0a08133259714bc1$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};

});

parcelRegister("1HSKK", function(module, exports) {

$parcel$export(module.exports, "separated", () => $13e44761c4ec866c$export$beaabdf62f4a639d);
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 
var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");
var $13e44761c4ec866c$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $13e44761c4ec866c$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $13e44761c4ec866c$export$871de8747c9eaa88(f));
};
var $13e44761c4ec866c$var$_mapLeft = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $13e44761c4ec866c$export$472de43a55e4aa49(f));
};
var $13e44761c4ec866c$var$_bimap = function(fa, g, f) {
    return (0, $72EOc.pipe)(fa, $13e44761c4ec866c$export$eb54baf0b342cb1d(g, f));
};
var $13e44761c4ec866c$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $13e44761c4ec866c$export$beaabdf62f4a639d($13e44761c4ec866c$export$eabcd2c8791e7bf4(fa), f($13e44761c4ec866c$export$79ffe56a765070d2(fa)));
    };
};
var $13e44761c4ec866c$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $13e44761c4ec866c$export$beaabdf62f4a639d(f($13e44761c4ec866c$export$eabcd2c8791e7bf4(fa)), $13e44761c4ec866c$export$79ffe56a765070d2(fa));
    };
};
var $13e44761c4ec866c$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $13e44761c4ec866c$export$beaabdf62f4a639d(f($13e44761c4ec866c$export$eabcd2c8791e7bf4(fa)), g($13e44761c4ec866c$export$79ffe56a765070d2(fa)));
    };
};
var $13e44761c4ec866c$export$9156e739aa33e19f = 'Separated';
var $13e44761c4ec866c$export$fd0fe42029639505 = {
    URI: $13e44761c4ec866c$export$9156e739aa33e19f,
    mapLeft: $13e44761c4ec866c$var$_mapLeft,
    bimap: $13e44761c4ec866c$var$_bimap
};
var $13e44761c4ec866c$export$bd5b6bfc5fa2ee61 = {
    URI: $13e44761c4ec866c$export$9156e739aa33e19f,
    map: $13e44761c4ec866c$var$_map
};
var $13e44761c4ec866c$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($13e44761c4ec866c$export$bd5b6bfc5fa2ee61);
var $13e44761c4ec866c$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $13e44761c4ec866c$export$79ffe56a765070d2 = function(s) {
    return s.right;
};

});

parcelRegister("jNYdc", function(module, exports) {

$parcel$export(module.exports, "wiltDefault", () => $03b8897efe5e6a0f$export$f4cb42390e44d1d2);
$parcel$export(module.exports, "witherDefault", () => $03b8897efe5e6a0f$export$1f5c6f948d11a182);
$parcel$export(module.exports, "filterE", () => $03b8897efe5e6a0f$export$c40604f35db61519);

var $EfnK2 = parcelRequire("EfnK2");
function $03b8897efe5e6a0f$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $03b8897efe5e6a0f$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $03b8897efe5e6a0f$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $EfnK2.some(a) : $EfnK2.none;
                    });
                });
            };
        };
    };
}

});

parcelRegister("3n81G", function(module, exports) {

$parcel$export(module.exports, "guard", () => $2749bee247d49a72$export$864d727b48066337);
function $2749bee247d49a72$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}

});



parcelRegister("fFgN5", function(module, exports) {

$parcel$export(module.exports, "make", () => $b677b5a03c897589$export$dd44f18ab656f3bb);
$parcel$export(module.exports, "getApplicative", () => $b677b5a03c897589$export$1402880adb2295a7);

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");
var $b677b5a03c897589$export$dd44f18ab656f3bb = (0, $72EOc.unsafeCoerce);
function $b677b5a03c897589$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $b677b5a03c897589$export$804fed467fde44e4 = (0, $72EOc.identity);
var $b677b5a03c897589$export$1af51209b1b91d07 = (0, $72EOc.identity);
var $b677b5a03c897589$export$c55397fc301c5a = (0, $72EOc.identity);
var $b677b5a03c897589$export$e759a9a7f8d04692 = (0, $72EOc.identity);
var $b677b5a03c897589$export$c2a7ef2cc9b32b31 = (0, $72EOc.identity);
var $b677b5a03c897589$export$3d48c7fefc7b8ec2 = (0, $72EOc.identity);
var $b677b5a03c897589$export$575097c1c561f76f = (0, $72EOc.identity);
var $b677b5a03c897589$export$2e73cb3f0f25ed55 = (0, $72EOc.identity);
var $b677b5a03c897589$export$f37f1abb2c955577 = (0, $72EOc.identity);
function $b677b5a03c897589$export$81090df2aa47ff12(S) {
    return {
        URI: $b677b5a03c897589$export$9156e739aa33e19f,
        _E: undefined,
        map: $b677b5a03c897589$var$_map,
        ap: function(fab, fa) {
            return $b677b5a03c897589$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $b677b5a03c897589$export$1402880adb2295a7(M) {
    var A = $b677b5a03c897589$export$81090df2aa47ff12(M);
    return {
        URI: $b677b5a03c897589$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $b677b5a03c897589$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $b677b5a03c897589$var$_contramap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $b677b5a03c897589$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $b677b5a03c897589$var$_bimap = function(fa, f, g) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $b677b5a03c897589$var$_mapLeft = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$472de43a55e4aa49(f));
};
var $b677b5a03c897589$export$53b696d27ecb7ba7 = function() {
    return 0, $72EOc.unsafeCoerce;
};
var $b677b5a03c897589$export$871de8747c9eaa88 = function() {
    return 0, $72EOc.unsafeCoerce;
};
var $b677b5a03c897589$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $b677b5a03c897589$export$dd44f18ab656f3bb(f(fa));
    };
};
var $b677b5a03c897589$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $b677b5a03c897589$export$dd44f18ab656f3bb(f(fa));
    };
};
var $b677b5a03c897589$export$9156e739aa33e19f = 'Const';
var $b677b5a03c897589$export$bd5b6bfc5fa2ee61 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    map: $b677b5a03c897589$var$_map
};
var $b677b5a03c897589$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($b677b5a03c897589$export$bd5b6bfc5fa2ee61);
var $b677b5a03c897589$export$def901a57d5539c3 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    contramap: $b677b5a03c897589$var$_contramap
};
var $b677b5a03c897589$export$fd0fe42029639505 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    bimap: $b677b5a03c897589$var$_bimap,
    mapLeft: $b677b5a03c897589$var$_mapLeft
};
var $b677b5a03c897589$export$dfdd8a9a12668b21 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    map: $b677b5a03c897589$var$_map,
    contramap: $b677b5a03c897589$var$_contramap,
    bimap: $b677b5a03c897589$var$_bimap,
    mapLeft: $b677b5a03c897589$var$_mapLeft
};

});

parcelRegister("1Te5W", function(module, exports) {

$parcel$export(module.exports, "monoidAll", () => $1605dc6b7f5aa7d2$export$ea84ccdc68daa647);
$parcel$export(module.exports, "monoidAny", () => $1605dc6b7f5aa7d2$export$c147905ca5134122);

var $7Ievk = parcelRequire("7Ievk");

var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");

var $58DQ5 = parcelRequire("58DQ5");
var $1605dc6b7f5aa7d2$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $58DQ5.min(B).concat,
        empty: B.top
    };
};
var $1605dc6b7f5aa7d2$export$8960430cfd85939f = function(B) {
    return {
        concat: $58DQ5.max(B).concat,
        empty: B.bottom
    };
};
var $1605dc6b7f5aa7d2$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $58DQ5.reverse(M).concat,
        empty: M.empty
    };
};
var $1605dc6b7f5aa7d2$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($EfnK2.has.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $58DQ5.struct(monoids).concat,
        empty: empty
    };
};
var $1605dc6b7f5aa7d2$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $58DQ5.tuple.apply($58DQ5, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $1605dc6b7f5aa7d2$export$b314777ae20abca9 = function(M) {
    return $58DQ5.concatAll(M)(M.empty);
};
var $1605dc6b7f5aa7d2$export$50d82750fd26461d = {
    concat: $58DQ5.semigroupVoid.concat,
    empty: undefined
};
var $1605dc6b7f5aa7d2$export$4ab04e39033ac22a = $1605dc6b7f5aa7d2$export$65e3907585753458;
var $1605dc6b7f5aa7d2$export$dfc91d1e5b77420b = $1605dc6b7f5aa7d2$export$8cf3da7c1c9174ea;
var $1605dc6b7f5aa7d2$export$5ca84f9b29f1c1a2 = $1605dc6b7f5aa7d2$export$66c1ae025e96b4bc;
var $1605dc6b7f5aa7d2$export$9cc0388793460b00 = $1605dc6b7f5aa7d2$export$8960430cfd85939f;
var $1605dc6b7f5aa7d2$export$6d1c667712a51996 = $1605dc6b7f5aa7d2$export$96ec731ed4dcb222;
var $1605dc6b7f5aa7d2$export$93e2b83da34ff82a = $1605dc6b7f5aa7d2$export$b314777ae20abca9;
var $1605dc6b7f5aa7d2$export$ea84ccdc68daa647 = {
    concat: $58DQ5.semigroupAll.concat,
    empty: true
};
var $1605dc6b7f5aa7d2$export$c147905ca5134122 = {
    concat: $58DQ5.semigroupAny.concat,
    empty: false
};
var $1605dc6b7f5aa7d2$export$616ba591d6210ed8 = (0, $72EOc.getMonoid);
var $1605dc6b7f5aa7d2$export$5c6d2e402d334f37 = function() {
    return $1605dc6b7f5aa7d2$export$66c1ae025e96b4bc((0, $7Ievk.getMonoid)());
};
var $1605dc6b7f5aa7d2$export$fc39f3d77fa2e58a = {
    concat: $58DQ5.semigroupString.concat,
    empty: ''
};
var $1605dc6b7f5aa7d2$export$8f9c64d4a92a9eb6 = {
    concat: $58DQ5.semigroupSum.concat,
    empty: 0
};
var $1605dc6b7f5aa7d2$export$cb362f92c995f3b8 = {
    concat: $58DQ5.semigroupProduct.concat,
    empty: 1
};

});
parcelRegister("7Ievk", function(module, exports) {

$parcel$export(module.exports, "getMonoid", () => $59d7e4b4896d2e87$export$c2a7ef2cc9b32b31);
/**
 * @since 2.11.0
 */ 
var $72EOc = parcelRequire("72EOc");
var $59d7e4b4896d2e87$export$9156e739aa33e19f = 'Endomorphism';
var $59d7e4b4896d2e87$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $72EOc.flow)(first, second);
        }
    };
};
var $59d7e4b4896d2e87$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $59d7e4b4896d2e87$export$e759a9a7f8d04692().concat,
        empty: (0, $72EOc.identity)
    };
};

});


parcelRegister("bxsNd", function(module, exports) {

$parcel$export(module.exports, "none", () => $86691c66edf4fb98$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $86691c66edf4fb98$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "fromPredicate", () => $86691c66edf4fb98$export$23f31c55d7162b91);
$parcel$export(module.exports, "map", () => $86691c66edf4fb98$export$871de8747c9eaa88);
$parcel$export(module.exports, "isNone", () => $86691c66edf4fb98$export$e56af863d5645d5f);
$parcel$export(module.exports, "fromEither", () => $86691c66edf4fb98$export$80c878c9b1d77917);
$parcel$export(module.exports, "fold", () => $86691c66edf4fb98$export$93e2b83da34ff82a);
$parcel$export(module.exports, "getOrElse", () => $86691c66edf4fb98$export$8832081647a02ee7);
$parcel$export(module.exports, "fromNullable", () => $86691c66edf4fb98$export$b601f49376b4621a);
$parcel$export(module.exports, "chain", () => $86691c66edf4fb98$export$e08e3b67e392101e);
$parcel$export(module.exports, "option", () => $86691c66edf4fb98$export$a75d1723e6bda2ec);
$parcel$export(module.exports, "getFirstMonoid", () => $86691c66edf4fb98$export$56cd0d85e73e688f);

var $9xys1 = parcelRequire("9xys1");

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $9RniI = parcelRequire("9RniI");

var $58DQ5 = parcelRequire("58DQ5");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");

var $3n81G = parcelRequire("3n81G");
var $86691c66edf4fb98$export$f883a24d5edde77c = $EfnK2.none;
var $86691c66edf4fb98$export$ad14ef4001db2bcd = $EfnK2.some;
function $86691c66edf4fb98$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $86691c66edf4fb98$export$ad14ef4001db2bcd(a) : $86691c66edf4fb98$export$f883a24d5edde77c;
    };
}
var $86691c66edf4fb98$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(ma.left);
};
var $86691c66edf4fb98$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(ma.right);
};
var $86691c66edf4fb98$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$871de8747c9eaa88(f));
};
var $86691c66edf4fb98$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $86691c66edf4fb98$export$2f6ca3d3b1f80bf5(fa));
};
var $86691c66edf4fb98$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$533b26079ad0b4b(b, f));
};
var $86691c66edf4fb98$var$_foldMap = function(M) {
    var foldMapM = $86691c66edf4fb98$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
var $86691c66edf4fb98$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$7fef8bcdbb34f435(b, f));
};
var $86691c66edf4fb98$var$_traverse = function(F) {
    var traverseF = $86691c66edf4fb98$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$228be17d80722ab(that));
};
var $86691c66edf4fb98$var$_filter = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_filterMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $86691c66edf4fb98$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_partition = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_partitionMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$3117e3f9ececb6bc(f));
};
var $86691c66edf4fb98$export$9156e739aa33e19f = 'Option';
var $86691c66edf4fb98$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $86691c66edf4fb98$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($86691c66edf4fb98$export$e56af863d5645d5f(x) ? $86691c66edf4fb98$export$e56af863d5645d5f(y) : $86691c66edf4fb98$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $86691c66edf4fb98$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $86691c66edf4fb98$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $86691c66edf4fb98$export$5d7e502287836e58(x) ? $86691c66edf4fb98$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
var $86691c66edf4fb98$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(x) ? y : $86691c66edf4fb98$export$e56af863d5645d5f(y) ? x : $86691c66edf4fb98$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $86691c66edf4fb98$export$f883a24d5edde77c
    };
};
var $86691c66edf4fb98$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $86691c66edf4fb98$export$bd5b6bfc5fa2ee61 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map
};
var $86691c66edf4fb98$export$6554612db691658e = (0, $72EOc.dual)(2, (0, $cpwuW.as)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61));
var $86691c66edf4fb98$export$9284b360ca18a0fd = (0, $cpwuW.asUnit)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$ba255e9e49e00608 = $86691c66edf4fb98$export$ad14ef4001db2bcd;
var $86691c66edf4fb98$export$59a71046037e6c20 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    of: $86691c66edf4fb98$export$ba255e9e49e00608
};
var $86691c66edf4fb98$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fab) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $86691c66edf4fb98$export$efc21ddc6aeb363d = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap
};
var $86691c66edf4fb98$export$1279d2b7807629fd = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608
};
var $86691c66edf4fb98$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? $86691c66edf4fb98$export$f883a24d5edde77c : f(ma.value);
});
var $86691c66edf4fb98$export$f18d5acc27d70423 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16
};
var $86691c66edf4fb98$export$fb641926d034ac7d = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16
};
var $86691c66edf4fb98$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $86691c66edf4fb98$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $86691c66edf4fb98$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $86691c66edf4fb98$export$41404b31838667c9 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight
};
var $86691c66edf4fb98$export$41d1a04d78e7b141 = (0, $72EOc.dual)(2, function(self, that) {
    return $86691c66edf4fb98$export$e56af863d5645d5f(self) ? that() : self;
});
var $86691c66edf4fb98$export$1517cca7889d6aaa = $86691c66edf4fb98$export$41d1a04d78e7b141;
var $86691c66edf4fb98$export$228be17d80722ab = $86691c66edf4fb98$export$41d1a04d78e7b141;
var $86691c66edf4fb98$export$25ba4469a069167 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    alt: $86691c66edf4fb98$var$_alt
};
var $86691c66edf4fb98$export$7f9972325ebfd559 = function() {
    return $86691c66edf4fb98$export$f883a24d5edde77c;
};
var $86691c66edf4fb98$export$aaef8a3eae948f03 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    zero: $86691c66edf4fb98$export$7f9972325ebfd559
};
var $86691c66edf4fb98$export$864d727b48066337 = /*#__PURE__*/ (0, $3n81G.guard)($86691c66edf4fb98$export$aaef8a3eae948f03, $86691c66edf4fb98$export$59a71046037e6c20);
var $86691c66edf4fb98$export$4acb47accde578d2 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    alt: $86691c66edf4fb98$var$_alt,
    zero: $86691c66edf4fb98$export$7f9972325ebfd559
};
var $86691c66edf4fb98$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(wa) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(f(wa));
    };
};
var $86691c66edf4fb98$export$5b5dd0e212d2a5bc = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    extend: $86691c66edf4fb98$var$_extend
};
var $86691c66edf4fb98$export$8e16b83750b44988 = /*#__PURE__*/ $86691c66edf4fb98$export$5b8affa63fc6df16((0, $72EOc.identity));
var $86691c66edf4fb98$var$defaultSeparated = /*#__PURE__*/ (0, $1HSKK.separated)($86691c66edf4fb98$export$f883a24d5edde77c, $86691c66edf4fb98$export$f883a24d5edde77c);
var $86691c66edf4fb98$export$709f6946f4e97408 = function(ma) {
    return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? $86691c66edf4fb98$var$defaultSeparated : (0, $1HSKK.separated)($86691c66edf4fb98$export$da405662c16fca8e(ma.value), $86691c66edf4fb98$export$482f3615ecf01dc6(ma.value));
};
var $86691c66edf4fb98$export$4a21ac48141ac3c9 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408
};
var $86691c66edf4fb98$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : predicate(fa.value) ? fa : $86691c66edf4fb98$export$f883a24d5edde77c;
    };
};
var $86691c66edf4fb98$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : f(fa.value);
    };
};
var $86691c66edf4fb98$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $1HSKK.separated)($86691c66edf4fb98$var$_filter(fa, (0, $9RniI.not)(predicate)), $86691c66edf4fb98$var$_filter(fa, predicate));
    };
};
var $86691c66edf4fb98$export$3117e3f9ececb6bc = function(f) {
    return (0, $72EOc.flow)($86691c66edf4fb98$export$871de8747c9eaa88(f), $86691c66edf4fb98$export$709f6946f4e97408);
};
var $86691c66edf4fb98$export$d00e1c48fb621173 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408,
    filter: $86691c66edf4fb98$var$_filter,
    filterMap: $86691c66edf4fb98$var$_filterMap,
    partition: $86691c66edf4fb98$var$_partition,
    partitionMap: $86691c66edf4fb98$var$_partitionMap
};
var $86691c66edf4fb98$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(ta) ? F.of($86691c66edf4fb98$export$f883a24d5edde77c) : F.map(f(ta.value), $86691c66edf4fb98$export$ad14ef4001db2bcd);
        };
    };
};
var $86691c66edf4fb98$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ta) ? F.of($86691c66edf4fb98$export$f883a24d5edde77c) : F.map(ta.value, $86691c66edf4fb98$export$ad14ef4001db2bcd);
    };
};
var $86691c66edf4fb98$export$a0202666c3bda011 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight,
    traverse: $86691c66edf4fb98$var$_traverse,
    sequence: $86691c66edf4fb98$export$49bb65c2ea163039
};
var $86691c66edf4fb98$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($86691c66edf4fb98$export$a0202666c3bda011, $86691c66edf4fb98$export$4a21ac48141ac3c9);
var $86691c66edf4fb98$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($86691c66edf4fb98$export$a0202666c3bda011, $86691c66edf4fb98$export$4a21ac48141ac3c9);
var $86691c66edf4fb98$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $86691c66edf4fb98$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $86691c66edf4fb98$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $86691c66edf4fb98$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $86691c66edf4fb98$export$748d317b4c426f96 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight,
    traverse: $86691c66edf4fb98$var$_traverse,
    sequence: $86691c66edf4fb98$export$49bb65c2ea163039,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408,
    filter: $86691c66edf4fb98$var$_filter,
    filterMap: $86691c66edf4fb98$var$_filterMap,
    partition: $86691c66edf4fb98$var$_partition,
    partitionMap: $86691c66edf4fb98$var$_partitionMap,
    wither: $86691c66edf4fb98$var$_wither,
    wilt: $86691c66edf4fb98$var$_wilt
};
var $86691c66edf4fb98$export$8bf7aba4a9e09055 = function() {
    return $86691c66edf4fb98$export$f883a24d5edde77c;
};
var $86691c66edf4fb98$export$5f956d47d0619c3a = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16,
    throwError: $86691c66edf4fb98$export$8bf7aba4a9e09055
};
var $86691c66edf4fb98$export$80c878c9b1d77917 = $86691c66edf4fb98$export$482f3615ecf01dc6;
var $86691c66edf4fb98$export$825ea6cb6fc48d49 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    fromEither: $86691c66edf4fb98$export$80c878c9b1d77917
};
var $86691c66edf4fb98$export$5d7e502287836e58 = $EfnK2.isSome;
var $86691c66edf4fb98$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $86691c66edf4fb98$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $86691c66edf4fb98$export$ccb09033cefa61e8 = $86691c66edf4fb98$export$2d55ea551c238330;
var $86691c66edf4fb98$export$4659b591c19bdf3d = $86691c66edf4fb98$export$2d55ea551c238330;
var $86691c66edf4fb98$export$93e2b83da34ff82a = $86691c66edf4fb98$export$4659b591c19bdf3d;
var $86691c66edf4fb98$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $86691c66edf4fb98$export$8832081647a02ee7 = $86691c66edf4fb98$export$d8a997ff0e6436f3;
var $86691c66edf4fb98$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$bffa455ba8c619a6 = $86691c66edf4fb98$export$8e16b83750b44988;
var $86691c66edf4fb98$export$3f23594af5f37336 = /*#__PURE__*/ (0, $72EOc.dual)(2, $kgj0x.tap($86691c66edf4fb98$export$f18d5acc27d70423));
var $86691c66edf4fb98$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $72EOc.dual)(2, (0, $jFfj2.tapEither)($86691c66edf4fb98$export$825ea6cb6fc48d49, $86691c66edf4fb98$export$f18d5acc27d70423));
var $86691c66edf4fb98$export$ecd5e8ace626722c = /*#__PURE__*/ $86691c66edf4fb98$export$8b58be045bf06082((0, $72EOc.identity));
var $86691c66edf4fb98$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $jFfj2.fromEitherK)($86691c66edf4fb98$export$825ea6cb6fc48d49);
var $86691c66edf4fb98$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $jFfj2.chainEitherK)($86691c66edf4fb98$export$825ea6cb6fc48d49, $86691c66edf4fb98$export$f18d5acc27d70423);
var $86691c66edf4fb98$export$c5f2bdbf9b43f0c0 = $86691c66edf4fb98$export$be3ff275bb5a8ac9;
var $86691c66edf4fb98$export$b601f49376b4621a = function(a) {
    return a == null ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(a);
};
var $86691c66edf4fb98$export$d234c058d1d4e435 = function(f) {
    try {
        return $86691c66edf4fb98$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $86691c66edf4fb98$export$f883a24d5edde77c;
    }
};
var $86691c66edf4fb98$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $86691c66edf4fb98$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $86691c66edf4fb98$export$c69ca7b73fad45e1 = function(f) {
    return (0, $72EOc.flow)(f, $86691c66edf4fb98$export$b601f49376b4621a);
};
var $86691c66edf4fb98$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$b601f49376b4621a(f(ma.value));
    };
};
var $86691c66edf4fb98$export$b187f57ee1822bc5 = /*#__PURE__*/ $86691c66edf4fb98$export$4659b591c19bdf3d((0, $72EOc.constNull), (0, $72EOc.identity));
var $86691c66edf4fb98$export$cb585b8513fa8577 = /*#__PURE__*/ $86691c66edf4fb98$export$4659b591c19bdf3d((0, $72EOc.constUndefined), (0, $72EOc.identity));
function $86691c66edf4fb98$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $86691c66edf4fb98$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $86691c66edf4fb98$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $86691c66edf4fb98$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $86691c66edf4fb98$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $86691c66edf4fb98$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$2385a24977818dd0 = /*#__PURE__*/ $kgj0x.bind($86691c66edf4fb98$export$f18d5acc27d70423);
var $86691c66edf4fb98$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $86691c66edf4fb98$export$ba255e9e49e00608($EfnK2.emptyReadonlyArray);
var $86691c66edf4fb98$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $EfnK2.head(as));
        if ($86691c66edf4fb98$export$e56af863d5645d5f(o)) return $86691c66edf4fb98$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($86691c66edf4fb98$export$e56af863d5645d5f(o_1)) return $86691c66edf4fb98$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $86691c66edf4fb98$export$ad14ef4001db2bcd(out);
    };
};
var $86691c66edf4fb98$export$d4e79db5dc14cc1 = function(f) {
    var g = $86691c66edf4fb98$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $EfnK2.isNonEmpty(as) ? g(as) : $86691c66edf4fb98$export$c74b6e34b2b6efb0;
    };
};
var $86691c66edf4fb98$export$104a2841e9cbad06 = $86691c66edf4fb98$export$d4e79db5dc14cc1;
var $86691c66edf4fb98$export$64f39b2a2b79e1b1 = function(f) {
    return $86691c66edf4fb98$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $86691c66edf4fb98$export$d330b60315c14cd1 = /*#__PURE__*/ $86691c66edf4fb98$export$64f39b2a2b79e1b1((0, $72EOc.identity));
var $86691c66edf4fb98$export$e08e3b67e392101e = $86691c66edf4fb98$export$5b8affa63fc6df16;
var $86691c66edf4fb98$export$e3821ef4970c339c = $86691c66edf4fb98$export$3f23594af5f37336;
function $86691c66edf4fb98$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $86691c66edf4fb98$export$5d7e502287836e58(getOption(a));
    };
}
var $86691c66edf4fb98$export$c2a8dfc107523e74 = $86691c66edf4fb98$export$c81f992c08fd0bf3;
var $86691c66edf4fb98$export$a75d1723e6bda2ec = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    ap: $86691c66edf4fb98$var$_ap,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight,
    traverse: $86691c66edf4fb98$var$_traverse,
    sequence: $86691c66edf4fb98$export$49bb65c2ea163039,
    zero: $86691c66edf4fb98$export$7f9972325ebfd559,
    alt: $86691c66edf4fb98$var$_alt,
    extend: $86691c66edf4fb98$var$_extend,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408,
    filter: $86691c66edf4fb98$var$_filter,
    filterMap: $86691c66edf4fb98$var$_filterMap,
    partition: $86691c66edf4fb98$var$_partition,
    partitionMap: $86691c66edf4fb98$var$_partitionMap,
    wither: $86691c66edf4fb98$var$_wither,
    wilt: $86691c66edf4fb98$var$_wilt,
    throwError: $86691c66edf4fb98$export$8bf7aba4a9e09055
};
var $86691c66edf4fb98$export$18979a515d2a828e = /*#__PURE__*/ (0, $aYN4d.getApplySemigroup)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $9xys1.getApplicativeMonoid)($86691c66edf4fb98$export$1279d2b7807629fd);
var $86691c66edf4fb98$export$56cd0d85e73e688f = function() {
    return $86691c66edf4fb98$export$c2a7ef2cc9b32b31((0, $58DQ5.first)());
};
var $86691c66edf4fb98$export$ca391a563a1f3001 = function() {
    return $86691c66edf4fb98$export$c2a7ef2cc9b32b31((0, $58DQ5.last)());
};

});
parcelRegister("9xys1", function(module, exports) {

$parcel$export(module.exports, "getApplicativeMonoid", () => $6f21eb604bad4e3c$export$c8e1a8ea383fd0ff);
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 
var $aYN4d = parcelRequire("aYN4d");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");
function $6f21eb604bad4e3c$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $aYN4d.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $6f21eb604bad4e3c$export$9833a940afed18f3(F, G) {
    var map = (0, $cpwuW.getFunctorComposition)(F, G).map;
    var _ap = (0, $aYN4d.ap)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $72EOc.pipe)(fgab, _ap(fga));
        }
    };
}

});

parcelRegister("9RniI", function(module, exports) {

$parcel$export(module.exports, "not", () => $72db235846b6a73e$export$6003a5f097c73977);

var $72EOc = parcelRequire("72EOc");
var $72db235846b6a73e$var$contramap_ = function(predicate, f) {
    return (0, $72EOc.pipe)(predicate, $72db235846b6a73e$export$53b696d27ecb7ba7(f));
};
var $72db235846b6a73e$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $72EOc.flow)(f, predicate);
    };
};
var $72db235846b6a73e$export$9156e739aa33e19f = 'Predicate';
var $72db235846b6a73e$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $72EOc.pipe)(first, $72db235846b6a73e$export$252bb8b3bbdf6749(second));
        }
    };
};
var $72db235846b6a73e$export$d795ff673668f564 = function() {
    return {
        concat: $72db235846b6a73e$export$45c71cec3a7e90aa().concat,
        empty: (0, $72EOc.constFalse)
    };
};
var $72db235846b6a73e$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $72EOc.pipe)(first, $72db235846b6a73e$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $72db235846b6a73e$export$4c43b04d78b174fa = function() {
    return {
        concat: $72db235846b6a73e$export$d900a29579818780().concat,
        empty: (0, $72EOc.constTrue)
    };
};
var $72db235846b6a73e$export$def901a57d5539c3 = {
    URI: $72db235846b6a73e$export$9156e739aa33e19f,
    contramap: $72db235846b6a73e$var$contramap_
};
var $72db235846b6a73e$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $72db235846b6a73e$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $72db235846b6a73e$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};

});


parcelRegister("30crt", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $22fb05f0a3736777$export$a4627e546088548d);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $72EOc = parcelRequire("72EOc");
function $22fb05f0a3736777$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $22fb05f0a3736777$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $22fb05f0a3736777$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $22fb05f0a3736777$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $22fb05f0a3736777$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $22fb05f0a3736777$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $22fb05f0a3736777$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $22fb05f0a3736777$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $22fb05f0a3736777$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $22fb05f0a3736777$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $22fb05f0a3736777$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $22fb05f0a3736777$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $22fb05f0a3736777$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $22fb05f0a3736777$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $22fb05f0a3736777$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $22fb05f0a3736777$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $22fb05f0a3736777$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $22fb05f0a3736777$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $22fb05f0a3736777$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $22fb05f0a3736777$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $22fb05f0a3736777$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $22fb05f0a3736777$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $22fb05f0a3736777$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $22fb05f0a3736777$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $22fb05f0a3736777$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $22fb05f0a3736777$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $22fb05f0a3736777$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $22fb05f0a3736777$export$1124ffa357d27237(I) {
    var r = {};
    if ($22fb05f0a3736777$var$isFunctor(I)) r.map = $22fb05f0a3736777$export$871de8747c9eaa88(I);
    if ($22fb05f0a3736777$var$isContravariant(I)) r.contramap = $22fb05f0a3736777$export$53b696d27ecb7ba7(I);
    if ($22fb05f0a3736777$var$isFunctorWithIndex(I)) r.mapWithIndex = $22fb05f0a3736777$export$8f07ddce13659f50(I);
    if ($22fb05f0a3736777$var$isApply(I)) {
        r.ap = $22fb05f0a3736777$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $aYN4d.apFirst)(I);
        r.apSecond = (0, $aYN4d.apSecond)(I);
    }
    if ($22fb05f0a3736777$var$isChain(I)) {
        r.chain = $22fb05f0a3736777$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $kgj0x.chainFirst)(I);
        r.flatten = r.chain((0, $72EOc.identity));
    }
    if ($22fb05f0a3736777$var$isBifunctor(I)) {
        r.bimap = $22fb05f0a3736777$export$eb54baf0b342cb1d(I);
        r.mapLeft = $22fb05f0a3736777$export$472de43a55e4aa49(I);
    }
    if ($22fb05f0a3736777$var$isExtend(I)) {
        r.extend = $22fb05f0a3736777$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $72EOc.identity));
    }
    if ($22fb05f0a3736777$var$isFoldable(I)) {
        r.reduce = $22fb05f0a3736777$export$533b26079ad0b4b(I);
        r.foldMap = $22fb05f0a3736777$export$b66cdc0497d8a99a(I);
        r.reduceRight = $22fb05f0a3736777$export$7fef8bcdbb34f435(I);
    }
    if ($22fb05f0a3736777$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $22fb05f0a3736777$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $22fb05f0a3736777$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $22fb05f0a3736777$export$ce2b2fe0b88ccd0a(I);
    }
    if ($22fb05f0a3736777$var$isAlt(I)) r.alt = $22fb05f0a3736777$export$228be17d80722ab(I);
    if ($22fb05f0a3736777$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($22fb05f0a3736777$var$isFilterable(I)) {
        r.filter = $22fb05f0a3736777$export$3dea766d36a8935f(I);
        r.filterMap = $22fb05f0a3736777$export$a04c6c6965dd4709(I);
        r.partition = $22fb05f0a3736777$export$b29f828819edca8d(I);
        r.partitionMap = $22fb05f0a3736777$export$3117e3f9ececb6bc(I);
    }
    if ($22fb05f0a3736777$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $22fb05f0a3736777$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $22fb05f0a3736777$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $22fb05f0a3736777$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $22fb05f0a3736777$export$bc7c0794b9c6f3ba(I);
    }
    if ($22fb05f0a3736777$var$isProfunctor(I)) r.promap = $22fb05f0a3736777$export$6684e88861ab74ec(I);
    if ($22fb05f0a3736777$var$isSemigroupoid(I)) r.compose = $22fb05f0a3736777$export$f672e0b6f7222cd7(I);
    if ($22fb05f0a3736777$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $22fb05f0a3736777$export$a4627e546088548d = (0, $72EOc.pipe);

});

parcelRegister("4O2fb", function(module, exports) {

$parcel$export(module.exports, "fromIso", () => $37fd928b21aaf2a5$export$3160d47a1ad63980);

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $4qiTD = parcelRequire("4qiTD");

var $kxnus = parcelRequire("kxnus");

var $lV5N9 = parcelRequire("lV5N9");
var $37fd928b21aaf2a5$export$493d36ec626b6698 = $lV5N9.at;
var $37fd928b21aaf2a5$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $37fd928b21aaf2a5$export$493d36ec626b6698(function(i) {
            return (0, $30crt.pipe)(iso, $lV5N9.isoAsLens, $lV5N9.lensComposeLens(sia.at(i)));
        });
    };
};
var $37fd928b21aaf2a5$export$ba8573d258bae607 = $lV5N9.atReadonlyRecord;
var $37fd928b21aaf2a5$export$3d6583cb45ca961e = function(E) {
    var lookupE = $4qiTD.lookup(E);
    var deleteAtE = $4qiTD.deleteAt(E);
    var insertAtE = $4qiTD.insertAt(E);
    return function() {
        return $37fd928b21aaf2a5$export$493d36ec626b6698(function(key) {
            return $lV5N9.lens(function(s) {
                return lookupE(key, s);
            }, $bxsNd.fold(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $37fd928b21aaf2a5$export$388a7d8e51ea972f = function(E) {
    var elemE = $kxnus.elem(E);
    var insertE = $kxnus.insert(E);
    var removeE = $kxnus.remove(E);
    return $37fd928b21aaf2a5$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $lV5N9.lens(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $37fd928b21aaf2a5$export$1cfc761eca4929a9 = $lV5N9.atReadonlyRecord;

});
parcelRegister("4qiTD", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $33883f933227ea54$export$dfc7155ac0343b8);
$parcel$export(module.exports, "deleteAt", () => $33883f933227ea54$export$90f9093465da3136);
$parcel$export(module.exports, "insertAt", () => $33883f933227ea54$export$9f200c4466975173);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $bxsNd = parcelRequire("bxsNd");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");
var $33883f933227ea54$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $33883f933227ea54$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $33883f933227ea54$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $33883f933227ea54$export$346677f925de839c = function(m) {
    return m.size;
};
var $33883f933227ea54$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $33883f933227ea54$export$6a0d13241802fe80(E) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $33883f933227ea54$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $EfnK2.isSome(lookupE(k, m));
    };
}
function $33883f933227ea54$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $33883f933227ea54$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $33883f933227ea54$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $33883f933227ea54$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $33883f933227ea54$export$bb44f104e3c54dae(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $33883f933227ea54$export$4aaa3912a3956cb7 = function(O) {
    return $33883f933227ea54$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $33883f933227ea54$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $33883f933227ea54$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $EfnK2.some([
                kas[b],
                b + 1
            ]) : $EfnK2.none;
        });
    };
}
var $33883f933227ea54$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($EfnK2.isNone(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $33883f933227ea54$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($EfnK2.isSome(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $33883f933227ea54$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $33883f933227ea54$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $33883f933227ea54$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($EfnK2.isNone(found)) return $EfnK2.none;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $EfnK2.some(m);
            var r = new Map(m);
            r.set(fk, next);
            return $EfnK2.some(r);
        };
    };
};
function $33883f933227ea54$export$3e41007ebfff0e64(E) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    var deleteAtE = $33883f933227ea54$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $72EOc.pipe)(lookupE(k, m), $bxsNd.map(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $33883f933227ea54$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $EfnK2.some([
                ka,
                a
            ]);
        }
        return $EfnK2.none;
    };
}
function $33883f933227ea54$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $33883f933227ea54$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $72EOc.pipe)(lookupWithKeyE(k, m), $bxsNd.map(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $33883f933227ea54$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $33883f933227ea54$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $33883f933227ea54$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($EfnK2.isNone(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $33883f933227ea54$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $33883f933227ea54$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $33883f933227ea54$export$35d0420a84c5d3ae(SK, SA);
    return (0, $3Md1m.fromEquals)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $33883f933227ea54$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $33883f933227ea54$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(mx)) return my;
            if ($33883f933227ea54$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($EfnK2.isSome(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $33883f933227ea54$export$6e22c362a0406a2c
    };
}
var $33883f933227ea54$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $33883f933227ea54$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($EfnK2.isSome(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $33883f933227ea54$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $33883f933227ea54$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($EfnK2.isLeft(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
function $33883f933227ea54$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
var $33883f933227ea54$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($EfnK2.isSome(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $33883f933227ea54$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $33883f933227ea54$var$_map = function(fa, f) {
    return $33883f933227ea54$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $33883f933227ea54$var$_filter = function(fa, p) {
    return $33883f933227ea54$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $33883f933227ea54$var$_filterMap = function(fa, f) {
    return $33883f933227ea54$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $33883f933227ea54$var$_partition = function(fa, predicate) {
    return $33883f933227ea54$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $33883f933227ea54$var$_partitionMap = function(fa, f) {
    return $33883f933227ea54$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $33883f933227ea54$var$_filterWithIndex = function(fa, p) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$36e42aef19fc7171(p));
};
var $33883f933227ea54$var$_filterMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$30c5cbe848021e97(f));
};
var $33883f933227ea54$var$_partitionWithIndex = function(fa, p) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$dad5e500f2bab9bc(p));
};
var $33883f933227ea54$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$bc7c0794b9c6f3ba(f));
};
var $33883f933227ea54$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($EfnK2.isSome(oa)) m.set(k, oa.value);
    }
    return m;
};
var $33883f933227ea54$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $33883f933227ea54$var$_filter(fa, predicate);
    };
};
var $33883f933227ea54$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_filterMap(fa, f);
    };
};
var $33883f933227ea54$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_map(fa, f);
    };
};
var $33883f933227ea54$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_mapWithIndex(fa, f);
    };
};
var $33883f933227ea54$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $33883f933227ea54$var$_partition(fa, predicate);
    };
};
var $33883f933227ea54$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_partitionMap(fa, f);
    };
};
var $33883f933227ea54$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($EfnK2.isLeft(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $1HSKK.separated)(left, right);
};
var $33883f933227ea54$export$9156e739aa33e19f = 'ReadonlyMap';
var $33883f933227ea54$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $33883f933227ea54$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $33883f933227ea54$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $33883f933227ea54$export$baca17b4aff42f82(E, S).concat,
        empty: $33883f933227ea54$export$6e22c362a0406a2c
    };
};
var $33883f933227ea54$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $33883f933227ea54$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $33883f933227ea54$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $33883f933227ea54$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $33883f933227ea54$export$d600270efcad85ac() {
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex,
        compact: $33883f933227ea54$export$8e16b83750b44988,
        separate: $33883f933227ea54$export$709f6946f4e97408,
        filter: $33883f933227ea54$var$_filter,
        filterMap: $33883f933227ea54$var$_filterMap,
        partition: $33883f933227ea54$var$_partition,
        partitionMap: $33883f933227ea54$var$_partitionMap,
        partitionMapWithIndex: $33883f933227ea54$var$_partitionMapWithIndex,
        partitionWithIndex: $33883f933227ea54$var$_partitionWithIndex,
        filterMapWithIndex: $33883f933227ea54$var$_filterMapWithIndex,
        filterWithIndex: $33883f933227ea54$var$_filterWithIndex
    };
}
var $33883f933227ea54$export$bd5b6bfc5fa2ee61 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    map: $33883f933227ea54$var$_map
};
var $33883f933227ea54$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($33883f933227ea54$export$bd5b6bfc5fa2ee61);
var $33883f933227ea54$export$7c7748da5f3db60f = function() {
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex
    };
};
var $33883f933227ea54$export$4a21ac48141ac3c9 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    compact: $33883f933227ea54$export$8e16b83750b44988,
    separate: $33883f933227ea54$export$709f6946f4e97408
};
var $33883f933227ea54$export$d00e1c48fb621173 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    map: $33883f933227ea54$var$_map,
    compact: $33883f933227ea54$export$8e16b83750b44988,
    separate: $33883f933227ea54$export$709f6946f4e97408,
    filter: $33883f933227ea54$var$_filter,
    filterMap: $33883f933227ea54$var$_filterMap,
    partition: $33883f933227ea54$var$_partition,
    partitionMap: $33883f933227ea54$var$_partitionMap
};
var $33883f933227ea54$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $33883f933227ea54$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $33883f933227ea54$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $33883f933227ea54$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $33883f933227ea54$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $33883f933227ea54$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $33883f933227ea54$export$d544f02c7cebdaed = function(O) {
    var reduceO = $33883f933227ea54$export$533b26079ad0b4b(O);
    var foldMapO = $33883f933227ea54$export$b66cdc0497d8a99a(O);
    var reduceRightO = $33883f933227ea54$export$7fef8bcdbb34f435(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $72EOc.pipe)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceRightO(b, f));
        }
    };
};
var $33883f933227ea54$export$bbd3ef8720e22369 = function(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$18153bb1181268e5 = function(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $33883f933227ea54$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$6c59d75f118e7bc9 = function(O) {
    var F = $33883f933227ea54$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $33883f933227ea54$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $33883f933227ea54$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $33883f933227ea54$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $72EOc.pipe)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $33883f933227ea54$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $33883f933227ea54$export$46b81797a3375b8c(O);
    var F = $33883f933227ea54$export$d544f02c7cebdaed(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $33883f933227ea54$export$46b81797a3375b8c = function(O) {
    var FWI = $33883f933227ea54$export$6c59d75f118e7bc9(O);
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $72EOc.SK));
        };
    };
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $33883f933227ea54$export$bb8ef26a634cac7b(O) {
    var TWI = $33883f933227ea54$export$46b81797a3375b8c(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        compact: $33883f933227ea54$export$8e16b83750b44988,
        separate: $33883f933227ea54$export$709f6946f4e97408,
        filter: $33883f933227ea54$var$_filter,
        filterMap: $33883f933227ea54$var$_filterMap,
        partition: $33883f933227ea54$var$_partition,
        partitionMap: $33883f933227ea54$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $jNYdc.wiltDefault)(TWI, $33883f933227ea54$export$4a21ac48141ac3c9),
        wither: (0, $jNYdc.witherDefault)(TWI, $33883f933227ea54$export$4a21ac48141ac3c9)
    };
}
var $33883f933227ea54$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(first)) return second;
            if ($33883f933227ea54$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($EfnK2.isSome(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($EfnK2.isNone(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(first) || $33883f933227ea54$export$dd1bc94b04021eeb(second)) return $33883f933227ea54$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($EfnK2.isSome(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$acaf96a27438246b = function(E) {
    var memberE = $33883f933227ea54$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(first)) return second;
            if ($33883f933227ea54$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$9f200c4466975173 = $33883f933227ea54$export$ff82449ce381c54a;
var $33883f933227ea54$export$28562fb56044e6b5 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    map: $33883f933227ea54$var$_map,
    compact: $33883f933227ea54$export$8e16b83750b44988,
    separate: $33883f933227ea54$export$709f6946f4e97408,
    filter: $33883f933227ea54$var$_filter,
    filterMap: $33883f933227ea54$var$_filterMap,
    partition: $33883f933227ea54$var$_partition,
    partitionMap: $33883f933227ea54$var$_partitionMap
};

});

parcelRegister("kxnus", function(module, exports) {

$parcel$export(module.exports, "elem", () => $ef391c668eef0729$export$5bf96401662340b7);
$parcel$export(module.exports, "insert", () => $ef391c668eef0729$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "remove", () => $ef391c668eef0729$export$cd7f480d6b8286c3);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $9RniI = parcelRequire("9RniI");

var $1HSKK = parcelRequire("1HSKK");
var $ef391c668eef0729$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $ef391c668eef0729$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $ef391c668eef0729$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $ef391c668eef0729$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $ef391c668eef0729$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $ef391c668eef0729$export$871de8747c9eaa88(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $ef391c668eef0729$export$e08e3b67e392101e(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $ef391c668eef0729$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $ef391c668eef0729$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
function $ef391c668eef0729$export$971dd5b0dfd021b6(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $ef391c668eef0729$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($ef391c668eef0729$export$dd1bc94b04021eeb(me)) return that;
        if ($ef391c668eef0729$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $ef391c668eef0729$export$bc86dfbf7795668c(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $ef391c668eef0729$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($ef391c668eef0729$export$dd1bc94b04021eeb(me) || $ef391c668eef0729$export$dd1bc94b04021eeb(that)) return $ef391c668eef0729$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $ef391c668eef0729$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $ef391c668eef0729$export$5bf96401662340b7(EB);
            var hasC = $ef391c668eef0729$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $1HSKK.separated)(left, right);
        };
    };
}
function $ef391c668eef0729$export$acaf96a27438246b(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $ef391c668eef0729$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $ef391c668eef0729$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $ef391c668eef0729$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $ef391c668eef0729$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $ef391c668eef0729$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $ef391c668eef0729$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $ef391c668eef0729$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $ef391c668eef0729$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $ef391c668eef0729$export$21a5ca8aa77d35ff(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $ef391c668eef0729$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $ef391c668eef0729$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $ef391c668eef0729$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    var removeE = $ef391c668eef0729$export$cd7f480d6b8286c3(E);
    var insertE = $ef391c668eef0729$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $ef391c668eef0729$export$8e16b83750b44988 = function(E) {
    return $ef391c668eef0729$export$a04c6c6965dd4709(E)((0, $72EOc.identity));
};
function $ef391c668eef0729$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $ef391c668eef0729$export$5bf96401662340b7(EE);
        var elemEA = $ef391c668eef0729$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $1HSKK.separated)(left, right);
    };
}
function $ef391c668eef0729$export$a04c6c6965dd4709(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $ef391c668eef0729$export$6e22c362a0406a2c = new Set();
var $ef391c668eef0729$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $ef391c668eef0729$export$346677f925de839c = function(set) {
    return set.size;
};
var $ef391c668eef0729$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $ef391c668eef0729$export$7ecc1a3b11b57dab(predicate) {
    return (0, $9RniI.not)($ef391c668eef0729$export$ad14ef4001db2bcd((0, $9RniI.not)(predicate)));
}
function $ef391c668eef0729$export$af04532ec9ff13d2(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $ef391c668eef0729$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $ef391c668eef0729$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $ef391c668eef0729$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $ef391c668eef0729$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $ef391c668eef0729$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $ef391c668eef0729$export$9156e739aa33e19f = 'ReadonlySet';
function $ef391c668eef0729$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $ef391c668eef0729$export$804fed467fde44e4(E) {
    var subsetE = $ef391c668eef0729$export$af04532ec9ff13d2(E);
    return (0, $3Md1m.fromEquals)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $ef391c668eef0729$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $ef391c668eef0729$export$971dd5b0dfd021b6(E)
    };
};
var $ef391c668eef0729$export$c487aac9f4157837 = function(E) {
    return {
        concat: $ef391c668eef0729$export$baca17b4aff42f82(E).concat,
        empty: $ef391c668eef0729$export$6e22c362a0406a2c
    };
};
var $ef391c668eef0729$export$d379a869a72e4055 = function(E) {
    return {
        concat: $ef391c668eef0729$export$bc86dfbf7795668c(E)
    };
};
var $ef391c668eef0729$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $ef391c668eef0729$export$acaf96a27438246b(E)
    };
};
var $ef391c668eef0729$export$571d59b505e6bb4e = $ef391c668eef0729$export$9288e031f1846591;

});

parcelRegister("lV5N9", function(module, exports) {

$parcel$export(module.exports, "iso", () => $ff5369f959674226$export$1aba8f741a0eae06);
$parcel$export(module.exports, "isoAsLens", () => $ff5369f959674226$export$d001ee9513dee7c1);
$parcel$export(module.exports, "lens", () => $ff5369f959674226$export$21cde5187c2605a3);
$parcel$export(module.exports, "isoAsPrism", () => $ff5369f959674226$export$fde8c5b9dff57abc);
$parcel$export(module.exports, "prism", () => $ff5369f959674226$export$e469dcfea9910464);
$parcel$export(module.exports, "isoAsOptional", () => $ff5369f959674226$export$4d3db894cf45abd5);
$parcel$export(module.exports, "optional", () => $ff5369f959674226$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "isoAsTraversal", () => $ff5369f959674226$export$e55a826b3ba968d2);
$parcel$export(module.exports, "traversal", () => $ff5369f959674226$export$8666ce7a134c2314);
$parcel$export(module.exports, "lensAsOptional", () => $ff5369f959674226$export$bae94c671b4dc75d);
$parcel$export(module.exports, "lensAsTraversal", () => $ff5369f959674226$export$e5de01c31c85830c);
$parcel$export(module.exports, "lensComposeLens", () => $ff5369f959674226$export$62d1b5266563d2b6);
$parcel$export(module.exports, "prismComposePrism", () => $ff5369f959674226$export$af9c087537c23eb1);
$parcel$export(module.exports, "lensComposePrism", () => $ff5369f959674226$export$ffffe1ca21811d93);
$parcel$export(module.exports, "optionalComposeOptional", () => $ff5369f959674226$export$8e08893559c32e38);
$parcel$export(module.exports, "prismAsOptional", () => $ff5369f959674226$export$70f4d204f3bdc8bd);
$parcel$export(module.exports, "lensId", () => $ff5369f959674226$export$a4b03755c6673298);
$parcel$export(module.exports, "lensProp", () => $ff5369f959674226$export$a6ba95b157529836);
$parcel$export(module.exports, "lensProps", () => $ff5369f959674226$export$c19575454e66bf5f);
$parcel$export(module.exports, "lensComponent", () => $ff5369f959674226$export$103f2a6258fae742);
$parcel$export(module.exports, "lensAtKey", () => $ff5369f959674226$export$fc68a3bfc89f0b98);
$parcel$export(module.exports, "atReadonlyRecord", () => $ff5369f959674226$export$ba8573d258bae607);
$parcel$export(module.exports, "prismSet", () => $ff5369f959674226$export$97725fa315d6412c);
$parcel$export(module.exports, "prismAsTraversal", () => $ff5369f959674226$export$18564f4597667b6a);
$parcel$export(module.exports, "prismModifyOption", () => $ff5369f959674226$export$ddb3ff54eaa1c530);
$parcel$export(module.exports, "prismModify", () => $ff5369f959674226$export$f545e0bcbe4b5ea7);
$parcel$export(module.exports, "prismComposeLens", () => $ff5369f959674226$export$dad01448ef670850);
$parcel$export(module.exports, "prismFromNullable", () => $ff5369f959674226$export$258cc98aa6d7d21b);
$parcel$export(module.exports, "prismFromPredicate", () => $ff5369f959674226$export$8f316a2f03469694);
$parcel$export(module.exports, "prismSome", () => $ff5369f959674226$export$782e8b2fe031f968);
$parcel$export(module.exports, "prismRight", () => $ff5369f959674226$export$929e170fdd93186c);
$parcel$export(module.exports, "prismLeft", () => $ff5369f959674226$export$97ae81cf28b21f26);
$parcel$export(module.exports, "optionalAsTraversal", () => $ff5369f959674226$export$a595a5197cc37264);
$parcel$export(module.exports, "optionalModifyOption", () => $ff5369f959674226$export$48aae8aebe6d3ee9);
$parcel$export(module.exports, "optionalModify", () => $ff5369f959674226$export$6d575f282c3c1d48);
$parcel$export(module.exports, "optionalIndex", () => $ff5369f959674226$export$47ac94aa95300c6f);
$parcel$export(module.exports, "indexReadonlyArray", () => $ff5369f959674226$export$bb0c054375ca4b0);
$parcel$export(module.exports, "optionalIndexNonEmpty", () => $ff5369f959674226$export$83e62439a4d30c4c);
$parcel$export(module.exports, "indexReadonlyNonEmptyArray", () => $ff5369f959674226$export$165af7b747e6b1f1);
$parcel$export(module.exports, "optionalKey", () => $ff5369f959674226$export$a6c26e1663200bf4);
$parcel$export(module.exports, "indexReadonlyRecord", () => $ff5369f959674226$export$3c3468aec3b83bbf);
$parcel$export(module.exports, "optionalFindFirst", () => $ff5369f959674226$export$220673392b48821b);
$parcel$export(module.exports, "optionalFindFirstNonEmpty", () => $ff5369f959674226$export$cf29cfc68de9a659);
$parcel$export(module.exports, "traversalComposeTraversal", () => $ff5369f959674226$export$2c68ab81171b083f);
$parcel$export(module.exports, "ApplicativeIdentity", () => $ff5369f959674226$export$7c4912ca011fa00e);
$parcel$export(module.exports, "fromTraversable", () => $ff5369f959674226$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "traversalTraverse", () => $ff5369f959674226$export$35db6fcbd934c57);
$parcel$export(module.exports, "index", () => $ff5369f959674226$export$b610b8812bbcded9);
$parcel$export(module.exports, "at", () => $ff5369f959674226$export$493d36ec626b6698);

var $8yI6w = parcelRequire("8yI6w");

var $hDHPV = parcelRequire("hDHPV");

var $72EOc = parcelRequire("72EOc");

var $bxsNd = parcelRequire("bxsNd");

var $2BN86 = parcelRequire("2BN86");

var $30crt = parcelRequire("30crt");
var $ff5369f959674226$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ff5369f959674226$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $ff5369f959674226$export$d001ee9513dee7c1 = function(sa) {
    return $ff5369f959674226$export$21cde5187c2605a3(sa.get, (0, $72EOc.flow)(sa.reverseGet, (0, $72EOc.constant)));
};
var $ff5369f959674226$export$fde8c5b9dff57abc = function(sa) {
    return $ff5369f959674226$export$e469dcfea9910464((0, $72EOc.flow)(sa.get, $bxsNd.some), sa.reverseGet);
};
var $ff5369f959674226$export$4d3db894cf45abd5 = function(sa) {
    return $ff5369f959674226$export$516e28dec6a4b6d4((0, $72EOc.flow)(sa.get, $bxsNd.some), (0, $72EOc.flow)(sa.reverseGet, (0, $72EOc.constant)));
};
var $ff5369f959674226$export$e55a826b3ba968d2 = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $ff5369f959674226$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $ff5369f959674226$export$bae94c671b4dc75d = function(sa) {
    return $ff5369f959674226$export$516e28dec6a4b6d4((0, $72EOc.flow)(sa.get, $bxsNd.some), sa.set);
};
var $ff5369f959674226$export$e5de01c31c85830c = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $ff5369f959674226$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $ff5369f959674226$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$e469dcfea9910464((0, $72EOc.flow)(sa.getOption, $bxsNd.chain(ab.getOption)), (0, $72EOc.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $ff5369f959674226$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$70f4d204f3bdc8bd(ab))($ff5369f959674226$export$bae94c671b4dc75d(sa));
    };
};
var $ff5369f959674226$export$a4b03755c6673298 = function() {
    return $ff5369f959674226$export$21cde5187c2605a3((0, $72EOc.identity), (0, $72EOc.constant));
};
var $ff5369f959674226$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $ff5369f959674226$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $ff5369f959674226$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $ff5369f959674226$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$62d1b5266563d2b6($ff5369f959674226$export$ba8573d258bae607().at(key)));
    };
};
var $ff5369f959674226$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $ff5369f959674226$export$70f4d204f3bdc8bd = function(sa) {
    return $ff5369f959674226$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $ff5369f959674226$export$97725fa315d6412c(a)(sa);
    });
};
var $ff5369f959674226$export$18564f4597667b6a = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $ff5369f959674226$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $ff5369f959674226$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.map(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $ff5369f959674226$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $ff5369f959674226$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $30crt.pipe)(g(s), $bxsNd.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $ff5369f959674226$export$97725fa315d6412c = function(a) {
    return $ff5369f959674226$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $ff5369f959674226$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$bae94c671b4dc75d(ab))($ff5369f959674226$export$70f4d204f3bdc8bd(sa));
    };
};
var $ff5369f959674226$export$258cc98aa6d7d21b = function() {
    return $ff5369f959674226$export$e469dcfea9910464($bxsNd.fromNullable, (0, $72EOc.identity));
};
var $ff5369f959674226$export$8f316a2f03469694 = function(predicate) {
    return $ff5369f959674226$export$e469dcfea9910464($bxsNd.fromPredicate(predicate), (0, $72EOc.identity));
};
var $ff5369f959674226$export$782e8b2fe031f968 = function() {
    return $ff5369f959674226$export$e469dcfea9910464((0, $72EOc.identity), $bxsNd.some);
};
var $ff5369f959674226$export$929e170fdd93186c = function() {
    return $ff5369f959674226$export$e469dcfea9910464($bxsNd.fromEither, $2BN86.right);
};
var $ff5369f959674226$export$97ae81cf28b21f26 = function() {
    return $ff5369f959674226$export$e469dcfea9910464(function(s) {
        return $2BN86.isLeft(s) ? $bxsNd.some(s.left) : $bxsNd.none;
    }, $2BN86.left);
};
var $ff5369f959674226$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $ff5369f959674226$export$a595a5197cc37264 = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $ff5369f959674226$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $30crt.pipe)(optional.getOption(s), $bxsNd.map(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $ff5369f959674226$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $ff5369f959674226$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $30crt.pipe)(g(s), $bxsNd.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $ff5369f959674226$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$516e28dec6a4b6d4((0, $72EOc.flow)(sa.getOption, $bxsNd.chain(ab.getOption)), function(b) {
            return $ff5369f959674226$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $ff5369f959674226$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$bb0c054375ca4b0().index(i)));
    };
};
var $ff5369f959674226$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$165af7b747e6b1f1().index(i)));
    };
};
var $ff5369f959674226$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$3c3468aec3b83bbf().index(key)));
    };
};
var $ff5369f959674226$export$220673392b48821b = function(predicate) {
    return $ff5369f959674226$export$516e28dec6a4b6d4($8yI6w.findFirst(predicate), function(a) {
        return function(s) {
            return (0, $30crt.pipe)($8yI6w.findIndex(predicate)(s), $bxsNd.fold(function() {
                return s;
            }, function(i) {
                return $8yI6w.unsafeUpdateAt(i, a, s);
            }));
        };
    });
};
var $ff5369f959674226$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $ff5369f959674226$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $ff5369f959674226$export$cf29cfc68de9a659 = function(predicate) {
    return $ff5369f959674226$export$516e28dec6a4b6d4($8yI6w.findFirst(predicate), function(a) {
        return function(as) {
            return (0, $30crt.pipe)($8yI6w.findIndex(predicate)(as), $bxsNd.fold(function() {
                return as;
            }, function(i) {
                return $ff5369f959674226$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $ff5369f959674226$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $ff5369f959674226$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $ff5369f959674226$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $72EOc.identity),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $ff5369f959674226$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $ff5369f959674226$export$126b5a87c58d3f9c(T) {
    return function() {
        return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $ff5369f959674226$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $ff5369f959674226$export$35db6fcbd934c57(T) {
    return $ff5369f959674226$export$2c68ab81171b083f($ff5369f959674226$export$126b5a87c58d3f9c(T)());
}
var $ff5369f959674226$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $ff5369f959674226$export$bb0c054375ca4b0 = function() {
    return $ff5369f959674226$export$b610b8812bbcded9(function(i) {
        return $ff5369f959674226$export$516e28dec6a4b6d4(function(as) {
            return $8yI6w.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $30crt.pipe)($8yI6w.lookup(i, as), $bxsNd.fold(function() {
                    return as;
                }, function() {
                    return $8yI6w.unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $ff5369f959674226$export$165af7b747e6b1f1 = function() {
    return $ff5369f959674226$export$b610b8812bbcded9(function(i) {
        return $ff5369f959674226$export$516e28dec6a4b6d4(function(as) {
            return $8yI6w.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $30crt.pipe)($8yI6w.lookup(i, as), $bxsNd.fold(function() {
                    return as;
                }, function() {
                    return $ff5369f959674226$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $ff5369f959674226$export$3c3468aec3b83bbf = function() {
    return $ff5369f959674226$export$b610b8812bbcded9(function(k) {
        return $ff5369f959674226$export$516e28dec6a4b6d4(function(r) {
            return $hDHPV.lookup(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $bxsNd.isNone($hDHPV.lookup(k, r))) return r;
                return $hDHPV.insertAt(k, a)(r);
            };
        });
    });
};
var $ff5369f959674226$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $ff5369f959674226$export$ba8573d258bae607() {
    return $ff5369f959674226$export$493d36ec626b6698(function(key) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(r) {
            return $hDHPV.lookup(key, r);
        }, $bxsNd.fold(function() {
            return $hDHPV.deleteAt(key);
        }, function(a) {
            return $hDHPV.insertAt(key, a);
        }));
    });
}

});
parcelRegister("hDHPV", function(module, exports) {

$parcel$export(module.exports, "deleteAt", () => $cd78153388da00d3$export$90f9093465da3136);
$parcel$export(module.exports, "lookup", () => $cd78153388da00d3$export$dfc7155ac0343b8);
$parcel$export(module.exports, "insertAt", () => $cd78153388da00d3$export$9f200c4466975173);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $1HSKK = parcelRequire("1HSKK");

var $jmlhE = parcelRequire("jmlhE");

var $jNYdc = parcelRequire("jNYdc");
var $cd78153388da00d3$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $cd78153388da00d3$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $cd78153388da00d3$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $cd78153388da00d3$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($EfnK2.has.call(r, k)) return false;
    }
    return true;
};
var $cd78153388da00d3$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $cd78153388da00d3$export$ed97f33186d4b816 = /*#__PURE__*/ $cd78153388da00d3$var$keys_($jmlhE.Ord);
function $cd78153388da00d3$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $cd78153388da00d3$export$bb44f104e3c54dae($jmlhE.Ord)(O);
    var keysO = $cd78153388da00d3$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $cd78153388da00d3$export$4aaa3912a3956cb7 = /*#__PURE__*/ $cd78153388da00d3$export$bb44f104e3c54dae($jmlhE.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $cd78153388da00d3$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $cd78153388da00d3$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $EfnK2.some([
                sas[b],
                b + 1
            ]) : $EfnK2.none;
        });
    };
}
var $cd78153388da00d3$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($EfnK2.has.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $cd78153388da00d3$export$a4f4bb6b1453fff5 = function(k, r) {
    return $EfnK2.has.call(r, k);
};
function $cd78153388da00d3$export$90f9093465da3136(k) {
    return function(r) {
        if (!$EfnK2.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $cd78153388da00d3$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, r)) return $EfnK2.none;
        if (r[k] === a) return $EfnK2.some(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $EfnK2.some(out);
    };
};
var $cd78153388da00d3$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, r)) return $EfnK2.none;
        var next = f(r[k]);
        if (next === r[k]) return $EfnK2.some(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $EfnK2.some(out);
    };
};
function $cd78153388da00d3$export$3e41007ebfff0e64(k) {
    var deleteAtk = $cd78153388da00d3$export$90f9093465da3136(k);
    return function(r) {
        var oa = $cd78153388da00d3$export$dfc7155ac0343b8(k, r);
        return $EfnK2.isNone(oa) ? $EfnK2.none : $EfnK2.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $cd78153388da00d3$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $cd78153388da00d3$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$EfnK2.has.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $cd78153388da00d3$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $cd78153388da00d3$export$dfc7155ac0343b8(k, r);
    };
    return $EfnK2.has.call(r, k) ? $EfnK2.some(r[k]) : $EfnK2.none;
}
var $cd78153388da00d3$export$6e22c362a0406a2c = {};
function $cd78153388da00d3$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $cd78153388da00d3$export$871de8747c9eaa88(f) {
    return $cd78153388da00d3$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $cd78153388da00d3$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $cd78153388da00d3$export$bbd3ef8720e22369($jmlhE.Ord).apply(void 0, args);
    var keysO = $cd78153388da00d3$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $cd78153388da00d3$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $cd78153388da00d3$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $cd78153388da00d3$export$18153bb1181268e5($jmlhE.Ord)(O);
}
function $cd78153388da00d3$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $cd78153388da00d3$export$ce2b2fe0b88ccd0a($jmlhE.Ord).apply(void 0, args);
    var keysO = $cd78153388da00d3$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $cd78153388da00d3$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $cd78153388da00d3$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $cd78153388da00d3$var$_traverseWithIndex($jmlhE.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $cd78153388da00d3$export$df3f009e3d155b20(F) {
    var traverseOF = $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $cd78153388da00d3$export$49bb65c2ea163039(F) {
    return $cd78153388da00d3$export$5d141086b2c0bc6($jmlhE.Ord)(F);
}
var $cd78153388da00d3$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $cd78153388da00d3$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $72EOc.pipe)(fa, traverseF(f)), $cd78153388da00d3$export$8e16b83750b44988);
        };
    };
};
var $cd78153388da00d3$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $cd78153388da00d3$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $72EOc.pipe)(fa, traverseF(f)), $cd78153388da00d3$export$709f6946f4e97408);
        };
    };
};
function $cd78153388da00d3$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
function $cd78153388da00d3$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
function $cd78153388da00d3$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) {
            var ob = f(k, r[k]);
            if ($EfnK2.isSome(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $cd78153388da00d3$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($EfnK2.has.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $cd78153388da00d3$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $cd78153388da00d3$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $72EOc.identity));
    };
}
function $cd78153388da00d3$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $EfnK2.has.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $cd78153388da00d3$export$9f69d28786a8399c = $cd78153388da00d3$export$4aaa3912a3956cb7;
var $cd78153388da00d3$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $cd78153388da00d3$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $cd78153388da00d3$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $cd78153388da00d3$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $cd78153388da00d3$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $cd78153388da00d3$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(first)) return second;
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($cd78153388da00d3$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $cd78153388da00d3$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(first) || $cd78153388da00d3$export$dd1bc94b04021eeb(second)) return $cd78153388da00d3$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($cd78153388da00d3$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $cd78153388da00d3$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($cd78153388da00d3$export$dd1bc94b04021eeb(first)) return second;
        if ($cd78153388da00d3$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $cd78153388da00d3$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$871de8747c9eaa88(f));
};
var $cd78153388da00d3$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$8f07ddce13659f50(f));
};
var $cd78153388da00d3$export$8eef5fdba9512999 = function(O) {
    var reduceO = $cd78153388da00d3$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceO(b, f));
    };
};
var $cd78153388da00d3$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $cd78153388da00d3$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $72EOc.pipe)(fa, foldMapM(f));
        };
    };
};
var $cd78153388da00d3$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $cd78153388da00d3$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceRightO(b, f));
    };
};
var $cd78153388da00d3$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$3dea766d36a8935f(predicate));
};
var $cd78153388da00d3$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$a04c6c6965dd4709(f));
};
var $cd78153388da00d3$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$b29f828819edca8d(predicate));
};
var $cd78153388da00d3$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$3117e3f9ececb6bc(f));
};
var $cd78153388da00d3$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $cd78153388da00d3$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceWithIndexO(b, f));
    };
};
var $cd78153388da00d3$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $cd78153388da00d3$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
        };
    };
};
var $cd78153388da00d3$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $cd78153388da00d3$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceRightWithIndexO(b, f));
    };
};
var $cd78153388da00d3$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$bc7c0794b9c6f3ba(f));
};
var $cd78153388da00d3$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $cd78153388da00d3$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$30c5cbe848021e97(f));
};
var $cd78153388da00d3$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$36e42aef19fc7171(predicateWithIndex));
};
var $cd78153388da00d3$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $cd78153388da00d3$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $72EOc.flow)((0, $72EOc.SK), f));
        };
    };
};
var $cd78153388da00d3$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $cd78153388da00d3$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $72EOc.identity));
        };
    };
};
var $cd78153388da00d3$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $cd78153388da00d3$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($cd78153388da00d3$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $cd78153388da00d3$export$3dea766d36a8935f = function(predicate) {
    return $cd78153388da00d3$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $cd78153388da00d3$export$a04c6c6965dd4709 = function(f) {
    return $cd78153388da00d3$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $cd78153388da00d3$export$b29f828819edca8d = function(predicate) {
    return $cd78153388da00d3$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $cd78153388da00d3$export$3117e3f9ececb6bc = function(f) {
    return $cd78153388da00d3$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $cd78153388da00d3$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $cd78153388da00d3$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $cd78153388da00d3$export$533b26079ad0b4b($jmlhE.Ord).apply(void 0, args);
}
function $cd78153388da00d3$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $cd78153388da00d3$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $cd78153388da00d3$export$b66cdc0497d8a99a($jmlhE.Ord)(O);
}
function $cd78153388da00d3$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $cd78153388da00d3$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $cd78153388da00d3$export$7fef8bcdbb34f435($jmlhE.Ord).apply(void 0, args);
}
var $cd78153388da00d3$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($EfnK2.has.call(r, k)) {
        var oa = r[k];
        if ($EfnK2.isSome(oa)) out[k] = oa.value;
    }
    return out;
};
var $cd78153388da00d3$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($EfnK2.has.call(r, k)) {
        var e = r[k];
        if ($EfnK2.isLeft(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $1HSKK.separated)(left, right);
};
var $cd78153388da00d3$export$9156e739aa33e19f = 'ReadonlyRecord';
function $cd78153388da00d3$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $cd78153388da00d3$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $cd78153388da00d3$export$3cb5cd7f7776c81($jmlhE.Ord)(O);
}
function $cd78153388da00d3$export$804fed467fde44e4(E) {
    var isSubrecordE = $cd78153388da00d3$export$36e6f76a1d117b8a(E);
    return (0, $3Md1m.fromEquals)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $cd78153388da00d3$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(first)) return second;
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($EfnK2.has.call(second, k)) r[k] = $EfnK2.has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $cd78153388da00d3$export$6e22c362a0406a2c
    };
}
var $cd78153388da00d3$export$bd5b6bfc5fa2ee61 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab
};
var $cd78153388da00d3$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($cd78153388da00d3$export$bd5b6bfc5fa2ee61);
var $cd78153388da00d3$export$9fdffe0fe1e91cad = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c
};
var $cd78153388da00d3$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O)
    };
};
var $cd78153388da00d3$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        reduceWithIndex: $cd78153388da00d3$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $cd78153388da00d3$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $cd78153388da00d3$export$3b7618311030b1af(O)
    };
};
var $cd78153388da00d3$export$4a21ac48141ac3c9 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408
};
var $cd78153388da00d3$export$d00e1c48fb621173 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d
};
var $cd78153388da00d3$export$c29a647071e542ec = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
    filterMapWithIndex: $cd78153388da00d3$export$ac207938ecd8ddc4,
    filterWithIndex: $cd78153388da00d3$export$560430393fed15de,
    partitionMapWithIndex: $cd78153388da00d3$export$18034ec93490e9d2,
    partitionWithIndex: $cd78153388da00d3$export$31601036bfbf1c76
};
var $cd78153388da00d3$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        map: $cd78153388da00d3$export$a0135aecf4a782ab,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        traverse: $cd78153388da00d3$export$b3c6f3d9661cffba(O),
        sequence: $cd78153388da00d3$export$5d141086b2c0bc6(O)
    };
};
var $cd78153388da00d3$export$46b81797a3375b8c = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        map: $cd78153388da00d3$export$a0135aecf4a782ab,
        mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        reduceWithIndex: $cd78153388da00d3$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $cd78153388da00d3$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $cd78153388da00d3$export$3b7618311030b1af(O),
        traverse: $cd78153388da00d3$export$b3c6f3d9661cffba(O),
        sequence: $cd78153388da00d3$export$5d141086b2c0bc6(O),
        traverseWithIndex: $cd78153388da00d3$var$_traverseWithIndex(O)
    };
};
var $cd78153388da00d3$export$bb8ef26a634cac7b = function(O) {
    var T = $cd78153388da00d3$export$4e0ffba11065d2c1(O);
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        map: $cd78153388da00d3$export$a0135aecf4a782ab,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $cd78153388da00d3$export$8e16b83750b44988,
        separate: $cd78153388da00d3$export$709f6946f4e97408,
        filter: $cd78153388da00d3$export$ec7439dc64f73058,
        filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
        partition: $cd78153388da00d3$export$8d112ad5a197e16a,
        partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
        wither: (0, $jNYdc.witherDefault)(T, $cd78153388da00d3$export$4a21ac48141ac3c9),
        wilt: (0, $jNYdc.wiltDefault)(T, $cd78153388da00d3$export$4a21ac48141ac3c9)
    };
};
var $cd78153388da00d3$export$baca17b4aff42f82 = function(S) {
    var unionS = $cd78153388da00d3$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $cd78153388da00d3$export$c487aac9f4157837 = function(S) {
    return {
        concat: $cd78153388da00d3$export$baca17b4aff42f82(S).concat,
        empty: $cd78153388da00d3$export$6e22c362a0406a2c
    };
};
var $cd78153388da00d3$export$d379a869a72e4055 = function(S) {
    var intersectionS = $cd78153388da00d3$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $cd78153388da00d3$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $cd78153388da00d3$export$acaf96a27438246b(second)(first);
        }
    };
};
var $cd78153388da00d3$export$41404b31838667c9 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord)
};
var $cd78153388da00d3$export$e8f7d17aaff345cb = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    reduceWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$dd5ca3bcbad0b6af($jmlhE.Ord),
    foldMapWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$e08bbf939bdc3250($jmlhE.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$3b7618311030b1af($jmlhE.Ord)
};
var $cd78153388da00d3$export$a0202666c3bda011 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039
};
var $cd78153388da00d3$export$bd7b528d8c36ec41 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    reduceWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$dd5ca3bcbad0b6af($jmlhE.Ord),
    foldMapWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$e08bbf939bdc3250($jmlhE.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$3b7618311030b1af($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $cd78153388da00d3$var$_traverseWithIndex($jmlhE.Ord)
};
var $cd78153388da00d3$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($cd78153388da00d3$export$a0202666c3bda011, $cd78153388da00d3$export$4a21ac48141ac3c9);
var $cd78153388da00d3$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($cd78153388da00d3$export$a0202666c3bda011, $cd78153388da00d3$export$4a21ac48141ac3c9);
var $cd78153388da00d3$export$748d317b4c426f96 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
    wither: $cd78153388da00d3$var$_wither,
    wilt: $cd78153388da00d3$var$_wilt
};
var $cd78153388da00d3$export$9f200c4466975173 = $cd78153388da00d3$export$ff82449ce381c54a;
function $cd78153388da00d3$export$5a15a386532a5ea4(k, r) {
    return $EfnK2.has.call(r === undefined ? this : r, k);
}
var $cd78153388da00d3$export$74b9182b22de2bc1 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$dd5ca3bcbad0b6af($jmlhE.Ord),
    foldMapWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$e08bbf939bdc3250($jmlhE.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$3b7618311030b1af($jmlhE.Ord),
    filterMapWithIndex: $cd78153388da00d3$export$ac207938ecd8ddc4,
    filterWithIndex: $cd78153388da00d3$export$560430393fed15de,
    partitionMapWithIndex: $cd78153388da00d3$export$18034ec93490e9d2,
    partitionWithIndex: $cd78153388da00d3$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $cd78153388da00d3$var$_traverseWithIndex($jmlhE.Ord),
    wither: $cd78153388da00d3$var$_wither,
    wilt: $cd78153388da00d3$var$_wilt
};

});
parcelRegister("jmlhE", function(module, exports) {

$parcel$export(module.exports, "Ord", () => $e18094e42952cec8$export$ee8aa95bfab51c5);

var $ecsM6 = parcelRequire("ecsM6");
var $e18094e42952cec8$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $e18094e42952cec8$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $e18094e42952cec8$export$6e22c362a0406a2c = '';
var $e18094e42952cec8$export$8f55868b713abdc3 = {
    concat: $e18094e42952cec8$export$c16b1dbe8a4166b6.concat,
    empty: $e18094e42952cec8$export$6e22c362a0406a2c
};
var $e18094e42952cec8$export$ee8aa95bfab51c5 = {
    equals: $e18094e42952cec8$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $e18094e42952cec8$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $e18094e42952cec8$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $e18094e42952cec8$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $e18094e42952cec8$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $e18094e42952cec8$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $e18094e42952cec8$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $e18094e42952cec8$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $e18094e42952cec8$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $e18094e42952cec8$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $e18094e42952cec8$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $e18094e42952cec8$export$346677f925de839c = function(s) {
    return s.length;
};
var $e18094e42952cec8$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $ecsM6.isNonEmpty)(out) ? out : [
            s
        ];
    };
};
var $e18094e42952cec8$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $e18094e42952cec8$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $e18094e42952cec8$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};

});


parcelRegister("2BN86", function(module, exports) {

$parcel$export(module.exports, "left", () => $1e6525975b6cc660$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $1e6525975b6cc660$export$79ffe56a765070d2);
$parcel$export(module.exports, "isLeft", () => $1e6525975b6cc660$export$d649b6842e09f2b);

var $9xys1 = parcelRequire("9xys1");

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $5CEm3 = parcelRequire("5CEm3");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");
var $1e6525975b6cc660$export$eabcd2c8791e7bf4 = $EfnK2.left;
var $1e6525975b6cc660$export$79ffe56a765070d2 = $EfnK2.right;
var $1e6525975b6cc660$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $1e6525975b6cc660$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$871de8747c9eaa88(f));
};
var $1e6525975b6cc660$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $1e6525975b6cc660$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $1e6525975b6cc660$export$b66cdc0497d8a99a(M);
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$7fef8bcdbb34f435(b, f));
};
var $1e6525975b6cc660$var$_traverse = function(F) {
    var traverseF = $1e6525975b6cc660$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
var $1e6525975b6cc660$var$_bimap = function(fa, f, g) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$eb54baf0b342cb1d(f, g));
};
var $1e6525975b6cc660$var$_mapLeft = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $1e6525975b6cc660$export$8b58be045bf06082(f));
};
var $1e6525975b6cc660$var$_chainRec = function(a, f) {
    return (0, $5CEm3.tailRec)(f(a), function(e) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(e) ? $1e6525975b6cc660$export$79ffe56a765070d2($1e6525975b6cc660$export$eabcd2c8791e7bf4(e.left)) : $1e6525975b6cc660$export$d649b6842e09f2b(e.right) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(f(e.right.left)) : $1e6525975b6cc660$export$79ffe56a765070d2($1e6525975b6cc660$export$79ffe56a765070d2(e.right.right));
    });
};
var $1e6525975b6cc660$export$9156e739aa33e19f = 'Either';
var $1e6525975b6cc660$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $1e6525975b6cc660$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($1e6525975b6cc660$export$d649b6842e09f2b(x) ? $1e6525975b6cc660$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $1e6525975b6cc660$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $1e6525975b6cc660$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(y) ? x : $1e6525975b6cc660$export$d649b6842e09f2b(x) ? y : $1e6525975b6cc660$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $1e6525975b6cc660$export$cfae3069ac05ff4c = function(M) {
    var empty = $1e6525975b6cc660$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $1e6525975b6cc660$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? (0, $1HSKK.separated)(ma, ma) : $1e6525975b6cc660$export$d649b6842e09f2b(ma.right) ? (0, $1HSKK.separated)($1e6525975b6cc660$export$79ffe56a765070d2(ma.right.left), empty) : (0, $1HSKK.separated)(empty, $1e6525975b6cc660$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $1e6525975b6cc660$export$a4e870b0a57ec14e = function(M) {
    var empty = $1e6525975b6cc660$export$eabcd2c8791e7bf4(M.empty);
    var _a = $1e6525975b6cc660$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? (0, $1HSKK.separated)(ma, ma) : p(ma.right) ? (0, $1HSKK.separated)(empty, $1e6525975b6cc660$export$79ffe56a765070d2(ma.right)) : (0, $1HSKK.separated)($1e6525975b6cc660$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($1e6525975b6cc660$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $1e6525975b6cc660$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($1e6525975b6cc660$export$d649b6842e09f2b(ma)) return (0, $1HSKK.separated)(ma, ma);
            var e = f(ma.right);
            return $1e6525975b6cc660$export$d649b6842e09f2b(e) ? (0, $1HSKK.separated)($1e6525975b6cc660$export$79ffe56a765070d2(e.left), empty) : (0, $1HSKK.separated)(empty, $1e6525975b6cc660$export$79ffe56a765070d2(e.right));
        }
    };
};
var $1e6525975b6cc660$export$bb8ef26a634cac7b = function(M) {
    var F_ = $1e6525975b6cc660$export$a4e870b0a57ec14e(M);
    var C = $1e6525975b6cc660$export$cfae3069ac05ff4c(M);
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $1e6525975b6cc660$var$_traverse,
        sequence: $1e6525975b6cc660$export$49bb65c2ea163039,
        reduce: $1e6525975b6cc660$var$_reduce,
        foldMap: $1e6525975b6cc660$var$_foldMap,
        reduceRight: $1e6525975b6cc660$var$_reduceRight,
        wither: (0, $jNYdc.witherDefault)($1e6525975b6cc660$export$a0202666c3bda011, C),
        wilt: (0, $jNYdc.wiltDefault)($1e6525975b6cc660$export$a0202666c3bda011, C)
    };
};
var $1e6525975b6cc660$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        ap: function(fab, fa) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(fab) ? $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? fa : $1e6525975b6cc660$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $1e6525975b6cc660$export$ba255e9e49e00608
    };
};
var $1e6525975b6cc660$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        alt: function(me, that) {
            if ($1e6525975b6cc660$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $1e6525975b6cc660$export$d649b6842e09f2b(ea) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $1e6525975b6cc660$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? fa : $1e6525975b6cc660$export$79ffe56a765070d2(f(fa.right));
    };
};
var $1e6525975b6cc660$export$bd5b6bfc5fa2ee61 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map
};
var $1e6525975b6cc660$export$6554612db691658e = (0, $72EOc.dual)(2, (0, $cpwuW.as)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61));
var $1e6525975b6cc660$export$9284b360ca18a0fd = (0, $cpwuW.asUnit)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$ba255e9e49e00608 = $1e6525975b6cc660$export$79ffe56a765070d2;
var $1e6525975b6cc660$export$59a71046037e6c20 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    of: $1e6525975b6cc660$export$ba255e9e49e00608
};
var $1e6525975b6cc660$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fab) ? fab : $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? fa : $1e6525975b6cc660$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $1e6525975b6cc660$export$2f6ca3d3b1f80bf5 = $1e6525975b6cc660$export$321be6e231de8eac;
var $1e6525975b6cc660$export$efc21ddc6aeb363d = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap
};
var $1e6525975b6cc660$export$1279d2b7807629fd = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    of: $1e6525975b6cc660$export$ba255e9e49e00608
};
var $1e6525975b6cc660$export$f18d5acc27d70423 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16
};
var $1e6525975b6cc660$export$fb641926d034ac7d = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    of: $1e6525975b6cc660$export$ba255e9e49e00608,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16
};
var $1e6525975b6cc660$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $1e6525975b6cc660$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $1e6525975b6cc660$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $1e6525975b6cc660$export$41404b31838667c9 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    reduce: $1e6525975b6cc660$var$_reduce,
    foldMap: $1e6525975b6cc660$var$_foldMap,
    reduceRight: $1e6525975b6cc660$var$_reduceRight
};
var $1e6525975b6cc660$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ta) ? F.of($1e6525975b6cc660$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $1e6525975b6cc660$export$79ffe56a765070d2);
        };
    };
};
var $1e6525975b6cc660$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? F.of($1e6525975b6cc660$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $1e6525975b6cc660$export$79ffe56a765070d2);
    };
};
var $1e6525975b6cc660$export$a0202666c3bda011 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    reduce: $1e6525975b6cc660$var$_reduce,
    foldMap: $1e6525975b6cc660$var$_foldMap,
    reduceRight: $1e6525975b6cc660$var$_reduceRight,
    traverse: $1e6525975b6cc660$var$_traverse,
    sequence: $1e6525975b6cc660$export$49bb65c2ea163039
};
var $1e6525975b6cc660$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(f(fa.left)) : $1e6525975b6cc660$export$79ffe56a765070d2(g(fa.right));
    };
};
var $1e6525975b6cc660$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $1e6525975b6cc660$export$fd0fe42029639505 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    bimap: $1e6525975b6cc660$var$_bimap,
    mapLeft: $1e6525975b6cc660$var$_mapLeft
};
var $1e6525975b6cc660$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $1e6525975b6cc660$export$228be17d80722ab = $1e6525975b6cc660$export$1517cca7889d6aaa;
var $1e6525975b6cc660$export$25ba4469a069167 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    alt: $1e6525975b6cc660$var$_alt
};
var $1e6525975b6cc660$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(wa) ? wa : $1e6525975b6cc660$export$79ffe56a765070d2(f(wa));
    };
};
var $1e6525975b6cc660$export$5b5dd0e212d2a5bc = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    extend: $1e6525975b6cc660$var$_extend
};
var $1e6525975b6cc660$export$be58f7327716329d = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
    chainRec: $1e6525975b6cc660$var$_chainRec
};
var $1e6525975b6cc660$export$8bf7aba4a9e09055 = $1e6525975b6cc660$export$eabcd2c8791e7bf4;
var $1e6525975b6cc660$export$5f956d47d0619c3a = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    of: $1e6525975b6cc660$export$ba255e9e49e00608,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
    throwError: $1e6525975b6cc660$export$8bf7aba4a9e09055
};
var $1e6525975b6cc660$export$825ea6cb6fc48d49 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    fromEither: (0, $72EOc.identity)
};
var $1e6525975b6cc660$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $jFfj2.fromPredicate)($1e6525975b6cc660$export$825ea6cb6fc48d49);
var $1e6525975b6cc660$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $jFfj2.fromOption)($1e6525975b6cc660$export$825ea6cb6fc48d49);
var $1e6525975b6cc660$export$d649b6842e09f2b = $EfnK2.isLeft;
var $1e6525975b6cc660$export$a9d71693f0c1a85d = $EfnK2.isRight;
var $1e6525975b6cc660$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $1e6525975b6cc660$export$ccb09033cefa61e8 = $1e6525975b6cc660$export$2d55ea551c238330;
var $1e6525975b6cc660$export$4659b591c19bdf3d = $1e6525975b6cc660$export$2d55ea551c238330;
var $1e6525975b6cc660$export$93e2b83da34ff82a = $1e6525975b6cc660$export$4659b591c19bdf3d;
var $1e6525975b6cc660$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $1e6525975b6cc660$export$8832081647a02ee7 = $1e6525975b6cc660$export$d8a997ff0e6436f3;
var $1e6525975b6cc660$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$ac044f4aa9961a4f = $1e6525975b6cc660$export$5f28d9feedcfd46e;
var $1e6525975b6cc660$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$8a00020751233172 = $1e6525975b6cc660$export$ed01bc59c3d06bf3;
var $1e6525975b6cc660$export$3f23594af5f37336 = /*#__PURE__*/ (0, $72EOc.dual)(2, $kgj0x.tap($1e6525975b6cc660$export$f18d5acc27d70423));
var $1e6525975b6cc660$export$2409099f1fc434fb = /*#__PURE__*/ $1e6525975b6cc660$export$5b8affa63fc6df16((0, $72EOc.identity));
var $1e6525975b6cc660$export$bffa455ba8c619a6 = $1e6525975b6cc660$export$2409099f1fc434fb;
var $1e6525975b6cc660$export$ecd5e8ace626722c = /*#__PURE__*/ $1e6525975b6cc660$export$8b58be045bf06082((0, $72EOc.identity));
var $1e6525975b6cc660$export$a907462f448b49f8 = /*#__PURE__*/ (0, $jFfj2.fromOptionK)($1e6525975b6cc660$export$825ea6cb6fc48d49);
var $1e6525975b6cc660$export$12d26179deb6a68a = /*#__PURE__*/ (0, $jFfj2.chainOptionK)($1e6525975b6cc660$export$825ea6cb6fc48d49, $1e6525975b6cc660$export$f18d5acc27d70423);
var $1e6525975b6cc660$export$377cc334277e5c3c = $1e6525975b6cc660$export$12d26179deb6a68a;
/** @internal */ var $1e6525975b6cc660$var$_FromEither = {
    fromEither: $1e6525975b6cc660$export$825ea6cb6fc48d49.fromEither
};
var $1e6525975b6cc660$export$cd139e14432f317b = /*#__PURE__*/ $EfnK2.liftNullable($1e6525975b6cc660$var$_FromEither);
var $1e6525975b6cc660$export$ea4a22f93200df79 = /*#__PURE__*/ $EfnK2.liftOption($1e6525975b6cc660$var$_FromEither);
/** @internal */ var $1e6525975b6cc660$var$_FlatMap = {
    flatMap: $1e6525975b6cc660$export$5b8affa63fc6df16
};
var $1e6525975b6cc660$export$1a0515933c5c84fe = /*#__PURE__*/ $EfnK2.flatMapNullable($1e6525975b6cc660$var$_FromEither, $1e6525975b6cc660$var$_FlatMap);
var $1e6525975b6cc660$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $EfnK2.flatMapOption($1e6525975b6cc660$var$_FromEither, $1e6525975b6cc660$var$_FlatMap);
var $1e6525975b6cc660$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $jFfj2.filterOrElse)($1e6525975b6cc660$export$825ea6cb6fc48d49, $1e6525975b6cc660$export$f18d5acc27d70423);
var $1e6525975b6cc660$export$84511cf4503ec9dd = $1e6525975b6cc660$export$30af8ca9498ddf5b;
var $1e6525975b6cc660$export$b0e76d9850c64156 = function(ma) {
    return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? $1e6525975b6cc660$export$79ffe56a765070d2(ma.left) : $1e6525975b6cc660$export$eabcd2c8791e7bf4(ma.right);
};
var $1e6525975b6cc660$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $1e6525975b6cc660$export$41d1a04d78e7b141 = $1e6525975b6cc660$export$efd845e0c87089a6;
var $1e6525975b6cc660$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(e) : $1e6525975b6cc660$export$79ffe56a765070d2(a);
    };
};
var $1e6525975b6cc660$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $1e6525975b6cc660$export$79ffe56a765070d2(f());
    } catch (e) {
        return $1e6525975b6cc660$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $1e6525975b6cc660$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $1e6525975b6cc660$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $1e6525975b6cc660$export$c69ca7b73fad45e1 = function(e) {
    var from = $1e6525975b6cc660$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $72EOc.flow)(f, from);
    };
};
var $1e6525975b6cc660$export$c81f992c08fd0bf3 = function(e) {
    var from = $1e6525975b6cc660$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $1e6525975b6cc660$export$5b8affa63fc6df16(from(f));
    };
};
var $1e6525975b6cc660$export$a0886ed3a572729f = /*#__PURE__*/ $1e6525975b6cc660$export$ccb09033cefa61e8((0, $72EOc.identity), (0, $72EOc.identity));
function $1e6525975b6cc660$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $1e6525975b6cc660$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $1e6525975b6cc660$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $1e6525975b6cc660$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $1e6525975b6cc660$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $1e6525975b6cc660$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $1e6525975b6cc660$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$2385a24977818dd0 = /*#__PURE__*/ $kgj0x.bind($1e6525975b6cc660$export$f18d5acc27d70423);
var $1e6525975b6cc660$export$e0d5b1cbe98976d9 = $1e6525975b6cc660$export$2385a24977818dd0;
var $1e6525975b6cc660$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$5c01f27714264b3d = $1e6525975b6cc660$export$8cbfc0239f42bb49;
var $1e6525975b6cc660$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $1e6525975b6cc660$export$ba255e9e49e00608($EfnK2.emptyReadonlyArray);
var $1e6525975b6cc660$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $EfnK2.head(as));
        if ($1e6525975b6cc660$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($1e6525975b6cc660$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $1e6525975b6cc660$export$79ffe56a765070d2(out);
    };
};
var $1e6525975b6cc660$export$d4e79db5dc14cc1 = function(f) {
    var g = $1e6525975b6cc660$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $EfnK2.isNonEmpty(as) ? g(as) : $1e6525975b6cc660$export$c74b6e34b2b6efb0;
    };
};
var $1e6525975b6cc660$export$104a2841e9cbad06 = $1e6525975b6cc660$export$d4e79db5dc14cc1;
var $1e6525975b6cc660$export$64f39b2a2b79e1b1 = function(f) {
    return $1e6525975b6cc660$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $1e6525975b6cc660$export$d330b60315c14cd1 = /*#__PURE__*/ $1e6525975b6cc660$export$64f39b2a2b79e1b1((0, $72EOc.identity));
var $1e6525975b6cc660$export$8e5885f0163d737a = $1e6525975b6cc660$export$5b8affa63fc6df16;
var $1e6525975b6cc660$export$e08e3b67e392101e = $1e6525975b6cc660$export$5b8affa63fc6df16;
var $1e6525975b6cc660$export$e3821ef4970c339c = $1e6525975b6cc660$export$3f23594af5f37336;
var $1e6525975b6cc660$export$5de78197fc44b933 = $1e6525975b6cc660$export$3f23594af5f37336;
function $1e6525975b6cc660$export$27924e57e9afff7f(s, onError) {
    return $1e6525975b6cc660$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $1e6525975b6cc660$export$702e019c6853c7a = function(u, onError) {
    return $1e6525975b6cc660$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $1e6525975b6cc660$export$5f5be1bb6cd1fded = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    of: $1e6525975b6cc660$export$ba255e9e49e00608,
    ap: $1e6525975b6cc660$var$_ap,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
    reduce: $1e6525975b6cc660$var$_reduce,
    foldMap: $1e6525975b6cc660$var$_foldMap,
    reduceRight: $1e6525975b6cc660$var$_reduceRight,
    traverse: $1e6525975b6cc660$var$_traverse,
    sequence: $1e6525975b6cc660$export$49bb65c2ea163039,
    bimap: $1e6525975b6cc660$var$_bimap,
    mapLeft: $1e6525975b6cc660$var$_mapLeft,
    alt: $1e6525975b6cc660$var$_alt,
    extend: $1e6525975b6cc660$var$_extend,
    chainRec: $1e6525975b6cc660$var$_chainRec,
    throwError: $1e6525975b6cc660$export$8bf7aba4a9e09055
};
var $1e6525975b6cc660$export$18979a515d2a828e = /*#__PURE__*/ (0, $aYN4d.getApplySemigroup)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $9xys1.getApplicativeMonoid)($1e6525975b6cc660$export$1279d2b7807629fd);
var $1e6525975b6cc660$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $aYN4d.getApplySemigroup)($1e6525975b6cc660$export$d9540e18497e6036(SE))(SA);
};
var $1e6525975b6cc660$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $9xys1.getApplicativeMonoid)($1e6525975b6cc660$export$d9540e18497e6036(SE))(MA);
};
function $1e6525975b6cc660$export$6843f928420ce3e4(SE) {
    var ap = $1e6525975b6cc660$export$d9540e18497e6036(SE).ap;
    var alt = $1e6525975b6cc660$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        of: $1e6525975b6cc660$export$ba255e9e49e00608,
        chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
        bimap: $1e6525975b6cc660$var$_bimap,
        mapLeft: $1e6525975b6cc660$var$_mapLeft,
        reduce: $1e6525975b6cc660$var$_reduce,
        foldMap: $1e6525975b6cc660$var$_foldMap,
        reduceRight: $1e6525975b6cc660$var$_reduceRight,
        extend: $1e6525975b6cc660$var$_extend,
        traverse: $1e6525975b6cc660$var$_traverse,
        sequence: $1e6525975b6cc660$export$49bb65c2ea163039,
        chainRec: $1e6525975b6cc660$var$_chainRec,
        throwError: $1e6525975b6cc660$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}

});
parcelRegister("5CEm3", function(module, exports) {

$parcel$export(module.exports, "tailRec", () => $417fcdfa682964a7$export$2e586eaa876dd2fd);
/**
 * @since 2.0.0
 */ var $417fcdfa682964a7$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};

});




parcelRegister("5kHfR", function(module, exports) {

$parcel$export(module.exports, "asLens", () => $3e205f7f2cd1627f$export$ba6dbfc52e933ec);
$parcel$export(module.exports, "asPrism", () => $3e205f7f2cd1627f$export$6963d4cf5712e556);
$parcel$export(module.exports, "asOptional", () => $3e205f7f2cd1627f$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $3e205f7f2cd1627f$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $3e205f7f2cd1627f$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "reverse", () => $3e205f7f2cd1627f$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "modify", () => $3e205f7f2cd1627f$export$3ff57735a52b8713);

var $72EOc = parcelRequire("72EOc");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $3e205f7f2cd1627f$export$1aba8f741a0eae06 = $lV5N9.iso;
var $3e205f7f2cd1627f$export$d560c7e4a29451c2 = function() {
    return $3e205f7f2cd1627f$export$1aba8f741a0eae06((0, $72EOc.identity), (0, $72EOc.identity));
};
var $3e205f7f2cd1627f$export$ba6dbfc52e933ec = $lV5N9.isoAsLens;
var $3e205f7f2cd1627f$export$6963d4cf5712e556 = $lV5N9.isoAsPrism;
var $3e205f7f2cd1627f$export$81a625dd455a09de = $lV5N9.isoAsOptional;
var $3e205f7f2cd1627f$export$ef38eac73d6f828f = $lV5N9.isoAsTraversal;
var $3e205f7f2cd1627f$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $3e205f7f2cd1627f$export$1aba8f741a0eae06((0, $72EOc.flow)(sa.get, ab.get), (0, $72EOc.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $3e205f7f2cd1627f$export$220ad92d18dabdd7 = $3e205f7f2cd1627f$export$f672e0b6f7222cd7;
var $3e205f7f2cd1627f$export$f5c3e419c6a355ce = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensComposeLens(ab));
};
var $3e205f7f2cd1627f$export$c1dc05e399870f6 = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$6963d4cf5712e556, $lV5N9.prismComposePrism(ab));
};
var $3e205f7f2cd1627f$export$323f76c400675c8b = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalComposeOptional(ab));
};
var $3e205f7f2cd1627f$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $3e205f7f2cd1627f$export$66c1ae025e96b4bc = function(sa) {
    return $3e205f7f2cd1627f$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $3e205f7f2cd1627f$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $3e205f7f2cd1627f$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $3e205f7f2cd1627f$export$b601f49376b4621a = function(sa) {
    return $3e205f7f2cd1627f$export$c1dc05e399870f6($lV5N9.prismFromNullable())(sa);
};
function $3e205f7f2cd1627f$export$3dea766d36a8935f(predicate) {
    return $3e205f7f2cd1627f$export$c1dc05e399870f6($lV5N9.prismFromPredicate(predicate));
}
var $3e205f7f2cd1627f$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensProp(prop));
};
var $3e205f7f2cd1627f$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensProps.apply($lV5N9, props));
};
var $3e205f7f2cd1627f$export$d8556a2a8f973135 = function(prop) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensComponent(prop));
};
var $3e205f7f2cd1627f$export$b610b8812bbcded9 = function(i) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalIndex(i));
};
var $3e205f7f2cd1627f$export$84162b00c25b711c = function(i) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalIndexNonEmpty(i));
};
var $3e205f7f2cd1627f$export$df61b30b684217c0 = function(key) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalKey(key));
};
var $3e205f7f2cd1627f$export$976574c443b9185b = function(key) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensAtKey(key));
};
var $3e205f7f2cd1627f$export$ad14ef4001db2bcd = /*#__PURE__*/ $3e205f7f2cd1627f$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismSome());
var $3e205f7f2cd1627f$export$79ffe56a765070d2 = /*#__PURE__*/ $3e205f7f2cd1627f$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismRight());
var $3e205f7f2cd1627f$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $3e205f7f2cd1627f$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismLeft());
function $3e205f7f2cd1627f$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $3e205f7f2cd1627f$export$9a2f228bed5035c2(predicate) {
    return $3e205f7f2cd1627f$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $3e205f7f2cd1627f$export$28e1f787311e0a21(predicate) {
    return $3e205f7f2cd1627f$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $3e205f7f2cd1627f$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $3e205f7f2cd1627f$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $3e205f7f2cd1627f$var$imap_ = function(ea, ab, ba) {
    return $3e205f7f2cd1627f$export$1aba8f741a0eae06((0, $72EOc.flow)(ea.get, ab), (0, $72EOc.flow)(ba, ea.reverseGet));
};
var $3e205f7f2cd1627f$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $3e205f7f2cd1627f$export$dbdf692cc5737cfd = {
    URI: $3e205f7f2cd1627f$export$9156e739aa33e19f,
    imap: $3e205f7f2cd1627f$var$imap_
};
var $3e205f7f2cd1627f$export$67666a3fb7d250d8 = {
    URI: $3e205f7f2cd1627f$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $3e205f7f2cd1627f$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $3e205f7f2cd1627f$export$3a8840c5b2ecf003 = {
    URI: $3e205f7f2cd1627f$export$9156e739aa33e19f,
    compose: $3e205f7f2cd1627f$export$67666a3fb7d250d8.compose,
    id: $3e205f7f2cd1627f$export$d560c7e4a29451c2
};

});

parcelRegister("2oRqE", function(module, exports) {

$parcel$export(module.exports, "fromAt", () => $1bf74485dbfc7fe3$export$c4dd3e639c7af330);
$parcel$export(module.exports, "fromIso", () => $1bf74485dbfc7fe3$export$3160d47a1ad63980);
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 
var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");

var $4qiTD = parcelRequire("4qiTD");
var $1bf74485dbfc7fe3$export$b610b8812bbcded9 = $lV5N9.index;
var $1bf74485dbfc7fe3$export$c4dd3e639c7af330 = function(at) {
    return $1bf74485dbfc7fe3$export$b610b8812bbcded9(function(i) {
        return $lV5N9.lensComposePrism($lV5N9.prismSome())(at.at(i));
    });
};
var $1bf74485dbfc7fe3$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $1bf74485dbfc7fe3$export$b610b8812bbcded9(function(i) {
            return (0, $30crt.pipe)(iso, $lV5N9.isoAsOptional, $lV5N9.optionalComposeOptional(sia.index(i)));
        });
    };
};
var $1bf74485dbfc7fe3$export$bb0c054375ca4b0 = $lV5N9.indexReadonlyArray;
var $1bf74485dbfc7fe3$export$165af7b747e6b1f1 = $lV5N9.indexReadonlyNonEmptyArray;
var $1bf74485dbfc7fe3$export$3c3468aec3b83bbf = $lV5N9.indexReadonlyRecord;
var $1bf74485dbfc7fe3$export$92da200d6ddb6846 = function(E) {
    var lookupE = $4qiTD.lookup(E);
    var insertAtE = $4qiTD.insertAt(E);
    return function() {
        return $1bf74485dbfc7fe3$export$b610b8812bbcded9(function(key) {
            return $lV5N9.optional(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $30crt.pipe)(lookupE(key, s), $bxsNd.fold(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $1bf74485dbfc7fe3$export$2cd1c249765cd0a4 = $lV5N9.indexReadonlyArray;
var $1bf74485dbfc7fe3$export$720226bf1ef46cb2 = $lV5N9.indexReadonlyRecord;

});

parcelRegister("40vng", function(module, exports) {

$parcel$export(module.exports, "lens", () => $2eaf7fc404ae0997$export$21cde5187c2605a3);
$parcel$export(module.exports, "id", () => $2eaf7fc404ae0997$export$d560c7e4a29451c2);
$parcel$export(module.exports, "asOptional", () => $2eaf7fc404ae0997$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $2eaf7fc404ae0997$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $2eaf7fc404ae0997$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $2eaf7fc404ae0997$export$f5c3e419c6a355ce);
$parcel$export(module.exports, "composeIso", () => $2eaf7fc404ae0997$export$220ad92d18dabdd7);
$parcel$export(module.exports, "composePrism", () => $2eaf7fc404ae0997$export$c1dc05e399870f6);
$parcel$export(module.exports, "composeOptional", () => $2eaf7fc404ae0997$export$323f76c400675c8b);
$parcel$export(module.exports, "composeTraversal", () => $2eaf7fc404ae0997$export$aa978f69e007229f);
$parcel$export(module.exports, "modify", () => $2eaf7fc404ae0997$export$3ff57735a52b8713);
$parcel$export(module.exports, "modifyF", () => $2eaf7fc404ae0997$export$a28005d3e6beb9a6);
$parcel$export(module.exports, "fromNullable", () => $2eaf7fc404ae0997$export$b601f49376b4621a);
$parcel$export(module.exports, "filter", () => $2eaf7fc404ae0997$export$3dea766d36a8935f);
$parcel$export(module.exports, "prop", () => $2eaf7fc404ae0997$export$977f3f6a9323c0f6);
$parcel$export(module.exports, "props", () => $2eaf7fc404ae0997$export$8128bb6492cf3de7);
$parcel$export(module.exports, "component", () => $2eaf7fc404ae0997$export$d8556a2a8f973135);
$parcel$export(module.exports, "index", () => $2eaf7fc404ae0997$export$b610b8812bbcded9);
$parcel$export(module.exports, "indexNonEmpty", () => $2eaf7fc404ae0997$export$84162b00c25b711c);
$parcel$export(module.exports, "key", () => $2eaf7fc404ae0997$export$df61b30b684217c0);
$parcel$export(module.exports, "atKey", () => $2eaf7fc404ae0997$export$976574c443b9185b);
$parcel$export(module.exports, "some", () => $2eaf7fc404ae0997$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "right", () => $2eaf7fc404ae0997$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $2eaf7fc404ae0997$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "traverse", () => $2eaf7fc404ae0997$export$df3f009e3d155b20);
$parcel$export(module.exports, "findFirst", () => $2eaf7fc404ae0997$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstNonEmpty", () => $2eaf7fc404ae0997$export$28e1f787311e0a21);
$parcel$export(module.exports, "imap", () => $2eaf7fc404ae0997$export$b2517b0ab3a58435);
$parcel$export(module.exports, "URI", () => $2eaf7fc404ae0997$export$9156e739aa33e19f);
$parcel$export(module.exports, "Invariant", () => $2eaf7fc404ae0997$export$dbdf692cc5737cfd);
$parcel$export(module.exports, "Semigroupoid", () => $2eaf7fc404ae0997$export$67666a3fb7d250d8);
$parcel$export(module.exports, "Category", () => $2eaf7fc404ae0997$export$3a8840c5b2ecf003);

var $72EOc = parcelRequire("72EOc");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $2eaf7fc404ae0997$export$21cde5187c2605a3 = $lV5N9.lens;
var $2eaf7fc404ae0997$export$d560c7e4a29451c2 = $lV5N9.lensId;
var $2eaf7fc404ae0997$export$81a625dd455a09de = $lV5N9.lensAsOptional;
var $2eaf7fc404ae0997$export$ef38eac73d6f828f = $lV5N9.lensAsTraversal;
var $2eaf7fc404ae0997$export$f672e0b6f7222cd7 = $lV5N9.lensComposeLens;
var $2eaf7fc404ae0997$export$f5c3e419c6a355ce = $2eaf7fc404ae0997$export$f672e0b6f7222cd7;
var $2eaf7fc404ae0997$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsLens, $2eaf7fc404ae0997$export$f672e0b6f7222cd7);
var $2eaf7fc404ae0997$export$c1dc05e399870f6 = $lV5N9.lensComposePrism;
var $2eaf7fc404ae0997$export$323f76c400675c8b = function(ab) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalComposeOptional(ab));
};
var $2eaf7fc404ae0997$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $2eaf7fc404ae0997$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $2eaf7fc404ae0997$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $2eaf7fc404ae0997$export$b601f49376b4621a = function(sa) {
    return $2eaf7fc404ae0997$export$c1dc05e399870f6($lV5N9.prismFromNullable())(sa);
};
function $2eaf7fc404ae0997$export$3dea766d36a8935f(predicate) {
    return $2eaf7fc404ae0997$export$c1dc05e399870f6($lV5N9.prismFromPredicate(predicate));
}
var $2eaf7fc404ae0997$export$977f3f6a9323c0f6 = $lV5N9.lensProp;
var $2eaf7fc404ae0997$export$8128bb6492cf3de7 = $lV5N9.lensProps;
var $2eaf7fc404ae0997$export$d8556a2a8f973135 = $lV5N9.lensComponent;
var $2eaf7fc404ae0997$export$b610b8812bbcded9 = function(i) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalIndex(i));
};
var $2eaf7fc404ae0997$export$84162b00c25b711c = function(i) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalIndexNonEmpty(i));
};
var $2eaf7fc404ae0997$export$df61b30b684217c0 = function(key) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalKey(key));
};
var $2eaf7fc404ae0997$export$976574c443b9185b = $lV5N9.lensAtKey;
var $2eaf7fc404ae0997$export$ad14ef4001db2bcd = /*#__PURE__*/ $2eaf7fc404ae0997$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismSome());
var $2eaf7fc404ae0997$export$79ffe56a765070d2 = /*#__PURE__*/ $2eaf7fc404ae0997$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismRight());
var $2eaf7fc404ae0997$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $2eaf7fc404ae0997$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismLeft());
function $2eaf7fc404ae0997$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $2eaf7fc404ae0997$export$9a2f228bed5035c2(predicate) {
    return $2eaf7fc404ae0997$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $2eaf7fc404ae0997$export$28e1f787311e0a21(predicate) {
    return $2eaf7fc404ae0997$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $2eaf7fc404ae0997$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $2eaf7fc404ae0997$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $2eaf7fc404ae0997$var$imap_ = function(ea, ab, ba) {
    return $2eaf7fc404ae0997$export$21cde5187c2605a3((0, $72EOc.flow)(ea.get, ab), (0, $72EOc.flow)(ba, ea.set));
};
var $2eaf7fc404ae0997$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $2eaf7fc404ae0997$export$dbdf692cc5737cfd = {
    URI: $2eaf7fc404ae0997$export$9156e739aa33e19f,
    imap: $2eaf7fc404ae0997$var$imap_
};
var $2eaf7fc404ae0997$export$67666a3fb7d250d8 = {
    URI: $2eaf7fc404ae0997$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $2eaf7fc404ae0997$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $2eaf7fc404ae0997$export$3a8840c5b2ecf003 = {
    URI: $2eaf7fc404ae0997$export$9156e739aa33e19f,
    compose: $2eaf7fc404ae0997$export$67666a3fb7d250d8.compose,
    id: $2eaf7fc404ae0997$export$d560c7e4a29451c2
};

});

parcelRegister("43LA8", function(module, exports) {

$parcel$export(module.exports, "asTraversal", () => $2f4c5a010ae2fc94$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $2f4c5a010ae2fc94$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modifyOption", () => $2f4c5a010ae2fc94$export$a2ef9d652875bdfa);
$parcel$export(module.exports, "modify", () => $2f4c5a010ae2fc94$export$3ff57735a52b8713);

var $72EOc = parcelRequire("72EOc");

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $2f4c5a010ae2fc94$export$516e28dec6a4b6d4 = $lV5N9.optional;
var $2f4c5a010ae2fc94$export$d560c7e4a29451c2 = function() {
    return $2f4c5a010ae2fc94$export$516e28dec6a4b6d4($bxsNd.some, (0, $72EOc.constant));
};
var $2f4c5a010ae2fc94$export$ef38eac73d6f828f = $lV5N9.optionalAsTraversal;
var $2f4c5a010ae2fc94$export$f672e0b6f7222cd7 = $lV5N9.optionalComposeOptional;
var $2f4c5a010ae2fc94$export$323f76c400675c8b = $2f4c5a010ae2fc94$export$f672e0b6f7222cd7;
var $2f4c5a010ae2fc94$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsOptional, $2f4c5a010ae2fc94$export$f672e0b6f7222cd7);
var $2f4c5a010ae2fc94$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.lensAsOptional, $lV5N9.optionalComposeOptional);
var $2f4c5a010ae2fc94$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.prismAsOptional, $lV5N9.optionalComposeOptional);
var $2f4c5a010ae2fc94$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($2f4c5a010ae2fc94$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $2f4c5a010ae2fc94$export$a2ef9d652875bdfa = $lV5N9.optionalModifyOption;
var $2f4c5a010ae2fc94$export$b2a7969df3fe0aa3 = function(a) {
    return $2f4c5a010ae2fc94$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $2f4c5a010ae2fc94$export$3ff57735a52b8713 = $lV5N9.optionalModify;
function $2f4c5a010ae2fc94$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $2f4c5a010ae2fc94$export$b601f49376b4621a = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismFromNullable()));
function $2f4c5a010ae2fc94$export$3dea766d36a8935f(predicate) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.prismAsOptional($lV5N9.prismFromPredicate(predicate)));
}
var $2f4c5a010ae2fc94$export$977f3f6a9323c0f6 = function(prop) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProp(prop), $lV5N9.lensAsOptional));
};
var $2f4c5a010ae2fc94$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProps.apply($lV5N9, props), $lV5N9.lensAsOptional));
};
var $2f4c5a010ae2fc94$export$d8556a2a8f973135 = function(prop) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensComponent(prop), $lV5N9.lensAsOptional));
};
var $2f4c5a010ae2fc94$export$b610b8812bbcded9 = $lV5N9.optionalIndex;
var $2f4c5a010ae2fc94$export$84162b00c25b711c = $lV5N9.optionalIndexNonEmpty;
var $2f4c5a010ae2fc94$export$df61b30b684217c0 = $lV5N9.optionalKey;
var $2f4c5a010ae2fc94$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.lensAsOptional($lV5N9.atReadonlyRecord().at(key))));
    };
};
var $2f4c5a010ae2fc94$export$ad14ef4001db2bcd = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismSome()));
var $2f4c5a010ae2fc94$export$79ffe56a765070d2 = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismRight()));
var $2f4c5a010ae2fc94$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismLeft()));
function $2f4c5a010ae2fc94$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($2f4c5a010ae2fc94$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $2f4c5a010ae2fc94$export$9a2f228bed5035c2(predicate) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.optionalFindFirst(predicate));
}
function $2f4c5a010ae2fc94$export$28e1f787311e0a21(predicate) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $2f4c5a010ae2fc94$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $2f4c5a010ae2fc94$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $2f4c5a010ae2fc94$var$imap_ = function(ea, ab, ba) {
    return $2f4c5a010ae2fc94$export$516e28dec6a4b6d4((0, $72EOc.flow)(ea.getOption, $bxsNd.map(ab)), (0, $72EOc.flow)(ba, ea.set));
};
var $2f4c5a010ae2fc94$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $2f4c5a010ae2fc94$export$dbdf692cc5737cfd = {
    URI: $2f4c5a010ae2fc94$export$9156e739aa33e19f,
    imap: $2f4c5a010ae2fc94$var$imap_
};
var $2f4c5a010ae2fc94$export$67666a3fb7d250d8 = {
    URI: $2f4c5a010ae2fc94$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $2f4c5a010ae2fc94$export$3a8840c5b2ecf003 = {
    URI: $2f4c5a010ae2fc94$export$9156e739aa33e19f,
    compose: $2f4c5a010ae2fc94$export$67666a3fb7d250d8.compose,
    id: $2f4c5a010ae2fc94$export$d560c7e4a29451c2
};

});

parcelRegister("ftUJ4", function(module, exports) {

$parcel$export(module.exports, "fromPredicate", () => $b4559109cd54548d$export$23f31c55d7162b91);
$parcel$export(module.exports, "asOptional", () => $b4559109cd54548d$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $b4559109cd54548d$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $b4559109cd54548d$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $b4559109cd54548d$export$f5c3e419c6a355ce);

var $72EOc = parcelRequire("72EOc");

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $b4559109cd54548d$export$e469dcfea9910464 = $lV5N9.prism;
var $b4559109cd54548d$export$d560c7e4a29451c2 = function() {
    return $b4559109cd54548d$export$e469dcfea9910464($bxsNd.some, (0, $72EOc.identity));
};
var $b4559109cd54548d$export$23f31c55d7162b91 = $lV5N9.prismFromPredicate;
var $b4559109cd54548d$export$81a625dd455a09de = $lV5N9.prismAsOptional;
var $b4559109cd54548d$export$ef38eac73d6f828f = $lV5N9.prismAsTraversal;
var $b4559109cd54548d$export$f672e0b6f7222cd7 = $lV5N9.prismComposePrism;
var $b4559109cd54548d$export$c1dc05e399870f6 = $b4559109cd54548d$export$f672e0b6f7222cd7;
var $b4559109cd54548d$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsPrism, $b4559109cd54548d$export$f672e0b6f7222cd7);
var $b4559109cd54548d$export$f5c3e419c6a355ce = $lV5N9.prismComposeLens;
var $b4559109cd54548d$export$323f76c400675c8b = function(ab) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalComposeOptional(ab));
};
var $b4559109cd54548d$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $b4559109cd54548d$export$adaa4cf7ef1b65be = $lV5N9.prismSet;
var $b4559109cd54548d$export$a2ef9d652875bdfa = $lV5N9.prismModifyOption;
var $b4559109cd54548d$export$3ff57735a52b8713 = $lV5N9.prismModify;
function $b4559109cd54548d$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $b4559109cd54548d$export$b601f49376b4621a = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismFromNullable());
function $b4559109cd54548d$export$3dea766d36a8935f(predicate) {
    return $b4559109cd54548d$export$f672e0b6f7222cd7($lV5N9.prismFromPredicate(predicate));
}
var $b4559109cd54548d$export$977f3f6a9323c0f6 = function(prop) {
    return $b4559109cd54548d$export$f5c3e419c6a355ce((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProp(prop)));
}; // TODO: simplify?
var $b4559109cd54548d$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $b4559109cd54548d$export$f5c3e419c6a355ce((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProps.apply($lV5N9, props)));
};
var $b4559109cd54548d$export$d8556a2a8f973135 = function(prop) {
    return $b4559109cd54548d$export$f5c3e419c6a355ce((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensComponent(prop)));
};
var $b4559109cd54548d$export$b610b8812bbcded9 = function(i) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalIndex(i));
};
var $b4559109cd54548d$export$84162b00c25b711c = function(i) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalIndexNonEmpty(i));
};
var $b4559109cd54548d$export$df61b30b684217c0 = function(key) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalKey(key));
};
var $b4559109cd54548d$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $lV5N9.prismComposeLens($lV5N9.atReadonlyRecord().at(key))(sa);
    };
};
var $b4559109cd54548d$export$ad14ef4001db2bcd = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismSome());
var $b4559109cd54548d$export$79ffe56a765070d2 = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismRight());
var $b4559109cd54548d$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismLeft());
function $b4559109cd54548d$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $b4559109cd54548d$export$9a2f228bed5035c2(predicate) {
    return $b4559109cd54548d$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $b4559109cd54548d$export$28e1f787311e0a21(predicate) {
    return $b4559109cd54548d$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $b4559109cd54548d$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $b4559109cd54548d$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $b4559109cd54548d$var$imap_ = function(ea, ab, ba) {
    return $b4559109cd54548d$export$e469dcfea9910464((0, $72EOc.flow)(ea.getOption, $bxsNd.map(ab)), (0, $72EOc.flow)(ba, ea.reverseGet));
};
var $b4559109cd54548d$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $b4559109cd54548d$export$dbdf692cc5737cfd = {
    URI: $b4559109cd54548d$export$9156e739aa33e19f,
    imap: $b4559109cd54548d$var$imap_
};
var $b4559109cd54548d$export$67666a3fb7d250d8 = {
    URI: $b4559109cd54548d$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $b4559109cd54548d$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $b4559109cd54548d$export$3a8840c5b2ecf003 = {
    URI: $b4559109cd54548d$export$9156e739aa33e19f,
    compose: $b4559109cd54548d$export$67666a3fb7d250d8.compose,
    id: $b4559109cd54548d$export$d560c7e4a29451c2
};

});

parcelRegister("7NEBD", function(module, exports) {

$parcel$export(module.exports, "fromTraversable", () => $5adc9b83d7d033c2$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "compose", () => $5adc9b83d7d033c2$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modify", () => $5adc9b83d7d033c2$export$3ff57735a52b8713);
$parcel$export(module.exports, "set", () => $5adc9b83d7d033c2$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "filter", () => $5adc9b83d7d033c2$export$3dea766d36a8935f);

var $fFgN5 = parcelRequire("fFgN5");

var $72EOc = parcelRequire("72EOc");

var $30crt = parcelRequire("30crt");

var $8yI6w = parcelRequire("8yI6w");

var $lV5N9 = parcelRequire("lV5N9");
var $5adc9b83d7d033c2$export$8666ce7a134c2314 = $lV5N9.traversal;
var $5adc9b83d7d033c2$export$d560c7e4a29451c2 = function() {
    return $5adc9b83d7d033c2$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $5adc9b83d7d033c2$export$126b5a87c58d3f9c = $lV5N9.fromTraversable;
var $5adc9b83d7d033c2$export$f672e0b6f7222cd7 = $lV5N9.traversalComposeTraversal;
var $5adc9b83d7d033c2$export$aa978f69e007229f = $5adc9b83d7d033c2$export$f672e0b6f7222cd7;
var $5adc9b83d7d033c2$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsTraversal, $5adc9b83d7d033c2$export$f672e0b6f7222cd7);
var $5adc9b83d7d033c2$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.lensAsTraversal, $lV5N9.traversalComposeTraversal);
var $5adc9b83d7d033c2$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.prismAsTraversal, $lV5N9.traversalComposeTraversal);
var $5adc9b83d7d033c2$export$323f76c400675c8b = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.optionalAsTraversal, $lV5N9.traversalComposeTraversal);
var $5adc9b83d7d033c2$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($lV5N9.ApplicativeIdentity)(f);
    };
};
var $5adc9b83d7d033c2$export$adaa4cf7ef1b65be = function(a) {
    return $5adc9b83d7d033c2$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $5adc9b83d7d033c2$export$b601f49376b4621a = function(sa) {
    return $5adc9b83d7d033c2$export$c1dc05e399870f6($lV5N9.prismFromNullable())(sa);
};
function $5adc9b83d7d033c2$export$3dea766d36a8935f(predicate) {
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.prismAsTraversal($lV5N9.prismFromPredicate(predicate)));
}
var $5adc9b83d7d033c2$export$977f3f6a9323c0f6 = function(prop) {
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProp(prop), $lV5N9.lensAsTraversal));
};
var $5adc9b83d7d033c2$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProps.apply($lV5N9, props), $lV5N9.lensAsTraversal));
};
var $5adc9b83d7d033c2$export$d8556a2a8f973135 = function(prop) {
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensComponent(prop), $lV5N9.lensAsTraversal));
};
var $5adc9b83d7d033c2$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.optionalAsTraversal($lV5N9.indexReadonlyArray().index(i))));
    };
};
var $5adc9b83d7d033c2$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.optionalAsTraversal($lV5N9.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $5adc9b83d7d033c2$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.optionalAsTraversal($lV5N9.indexReadonlyRecord().index(key))));
    };
};
var $5adc9b83d7d033c2$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.lensAsTraversal($lV5N9.atReadonlyRecord().at(key))));
    };
};
var $5adc9b83d7d033c2$export$ad14ef4001db2bcd = /*#__PURE__*/ $5adc9b83d7d033c2$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsTraversal(/*#__PURE__*/ $lV5N9.prismSome()));
var $5adc9b83d7d033c2$export$79ffe56a765070d2 = /*#__PURE__*/ $5adc9b83d7d033c2$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsTraversal(/*#__PURE__*/ $lV5N9.prismRight()));
var $5adc9b83d7d033c2$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $5adc9b83d7d033c2$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsTraversal(/*#__PURE__*/ $lV5N9.prismLeft()));
var $5adc9b83d7d033c2$export$df3f009e3d155b20 = $lV5N9.traversalTraverse;
function $5adc9b83d7d033c2$export$9a2f228bed5035c2(predicate) {
    return $5adc9b83d7d033c2$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $5adc9b83d7d033c2$export$28e1f787311e0a21(predicate) {
    return $5adc9b83d7d033c2$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $5adc9b83d7d033c2$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($fFgN5.getApplicative(M))(function(a) {
                return $fFgN5.make(f(a));
            });
        };
    };
};
var $5adc9b83d7d033c2$export$93e2b83da34ff82a = function(M) {
    return $5adc9b83d7d033c2$export$b66cdc0497d8a99a(M)((0, $72EOc.identity));
};
var $5adc9b83d7d033c2$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $5adc9b83d7d033c2$export$b66cdc0497d8a99a($8yI6w.getMonoid())($8yI6w.of)(sa)(s);
    };
};
var $5adc9b83d7d033c2$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $5adc9b83d7d033c2$export$67666a3fb7d250d8 = {
    URI: $5adc9b83d7d033c2$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $5adc9b83d7d033c2$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $5adc9b83d7d033c2$export$3a8840c5b2ecf003 = {
    URI: $5adc9b83d7d033c2$export$9156e739aa33e19f,
    compose: $5adc9b83d7d033c2$export$67666a3fb7d250d8.compose,
    id: $5adc9b83d7d033c2$export$d560c7e4a29451c2
};

});


parcelRegister("gyqrs", function(module, exports) {

$parcel$export(module.exports, "BASE_STREAM_URL", () => $6f61a4b2d82d43e7$export$7c03f5942efb8a41);
const $6f61a4b2d82d43e7$export$7c03f5942efb8a41 = '/gateway/api/assist/api/ai';

});


parcelRegister("LzBwp", function(module, exports) {

$parcel$export(module.exports, "makeConvoAIStreamRequest", () => $69c89c3d2d0641e2$export$2f20a85d8fafe2d9);

var $iX7e9 = parcelRequire("iX7e9");

var $kAaxz = parcelRequire("kAaxz");

var $hoKUP = parcelRequire("hoKUP");
function $69c89c3d2d0641e2$export$2f20a85d8fafe2d9(requestConfig) {
    const behaviorSubject = new (0, $iX7e9.BehaviorSubject)((0, $kAaxz.getDefaultConvoAIStreamingState)());
    fetch(requestConfig.url, {
        credentials: 'include',
        ...requestConfig.requestInitParams
    }).then((response)=>(0, $hoKUP.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'CHANNEL_ID':
                    const channelId = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).ChannelId,
                        content: channelId,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $kAaxz.ConvoAIResponseState).FinalResponse,
                        content: bufferContent
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? [],
                        responseState: (0, $kAaxz.ConvoAIResponseState).FollowUp
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $kAaxz.ConvoAIResponseState).Error,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
}

});
parcelRegister("hoKUP", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $20c346f17ddaccf2$export$e45226161c660403);

var $bddW2 = parcelRequire("bddW2");

var $93WqG = parcelRequire("93WqG");
async function* $20c346f17ddaccf2$export$e45226161c660403(response) {
    // Read the response body only if the status is 200 and the body is not null
    if (response.status === 200 && response.body) try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
            }
        };
        return;
    }
    // parse the response body as text which should be safe
    const responseText = await response.text();
    try {
        // try to parse the response body as json
        const responseJson = JSON.parse(responseText);
        // covered HTTP errors only from this doc
        // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
        // Kept for extra error handling security as we migrate to convo-ai from agent service
        yield (0, $bddW2.match)({
            status: response.status,
            body: response.body,
            text: responseText,
            json: responseJson
        }).returnType().with({
            status: 201
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 400
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 403
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 429
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).RATE_LIMIT,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 500
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            body: (0, $bddW2.P).nullish
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[Error]: response.body is missing. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).otherwise(({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            }));
    } catch (error) {
        yield {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: UNABLE_TO_PARSE_HTTP_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }
}

});


parcelRegister("2864f", function(module, exports) {

$parcel$export(module.exports, "parsePartialConvoAIJsonIfNeeded", () => $b0fe2e92f6e87b5f$export$d2c9dfa182282b6d);

var $aGU6X = parcelRequire("aGU6X");

var $kAaxz = parcelRequire("kAaxz");
function $b0fe2e92f6e87b5f$export$d2c9dfa182282b6d(state, config) {
    if (state.responseState !== (0, $kAaxz.ConvoAIResponseState).Initialization && config.enablePartialJson && state.content) try {
        const parsedContent = (0, $aGU6X.parse)(state.content);
        return {
            ...state,
            content: parsedContent
        };
    } catch (error) {}
    return state;
}

});
parcelRegister("aGU6X", function(module, exports) {
"use strict";
var $7c895a27d7315d26$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7c895a27d7315d26$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7c895a27d7315d26$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.MalformedJSON = module.exports.PartialJSON = module.exports.parseJSON = module.exports.parse = void 0;

Object.defineProperty(module.exports, "Allow", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1tDCw")).Allow;
    }
});

$7c895a27d7315d26$var$__exportStar((parcelRequire("1tDCw")), module.exports);
class $7c895a27d7315d26$var$PartialJSON extends Error {
}
module.exports.PartialJSON = $7c895a27d7315d26$var$PartialJSON;
class $7c895a27d7315d26$var$MalformedJSON extends Error {
}
module.exports.MalformedJSON = $7c895a27d7315d26$var$MalformedJSON;
/**
 * Parse incomplete JSON
 * @param {string} jsonString Partial JSON to be parsed
 * @param {number} allowPartial Specify what types are allowed to be partial, see {@link Allow} for details
 * @returns The parsed JSON
 * @throws {PartialJSON} If the JSON is incomplete (related to the `allow` parameter)
 * @throws {MalformedJSON} If the JSON is malformed
 */ function $7c895a27d7315d26$var$parseJSON(jsonString, allowPartial = (parcelRequire("1tDCw")).Allow.ALL) {
    if (typeof jsonString !== "string") throw new TypeError(`expecting str, got ${typeof jsonString}`);
    if (!jsonString.trim()) throw new Error(`${jsonString} is empty`);
    return $7c895a27d7315d26$var$_parseJSON(jsonString.trim(), allowPartial);
}
module.exports.parseJSON = $7c895a27d7315d26$var$parseJSON;
const $7c895a27d7315d26$var$_parseJSON = (jsonString, allow)=>{
    const length = jsonString.length;
    let index = 0;
    const markPartialJSON = (msg)=>{
        throw new $7c895a27d7315d26$var$PartialJSON(`${msg} at position ${index}`);
    };
    const throwMalformedError = (msg)=>{
        throw new $7c895a27d7315d26$var$MalformedJSON(`${msg} at position ${index}`);
    };
    const parseAny = ()=>{
        skipBlank();
        if (index >= length) markPartialJSON("Unexpected end of input");
        if (jsonString[index] === '"') return parseStr();
        if (jsonString[index] === "{") return parseObj();
        if (jsonString[index] === "[") return parseArr();
        if (jsonString.substring(index, index + 4) === "null" || (parcelRequire("1tDCw")).Allow.NULL & allow && length - index < 4 && "null".startsWith(jsonString.substring(index))) {
            index += 4;
            return null;
        }
        if (jsonString.substring(index, index + 4) === "true" || (parcelRequire("1tDCw")).Allow.BOOL & allow && length - index < 4 && "true".startsWith(jsonString.substring(index))) {
            index += 4;
            return true;
        }
        if (jsonString.substring(index, index + 5) === "false" || (parcelRequire("1tDCw")).Allow.BOOL & allow && length - index < 5 && "false".startsWith(jsonString.substring(index))) {
            index += 5;
            return false;
        }
        if (jsonString.substring(index, index + 8) === "Infinity" || (parcelRequire("1tDCw")).Allow.INFINITY & allow && length - index < 8 && "Infinity".startsWith(jsonString.substring(index))) {
            index += 8;
            return Infinity;
        }
        if (jsonString.substring(index, index + 9) === "-Infinity" || (parcelRequire("1tDCw")).Allow._INFINITY & allow && 1 < length - index && length - index < 9 && "-Infinity".startsWith(jsonString.substring(index))) {
            index += 9;
            return -Infinity;
        }
        if (jsonString.substring(index, index + 3) === "NaN" || (parcelRequire("1tDCw")).Allow.NAN & allow && length - index < 3 && "NaN".startsWith(jsonString.substring(index))) {
            index += 3;
            return NaN;
        }
        return parseNum();
    };
    const parseStr = ()=>{
        const start = index;
        let escape = false;
        index++; // skip initial quote
        while(index < length && (jsonString[index] !== '"' || escape && jsonString[index - 1] === "\\")){
            escape = jsonString[index] === "\\" ? !escape : false;
            index++;
        }
        if (jsonString.charAt(index) == '"') try {
            return JSON.parse(jsonString.substring(start, ++index - Number(escape)));
        } catch (e) {
            throwMalformedError(String(e));
        }
        else if ((parcelRequire("1tDCw")).Allow.STR & allow) try {
            return JSON.parse(jsonString.substring(start, index - Number(escape)) + '"');
        } catch (e) {
            // SyntaxError: Invalid escape sequence
            return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("\\")) + '"');
        }
        markPartialJSON("Unterminated string literal");
    };
    const parseObj = ()=>{
        index++; // skip initial brace
        skipBlank();
        const obj = {};
        try {
            while(jsonString[index] !== "}"){
                skipBlank();
                if (index >= length && (parcelRequire("1tDCw")).Allow.OBJ & allow) return obj;
                const key = parseStr();
                skipBlank();
                index++; // skip colon
                try {
                    const value = parseAny();
                    obj[key] = value;
                } catch (e) {
                    if ((parcelRequire("1tDCw")).Allow.OBJ & allow) return obj;
                    else throw e;
                }
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("1tDCw")).Allow.OBJ & allow) return obj;
            else markPartialJSON("Expected '}' at end of object");
        }
        index++; // skip final brace
        return obj;
    };
    const parseArr = ()=>{
        index++; // skip initial bracket
        const arr = [];
        try {
            while(jsonString[index] !== "]"){
                arr.push(parseAny());
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("1tDCw")).Allow.ARR & allow) return arr;
            markPartialJSON("Expected ']' at end of array");
        }
        index++; // skip final bracket
        return arr;
    };
    const parseNum = ()=>{
        if (index === 0) {
            if (jsonString === "-") throwMalformedError("Not sure what '-' is");
            try {
                return JSON.parse(jsonString);
            } catch (e) {
                if ((parcelRequire("1tDCw")).Allow.NUM & allow) try {
                    return JSON.parse(jsonString.substring(0, jsonString.lastIndexOf("e")));
                } catch (e) {}
                throwMalformedError(String(e));
            }
        }
        const start = index;
        if (jsonString[index] === "-") index++;
        while(jsonString[index] && ",]}".indexOf(jsonString[index]) === -1)index++;
        if (index == length && !((parcelRequire("1tDCw")).Allow.NUM & allow)) markPartialJSON("Unterminated number literal");
        try {
            return JSON.parse(jsonString.substring(start, index));
        } catch (e) {
            if (jsonString.substring(start, index) === "-") markPartialJSON("Not sure what '-' is");
            try {
                return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("e")));
            } catch (e) {
                throwMalformedError(String(e));
            }
        }
    };
    const skipBlank = ()=>{
        while(index < length && " \n\r\t".includes(jsonString[index]))index++;
    };
    return parseAny();
};
const $7c895a27d7315d26$var$parse = $7c895a27d7315d26$var$parseJSON;
module.exports.parse = $7c895a27d7315d26$var$parse;

});
parcelRegister("1tDCw", function(module, exports) {
"use strict";
/**
 * Sometimes you don't allow every type to be partially parsed.
 * For example, you may not want a partial number because it may increase its size gradually before it's complete.
 * In this case, you can use the `Allow` object to control what types you allow to be partially parsed.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.ALL = module.exports.COLLECTION = module.exports.ATOM = module.exports.SPECIAL = module.exports.INF = module.exports._INFINITY = module.exports.INFINITY = module.exports.NAN = module.exports.BOOL = module.exports.NULL = module.exports.OBJ = module.exports.ARR = module.exports.NUM = module.exports.STR = void 0;
/**
 * allow partial strings like `"hello \u12` to be parsed as `"hello "`
 */ module.exports.STR = 1;
/**
 * allow partial numbers like `123.` to be parsed as `123`
 */ module.exports.NUM = 2;
/**
 * allow partial arrays like `[1, 2,` to be parsed as `[1, 2]`
 */ module.exports.ARR = 4;
/**
 * allow partial objects like `{"a": 1, "b":` to be parsed as `{"a": 1}`
 */ module.exports.OBJ = 8;
/**
 * allow `nu` to be parsed as `null`
 */ module.exports.NULL = 16;
/**
 * allow `tr` to be parsed as `true`, and `fa` to be parsed as `false`
 */ module.exports.BOOL = 32;
/**
 * allow `Na` to be parsed as `NaN`
 */ module.exports.NAN = 64;
/**
 * allow `Inf` to be parsed as `Infinity`
 */ module.exports.INFINITY = 128;
/**
 * allow `-Inf` to be parsed as `-Infinity`
 */ module.exports._INFINITY = 256;
module.exports.INF = module.exports.INFINITY | module.exports._INFINITY;
module.exports.SPECIAL = module.exports.NULL | module.exports.BOOL | module.exports.INF | module.exports.NAN;
module.exports.ATOM = module.exports.STR | module.exports.NUM | module.exports.SPECIAL;
module.exports.COLLECTION = module.exports.ARR | module.exports.OBJ;
module.exports.ALL = module.exports.ATOM | module.exports.COLLECTION;
/**
 * Control what types you allow to be partially parsed.
 * The default is to allow all types to be partially parsed, which in most casees is the best option.
 * @example
 * If you don't want to allow partial objects, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, Allow.ARR); // [ { a: 1, b: 2 } ]
 * ```
 * Or you can use `~` to disallow a type:
 * ```ts
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, ~Allow.OBJ); // [ { a: 1, b: 2 } ]
 * ```
 * @example
 * If you don't want to allow partial strings, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`["complete string", "incompl`, ~Allow.STR); // [ 'complete string' ]
 * ```
 */ module.exports.Allow = {
    STR: module.exports.STR,
    NUM: module.exports.NUM,
    ARR: module.exports.ARR,
    OBJ: module.exports.OBJ,
    NULL: module.exports.NULL,
    BOOL: module.exports.BOOL,
    NAN: module.exports.NAN,
    INFINITY: module.exports.INFINITY,
    _INFINITY: module.exports._INFINITY,
    INF: module.exports.INF,
    SPECIAL: module.exports.SPECIAL,
    ATOM: module.exports.ATOM,
    COLLECTION: module.exports.COLLECTION,
    ALL: module.exports.ALL
};
module.exports.default = module.exports.Allow;

});



parcelRegister("aOfhe", function(module, exports) {

$parcel$export(module.exports, "logConvoAIInfo", () => $ffa31632e87ec23b$export$7eba3e1ed428e5ae);
const $ffa31632e87ec23b$export$7eba3e1ed428e5ae = (message, config, data)=>{
    if (config.enableLocalVerboseLogs) // eslint-disable-next-line no-console
    console.info(`[@atlassian/convo-ai-streaming] [${message}]:`, data);
};

});





parcelRegister("1ASvP", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $648b40683bbc8a0b$export$2c6963927dbc68f1);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");
class $648b40683bbc8a0b$var$MountEventComponent extends (0, $gwFzn.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $648b40683bbc8a0b$var$MountEventComponentWithHOC = (0, $1DWH0.default)()($648b40683bbc8a0b$var$MountEventComponent);
const $648b40683bbc8a0b$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($648b40683bbc8a0b$var$MountEventComponentWithHOC, {
        ...props
    });

});

parcelRegister("kfViO", function(module, exports) {

$parcel$export(module.exports, "countADFChars", () => $1716be1127a34d35$export$2d424d3a12064a81);

var $6jPem = parcelRequire("6jPem");
const $1716be1127a34d35$export$2d424d3a12064a81 = (value)=>{
    if (!value) return 0;
    let chars = 0;
    (0, $6jPem.traverse)(value, {
        text: (node)=>{
            if (node.text) chars += node.text.length;
        },
        emoji: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        },
        paragraph: ()=>{
            chars += 1;
        },
        mention: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        }
    });
    // Subtract 1 due to doc node
    return chars ? chars - 1 : chars;
};

});

parcelRegister("9BGuq", function(module, exports) {

$parcel$export(module.exports, "useAiIssueCreateAnalytics", () => $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $1mDVg = parcelRequire("1mDVg");
const $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return (0, $gwFzn.useMemo)(()=>({
            fireTrack: (name, attributes)=>{
                const source = 'aiIssueCreate';
                const [actionSubject, action] = name.split(' ');
                const eventAttributes = {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    ...attributes
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: source,
                        action: action,
                        actionSubject: actionSubject,
                        attributes: eventAttributes
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent,
        pageMode,
        hasEditPermission
    ]);
};

});

parcelRegister("arvSz", function(module, exports) {

$parcel$export(module.exports, "useStreamingHookProps", () => $5dcd84d787afdff9$export$8b355f71d361cab7);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $93WqG = parcelRequire("93WqG");

var $9wGTI = parcelRequire("9wGTI");

var $9BGuq = parcelRequire("9BGuq");
const $5dcd84d787afdff9$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $93WqG.ConvoAIErrorMessage).NOT_FOUND,
        (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $5dcd84d787afdff9$export$8b355f71d361cab7 = ({ confluencePage: confluencePage, highlightedText: highlightedText, overrideXProduct: overrideXProduct })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { locale: locale } = (0, $dBxQj.default)();
    return (0, $gwFzn.useMemo)(()=>({
            analyticsConfig: {
                aiFeatureName: 'confluenceAiWorkCreationConvoAI',
                product: 'confluence',
                subproduct: 'jira',
                useDefaultGASv3EventSchema: false,
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            },
            requestHeaderOverrides: {
                overrideXProduct: overrideXProduct
            },
            issueConfig: {
                max_issues: 1,
                suggested_issue_field_types: [
                    {
                        issue_type: 'Task',
                        fields: [
                            {
                                field_name: 'Summary',
                                field_type: 'Short-Text'
                            },
                            {
                                field_name: 'Description',
                                field_type: 'Paragraph'
                            }
                        ]
                    }
                ]
            },
            experienceId: 'ai-issue-create-confluence',
            sourceType: 'documentation',
            input: {
                source: 'CONFLUENCE',
                context: {
                    primary_text: confluencePage,
                    highlighted_text: highlightedText
                },
                ...(0, $9wGTI.fg)('aiwc_migrate_to_convo_ai_sends_locale_crcs-2021') && {
                    locale: locale
                }
            },
            onCompletion: ()=>{},
            customExperienceTracker: {
                start: ()=>{
                    (0, $9wGTI.fg)('aiwc_migrate_to_convo_ai_sends_locale_crcs-2021') ? fireTrack('aiIssueCreateFetchSuggestedFieldsRequest start', {
                        locale: locale
                    }) : fireTrack('aiIssueCreateFetchSuggestedFieldsRequest start');
                },
                succeed: ()=>{
                    (0, $9wGTI.fg)('aiwc_migrate_to_convo_ai_sends_locale_crcs-2021') ? fireTrack('aiIssueCreateFetchSuggestedFieldsRequest complete', {
                        haveResult: true,
                        locale: locale
                    }) : fireTrack('aiIssueCreateFetchSuggestedFieldsRequest complete', {
                        haveResult: true
                    });
                },
                fail: (convoAIStreamError)=>{
                    (0, $9wGTI.fg)('aiwc_migrate_to_convo_ai_sends_locale_crcs-2021') ? fireTrack('aiIssueCreateFetchSuggestedFieldsRequest fail', {
                        errorMessage: convoAIStreamError?.message?.content,
                        statusCode: convoAIStreamError?.message?.status_code,
                        message_template: convoAIStreamError?.message?.message_template,
                        shouldSlo: !$5dcd84d787afdff9$export$4177e9b841c72d1e(convoAIStreamError),
                        locale: locale
                    }) : fireTrack('aiIssueCreateFetchSuggestedFieldsRequest fail', {
                        errorMessage: convoAIStreamError?.message?.content,
                        statusCode: convoAIStreamError?.message?.status_code,
                        message_template: convoAIStreamError?.message?.message_template,
                        shouldSlo: !$5dcd84d787afdff9$export$4177e9b841c72d1e(convoAIStreamError)
                    });
                },
                abort: ()=>{
                    (0, $9wGTI.fg)('aiwc_migrate_to_convo_ai_sends_locale_crcs-2021') ? fireTrack('aiIssueCreateFetchSuggestedFieldsRequest abort', {
                        locale: locale
                    }) : fireTrack('aiIssueCreateFetchSuggestedFieldsRequest abort');
                }
            }
        }), [
        confluencePage,
        highlightedText,
        overrideXProduct,
        fireTrack,
        locale
    ]);
};

});

parcelRegister("7aGmI", function(module, exports) {

$parcel$export(module.exports, "SingleWorkCreateForm", () => $e690acb4757b7782$export$b4c01a5f89e8eb7d);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $fzqvY = parcelRequire("fzqvY");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $aoVih = parcelRequire("aoVih");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $2ay9q = parcelRequire("2ay9q");

var $5JTsO = parcelRequire("5JTsO");

var $1mDVg = parcelRequire("1mDVg");

var $4Jwpx = parcelRequire("4Jwpx");

var $aCdxq = parcelRequire("aCdxq");

var $4pDFC = parcelRequire("4pDFC");

var $lkF83 = parcelRequire("lkF83");

var $a2rs0 = parcelRequire("a2rs0");

var $4yWiB = parcelRequire("4yWiB");

var $3Sz0l = parcelRequire("3Sz0l");
const $e690acb4757b7782$var$singleWorkCreateFormStyles = (0, $ecnYn.xcss)({
    flexGrow: 1,
    overflowY: 'auto'
});
const $e690acb4757b7782$var$singleWorkCreateFormContainerStyles = (0, $ecnYn.xcss)({
    height: '100%'
});
const $e690acb4757b7782$export$b4c01a5f89e8eb7d = ({ closePanel: closePanel = ()=>{}, summary: initialSummary = '', descriptionAdf: initialDescription })=>{
    const { setCurrentSiteSelection: setCurrentSiteSelection } = (0, $1mDVg.useIssueCreateSidePanelActions)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    // State for form fields
    const [summary, setSummary] = (0, $gwFzn.useState)(initialSummary);
    const [description, setDescription] = (0, $gwFzn.useState)(initialDescription);
    const [isSubmitting, setIsSubmitting] = (0, $gwFzn.useState)(false);
    const [submissionError, setSubmissionError] = (0, $gwFzn.useState)(null);
    const { availableSites: // Site picker data
    availableSites, selectedSite: selectedSite, isSitePickerLoading: isSitePickerLoading, selectedProject: // Project picker data
    selectedProject, optionsRecentProjects: optionsRecentProjects, optionsAllProjects: optionsAllProjects, isProjectPickerLoading: isProjectPickerLoading, selectedIssueType: // Issue type picker data
    selectedIssueType, optionsIssueTypes: optionsIssueTypes, isIssueTypePickerLoading: isIssueTypePickerLoading, // Error handling
    error: formError, onSiteChange: // Change handlers
    onSiteChange, onProjectChange: onProjectChange, onIssueTypeChange: onIssueTypeChange } = (0, $5JTsO.useGetInitialDataForSingleIssueCreateForm)();
    const { createSingleWorkItemHandler: createSingleWorkItemHandler, loading: isCreating, error: createError } = (0, $4Jwpx.useCreateSingleWorkItem)();
    const handleSummaryChange = (0, $gwFzn.useCallback)((value)=>{
        setSummary(value);
    }, []);
    const handleDescriptionChange = (0, $gwFzn.useCallback)((value)=>{
        setDescription(value);
    }, []);
    const handleSubmit = (0, $gwFzn.useCallback)(async ()=>{
        if (isSubmitting || !selectedSite || !selectedProject || !selectedIssueType) return;
        try {
            setIsSubmitting(true);
            setSubmissionError(null);
            if (selectedSite) {
                setCurrentSiteSelection(selectedSite.cloudId);
                (0, $2ay9q.saveJiraConfigDetailsToLocalStorage)({
                    selectedSite: selectedSite
                });
            }
            await createSingleWorkItemHandler({
                cloudId: selectedSite.cloudId,
                issueBody: {
                    fields: {
                        summary: summary,
                        description: description,
                        project: {
                            id: selectedProject.id
                        },
                        issuetype: {
                            id: selectedIssueType.id
                        }
                    }
                }
            });
            // Close the panel on successful submission
            closePanel();
        } catch (_error) {
            setSubmissionError(formatMessage((0, $3E5yu.messages).singleWorkCreateFormJiraErrorText));
        } finally{
            setIsSubmitting(false);
        }
    }, [
        isSubmitting,
        selectedSite,
        selectedProject,
        selectedIssueType,
        setCurrentSiteSelection,
        summary,
        description,
        createSingleWorkItemHandler,
        closePanel,
        formatMessage
    ]);
    const onClose = (0, $gwFzn.useCallback)(()=>{
        closePanel();
    }, [
        closePanel
    ]);
    const isSaveDisabled = isSubmitting || isCreating || isSitePickerLoading || isProjectPickerLoading || !selectedSite || !summary.trim() || !selectedProject || !selectedIssueType; // Require all mandatory fields
    const error = submissionError || createError || formError;
    const singleWorkCreateFormBodyText = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleWorkCreateFormBodyTextIssueTermRefresh : (0, $3E5yu.messages).singleWorkCreateFormBodyText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        testId: "single-work-create-form-wrapper",
        direction: "column",
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $e690acb4757b7782$var$singleWorkCreateFormContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        xcss: $e690acb4757b7782$var$singleWorkCreateFormStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), singleWorkCreateFormBodyText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.accent.gray.bolder"
    }, "Required fields are marked with an asterisk *"), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "singleWorkCreateFormErrorSectionMessage"
    }, typeof error === 'string' ? error : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).singleWorkCreateFormJiraErrorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fzqvY.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("form", {
            id: "single-work-create-form",
            "data-testid": "single-work-create-form",
            ...formProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4pDFC.SiteSelector), {
            options: availableSites,
            value: selectedSite,
            onChange: onSiteChange,
            isLoading: isSitePickerLoading,
            isDisabled: isSitePickerLoading || isSubmitting || isCreating,
            isRequired: true,
            label: formatMessage((0, $3E5yu.messages).singleWorkCreateFormSite)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lkF83.ProjectSelector), {
            optionsAllProjects: optionsAllProjects,
            optionsRecentProjects: optionsRecentProjects,
            value: selectedProject,
            onChange: onProjectChange,
            isLoading: isProjectPickerLoading,
            isDisabled: isProjectPickerLoading || !selectedSite || isSubmitting || isCreating,
            label: formatMessage((0, $3E5yu.messages).singleWorkCreateFormProject),
            labelProjectSelectorRecentProjects: formatMessage((0, $3E5yu.messages).singleWorkCreateFormProjectSelectorRecentProjects),
            labelProjectSelectorProjects: formatMessage((0, $3E5yu.messages).singleWorkCreateFormProjectSelectorProjects),
            isRequired: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aCdxq.IssueTypeSelector), {
            optionsIssueTypes: optionsIssueTypes,
            value: selectedIssueType,
            onChange: onIssueTypeChange,
            isLoading: isIssueTypePickerLoading,
            isDisabled: isIssueTypePickerLoading || !selectedProject || isSubmitting || isCreating,
            label: (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? formatMessage((0, $3E5yu.messages).singleWorkCreateFormDefaultIssueTypeIssueTermRefresh) : formatMessage((0, $3E5yu.messages).singleWorkCreateFormDefaultIssueType),
            isRequired: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4yWiB.TextField), {
            label: formatMessage((0, $3E5yu.messages).workCreateCommonSummaryLabel),
            value: summary,
            onChange: handleSummaryChange,
            isRequired: true,
            isDisabled: isSubmitting || isCreating
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Sz0l.RichTextField), {
            label: formatMessage((0, $3E5yu.messages).workCreateCommonDescriptionLabel),
            value: description,
            onChange: handleDescriptionChange,
            isDisabled: isSubmitting || isCreating
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a2rs0.SingleWorkCreateFormFooter), {
        onClose: onClose,
        closePanel: closePanel,
        isSaveDisabled: isSaveDisabled
    }));
};

});
parcelRegister("5JTsO", function(module, exports) {

$parcel$export(module.exports, "useGetInitialDataForSingleIssueCreateForm", () => $527d6729eaff7a1c$export$7bec8bf1b5313edf);

var $gwFzn = parcelRequire("gwFzn");

var $6JynD = parcelRequire("6JynD");

var $hITg6 = parcelRequire("hITg6");

var $eRQAK = parcelRequire("eRQAK");
const $527d6729eaff7a1c$export$7bec8bf1b5313edf = ()=>{
    // Local state to manage selected values
    const [selectedSite, setSelectedSite] = (0, $gwFzn.useState)(null);
    const [selectedProject, setSelectedProject] = (0, $gwFzn.useState)(null);
    const [projectSelectorQuery, setProjectSelectorQuery] = (0, $gwFzn.useState)(null);
    // Site picker - First step
    const sitesResult = (0, $6JynD.useGetAvailableSitesForSingleIssueCreateForm)();
    const { availableSites: availableSites = [], isLoading: isSitePickerLoading = false, error: sitesError = null } = sitesResult || {};
    // Auto-select first site if available
    (0, $gwFzn.useEffect)(()=>{
        if (availableSites.length > 0 && !selectedSite) setSelectedSite(availableSites[0]);
    }, [
        availableSites,
        selectedSite
    ]);
    // Project picker - Second step (depends on selected site)
    const { optionsRecentProjects: optionsRecentProjects, optionsAllProjects: optionsAllProjects, selectedProject: projectFromHook, isLoading: isProjectPickerLoading, error: projectsError, onProjectChange: handleProjectChangeFromHook } = (0, $hITg6.useGetJiraProjectsForSingleIssueCreateForm)(selectedSite, projectSelectorQuery);
    // Update selected project when project hook returns a selection
    (0, $gwFzn.useEffect)(()=>{
        if (projectFromHook) setSelectedProject(projectFromHook);
    }, [
        projectFromHook
    ]);
    // Issue type picker - Third step (depends on selected site and project)
    const { optionsIssueTypes: optionsIssueTypes, selectedIssueType: selectedIssueType, isLoading: isIssueTypePickerLoading, error: issueTypesError, onIssueTypeChange: onIssueTypeChange } = (0, $eRQAK.useGetIssueTypesForSingleIssueCreateForm)(selectedSite, selectedProject);
    // Handlers for form changes
    const handleSiteChange = (0, $gwFzn.useCallback)((site)=>{
        setSelectedSite(site);
        // Reset dependent fields
        setSelectedProject(null);
        setProjectSelectorQuery(null);
    }, []);
    const handleProjectChange = (0, $gwFzn.useCallback)((project)=>{
        setSelectedProject(project);
        handleProjectChangeFromHook(project);
    }, [
        handleProjectChangeFromHook
    ]);
    // Combine all data
    const singleIssueCreateInitialData = {
        availableSites: // Site picker data
        availableSites,
        selectedSite: selectedSite,
        isSitePickerLoading: isSitePickerLoading,
        selectedProject: // Project picker data
        selectedProject,
        optionsRecentProjects: optionsRecentProjects,
        optionsAllProjects: optionsAllProjects,
        isProjectPickerLoading: isProjectPickerLoading,
        selectedIssueType: // Issue type picker data
        selectedIssueType,
        optionsIssueTypes: optionsIssueTypes,
        isIssueTypePickerLoading: isIssueTypePickerLoading,
        // Error handling
        error: sitesError || projectsError || issueTypesError,
        // Change handlers
        onSiteChange: handleSiteChange,
        onProjectChange: handleProjectChange,
        onIssueTypeChange: onIssueTypeChange
    };
    return singleIssueCreateInitialData;
};

});
parcelRegister("6JynD", function(module, exports) {

$parcel$export(module.exports, "useGetAvailableSitesForSingleIssueCreateForm", () => $3a31f2af6057b1bc$export$cc99372de1b01e21);

var $gwFzn = parcelRequire("gwFzn");

var $g5o3i = parcelRequire("g5o3i");

var $bQm3c = parcelRequire("bQm3c");

var $2ay9q = parcelRequire("2ay9q");
const $3a31f2af6057b1bc$export$cc99372de1b01e21 = (props = {})=>{
    const { onSitesLoaded: onSitesLoaded, onError: onError } = props;
    const { cloudId: sessionCloudId } = (0, $bQm3c.useSessionData)();
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const overrideCloudIdForSitePicker = persistedOverrideCloudId || sessionCloudId;
    // State for decoupled logic
    const [availableSites, setAvailableSites] = (0, $gwFzn.useState)([]);
    const [selectedAvailableSite, setSelectedAvailableSite] = (0, $gwFzn.useState)(null);
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(true);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const onComplete = (0, $gwFzn.useCallback)(({ availableSites: availableSitesFromResponse })=>{
        const firstSite = availableSitesFromResponse[0];
        const preferredSite = availableSitesFromResponse.find((site)=>site.cloudId === overrideCloudIdForSitePicker);
        setSelectedAvailableSite(preferredSite || firstSite);
        setAvailableSites(availableSitesFromResponse);
        setIsLoading(false);
        onSitesLoaded?.(availableSitesFromResponse);
    }, [
        setAvailableSites,
        setIsLoading,
        onSitesLoaded,
        setSelectedAvailableSite,
        overrideCloudIdForSitePicker
    ]);
    const onErrorHandler = (0, $gwFzn.useCallback)((err)=>{
        setError(err);
        setIsLoading(false);
        onError?.(err);
    }, [
        setError,
        setIsLoading,
        onError
    ]);
    (0, $g5o3i.useGetFirstAvailableSiteDomain)({
        preferredCloudId: overrideCloudIdForSitePicker,
        onComplete: onComplete,
        onError: onErrorHandler
    });
    return {
        availableSites: availableSites,
        isLoading: isLoading,
        error: error,
        selectedAvailableSite: selectedAvailableSite
    };
};

});

parcelRegister("hITg6", function(module, exports) {

$parcel$export(module.exports, "useGetJiraProjectsForSingleIssueCreateForm", () => $b037cf4e6160cf81$export$6982b2e6c17e7885);

var $gwFzn = parcelRequire("gwFzn");

var $k9cgj = parcelRequire("k9cgj");
const $b037cf4e6160cf81$export$6982b2e6c17e7885 = (selectedAvailableSite = null, projectSelectorQuery = null)=>{
    const [optionsRecentProjects, setOptionsRecentProjects] = (0, $gwFzn.useState)([]);
    const [optionsAllProjects, setOptionsAllProjects] = (0, $gwFzn.useState)([]);
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [selectedProject, setSelectedProject] = (0, $gwFzn.useState)(null);
    const resetState = (0, $gwFzn.useCallback)(()=>{
        setOptionsRecentProjects([]);
        setOptionsAllProjects([]);
        setSelectedProject(null);
        setError(null);
    }, []);
    // Reset state when site changes
    (0, $gwFzn.useEffect)(()=>{
        resetState();
    }, [
        selectedAvailableSite?.cloudId,
        resetState
    ]);
    // Fetch projects when site is available
    (0, $gwFzn.useEffect)(()=>{
        if (!selectedAvailableSite?.cloudId) return;
        const cloudId = selectedAvailableSite.cloudId;
        const query = projectSelectorQuery?.trim() || '';
        const fetchProjects = async ()=>{
            setIsLoading(true);
            setError(null);
            try {
                if (query) {
                    // If there's a search query, only fetch filtered projects
                    const searchResults = await (0, $k9cgj.fetchJiraProjects)({
                        cloudId: cloudId,
                        query: query
                    });
                    setOptionsRecentProjects([]);
                    setOptionsAllProjects(searchResults || []);
                    // Auto-select first search result
                    if (searchResults && searchResults.length > 0) setSelectedProject(searchResults[0]);
                } else {
                    // Otherwise fetch both recent and all projects
                    const [recentProjectsResult, allProjectsResult] = await Promise.allSettled([
                        (0, $k9cgj.fetchRecentJiraProjects)({
                            cloudId: cloudId
                        }),
                        (0, $k9cgj.fetchJiraProjects)({
                            cloudId: cloudId
                        })
                    ]);
                    let recentProjectsWithPermissions = [];
                    // Handle recent projects
                    if (recentProjectsResult.status === 'fulfilled' && recentProjectsResult.value) {
                        const recentProjectIds = recentProjectsResult.value.map((project)=>project.id);
                        if (recentProjectIds.length > 0) {
                            recentProjectsWithPermissions = await (0, $k9cgj.fetchJiraProjects)({
                                cloudId: cloudId,
                                projectIds: recentProjectIds
                            }) || [];
                            setOptionsRecentProjects(recentProjectsWithPermissions);
                        }
                    }
                    // Handle all projects
                    if (allProjectsResult.status === 'fulfilled' && allProjectsResult.value) {
                        const allProjects = allProjectsResult.value;
                        setOptionsAllProjects(allProjects);
                        if (recentProjectsWithPermissions.length > 0) setSelectedProject(recentProjectsWithPermissions[0]);
                        else if (allProjects.length > 0) setSelectedProject(allProjects[0]);
                    }
                }
            } catch (e) {
                setError(e);
                resetState();
            } finally{
                setIsLoading(false);
            }
        };
        fetchProjects();
    }, [
        selectedAvailableSite?.cloudId,
        projectSelectorQuery,
        resetState
    ]);
    const handleProjectChange = (0, $gwFzn.useCallback)((project)=>{
        setSelectedProject(project);
    }, []);
    return {
        optionsRecentProjects: optionsRecentProjects,
        optionsAllProjects: optionsAllProjects,
        selectedProject: selectedProject,
        isLoading: isLoading,
        error: error,
        onProjectChange: handleProjectChange
    };
};

});
parcelRegister("k9cgj", function(module, exports) {

$parcel$export(module.exports, "fetchJiraProjects", () => $8c7990e76592fea1$export$3643d7b900ddb907);
$parcel$export(module.exports, "fetchRecentJiraProjects", () => $8c7990e76592fea1$export$7c1ee4a22f76eab4);
$parcel$export(module.exports, "fetchIssueTypes", () => $8c7990e76592fea1$export$2434906985ee7db);
$parcel$export(module.exports, "createIssue", () => $8c7990e76592fea1$export$b61347e00e271b8e);
$parcel$export(module.exports, "createBulkIssues", () => $8c7990e76592fea1$export$b2c5c6a2eab6752b);
$parcel$export(module.exports, "fetchIssuesMetadata", () => $8c7990e76592fea1$export$33757cfaf527b436);
$parcel$export(module.exports, "mapGICPayloadToCreateIssueResponse", () => $8c7990e76592fea1$export$fea6fd4de12a3df);
$parcel$export(module.exports, "getJiraAiEnablement", () => $8c7990e76592fea1$export$741d044e24209da7);

var $f7B1p = parcelRequire("f7B1p");
const $8c7990e76592fea1$var$getJiraProjectsEndpoint = ({ cloudId: cloudId, query: query, projectIds: projectIds })=>{
    let endpoint = `/gateway/api/ex/jira/${cloudId}/rest/api/3/project/search?action=create`;
    if (projectIds && projectIds.length > 0) endpoint += `&id=${projectIds.join('&id=')}`;
    if (query && query.length > 0) endpoint += `&query=${query}`;
    return endpoint;
};
const $8c7990e76592fea1$export$3643d7b900ddb907 = async ({ cloudId: cloudId, query: query, projectIds: projectIds })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getJiraProjectsEndpoint({
            cloudId: cloudId,
            query: query,
            projectIds: projectIds
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        const projects = data?.values;
        if (!projects) throw new Error('Parsing response from fetchJiraProjects failed');
        return projects;
    } catch (_error) {
        throw new Error('Request to fetchJiraProjects agent failed');
    }
};
const $8c7990e76592fea1$var$getRecentJiraProjectsEndpoint = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/project/recent`;
const $8c7990e76592fea1$export$7c1ee4a22f76eab4 = async ({ cloudId: cloudId })=>{
    try {
        if (!cloudId) throw new Error('cloudId is required');
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getRecentJiraProjectsEndpoint(cloudId), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const recentProjects = await response.json();
        if (!recentProjects) throw new Error('Parsing response from getRecentJiraProjects failed');
        return recentProjects;
    } catch (_error) {
        throw new Error('Request to fetchRecentJiraProjects agent failed');
    }
};
const $8c7990e76592fea1$export$7486116a104ef6e1 = ({ cloudId: cloudId, projectId: projectId })=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes`;
const $8c7990e76592fea1$export$2434906985ee7db = async ({ cloudId: cloudId, projectId: projectId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$export$7486116a104ef6e1({
            cloudId: cloudId,
            projectId: projectId
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        const issues = data?.issueTypes;
        if (!issues) throw new Error('Parsing response from fetchIssueTypes failed');
        return issues;
    } catch (_error) {
        throw new Error('Request to fetchIssueTypes agent failed');
    }
};
const $8c7990e76592fea1$export$2c19a8a7ef06a941 = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue`;
const $8c7990e76592fea1$export$f47c2dad96a0a8ce = ({ cloudId: cloudId, issueBody: issueBody })=>{
    return (0, $f7B1p.cfetch)($8c7990e76592fea1$export$2c19a8a7ef06a941(cloudId), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(issueBody)
    });
};
const $8c7990e76592fea1$export$b61347e00e271b8e = async ({ cloudId: cloudId, issueBody: issueBody })=>{
    try {
        const response = await $8c7990e76592fea1$export$f47c2dad96a0a8ce({
            cloudId: cloudId,
            issueBody: issueBody
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from createIssue failed');
        return data;
    } catch (_error) {
        throw new Error('Request to createIssue agent failed');
    }
};
const $8c7990e76592fea1$export$7308ced31fe15b63 = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/bulk`;
const $8c7990e76592fea1$export$b2c5c6a2eab6752b = async ({ cloudId: cloudId, issueBody: issueBody })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$export$7308ced31fe15b63(cloudId), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(issueBody)
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from createBulkIssues failed');
        return data;
    } catch (_error) {
        throw new Error('Request to createBulkIssues agent failed');
    }
};
const $8c7990e76592fea1$export$e2e9228ec6723fb3 = (tasks, limit)=>{
    return new Promise((resolve)=>{
        const results = [];
        if (tasks.length <= 0) return resolve(results);
        let currentIndex = 0;
        let activePromises = 0;
        const processNext = ()=>{
            while(activePromises < limit && currentIndex < tasks.length){
                const index = currentIndex++;
                activePromises++;
                tasks[index]().then((value)=>handleSettlement(index, {
                        status: 'fulfilled',
                        value: value
                    }), (reason)=>handleSettlement(index, {
                        status: 'rejected',
                        reason: reason
                    }));
            }
        };
        const handleSettlement = (index, result)=>{
            results[index] = result;
            activePromises--;
            if (currentIndex >= tasks.length && activePromises === 0) resolve(results);
            else processNext();
        };
        processNext();
    });
};
const $8c7990e76592fea1$var$getIssuesMetadataEndpoint = ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, maxResults: maxResults, startAt: startAt })=>{
    const base = `/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes/${issueTypeId}`;
    const withMaxResults = `${base}?maxResults=${maxResults}`;
    return `${withMaxResults}&startAt=${startAt}`;
};
const $8c7990e76592fea1$export$33757cfaf527b436 = async ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, maxResults: maxResults = 200, page: page = 0, consolidatedFields: consolidatedFields = [] })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getIssuesMetadataEndpoint({
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            maxResults: maxResults,
            startAt: page * maxResults
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from issues metadata failed');
        const finalConsolidatedFields = [
            ...consolidatedFields,
            ...data.fields
        ];
        // The API can return a maximum result of 200. However, Issue types can sometimes have more than
        // 200 fields, in which case, the API may not be able to retrieve the summary and description fields correctly.
        // Therefore we call this API until the number of consolidated fields is equal to the value of 'total' indicated in the API response.
        // This 'total' indicates the total number of fields in all pages.
        if (data.total > finalConsolidatedFields.length) return await $8c7990e76592fea1$export$33757cfaf527b436({
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            maxResults: maxResults,
            page: page + 1,
            consolidatedFields: finalConsolidatedFields
        });
        return {
            fields: finalConsolidatedFields,
            maxResults: data.maxResults,
            total: data.total,
            startAt: data.startAt
        };
    } catch (_error) {
        throw new Error('Error retrieving issue metadata');
    }
};
const $8c7990e76592fea1$export$fea6fd4de12a3df = (payload)=>{
    return {
        id: payload.issueId ? payload.issueId.toString() : '',
        key: payload.issueKey,
        self: payload.link,
        transition: {
            status: 200,
            errorCollection: {
                errorMessages: [],
                errors: {}
            }
        },
        summary: payload.summary
    };
};
const $8c7990e76592fea1$export$f758b0f2f750cf99 = (cloudId, jiraProduct)=>`/gateway/api/ex/jira/${cloudId}/rest/api/1/aiconfig/ai-enabled/${jiraProduct}`;
const $8c7990e76592fea1$export$922a2bf0f405ea63 = (cloudId, jiraProduct)=>{
    return (0, $f7B1p.cfetch)($8c7990e76592fea1$export$f758b0f2f750cf99(cloudId, jiraProduct), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include'
    });
};
const $8c7990e76592fea1$export$741d044e24209da7 = async (cloudId, jiraProduct)=>{
    try {
        const response = await $8c7990e76592fea1$export$922a2bf0f405ea63(cloudId, jiraProduct);
        const data = await response.json();
        if (!data) throw new Error('Parsing response from getJiraAiEnablementRequest failed');
        return data;
    } catch (_error) {
        throw new Error('Request to getJiraAiEnablementRequest agent failed');
    }
};

});


parcelRegister("eRQAK", function(module, exports) {

$parcel$export(module.exports, "useGetIssueTypesForSingleIssueCreateForm", () => $a0fac2ce8f0fbcd1$export$fbdd964392be920e);

var $gwFzn = parcelRequire("gwFzn");

var $k9cgj = parcelRequire("k9cgj");
const $a0fac2ce8f0fbcd1$export$34eff5686aa81020 = 'fetch-issue-types';
const $a0fac2ce8f0fbcd1$export$fbdd964392be920e = (selectedAvailableSite = null, selectedProject = null)=>{
    const [optionsIssueTypes, setOptionsIssueTypes] = (0, $gwFzn.useState)([]);
    const [selectedIssueType, setSelectedIssueType] = (0, $gwFzn.useState)(null);
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const resetState = (0, $gwFzn.useCallback)(()=>{
        setOptionsIssueTypes([]);
        setSelectedIssueType(null);
        setError(null);
    }, []);
    // Reset state when project changes
    (0, $gwFzn.useEffect)(()=>{
        resetState();
    }, [
        selectedProject?.id,
        resetState
    ]);
    // Fetch issue types when dependencies are available
    (0, $gwFzn.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        const projectId = selectedProject?.id;
        if (!cloudId || !projectId) return;
        const fetchIssues = async ()=>{
            setIsLoading(true);
            setError(null);
            try {
                const data = await (0, $k9cgj.fetchIssueTypes)({
                    cloudId: cloudId,
                    projectId: projectId
                });
                const validIssueTypes = data?.filter((issueType)=>!issueType.subtask) || [];
                setOptionsIssueTypes(validIssueTypes);
                if (validIssueTypes.length > 0) setSelectedIssueType(validIssueTypes[0]);
            } catch (e) {
                resetState();
                setError(e);
            } finally{
                setIsLoading(false);
            }
        };
        fetchIssues();
    }, [
        selectedAvailableSite?.cloudId,
        selectedProject?.id,
        resetState
    ]);
    const handleIssueTypeChange = (0, $gwFzn.useCallback)((issueType)=>{
        setSelectedIssueType(issueType);
    }, []);
    return {
        optionsIssueTypes: optionsIssueTypes,
        selectedIssueType: selectedIssueType,
        isLoading: isLoading,
        error: error,
        onIssueTypeChange: handleIssueTypeChange
    };
};

});


parcelRegister("4Jwpx", function(module, exports) {

$parcel$export(module.exports, "useCreateSingleWorkItem", () => $9a838fe55351f3a3$export$9cf0fd9a7347ef44);

var $gwFzn = parcelRequire("gwFzn");

var $k9cgj = parcelRequire("k9cgj");
const $9a838fe55351f3a3$export$9cf0fd9a7347ef44 = ()=>{
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [response, setResponse] = (0, $gwFzn.useState)(null);
    const createSingleWorkItemHandler = (0, $gwFzn.useCallback)(async ({ cloudId: cloudId, issueBody: issueBody })=>{
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const result = await (0, $k9cgj.createIssue)({
                cloudId: cloudId,
                issueBody: issueBody
            });
            setResponse(result || null);
        } catch (err) {
            setError('Failed to create issue');
        } finally{
            setLoading(false);
        }
    }, []);
    return {
        createSingleWorkItemHandler: createSingleWorkItemHandler,
        loading: loading,
        error: error,
        response: response
    };
};

});

parcelRegister("aCdxq", function(module, exports) {

$parcel$export(module.exports, "IssueTypeSelector", () => $52e9bc47e2ec1c07$export$aa04298ab6db90d8);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $fb3kw = parcelRequire("fb3kw");

var $3hOY6 = parcelRequire("3hOY6");
var $2gD2K = parcelRequire("2gD2K");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $f0BVO = parcelRequire("f0BVO");

var $CbMiC = parcelRequire("CbMiC");

var $jOfMg = parcelRequire("jOfMg");
const $52e9bc47e2ec1c07$var$mapIssueTypeToOption = (issueType)=>{
    return {
        label: issueType.name,
        value: issueType,
        avatarUrl: (0, $f0BVO.transformStargateUrl)(issueType.iconUrl)
    };
};
const $52e9bc47e2ec1c07$var$IssueTypeOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jOfMg.BulkConfigureSelectOption), {
        label: props.label,
        avatarUrl: props.data.avatarUrl
    }));
const $52e9bc47e2ec1c07$var$IssueTypeSingleValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jOfMg.BulkConfigureSelectOption), {
        label: props.data.label,
        avatarUrl: props.data.avatarUrl
    }));
const $52e9bc47e2ec1c07$export$aa04298ab6db90d8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { selectedIssueType: selectedIssueType, optionsIssueTypes: issueTypes } = (0, $CbMiC.useIssueTypesState)();
    const { setSelectedIssueType: setSelectedIssueType } = (0, $CbMiC.useIssueTypesActions)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    // Old Sweet State logic
    const optionsSweetState = (0, $gwFzn.useMemo)(()=>{
        return issueTypes?.map($52e9bc47e2ec1c07$var$mapIssueTypeToOption);
    }, [
        issueTypes
    ]);
    const onChangeSweetState = (0, $gwFzn.useCallback)((selectedOption)=>{
        if (selectedOption && selectedOption.value !== selectedIssueType) setSelectedIssueType(selectedOption.value);
    }, [
        selectedIssueType,
        setSelectedIssueType
    ]);
    const selectedValueSweetState = selectedIssueType ? $52e9bc47e2ec1c07$var$mapIssueTypeToOption(selectedIssueType) : null;
    // New decoupled logic (props/local state)
    const { optionsIssueTypes: optionsIssueTypes = [], value: controlledValue, onChange: onChange, isLoading: isLoading = false, isDisabled: isDisabled = false, label: label } = props;
    const [localValue, setLocalValue] = (0, $gwFzn.useState)(controlledValue ?? null);
    (0, $gwFzn.useEffect)(()=>{
        if (controlledValue !== undefined) setLocalValue(controlledValue);
    }, [
        controlledValue
    ]);
    const mappedOptions = (0, $gwFzn.useMemo)(()=>optionsIssueTypes.map($52e9bc47e2ec1c07$var$mapIssueTypeToOption), [
        optionsIssueTypes
    ]);
    if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) // Old Sweet State logic
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: "defaultIssueTypes",
        label: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkConfigureFormDefaultIssueTypeIssueTermRefresh : (0, $3E5yu.messages).bulkConfigureFormDefaultIssueType),
        testId: "work-create-issue-type-field"
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            options: optionsSweetState,
            isDisabled: isConfigureLoading || !selectedValueSweetState,
            isLoading: isConfigureLoading,
            value: selectedValueSweetState,
            onChange: onChangeSweetState,
            components: {
                Option: $52e9bc47e2ec1c07$var$IssueTypeOption,
                SingleValue: $52e9bc47e2ec1c07$var$IssueTypeSingleValue
            }
        })));
    const handleChange = (selectedOption)=>{
        if (!selectedOption || !selectedOption.value) return;
        if (selectedOption.value === localValue) return;
        setLocalValue(selectedOption.value);
        onChange?.(selectedOption.value);
    };
    const selectedValue = localValue ? $52e9bc47e2ec1c07$var$mapIssueTypeToOption(localValue) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: "defaultIssueTypes",
        // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
        label: label ?? formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkConfigureFormDefaultIssueTypeIssueTermRefresh : (0, $3E5yu.messages).bulkConfigureFormDefaultIssueType),
        testId: "work-create-issue-type-field",
        isRequired: props.isRequired ?? false
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            value: selectedValue,
            options: mappedOptions,
            onChange: handleChange,
            isLoading: isLoading,
            isDisabled: isLoading || isDisabled || !selectedValue,
            components: {
                Option: $52e9bc47e2ec1c07$var$IssueTypeOption,
                SingleValue: $52e9bc47e2ec1c07$var$IssueTypeSingleValue
            }
        })));
};

});
parcelRegister("jOfMg", function(module, exports) {

$parcel$export(module.exports, "BulkConfigureSelectOption", () => $889600fbced24328$export$f4d12280b3fb5f60);

var $gwFzn = parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");
const $889600fbced24328$export$f4d12280b3fb5f60 = ({ label: label, avatarUrl: avatarUrl })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        size: "medium"
    }, label));
};

});


parcelRegister("4pDFC", function(module, exports) {

$parcel$export(module.exports, "SiteSelector", () => $445bd7561410e232$export$515237fa9c64c5dc);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $fb3kw = parcelRequire("fb3kw");

var $2gD2K = parcelRequire("2gD2K");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $CbMiC = parcelRequire("CbMiC");
const $445bd7561410e232$export$24eb759d590e7556 = (site)=>({
        label: site.displayName,
        value: site
    });
const $445bd7561410e232$export$515237fa9c64c5dc = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    // Old Sweet State logic
    const { selectedAvailableSite: selectedAvailableSite, optionsAvailableSites: optionsAvailableSites } = (0, $CbMiC.useAvailableSitesState)();
    const { setSelectedAvailableSite: setSelectedAvailableSite } = (0, $CbMiC.useAvailableSitesActions)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    const optionsSweetState = (0, $gwFzn.useMemo)(()=>{
        return optionsAvailableSites?.map($445bd7561410e232$export$24eb759d590e7556);
    }, [
        optionsAvailableSites
    ]);
    const onChangeSweetState = (0, $gwFzn.useCallback)((selectedOptionSweetState)=>{
        if (selectedOptionSweetState && selectedOptionSweetState.value !== selectedAvailableSite) setSelectedAvailableSite(selectedOptionSweetState.value);
    }, [
        selectedAvailableSite,
        setSelectedAvailableSite
    ]);
    // New decoupled logic (props/local state)
    const { options: options = [], value: controlledValue, onChange: onChange, isLoading: isLoading = false, isDisabled: isDisabled = false, label: label } = props;
    const [localValue, setLocalValue] = (0, $gwFzn.useState)(controlledValue ?? null);
    const mappedOptions = (0, $gwFzn.useMemo)(()=>options?.map($445bd7561410e232$export$24eb759d590e7556), [
        options
    ]);
    const selectedValue = localValue ? $445bd7561410e232$export$24eb759d590e7556(localValue) : null;
    // Keep local state in sync with controlled value
    (0, $gwFzn.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) return;
        if (controlledValue !== undefined) setLocalValue(controlledValue);
    }, [
        controlledValue,
        setLocalValue
    ]);
    if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: "sites",
        label: formatMessage((0, $3E5yu.messages).bulkConfigureFormSite),
        testId: "work-create-site-field"
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            value: selectedAvailableSite ? $445bd7561410e232$export$24eb759d590e7556(selectedAvailableSite) : null,
            options: optionsSweetState,
            onChange: onChangeSweetState,
            isLoading: isConfigureLoading,
            isDisabled: isConfigureLoading
        })));
    const handleChange = (selectedOption)=>{
        if (!selectedOption || !selectedOption.value) return;
        if (selectedOption.value === localValue) return;
        const newValue = selectedOption ? selectedOption.value : null;
        setLocalValue(newValue);
        onChange?.(newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: "sites",
        // TODO: Remove formatMessage(messages.bulkConfigureFormSite) once we cleanup jira_ai_decouple_issue_create_fields FF
        label: label ?? formatMessage((0, $3E5yu.messages).bulkConfigureFormSite),
        testId: "work-create-site-field",
        isRequired: props.isRequired ?? false
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            value: selectedValue,
            options: mappedOptions,
            onChange: handleChange,
            isLoading: isLoading,
            isDisabled: isDisabled || isLoading
        })));
};

});

parcelRegister("lkF83", function(module, exports) {

$parcel$export(module.exports, "ProjectSelector", () => $46689f7fc671df97$export$a764642e4b725728);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $fb3kw = parcelRequire("fb3kw");

var $3hOY6 = parcelRequire("3hOY6");
var $2gD2K = parcelRequire("2gD2K");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $CbMiC = parcelRequire("CbMiC");

var $f0BVO = parcelRequire("f0BVO");

var $jOfMg = parcelRequire("jOfMg");
const $46689f7fc671df97$var$mapProjectToOption = (project)=>{
    return {
        label: project.name,
        value: project,
        avatarUrl: (0, $f0BVO.transformStargateUrl)(project.avatarUrls['48x48'])
    };
};
const $46689f7fc671df97$var$ProjectTypeOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jOfMg.BulkConfigureSelectOption), {
        label: props.label,
        avatarUrl: props.data.avatarUrl
    }));
const $46689f7fc671df97$var$ProjectTypeSingleValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jOfMg.BulkConfigureSelectOption), {
        label: props.data.label,
        avatarUrl: props.data.avatarUrl
    }));
const $46689f7fc671df97$export$a764642e4b725728 = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { selectedProject: selectedProject, optionsRecentProjects: recentProjects, optionsAllProjects: allProjects } = (0, $CbMiC.useProjectsState)();
    const { setSelectedProject: setSelectedProject, setProjectSelectorQuery: setProjectSelectorQuery } = (0, $CbMiC.useProjectsActions)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    // Old Sweet State logic
    const optionsSweetState = (0, $gwFzn.useMemo)(()=>{
        if (recentProjects && recentProjects.length > 0) return [
            {
                label: formatMessage((0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjects),
                options: recentProjects.map($46689f7fc671df97$var$mapProjectToOption)
            },
            {
                label: formatMessage((0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjects),
                options: allProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
        return [
            {
                options: allProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
    }, [
        recentProjects,
        allProjects,
        formatMessage
    ]);
    const onChangeSweetState = (0, $gwFzn.useCallback)((selectedOption)=>{
        if (selectedOption && selectedOption.value !== selectedProject) setSelectedProject(selectedOption.value);
    }, [
        selectedProject,
        setSelectedProject
    ]);
    const debounceTimeoutSweetStateRef = (0, $gwFzn.useRef)(null);
    const onInputChangeSweetState = (0, $gwFzn.useCallback)((query)=>{
        if (debounceTimeoutSweetStateRef.current) clearTimeout(debounceTimeoutSweetStateRef.current);
        debounceTimeoutSweetStateRef.current = setTimeout(()=>{
            setProjectSelectorQuery(query);
        }, 300);
    }, [
        setProjectSelectorQuery
    ]);
    const selectedValueSweetState = selectedProject ? $46689f7fc671df97$var$mapProjectToOption(selectedProject) : null;
    // New decoupled logic (props/local state)
    const { optionsAllProjects: optionsAllProjects = [], optionsRecentProjects: optionsRecentProjects = [], value: controlledValue, onChange: onChange, isLoading: isLoading = false, isDisabled: isDisabled = false, onInputChange: onInputChange, labelProjectSelectorRecentProjects: labelProjectSelectorRecentProjects, labelProjectSelectorProjects: labelProjectSelectorProjects } = props;
    const [localValue, setLocalValue] = (0, $gwFzn.useState)(controlledValue ?? null);
    const selectedValue = localValue ? $46689f7fc671df97$var$mapProjectToOption(localValue) : null;
    const groupedOptions = (0, $gwFzn.useMemo)(()=>{
        if (optionsRecentProjects && optionsRecentProjects.length > 0) return [
            {
                // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
                label: labelProjectSelectorRecentProjects ?? formatMessage((0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjects),
                options: optionsRecentProjects.map($46689f7fc671df97$var$mapProjectToOption)
            },
            {
                // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
                label: labelProjectSelectorProjects ?? formatMessage((0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjects),
                options: optionsAllProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
        return [
            {
                options: optionsAllProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
    }, [
        optionsRecentProjects,
        optionsAllProjects,
        formatMessage,
        labelProjectSelectorRecentProjects,
        labelProjectSelectorProjects
    ]);
    // Keep local state in sync with controlled value
    (0, $gwFzn.useEffect)(()=>{
        if (controlledValue !== undefined) setLocalValue(controlledValue);
    }, [
        controlledValue
    ]);
    const handleChange = (selectedOption)=>{
        if (!selectedOption || !selectedOption.value) return;
        if (selectedOption.value === localValue) return;
        const newValue = selectedOption ? selectedOption.value : null;
        setLocalValue(newValue);
        onChange?.(newValue);
    };
    // Debounce input change and let consumer set the state
    const debounceTimeoutRef = (0, $gwFzn.useRef)(null);
    const handleInputChange = (0, $gwFzn.useCallback)((query)=>{
        if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
        debounceTimeoutRef.current = setTimeout(()=>{
            if (onInputChange) onInputChange(query);
        }, 300);
    }, [
        onInputChange
    ]);
    if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) // Old Sweet State logic
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: "projects",
        // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
        label: props.label ?? formatMessage((0, $3E5yu.messages).bulkConfigureFormProject),
        testId: "work-create-project-field"
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            isDisabled: isConfigureLoading || !selectedValueSweetState,
            isLoading: isConfigureLoading,
            onInputChange: onInputChangeSweetState,
            value: selectedValueSweetState,
            options: optionsSweetState,
            onChange: onChangeSweetState,
            components: {
                Option: $46689f7fc671df97$var$ProjectTypeOption,
                SingleValue: $46689f7fc671df97$var$ProjectTypeSingleValue
            }
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: "projects",
        label: formatMessage((0, $3E5yu.messages).bulkConfigureFormProject),
        testId: "work-create-project-field",
        isRequired: props.isRequired ?? false
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            value: selectedValue,
            options: groupedOptions,
            onInputChange: handleInputChange,
            onChange: handleChange,
            isLoading: isLoading,
            isDisabled: isDisabled || isLoading || !selectedValue,
            components: {
                Option: $46689f7fc671df97$var$ProjectTypeOption,
                SingleValue: $46689f7fc671df97$var$ProjectTypeSingleValue
            }
        })));
};

});

parcelRegister("a2rs0", function(module, exports) {

$parcel$export(module.exports, "SingleWorkCreateFormFooter", () => $bdeb74854f9d18b3$export$fd3026cc2ddcf97);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $3E5yu = parcelRequire("3E5yu");

var $hq2Sz = parcelRequire("hq2Sz");
const $bdeb74854f9d18b3$var$footerBaseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    position: 'relative',
    flexShrink: 0,
    bottom: 'space.0',
    width: '100%',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.150',
        right: 'space.150',
        height: '1px',
        backgroundColor: 'elevation.surface',
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width'
    }
});
const $bdeb74854f9d18b3$export$fd3026cc2ddcf97 = ({ onClose: onClose, closePanel: closePanel, isSaveDisabled: isSaveDisabled, onSubmit: onSubmit })=>{
    const isMissingColumnMappingError = (0, $hq2Sz.useGetIsMissingColumnMappingError)();
    // We are directly navigating the user to the configure page if there are no issues to mapped.
    // Since the configure page doesn't have a way to close the side panel, we are changing the cancel button to allow the user to close the side panel in case they don't want to proceed.
    const onCancel = isMissingColumnMappingError ? closePanel : onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.200",
        paddingInline: "space.300",
        xcss: $bdeb74854f9d18b3$var$footerBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        testId: "single-work-create-form-cancel-button",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).singleCreateIssueFormFooterCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        type: "submit",
        form: "single-work-create-form",
        appearance: "primary",
        testId: "single-work-create-form-save-button",
        isDisabled: isSaveDisabled,
        onClick: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).singleCreateIssueFormFooterSave))));
};

});

parcelRegister("4yWiB", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $e5fb27fcd107a8cb$export$2c73285ae9390cec);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4noo5 = parcelRequire("4noo5");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $3E5yu = parcelRequire("3E5yu");
const $e5fb27fcd107a8cb$export$d0eaed274bd109d4 = '';
const $e5fb27fcd107a8cb$export$2c73285ae9390cec = ({ value: value, label: label, name: name = 'summary', onChange: onChange, placeholder: placeholder = $e5fb27fcd107a8cb$export$d0eaed274bd109d4, testId: testId = 'work-create-form-text-field', isRequired: isRequired = true, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const defaultLabel = formatMessage((0, $3E5yu.messages).workCreateCommonSummaryLabel);
    const errorMessage = formatMessage((0, $3E5yu.messages).workCreateCommonSummaryError);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        "aria-required": isRequired,
        name: name,
        isRequired: isRequired,
        defaultValue: value,
        label: label || defaultLabel,
        testId: testId
    }, ({ fieldProps: { id: id, onChange: formOnChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
            key: id,
            ...rest,
            placeholder: placeholder,
            onChange: (event)=>{
                formOnChange(event);
                onChange?.(event.currentTarget.value);
            },
            isCompact: true,
            isDisabled: isDisabled
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.ErrorMessage), null, errorMessage)));
};

});

parcelRegister("3Sz0l", function(module, exports) {

$parcel$export(module.exports, "RichTextField", () => $7d198726b3682f03$export$b3ef8585d8cbf390);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $kpYGL = parcelRequire("kpYGL");

var $jmjWc = parcelRequire("jmjWc");

var $3E5yu = parcelRequire("3E5yu");
const $7d198726b3682f03$var$LoadingSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
        width: "200px",
        height: "16px",
        testId: "skeleton"
    });

const $7d198726b3682f03$var$LazyEditorComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NQNn3",
    name: "LazyEditorComponent",
    loader: async ()=>(await (parcelRequire("7ElNC"))).EditorComponent,
    loading: $7d198726b3682f03$var$LoadingSkeleton
});
const $7d198726b3682f03$export$b3ef8585d8cbf390 = ({ value: value, label: label, name: name = 'description', testId: testId = 'work-create-form-description-field', onChange: onChange, isDisabled: isDisabled = false, isRequired: isRequired = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const defaultLabel = formatMessage((0, $3E5yu.messages).workCreateCommonDescriptionLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: name,
        label: label || defaultLabel,
        testId: testId,
        isRequired: isRequired
    }, ({ fieldProps: { id: id }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7d198726b3682f03$var$LazyEditorComponent, {
            id: id,
            initialValue: value,
            onChange: onChange,
            isDisabled: isDisabled
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.ErrorMessage), null, error)));
};

});
parcelRegister("7ElNC", function(module, exports) {

let $591d2db714f6db44$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $591d2db714f6db44$var$load("7vwsA"),
    $591d2db714f6db44$var$load("a9PRK"),
    $591d2db714f6db44$var$load("i73Fi"),
    $591d2db714f6db44$var$load("4Bp5z"),
    $591d2db714f6db44$var$load("eyMrr"),
    $591d2db714f6db44$var$load("g9CVe"),
    $591d2db714f6db44$var$load("c6MKV"),
    $591d2db714f6db44$var$load("ZJtkJ"),
    $591d2db714f6db44$var$load("aZinD"),
    $591d2db714f6db44$var$load("6qah4"),
    $591d2db714f6db44$var$load("ffEVr"),
    $591d2db714f6db44$var$load("iPz8n"),
    $591d2db714f6db44$var$load("joJy8"),
    $591d2db714f6db44$var$load("aHE9G"),
    $591d2db714f6db44$var$load("ic38u")
]).then(()=>parcelRequire('f0Lte'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});






parcelRegister("dAg4H", function(module, exports) {

$parcel$export(module.exports, "useIsAIIssueCreationAllowed", () => $3bc657bf57b962b7$export$8e6d40ccfb969320);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $lzcvT = parcelRequire("lzcvT");

var $9wGTI = parcelRequire("9wGTI");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $7mpOv = parcelRequire("7mpOv");

var $1mDVg = parcelRequire("1mDVg");

var $2R8mu = parcelRequire("2R8mu");

var $k9cgj = parcelRequire("k9cgj");
const $3bc657bf57b962b7$export$8e6d40ccfb969320 = ({ contentId: contentId })=>{
    const [{ currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isCreateManuallyPressed: isCreateManuallyPressed, pageMode: pageMode, hasEditPermission: hasEditPermission }, { setAiIssueCreationEnablement: setAiIssueCreationEnablement }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { edition: edition, accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const hasLicensedConfluenceAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isConfluenceAiEnabled = edition === (0, $d9tcB.ConfluenceEdition).PREMIUM && hasLicensedConfluenceAccess && isAIEnabledForContent && !(0, $lzcvT.isFedRamp)();
    (0, $gwFzn.useEffect)(()=>{
        // isCreateManuallyPressed - When there is AI error "Create Manually" button can be pressed by user.
        // We should honour this and create manually.  This will be overriden on refresh.
        if (isCreateManuallyPressed) {
            setAiIssueCreationEnablement({
                isEnabled: false
            });
            return;
        }
        // Short-circuit if Confluence Ai is enabled
        if (isConfluenceAiEnabled) {
            setAiIssueCreationEnablement({
                isEnabled: true,
                enablement: 'confluence'
            });
            return;
        }
        // Only update isEnabled AI state if not already set to false to avoid unnecessary state updates
        if (aiIssueCreationEnablement?.isEnabled && (0, $9wGTI.fg)('confluence_ai_access_policy')) setAiIssueCreationEnablement({
            isEnabled: false,
            enablement: 'confluence'
        });
        if (!(0, $9wGTI.fg)('jira_side_panel_aiwc_jira_ai_enablement')) return;
        const isJiraAiEnabled = async ()=>{
            /**
			 * 1. Cannot call Jira enablement API if site & project are not selected
			 * 2. Remove (cloudId !== currentSiteSelection) after Jira AI API supports
			 * 	  cross-site scenarios - https://hello.jira.atlassian.cloud/browse/CBT-4995
			 */ if (!currentSiteSelection || !currentProjectSelection?.selectedProjectType || cloudId !== currentSiteSelection) {
                setAiIssueCreationEnablement({
                    isEnabled: false
                });
                return;
            }
            try {
                const projectType = currentProjectSelection.selectedProjectType;
                const jiraEnablement = await (0, $k9cgj.getJiraAiEnablement)(currentSiteSelection, (0, $2R8mu.MESSAGE_PROJECT_TYPE_TO_API_PROJECT_TYPE)[projectType]);
                // 	User switches from a Jira AI enabled site to a no AI enabled site
                if (aiIssueCreationEnablement?.enablement == 'jira' && !jiraEnablement?.isEnabled) createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'disabled',
                        actionSubject: 'issueCreationAi',
                        attributes: {
                            pageMode: pageMode,
                            hasEditPermission: hasEditPermission
                        }
                    }
                }).fire();
                setAiIssueCreationEnablement({
                    isEnabled: jiraEnablement?.isEnabled ?? false,
                    enablement: jiraEnablement?.isEnabled ? 'jira' : undefined
                });
            } catch (_error) {
                setAiIssueCreationEnablement({
                    isEnabled: false
                });
            }
        };
        isJiraAiEnabled();
    }, [
        currentSiteSelection,
        currentProjectSelection?.selectedProjectType,
        setAiIssueCreationEnablement,
        aiIssueCreationEnablement,
        isConfluenceAiEnabled,
        createAnalyticsEvent,
        isCreateManuallyPressed,
        cloudId,
        pageMode,
        hasEditPermission
    ]);
};

});
parcelRegister("2R8mu", function(module, exports) {

$parcel$export(module.exports, "MESSAGE_PROJECT_TYPE_TO_API_PROJECT_TYPE", () => $71c94b57ccceac13$export$f7e2564263dc8770);
$parcel$export(module.exports, "FieldMetadataSchemaType", () => $71c94b57ccceac13$export$e70f0c6fcc814588);
$parcel$export(module.exports, "FieldMetadataSchemaCustom", () => $71c94b57ccceac13$export$a9a7f0c9ccbb6fb6);
$parcel$export(module.exports, "FieldMetadataSchemaSystem", () => $71c94b57ccceac13$export$2896cf63ba927114);
var $71c94b57ccceac13$export$af05362339233870 = /*#__PURE__*/ function(JiraProjectType) {
    JiraProjectType["JiraCore"] = "jira-core";
    JiraProjectType["JiraServiceDesk"] = "jira-servicedesk";
    JiraProjectType["JiraCustomerService"] = "jira-customer-service";
    JiraProjectType["JiraSoftware"] = "jira-software";
    JiraProjectType["JiraProductDiscovery"] = "jira-product-discovery";
    return JiraProjectType;
}({});
const $71c94b57ccceac13$export$f7e2564263dc8770 = {
    service_desk: "jira-servicedesk",
    software: "jira-software",
    customer_service: "jira-customer-service",
    business: "jira-core",
    product_discovery: "jira-product-discovery"
};
var $71c94b57ccceac13$export$e70f0c6fcc814588 = /*#__PURE__*/ function(FieldMetadataSchemaType) {
    FieldMetadataSchemaType["ANY"] = "any";
    FieldMetadataSchemaType["STRING"] = "string";
    FieldMetadataSchemaType["NUMBER"] = "number";
    FieldMetadataSchemaType["DATE"] = "date";
    FieldMetadataSchemaType["DATETIME"] = "datetime";
    FieldMetadataSchemaType["ISSUELINK"] = "issuelink";
    FieldMetadataSchemaType["ISSUETYPE"] = "issuetype";
    FieldMetadataSchemaType["USER"] = "user";
    FieldMetadataSchemaType["TEAM"] = "team";
    FieldMetadataSchemaType["PRIORITY"] = "priority";
    FieldMetadataSchemaType["ARRAY"] = "array";
    return FieldMetadataSchemaType;
}({});
var $71c94b57ccceac13$export$a9a7f0c9ccbb6fb6 = /*#__PURE__*/ function(FieldMetadataSchemaCustom) {
    FieldMetadataSchemaCustom["TEXT_AREA"] = "com.atlassian.jira.plugin.system.customfieldtypes:textarea";
    FieldMetadataSchemaCustom["TEXT_FIELD"] = "com.atlassian.jira.plugin.system.customfieldtypes:textfield";
    FieldMetadataSchemaCustom["PEOPLE"] = "com.atlassian.jira.plugin.system.customfieldtypes:people";
    return FieldMetadataSchemaCustom;
}({});
var $71c94b57ccceac13$export$2896cf63ba927114 = /*#__PURE__*/ function(FieldMetadataSchemaSystem) {
    FieldMetadataSchemaSystem["LABELS"] = "labels";
    return FieldMetadataSchemaSystem;
}({});

});


parcelRegister("bZC8A", function(module, exports) {

$parcel$export(module.exports, "handleAiIssueCreateError", () => $d2ef8f1ef1cac15d$export$844cd257c85281a);

var $gwFzn = parcelRequire("gwFzn");

var $2Nwuj = parcelRequire("2Nwuj");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");
const $d2ef8f1ef1cac15d$export$844cd257c85281a = (error)=>{
    let errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).singleCreateAiErrorDescription;
    let errorMessageValues;
    let hideTryAgain = false;
    if (error.message_template !== undefined && [
        'ACCEPTABLE_USE_VIOLATIONS',
        'ACCEPTABLE_USE_EVALUATION_EXCEPTION'
    ].includes(error.message_template)) {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).ethicalViolationErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).ethicalViolationErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    href: "https://www.atlassian.com/legal/acceptable-use-policy",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'RATE_LIMIT') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).rateLimitErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).rateLimitErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'FE_REQUEST_EXCEEDING_TOKEN_LENGTH') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).exceedingTokenLimitDescriptionIssueTermRefresh : (0, $3E5yu.messages).exceedingTokenLimitDescription;
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'NO_ANSWER_SUGGESTED_ISSUES') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).noAnswerSuggestedIssuesIssueTermRefresh : (0, $3E5yu.messages).noAnswerSuggestedIssues;
        hideTryAgain = true;
    }
    return {
        errorMessage: errorMessage,
        errorMessageValues: errorMessageValues,
        hideTryAgain: hideTryAgain
    };
};

});

parcelRegister("jE0Gg", function(module, exports) {

$parcel$export(module.exports, "useMessageListener", () => $3fdc1d9372d96a0e$export$2ac688f17b22f89f);

var $gwFzn = parcelRequire("gwFzn");

var $3E5yu = parcelRequire("3E5yu");

var $1mDVg = parcelRequire("1mDVg");
const $3fdc1d9372d96a0e$export$2ac688f17b22f89f = ()=>{
    const [{ currentSiteSelection: currentSiteSelection }, { setCurrentSiteSelection: setCurrentSiteSelection, setCurrentProjectSelection: setCurrentProjectSelection, setAiIssueCreationEnablement: setAiIssueCreationEnablement, setIsGicIframeReady: setIsGicIframeReady }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $gwFzn.useEffect)(()=>{
        const messageHandler = (message)=>{
            const eventName = message?.data?.event;
            const payload = message.data?.payload;
            switch(eventName){
                // Recieve message from GIC anywhere component for current site selection since it is in an inner iframe.
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED:
                    if (payload?.selectedCloudId && payload?.selectedCloudId !== '') {
                        // reset currentProjectSelection on site change since projects are tied per site
                        if (currentSiteSelection && payload?.selectedCloudId !== currentSiteSelection) setCurrentProjectSelection(undefined);
                        setCurrentSiteSelection(payload.selectedCloudId);
                    }
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED:
                    const project = {
                        selectedProjectType: payload?.selectedProjectType,
                        selectedProjectId: payload?.selectedProjectId,
                        selectedProjectKey: payload?.selectedProjectKey
                    };
                    setCurrentProjectSelection(project);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_READY:
                    setIsGicIframeReady(true);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    setIsGicIframeReady(false);
                    break;
                default:
            }
        };
        window.addEventListener('message', messageHandler);
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, [
        setCurrentSiteSelection,
        setCurrentProjectSelection,
        currentSiteSelection,
        setAiIssueCreationEnablement,
        setIsGicIframeReady
    ]);
};

});

parcelRegister("aXkRG", function(module, exports) {

$parcel$export(module.exports, "WorkItemCreationError", () => $b2fad5e9397af553$export$4ab514c5c6944b54);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $3E5yu = parcelRequire("3E5yu");

var $eqyNK = parcelRequire("eqyNK");

var $1mDVg = parcelRequire("1mDVg");
const $b2fad5e9397af553$var$errorTryAgainTestId = 'error-try-again-button';
const $b2fad5e9397af553$var$errorCreateManuallyTestId = 'error-create-manually-button';
const $b2fad5e9397af553$var$errorContainerStyle = (0, $ecnYn.xcss)({
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingInline: 'space.800'
});
const $b2fad5e9397af553$var$errorDescriptionStyle = (0, $ecnYn.xcss)({
    paddingBlock: 'space.300',
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)",
    color: 'color.text.subtle'
});
const $b2fad5e9397af553$var$buttonLayoutStyle = (0, $ecnYn.xcss)({
    width: '100%',
    paddingBlock: 'space.050'
});
const $b2fad5e9397af553$export$4ab514c5c6944b54 = ({ creationSource: creationSource, errorMessage: errorMessage, errorMessageValues: errorMessageValues, isCreatedWithAi: isCreatedWithAi, onTryAgain: onTryAgain, onCreateManually: onCreateManually })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: isCreatedWithAi ? 'ai creation error screen' : 'creation error screen',
                source: creationSource,
                attributes: {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        creationSource,
        pageMode,
        isCreatedWithAi,
        hasEditPermission
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b2fad5e9397af553$var$errorContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqyNK.WorkItemCreateErrorImage), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "error-description",
        xcss: $b2fad5e9397af553$var$errorDescriptionStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...errorMessage,
        values: errorMessageValues
    })), onTryAgain && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b2fad5e9397af553$var$buttonLayoutStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        testId: $b2fad5e9397af553$var$errorTryAgainTestId,
        onClick: onTryAgain
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).errorTryAgainButton))), onCreateManually && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b2fad5e9397af553$var$buttonLayoutStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        testId: $b2fad5e9397af553$var$errorCreateManuallyTestId,
        onClick: onCreateManually
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).errorCreateManuallyButton))));
};

});
parcelRegister("eqyNK", function(module, exports) {

$parcel$export(module.exports, "WorkItemCreateErrorImage", () => $ab2811fc194d3498$export$8d2e6241c5d3a027);

var $gwFzn = parcelRequire("gwFzn");
const $ab2811fc194d3498$export$8d2e6241c5d3a027 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "118",
        height: "97",
        viewBox: "0 0 118 97",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("g", {
        clipPath: "url(#clip0_1257_61439)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.33301 28.3123V96.881L25.1914 79.8548H84.7999V28.3123H5.33301Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M40.6277 30.3495C40.6277 25.4304 44.553 21.4886 49.4059 21.4886C54.2587 21.4886 58.184 25.4139 58.184 30.3495C58.184 32.8505 57.5877 33.9933 57.0412 34.722C56.3952 35.5667 55.5837 36.1629 54.1593 37.2064C53.9274 37.3886 53.6624 37.5708 53.3809 37.7695C51.6087 39.0779 49.3562 40.8667 47.6668 43.8314C45.9609 46.8126 45.0168 50.5558 45.0168 55.5079H53.7949C53.7949 51.6655 54.5071 49.5289 55.269 48.2205C56.0309 46.8789 57.0743 45.968 58.598 44.8417C58.7802 44.7092 58.979 44.5601 59.1943 44.4111C60.569 43.4173 62.5234 42.0095 63.9974 40.0717C65.9021 37.5873 66.9621 34.4736 66.9621 30.3495C66.9621 20.6439 59.1777 12.7104 49.4059 12.7104C39.634 12.7104 31.8496 20.6439 31.8496 30.3495V34.7386H40.6277V30.3495Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M49.406 62.1165C46.3751 62.1165 43.9238 64.5677 43.9238 67.5986C43.9238 70.6296 46.3751 73.0808 49.406 73.0808C52.437 73.0808 54.8882 70.6296 54.8882 67.5986C54.8882 64.5677 52.437 62.1165 49.406 62.1165Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.9489 28.3123H40.8596C40.6939 28.9582 40.6111 29.6538 40.6111 30.3494V34.7385H31.833V30.3494C31.833 29.6704 31.8661 28.9913 31.9489 28.3123Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M54.8882 67.5984C54.8882 70.6293 52.4369 73.0972 49.406 73.0972C46.375 73.0972 43.9072 70.6293 43.9072 67.5984C43.9072 64.5675 46.375 62.1162 49.406 62.1162C52.4369 62.1162 54.8882 64.5675 54.8882 67.5984Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M66.9619 30.3494C66.9619 34.4901 65.9019 37.5873 63.9972 40.0716C62.5232 42.0094 60.5688 43.4173 59.1941 44.411C58.9788 44.5766 58.78 44.7091 58.5979 44.8416C57.0741 45.9844 56.0307 46.8954 55.2688 48.2369C54.5069 49.5619 53.7947 51.6985 53.7947 55.5244H45.0166C45.0166 50.5723 45.9441 46.8291 47.65 43.8644C49.356 40.8998 51.6085 39.111 53.3641 37.786C53.6457 37.5873 53.9107 37.4051 54.1425 37.2229C55.5835 36.1629 56.3785 35.5832 57.0244 34.7385C57.5875 33.9932 58.1838 32.8504 58.1838 30.3494C58.1838 29.6538 58.101 28.9582 57.9354 28.3123H66.846C66.9288 28.9913 66.9619 29.6704 66.9619 30.3494Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M80.0122 22.0463C79.6799 22.0789 77.8184 13.4596 78.1559 9.83758C76.9474 9.23678 75.7989 7.52436 75.6751 5.62882C70.5183 2.41068 74.3806 11.5603 75.6468 14.3967C76.2719 12.3407 76.09 17.3947 76.7845 18.0977C76.7063 17.6783 78.3602 26.0497 79.7136 23.5492C79.9391 23.7906 80.3949 21.7647 80.0181 22.0492L80.0122 22.0463Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M97.9714 11.2108C97.4794 9.37567 98.1356 7.71565 99.2924 6.08381C97.9034 -0.291475 93.8658 10.4331 92.9202 13.0451C92.9202 13.0451 91.164 17.598 91.09 17.0666C90.2879 17.4821 86.1799 23.9708 89.259 23.5153C90.0562 22.4885 90.6584 20.094 91.6197 20.0239C93.7172 19.3392 95.6045 13.1619 97.9685 11.2017L97.9714 11.2108Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M114.75 26.5761C115.405 22.4193 108.013 26.2102 105.02 26.6553C105.02 26.6553 101.899 26.945 101.091 27.5785C101.545 27.5379 90.5256 29.2208 96.531 30.806C96.6829 30.737 100.499 30.1605 100.499 30.1605C105.624 30.8975 110.77 28.8288 114.753 26.57L114.75 26.5761Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("clipPath", {
        id: "clip0_1257_61439"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        width: "117",
        height: "97",
        fill: "white",
        transform: "translate(0.5)"
    }))));

});



parcelRegister("hib1D", function(module, exports) {

$parcel$export(module.exports, "IssueCreateSidePanelFooter", () => $c160271417b290c8$export$5e203ab8a2a5043e);

var $gwFzn = parcelRequire("gwFzn");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $74xbC = parcelRequire("74xbC");

var $1mDVg = parcelRequire("1mDVg");

var $hiixe = parcelRequire("hiixe");
const $c160271417b290c8$var$footerContainerStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.sunken'
});
const $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID = '5dd040e8-af22-4ef1-803e-136f659a1092';
const $c160271417b290c8$export$5e203ab8a2a5043e = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $c160271417b290c8$var$footerContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $74xbC.IssueCreateAiFeedback), {
        contentId: contentId,
        entrypointId: $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hiixe.AiSubFooter), null));
};

});
parcelRegister("74xbC", function(module, exports) {

$parcel$export(module.exports, "IssueCreateAiFeedback", () => $c5f4da66a3a122b0$export$abbdbb6d42a658e9);

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $dpPtd = parcelRequire("dpPtd");

var $ly2zj = parcelRequire("ly2zj");

var $1mDVg = parcelRequire("1mDVg");
const $c5f4da66a3a122b0$var$SOURCE = 'confluenceHighlightIssueCreate';
const $c5f4da66a3a122b0$export$abbdbb6d42a658e9 = ({ contentId: contentId, entrypointId: entrypointId })=>{
    const [{ aiState: aiState, aiAnalyticsContext: aiAnalyticsContext }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const shouldShowFeedbackCollector = aiState !== 'loading';
    const additionalAnalyticsContext = {
        additionalAnalyticsAttributes: aiAnalyticsContext
    };
    return shouldShowFeedbackCollector ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: entrypointId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.SmartsFeedbackComponent), {
        analyticsProperties: {
            source: $c5f4da66a3a122b0$var$SOURCE,
            ...additionalAnalyticsContext
        },
        contentId: contentId
    })))) : null;
};

});

parcelRegister("hiixe", function(module, exports) {

$parcel$export(module.exports, "AiSubFooter", () => $3e71e815c0c6ec61$export$85370ea3ee2e18db);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $4vzBZ = parcelRequire("4vzBZ");

var $7p4As = parcelRequire("7p4As");

var $3Mg7y = parcelRequire("3Mg7y");

var $3E5yu = parcelRequire("3E5yu");
const $3e71e815c0c6ec61$var$aiSubFooterWrapperStyle = (0, $ecnYn.xcss)({
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $3e71e815c0c6ec61$var$textColorStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.025',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $3e71e815c0c6ec61$export$85370ea3ee2e18db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3e71e815c0c6ec61$var$aiSubFooterWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
                ...iconProps,
                color: "var(--ds-text-subtlest, #626F86)",
                spacing: "none"
            }),
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "issue-create-side-panel.ai-footer.disclaimer-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3e71e815c0c6ec61$var$textColorStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).sidePanelFooterDisclaimerText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        spacing: "compact",
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), iconProps),
        href: "https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/",
        rel: "noopener",
        target: "_blank",
        testId: "issue-create-side-panel.ai-footer.powered-by-ai-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3e71e815c0c6ec61$var$textColorStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).sidePanelFooterAIText)))));

});


parcelRegister("6pbwW", function(module, exports) {

$parcel$export(module.exports, "IssueCreateSidePanelHeader", () => $47081d53dba235a2$export$7b151ed3fccdded0);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $lnqHu = parcelRequire("lnqHu");

var $1qfLF = parcelRequire("1qfLF");

var $lAFHW = parcelRequire("lAFHW");

var $4WZFP = parcelRequire("4WZFP");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");
const $47081d53dba235a2$var$headerMessageStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $47081d53dba235a2$export$7b151ed3fccdded0 = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lAFHW.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $47081d53dba235a2$var$headerMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelHeaderIssueTermRefresh : (0, $3E5yu.messages).sidePanelHeader)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
                label: "close-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: ()=>onClose(),
        testId: "close-issue-create-panel-button"
    })));
};

});


parcelRegister("3Fkx6", function(module, exports) {

$parcel$export(module.exports, "bulkCreateSidePanelTestId", () => $ef704f702045acf9$export$b3b1d63513bd5722);
$parcel$export(module.exports, "BULK_ISSUE_CREATE_SIDE_PANEL_ID", () => $ef704f702045acf9$export$a6cf0354d3df720c);
$parcel$export(module.exports, "BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH", () => $ef704f702045acf9$export$8f4d251ee889c2c8);
$parcel$export(module.exports, "BulkCreateSidePanelComponent", () => $ef704f702045acf9$export$7da6669cc576b7da);
$parcel$export(module.exports, "BulkCreateSidePanel", () => $ef704f702045acf9$export$b46ccdf5c201a7ce);

var $gwFzn = parcelRequire("gwFzn");

var $2Rith = parcelRequire("2Rith");

var $hq2Sz = parcelRequire("hq2Sz");

var $bIsmc = parcelRequire("bIsmc");

var $5wb21 = parcelRequire("5wb21");

var $gq4uD = parcelRequire("gq4uD");

var $fI2qC = parcelRequire("fI2qC");

var $jwedr = parcelRequire("jwedr");

var $98CLM = parcelRequire("98CLM");

var $26Yin = parcelRequire("26Yin");

var $cP6qJ = parcelRequire("cP6qJ");
const $ef704f702045acf9$export$b3b1d63513bd5722 = 'bulk-issue-create-side-panel';
const $ef704f702045acf9$export$a6cf0354d3df720c = 'bulk-issue-create-side-panel';
const $ef704f702045acf9$export$8f4d251ee889c2c8 = 320;
const $ef704f702045acf9$export$7da6669cc576b7da = ({ onClose: onClose })=>{
    (0, $gq4uD.useGetInitialDataForBulkIssueCreateForm)();
    const [state] = (0, $hq2Sz.useBulkCreateContext)();
    const { isCreatedWithAi: isCreatedWithAi, bulkIssuesList: bulkIssuesList } = state;
    (0, $fI2qC.useHasRequiredFields)();
    const { logSidePanelClosed: logSidePanelClosed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const handleOnClose = (0, $gwFzn.useCallback)(()=>{
        logSidePanelClosed();
        onClose();
    }, [
        logSidePanelClosed,
        onClose
    ]);
    const { isWarningDialogOpen: isWarningDialogOpen, handleConfirm: handleConfirm, handleCancel: handleCancel } = (0, $jwedr.useGetWarningDialogActions)(handleOnClose);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isCreatedWithAi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bIsmc.AiBulkNavigationContainer), {
        onClose: handleOnClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cP6qJ.BulkNavigationContainer), {
        onClose: handleOnClose
    }), isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        issuesCount: bulkIssuesList?.length
    }));
};
const $ef704f702045acf9$export$b46ccdf5c201a7ce = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5wb21.BulkIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: (0, $26Yin.AI_BULK_ISSUE_CREATE_FEATURE_NAME),
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ef704f702045acf9$export$7da6669cc576b7da, {
        onClose: onClose
    })));
};

});
parcelRegister("bIsmc", function(module, exports) {

$parcel$export(module.exports, "AiBulkNavigationContainer", () => $74a1b2d516d51f88$export$7d780be885e5d51a);

var $gwFzn = parcelRequire("gwFzn");

var $jiHhQ = parcelRequire("jiHhQ");

var $kW3me = parcelRequire("kW3me");

var $51DPv = parcelRequire("51DPv");

var $b7nPG = parcelRequire("b7nPG");

var $26Yin = parcelRequire("26Yin");

var $bHOLm = parcelRequire("bHOLm");
const $74a1b2d516d51f88$export$7d780be885e5d51a = ({ onClose: onClose })=>{
    const { logAiInteractionInitiated: logAiInteractionInitiated } = (0, $26Yin.useBulkCreateLoggingEvents)();
    (0, $gwFzn.useEffect)(()=>{
        logAiInteractionInitiated();
    }, [
        logAiInteractionInitiated
    ]);
    (0, $51DPv.useAiBulkFetchIssuesList)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bHOLm.AiBulkDefaultView), {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kW3me.BulkConfigureView), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jiHhQ.BulkEditIssueView), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b7nPG.BulkCreateFlagsContainer), null));
};

});
parcelRegister("jiHhQ", function(module, exports) {

$parcel$export(module.exports, "BulkEditIssueView", () => $e6b2e07d107802c1$export$bfc1d0fcda79c38d);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $9wGTI = parcelRequire("9wGTI");

var $hiixe = parcelRequire("hiixe");

var $aMxFD = parcelRequire("aMxFD");

var $kpUMH = parcelRequire("kpUMH");

var $hq2Sz = parcelRequire("hq2Sz");

var $2ay9q = parcelRequire("2ay9q");

var $jImJ9 = parcelRequire("jImJ9");

var $5Ew1A = parcelRequire("5Ew1A");

var $26Yin = parcelRequire("26Yin");

var $3E5yu = parcelRequire("3E5yu");

var $k9cgj = parcelRequire("k9cgj");

var $5urN6 = parcelRequire("5urN6");
const $e6b2e07d107802c1$var$bulkEditContentWrapper = (0, $ecnYn.xcss)({
    flexGrow: '1'
});
const $e6b2e07d107802c1$export$bfc1d0fcda79c38d = ({ isAiIssue: isAiIssue = false })=>{
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const setSingleIssuesCreated = (0, $hq2Sz.useSetSingleIssuesCreated)();
    const setNextIssueToEdit = (0, $hq2Sz.useSetNextIssueToEdit)();
    const currentPage = (0, $aMxFD.useAiBulkNavigationCurrentPage)();
    const { logSingleIssueCreateSuccess: logSingleIssueCreateSuccess, logSingleIssueCreateFailure: logSingleIssueCreateFailure, logCreateSingleIssueClick: logCreateSingleIssueClick } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const [{ currentIssueId: currentIssueId, currentJiraProject: currentJiraProject, currentJiraSite: currentJiraSite, bulkIssuesList: bulkIssuesList, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const issueType = (0, $hq2Sz.useGetIssueType)();
    const currentIssue = bulkIssuesList.find((issue)=>issue.id === currentIssueId);
    const { triggerSingleIssueCreatedFlag: triggerSingleIssueCreatedFlag } = (0, $jImJ9.useBulkCreateFlags)();
    const onDismiss = (0, $gwFzn.useCallback)(()=>{
        goToPage('default');
    }, [
        goToPage
    ]);
    const onClose = (0, $gwFzn.useCallback)((isCreateSuccess)=>{
        if (!isCreateSuccess) goToPage('default');
    }, [
        goToPage
    ]);
    const isOpen = currentPage === 'edit_issue';
    const onFailure = (0, $gwFzn.useCallback)((error)=>{
        logSingleIssueCreateFailure(error);
    }, [
        logSingleIssueCreateFailure
    ]);
    const onSuccess = (0, $gwFzn.useCallback)((payload)=>{
        logSingleIssueCreateSuccess();
        logCreateSingleIssueClick(payload?.issueId?.toString());
        triggerSingleIssueCreatedFlag(payload);
        // Save the cloud id in localStorage if an issue is created
        (0, $2ay9q.saveCloudIdToLocalStorage)(payload);
        const response = (0, $k9cgj.mapGICPayloadToCreateIssueResponse)(payload);
        const issueCreated = {
            ...response,
            summary: response.summary,
            rowIndex: currentIssue?.rowIndex
        };
        setSingleIssuesCreated(issueCreated);
        setNextIssueToEdit();
    }, [
        triggerSingleIssueCreatedFlag,
        logSingleIssueCreateSuccess,
        setSingleIssuesCreated,
        setNextIssueToEdit,
        logCreateSingleIssueClick,
        currentIssue
    ]);
    if (!currentIssue || !currentJiraProject || !issueType || !currentJiraSite) // TODO return error screen component
    return null;
    const { summary: summary, description: description, id: issueId } = currentIssue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Ew1A.SidePanelWrapper), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        testId: "bulk-edit-content-wrapper",
        xcss: $e6b2e07d107802c1$var$bulkEditContentWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5urN6.BulkCreateNavigationHeader), {
        onClose: onDismiss
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkCreateEditHeaderTextIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkCreateEditHeaderText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpUMH.GicPanelBody), {
        key: `issue-id-${issueId}`,
        cloudId: currentJiraSite.cloudId,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        analyticsSource: (0, $26Yin.getSource)(isCreatedFromTable),
        summary: summary,
        descriptionAdf: description,
        issueTypeId: issueType.id,
        configuration: {
            disableProjectDropdown: true,
            displaySitePicker: false
        },
        projectId: currentJiraProject.id,
        isCreatedWithAi: isCreatedWithAi,
        isCreatedFromTable: isCreatedFromTable
    }), isAiIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hiixe.AiSubFooter), null)));
};

});
parcelRegister("kpUMH", function(module, exports) {

$parcel$export(module.exports, "GicPanelBody", () => $1cfc86eef024eecc$export$3177b460ca1a5743);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $cfwlu = parcelRequire("cfwlu");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $2ay9q = parcelRequire("2ay9q");

var $1mDVg = parcelRequire("1mDVg");

var $7aGmI = parcelRequire("7aGmI");
const $1cfc86eef024eecc$var$noop = ()=>{};
const $1cfc86eef024eecc$export$3177b460ca1a5743 = ({ onClose: onClose, onSuccess: onSuccess, onFailure: onFailure, analyticsSource: analyticsSource, summary: summary, descriptionAdf: descriptionAdf, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, issueTypeId: issueTypeId, projectId: projectId, configuration: configuration, cloudId: cloudId })=>{
    const { cloudId: sessionCloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const overrideCloudIdForSitePicker = persistedOverrideCloudId !== sessionCloudId ? persistedOverrideCloudId : undefined;
    const currentCloudId = overrideCloudIdForSitePicker || cloudId;
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'linkCreateScreen',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    isCreatedFromTable: isCreatedFromTable,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission
                },
                source: analyticsSource
            }
        }).fire();
    }, [
        isCreatedWithAi,
        isCreatedFromTable,
        createAnalyticsEvent,
        analyticsSource,
        pageMode,
        hasEditPermission
    ]);
    if ((0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7aGmI.SingleWorkCreateForm), {
        closePanel: onClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: currentCloudId,
        consumer: "confluence-highlight-issue-create",
        onInit: $1cfc86eef024eecc$var$noop,
        onSuccess: onSuccess,
        onClose: onClose,
        onFailure: onFailure,
        summary: summary,
        descriptionAdf: descriptionAdf,
        overrideCloudId: overrideCloudIdForSitePicker,
        issueTypeId: issueTypeId,
        projectId: projectId,
        isPayloadReady: true,
        configuration: configuration
    });
};

});

parcelRegister("jImJ9", function(module, exports) {

$parcel$export(module.exports, "useBulkCreateFlags", () => $9a1f5308e6e530ee$export$89914132e011d9d2);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $auNCB = parcelRequire("auNCB");

var $kfIha = parcelRequire("kfIha");

var $9wGTI = parcelRequire("9wGTI");

var $aMxFD = parcelRequire("aMxFD");

var $3E5yu = parcelRequire("3E5yu");

var $j3CXY = parcelRequire("j3CXY");
const $9a1f5308e6e530ee$export$aff298770ebd2dda = 'bulk-issue-create--single-issue-created-flag';
const $9a1f5308e6e530ee$export$ba0b5c0cfc28f547 = 'bulk-issue-create--multiple-issues-created-flag';
const $9a1f5308e6e530ee$export$db06b037c240fa26 = 'bulk-issue-create--single-issue-insert-link-failure-flag';
const $9a1f5308e6e530ee$export$a625c427f2ed7356 = 'bulk-issue-create--multiple-issues-insert-link-failure-flag';
const $9a1f5308e6e530ee$export$89914132e011d9d2 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const flags = (0, $aMxFD.useBulkCreateFlagsContainer)();
    const getJiraIssuesLink = (0, $j3CXY.useGetJiraIssuesLink)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const triggerSingleIssueCreatedFlag = (0, $gwFzn.useCallback)((payload)=>{
        const link = getJiraIssuesLink([
            {
                key: payload.issueKey
            }
        ]);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$aff298770ebd2dda,
            type: 'success-circle',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitle, {
                issueKey: payload.issueKey,
                issueSummary: payload.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $auNCB.default), {
                        href: link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink
    ]);
    const triggerMultipleIssuesCreatedFlag = (0, $gwFzn.useCallback)((payload, reloadOnClick, showReloadAction)=>{
        const href = getJiraIssuesLink(payload);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$ba0b5c0cfc28f547,
            type: 'success-circle',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelMultipleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelMultipleIssueCreateSuccessFlagTitle, {
                issueCount: payload.length
            }),
            actions: [
                ...showReloadAction ? [
                    {
                        content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagReloadToSeeLinks),
                        onClick: reloadOnClick
                    }
                ] : [],
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagViewIssue, {
                        issueCount: payload.length
                    }),
                    href: href,
                    target: '_blank'
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink
    ]);
    const triggerSingleIssueInsertLinkFailureFlag = (0, $gwFzn.useCallback)((payload)=>{
        const link = getJiraIssuesLink([
            {
                key: payload.issueKey
            }
        ]);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$db06b037c240fa26,
            type: 'error',
            title: formatMessage((0, $3E5yu.messages).sidePanelSingleIssueInsertLinkFailureFlagTitle, {
                issueKey: payload.issueKey,
                issueSummary: payload.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $auNCB.default), {
                        href: link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink
    ]);
    const triggerMultipleIssuesInsertLinkFailureFlag = (0, $gwFzn.useCallback)((payload)=>{
        const href = getJiraIssuesLink(payload);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$a625c427f2ed7356,
            type: 'error',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelMultipleIssuesInsertLinkFailureFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelMultipleIssuesInsertLinkFailureFlagTitle, {
                issueCount: payload.length
            }),
            close: 'auto',
            actions: [
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagViewIssue, {
                        issueCount: payload.length
                    }),
                    href: href,
                    target: '_blank'
                },
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagCopyLink),
                    onClick: ()=>void copyToClipboard(href)
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink,
        copyToClipboard
    ]);
    return {
        triggerSingleIssueCreatedFlag: triggerSingleIssueCreatedFlag,
        triggerMultipleIssuesCreatedFlag: triggerMultipleIssuesCreatedFlag,
        triggerSingleIssueInsertLinkFailureFlag: triggerSingleIssueInsertLinkFailureFlag,
        triggerMultipleIssuesInsertLinkFailureFlag: triggerMultipleIssuesInsertLinkFailureFlag
    };
};

});
parcelRegister("j3CXY", function(module, exports) {

$parcel$export(module.exports, "useGetJiraIssuesLink", () => $512ab0a436635a50$export$fd734339a42971bc);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $1Q0l6 = parcelRequire("1Q0l6");
const $512ab0a436635a50$export$fd734339a42971bc = ()=>{
    const [{ currentJiraSite: currentJiraSite }] = (0, $hq2Sz.useBulkCreateContext)();
    return (0, $gwFzn.useCallback)((issues)=>{
        const currentSiteUrl = currentJiraSite?.url;
        if (issues.length > 1) {
            const issueKeys = issues.map((issue)=>issue.key).join(',');
            const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
            return `${currentSiteUrl}/issues/?jql=${jqlSearch}`;
        }
        return (0, $1Q0l6.constructJiraIssueUrl)(currentSiteUrl, issues[0].key);
    }, [
        currentJiraSite
    ]);
};

});


parcelRegister("5urN6", function(module, exports) {

$parcel$export(module.exports, "BulkCreateNavigationHeader", () => $ac64a6e53786764f$export$96d57f6ccda50ec9);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $bPdpL = parcelRequire("bPdpL");

var $1qfLF = parcelRequire("1qfLF");

var $hq2Sz = parcelRequire("hq2Sz");
const $ac64a6e53786764f$var$headerMessageStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $ac64a6e53786764f$export$96d57f6ccda50ec9 = ({ children: children, onClose: onClose })=>{
    const isMissingColumnMappingError = (0, $hq2Sz.useGetIsMissingColumnMappingError)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                label: "back-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: onClose,
        isDisabled: isMissingColumnMappingError,
        testId: "close-bulk-issue-create-panel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ac64a6e53786764f$var$headerMessageStyle
    }, children))));
};

});


parcelRegister("kW3me", function(module, exports) {

$parcel$export(module.exports, "BulkConfigureView", () => $d923f05cd22225af$export$ee2807e678386f7a);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $fzqvY = parcelRequire("fzqvY");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $aoVih = parcelRequire("aoVih");

var $9wGTI = parcelRequire("9wGTI");

var $aMxFD = parcelRequire("aMxFD");

var $hq2Sz = parcelRequire("hq2Sz");

var $3E5yu = parcelRequire("3E5yu");

var $5Ew1A = parcelRequire("5Ew1A");

var $CbMiC = parcelRequire("CbMiC");

var $2ay9q = parcelRequire("2ay9q");

var $5urN6 = parcelRequire("5urN6");

var $aCdxq = parcelRequire("aCdxq");
var $lkF83 = parcelRequire("lkF83");
var $4pDFC = parcelRequire("4pDFC");

var $hSYlt = parcelRequire("hSYlt");

var $c9t6B = parcelRequire("c9t6B");
const $d923f05cd22225af$var$bulkConfigureViewStyles = (0, $ecnYn.xcss)({
    flexGrow: 1,
    overflowY: 'auto'
});
const $d923f05cd22225af$export$ee2807e678386f7a = ({ closePanel: closePanel = ()=>{} })=>{
    const [{ isCreatedWithAi: isCreatedWithAi, currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, currentDefaultIssueType: currentDefaultIssueType }, { setCurrentJiraSite: setCurrentJiraSite, setCurrentJiraProject: setCurrentJiraProject, setCurrentDefaultIssueType: setCurrentDefaultIssueType }] = (0, $hq2Sz.useBulkCreateContext)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { optionsAvailableSites: optionsAvailableSites, selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { setSelectedAvailableSite: setSelectedAvailableSite } = (0, $CbMiC.useAvailableSitesActions)();
    const { selectedProject: selectedProject, optionsRecentProjects: optionsRecentProjects, optionsAllProjects: optionsAllProjects } = (0, $CbMiC.useProjectsState)();
    const { setSelectedProject: setSelectedProject, setProjectSelectorQuery: setProjectSelectorQuery } = (0, $CbMiC.useProjectsActions)();
    const { selectedIssueType: selectedIssueType, optionsIssueTypes: optionsIssueTypes } = (0, $CbMiC.useIssueTypesState)();
    const { setSelectedIssueType: setSelectedIssueType } = (0, $CbMiC.useIssueTypesActions)();
    const { isLoading: isLoading, isJiraError: isJiraError } = (0, $CbMiC.useIsConfigureLoading)();
    const resetConfigureState = (0, $CbMiC.useResetConfigureState)();
    const { setIsJiraError: setIsJiraError } = (0, $CbMiC.useProjectsActions)();
    const { setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings, initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings, saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping } = (0, $CbMiC.useMappingsActions)();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const currentPage = (0, $aMxFD.useAiBulkNavigationCurrentPage)();
    const isOpen = currentPage === 'configure';
    const isMissingColumnMappingError = (0, $hq2Sz.useGetIsMissingColumnMappingError)();
    const mappingViewRef = (0, $gwFzn.useRef)(null);
    const onSubmit = (0, $gwFzn.useCallback)(()=>{
        if (!isCreatedWithAi) {
            if (mappingViewRef.current?.validateMappings()) saveUnsavedColumnToFieldMapping();
            else return;
        }
        selectedAvailableSite && setCurrentJiraSite(selectedAvailableSite);
        selectedProject && setCurrentJiraProject(selectedProject);
        selectedIssueType && setCurrentDefaultIssueType(selectedIssueType);
        (0, $2ay9q.saveJiraConfigDetailsToLocalStorage)({
            selectedSite: selectedAvailableSite,
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType
        });
        goToPage('default');
    }, [
        selectedAvailableSite,
        setCurrentJiraSite,
        selectedProject,
        setCurrentJiraProject,
        selectedIssueType,
        setCurrentDefaultIssueType,
        isCreatedWithAi,
        saveUnsavedColumnToFieldMapping,
        goToPage
    ]);
    const onClose = (0, $gwFzn.useCallback)(()=>{
        if (currentJiraSite && currentJiraProject && currentDefaultIssueType) resetConfigureState(currentJiraSite, currentJiraProject, currentDefaultIssueType);
        if (!isCreatedWithAi) {
            setUnsavedColumnToFieldMappings(null);
            initUnsavedColumnToFieldMappings();
        }
        setIsJiraError(false);
        goToPage('default');
    }, [
        currentDefaultIssueType,
        currentJiraProject,
        currentJiraSite,
        goToPage,
        resetConfigureState,
        setIsJiraError,
        isCreatedWithAi,
        setUnsavedColumnToFieldMappings,
        initUnsavedColumnToFieldMappings
    ]);
    const isSaveDisabled = isLoading || !selectedAvailableSite || !selectedProject || !selectedIssueType;
    const bulkCreateConfigureBodyText = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkCreateConfigureBodyTextIssueTermRefresh : (0, $3E5yu.messages).bulkCreateConfigureBodyText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Ew1A.SidePanelWrapper), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        xcss: $d923f05cd22225af$var$bulkConfigureViewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5urN6.BulkCreateNavigationHeader), {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureHeaderText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), bulkCreateConfigureBodyText)), isJiraError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "bulkCreateErrorSectionMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureJiraErrorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fzqvY.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("form", {
            id: "configureForm",
            ...formProps
        }, (0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4pDFC.SiteSelector), {
            options: optionsAvailableSites ?? [],
            value: selectedAvailableSite,
            onChange: (site)=>site && setSelectedAvailableSite(site),
            isLoading: isLoading,
            isDisabled: isLoading,
            label: formatMessage((0, $3E5yu.messages).bulkConfigureFormSite)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lkF83.ProjectSelector), {
            optionsAllProjects: optionsAllProjects ?? [],
            optionsRecentProjects: optionsRecentProjects ?? [],
            value: selectedProject,
            onChange: (project)=>project && setSelectedProject(project),
            isLoading: isLoading,
            isDisabled: isLoading,
            onInputChange: (query)=>setProjectSelectorQuery(query),
            label: formatMessage((0, $3E5yu.messages).bulkConfigureFormProject),
            labelProjectSelectorRecentProjects: formatMessage((0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjects),
            labelProjectSelectorProjects: formatMessage((0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjects)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aCdxq.IssueTypeSelector), {
            optionsIssueTypes: optionsIssueTypes ?? [],
            value: selectedIssueType,
            onChange: (issueType)=>issueType && setSelectedIssueType(issueType),
            isLoading: isLoading,
            isDisabled: isLoading,
            label: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkConfigureFormDefaultIssueTypeIssueTermRefresh : (0, $3E5yu.messages).bulkConfigureFormDefaultIssueType)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4pDFC.SiteSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lkF83.ProjectSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aCdxq.IssueTypeSelector), null)))), isMissingColumnMappingError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "information",
        title: (0, $3E5yu.messages).bulkConfigureMissingTableCoulumnMappingErrorHeaderText.defaultMessage,
        testId: "bulkCreateWarningSectionMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMissingTableCoulumnMappingErrorText)), !isCreatedWithAi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hSYlt.ColumnToIssueFieldMappingView), {
        ref: mappingViewRef
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c9t6B.BulkConfigureFooter), {
        onClose: onClose,
        closePanel: closePanel,
        isSaveDisabled: isSaveDisabled
    }));
};

});
parcelRegister("hSYlt", function(module, exports) {

$parcel$export(module.exports, "ColumnToIssueFieldMappingView", () => $18b3c33293d9759e$export$aab6883e3d0e5f63);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $g5gZt = parcelRequire("g5gZt");

var $ccHMk = parcelRequire("ccHMk");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $7hXDW = parcelRequire("7hXDW");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $CbMiC = parcelRequire("CbMiC");

var $1mDVg = parcelRequire("1mDVg");

var $8F0Rx = parcelRequire("8F0Rx");
const $18b3c33293d9759e$var$mapFieldsToOptions = (fields)=>{
    return fields.map((field)=>({
            label: field.name,
            value: field
        }));
};
const $18b3c33293d9759e$var$createIssueFieldMappingKey = (mapping, index)=>{
    return `${index}-${mapping.column?.index ?? 'null'}-${mapping.field?.fieldId ?? 'null'}`;
};
const $18b3c33293d9759e$export$aab6883e3d0e5f63 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((_, ref)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [{ pageMode: pageMode }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    const { optionsColumns: optionsColumns, optionsIssueTypeFields: optionsIssueTypeFields, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, loadingIssueTypeFields: loadingIssueTypeFields } = (0, $CbMiC.useMappingsState)();
    const { setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings, addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping } = (0, $CbMiC.useMappingsActions)();
    const tableColumnOptions = optionsColumns ? optionsColumns.map((column)=>({
            label: column.header,
            value: column
        })) : [];
    const issueFieldOptions = optionsIssueTypeFields ? $18b3c33293d9759e$var$mapFieldsToOptions(optionsIssueTypeFields) : [];
    const isLoading = isConfigureLoading || loadingIssueTypeFields;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleMappingChange = (0, $gwFzn.useCallback)((index, newMapping)=>{
        if (unsavedColumnToFieldMappings) {
            const updatedMappings = unsavedColumnToFieldMappings.map((mapping, idx)=>idx === index ? newMapping : mapping);
            setUnsavedColumnToFieldMappings(updatedMappings);
        }
    }, [
        unsavedColumnToFieldMappings,
        setUnsavedColumnToFieldMappings
    ]);
    // Create a Set of mapped column indices for quick lookup
    const mappedColumnIndices = (0, $gwFzn.useMemo)(()=>{
        if (!unsavedColumnToFieldMappings) return new Set();
        return new Set(unsavedColumnToFieldMappings.map((mapping)=>mapping.column?.index).filter((index)=>index !== undefined));
    }, [
        unsavedColumnToFieldMappings
    ]);
    // Find the next available column that is not already mapped (or undefined if none exists)
    const nextAvailableColumn = (0, $gwFzn.useMemo)(()=>{
        if (!optionsColumns) return undefined;
        // Find the first unmapped column starting from index 0
        for (const column of optionsColumns){
            if (!mappedColumnIndices.has(column.index)) return column;
        }
        return undefined; // No available column found
    }, [
        optionsColumns,
        mappedColumnIndices
    ]);
    const addMapping = (0, $gwFzn.useCallback)(()=>{
        if (isLoading) return;
        const newMapping = {
            column: nextAvailableColumn,
            field: undefined,
            errors: {},
            isDefaultMapping: false
        };
        addUnsavedColumnToFieldMapping(newMapping);
    }, [
        isLoading,
        addUnsavedColumnToFieldMapping,
        nextAvailableColumn
    ]);
    const fireAddMappingAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'addMapping',
                type: 'ui',
                attributes: {
                    pageMode: pageMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageMode
    ]);
    const handleAddMappingClick = (0, $gwFzn.useCallback)(()=>{
        fireAddMappingAnalytics();
        addMapping();
    }, [
        fireAddMappingAnalytics,
        addMapping
    ]);
    // TODO: Please update the messages and ensure they are internationalized once the content design has been finalized.
    const validateMappings = ()=>{
        if (!unsavedColumnToFieldMappings) return false;
        let isValid = true;
        const mappedField = new Set();
        const updatedMappings = unsavedColumnToFieldMappings.map((mapping)=>{
            const { column: column, field: field } = mapping;
            const errors = {};
            if (!column) {
                errors.column = {
                    message: formatMessage((0, $3E5yu.messages).bulkConfigureMapTableToIssueErrorColumnNotSelected)
                };
                isValid = false;
            }
            if (!field) {
                errors.field = {
                    message: formatMessage((0, $3E5yu.messages).bulkConfigureMapTableToIssueErrorFieldNotSelected)
                };
                isValid = false;
            } else {
                const fieldId = field.fieldId;
                if (mappedField.has(fieldId)) {
                    errors.field = {
                        message: formatMessage((0, $3E5yu.messages).bulkConfigureMapTableToIssueErrorFieldAlreadyMapped)
                    };
                    isValid = false;
                } else mappedField.add(fieldId);
            }
            return {
                ...mapping,
                errors: errors
            };
        });
        setUnsavedColumnToFieldMappings(updatedMappings);
        return isValid;
    };
    (0, $gwFzn.useImperativeHandle)(ref, ()=>({
            validateMappings: validateMappings
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "small"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueTitleIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueDescriptionIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.300"
    }, unsavedColumnToFieldMappings?.map((mapping, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8F0Rx.ColumnToIssueFieldMapping), {
            key: $18b3c33293d9759e$var$createIssueFieldMappingKey(mapping, index),
            index: index,
            mapping: mapping,
            tableColumnOptions: tableColumnOptions,
            issueFieldOptions: issueFieldOptions,
            onMappingChange: handleMappingChange,
            isLoading: loadingIssueTypeFields || isLoading,
            isDisabled: loadingIssueTypeFields || isLoading,
            pageMode: pageMode
        }))))), (0, $9wGTI.fg)('confluence_bulk_issue_create_additional_mappings') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        padding: "space.0",
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), iconProps),
        onClick: handleAddMappingClick,
        isDisabled: loadingIssueTypeFields || isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueAddMapping)))));
});

});
parcelRegister("8F0Rx", function(module, exports) {

$parcel$export(module.exports, "ColumnToIssueFieldMapping", () => $e629f20933f2b7aa$export$1cb34fe05cdad9ea);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $eyWa4 = parcelRequire("eyWa4");

var $2gD2K = parcelRequire("2gD2K");

var $gQhRa = parcelRequire("gQhRa");
var $bfgIy = parcelRequire("bfgIy");

var $1qfLF = parcelRequire("1qfLF");

var $gKvd9 = parcelRequire("gKvd9");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $CbMiC = parcelRequire("CbMiC");
const $e629f20933f2b7aa$export$e4d267d65a03b8ba = 'table-column-select';
const $e629f20933f2b7aa$export$8083937ff4fc332a = 'issue-field-select';
const $e629f20933f2b7aa$export$1cb34fe05cdad9ea = ({ index: index, mapping: mapping, tableColumnOptions: tableColumnOptions, issueFieldOptions: issueFieldOptions, onMappingChange: onMappingChange, isLoading: isLoading, isDisabled: isDisabled, pageMode: pageMode })=>{
    const { deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping } = (0, $CbMiC.useMappingsActions)();
    const handleSelectChange = (0, $gwFzn.useCallback)((idx, key, newValue)=>{
        if (newValue) onMappingChange(idx, {
            ...mapping,
            [key]: newValue.value
        });
    }, [
        mapping,
        onMappingChange
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const deleteMapping = (0, $gwFzn.useCallback)((idx)=>{
        if (isLoading) return;
        deleteUnsavedColumnToFieldMapping(idx);
    }, [
        isLoading,
        deleteUnsavedColumnToFieldMapping
    ]);
    const fireDeleteMappingAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'deleteMapping',
                type: 'ui',
                attributes: {
                    pageMode: pageMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageMode
    ]);
    const handleDeleteMappingClick = (0, $gwFzn.useCallback)((idx)=>{
        fireDeleteMappingAnalytics();
        deleteMapping(idx);
    }, [
        fireDeleteMappingAnalytics,
        deleteMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bfgIy.Label), {
        htmlFor: "table-column-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueTableColumn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
        inputId: $e629f20933f2b7aa$export$e4d267d65a03b8ba,
        classNamePrefix: $e629f20933f2b7aa$export$e4d267d65a03b8ba,
        appearance: "default",
        options: tableColumnOptions,
        defaultValue: tableColumnOptions.find((option)=>option.value === mapping.column),
        onChange: (newValue)=>handleSelectChange(index, 'column', newValue),
        isLoading: isLoading,
        isDisabled: isDisabled
    }), mapping.errors.column && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.ErrorMessage), null, " ", mapping.errors.column.message, " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bfgIy.Label), {
        htmlFor: "issue-field-select"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueIssueFieldIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureMapTableToIssueIssueField)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
        inputId: $e629f20933f2b7aa$export$8083937ff4fc332a,
        classNamePrefix: $e629f20933f2b7aa$export$8083937ff4fc332a,
        appearance: "default",
        options: issueFieldOptions,
        defaultValue: issueFieldOptions.find((option)=>option.value === mapping.field),
        onChange: (newValue)=>handleSelectChange(index, 'field', newValue),
        isLoading: isLoading,
        isDisabled: isDisabled || mapping.isDefaultMapping
    }), mapping.errors.field && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.ErrorMessage), null, " ", mapping.errors.field.message, " ")), !mapping.isDefaultMapping && (0, $9wGTI.fg)('confluence_bulk_issue_create_additional_mappings') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        onClick: ()=>handleDeleteMappingClick(index),
        isDisabled: isDisabled,
        label: "",
        testId: "delete-additional-mapping"
    })));
};

});


parcelRegister("c9t6B", function(module, exports) {

$parcel$export(module.exports, "BulkConfigureFooter", () => $37a527a75d28e217$export$a11e7c1ace4beba4);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $3E5yu = parcelRequire("3E5yu");

var $hq2Sz = parcelRequire("hq2Sz");
const $37a527a75d28e217$var$footerBaseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    position: 'relative',
    flexShrink: 0,
    bottom: 'space.0',
    width: '100%',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.150',
        right: 'space.150',
        height: '1px',
        backgroundColor: 'elevation.surface',
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width'
    }
});
const $37a527a75d28e217$export$a11e7c1ace4beba4 = ({ onClose: onClose, closePanel: closePanel, isSaveDisabled: isSaveDisabled })=>{
    const isMissingColumnMappingError = (0, $hq2Sz.useGetIsMissingColumnMappingError)();
    // We are directly navigating the user to the configure page if there are no issues to mapped.
    // Since the configure page doesn't have a way to close the side panel, we are changing the cancel button to allow the user to close the side panel in case they don't want to proceed.
    const onCancel = isMissingColumnMappingError ? closePanel : onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.200",
        paddingInline: "space.300",
        xcss: $37a527a75d28e217$var$footerBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        testId: "configure-cancel-button",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureFooterCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        type: "submit",
        form: "configureForm",
        appearance: "primary",
        testId: "configure-save-button",
        isDisabled: isSaveDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkConfigureFooterSave))));
};

});


parcelRegister("51DPv", function(module, exports) {

$parcel$export(module.exports, "useAiBulkFetchIssuesList", () => $442da57a5d0af441$export$aeed5882f513d26a);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $CbMiC = parcelRequire("CbMiC");

var $dhtl2 = parcelRequire("dhtl2");
const $442da57a5d0af441$export$aeed5882f513d26a = ()=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, { setAiState: setAiState }] = (0, $hq2Sz.useBulkCreateContext)();
    const { currentAiState: currentAiState } = (0, $dhtl2.useAIAgentStreamingData)();
    const { isLoading: isLoading } = (0, $CbMiC.useIsConfigureLoading)();
    (0, $gwFzn.useEffect)(()=>{
        if (currentAiState === (0, $hq2Sz.AiStates).IDLE && isLoading) return;
        setAiState(currentAiState);
    }, [
        currentAiState,
        setAiState,
        isLoading
    ]);
};

});
parcelRegister("dhtl2", function(module, exports) {

$parcel$export(module.exports, "useAIAgentStreamingData", () => $92dbb54084f9d413$export$97b2d370f34c4fd9);

var $9wGTI = parcelRequire("9wGTI");

var $jnqIp = parcelRequire("jnqIp");

var $4cFF0 = parcelRequire("4cFF0");
const $92dbb54084f9d413$export$97b2d370f34c4fd9 = ()=>{
    const { aiAgentContent: aiAgentContent, aiAgentCurrentAiState: aiAgentCurrentAiState, aiAgentResponseState: aiAgentResponseState } = (0, $jnqIp.useAIAgentIssuesStreaming)((0, $9wGTI.fg)('confluence_ai_bulk_issue_convo_ai_migration'));
    const { convoAIContent: convoAIContent, convoAICurrentAiState: convoAICurrentAiState, convoAIResponseState: convoAIResponseState } = (0, $4cFF0.useConvoAIIssuesStreaming)((0, $9wGTI.fg)('confluence_ai_bulk_issue_convo_ai_migration'));
    if ((0, $9wGTI.fg)('confluence_ai_bulk_issue_convo_ai_migration')) return {
        content: convoAIContent,
        currentAiState: convoAICurrentAiState,
        responseState: convoAIResponseState
    };
    return {
        content: aiAgentContent,
        currentAiState: aiAgentCurrentAiState,
        responseState: aiAgentResponseState
    };
};

});
parcelRegister("jnqIp", function(module, exports) {

$parcel$export(module.exports, "useAIAgentIssuesStreaming", () => $47620fd954fbb053$export$cc0e93306dc05b9d);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $ioNzo = parcelRequire("ioNzo");
var $ar5A7 = parcelRequire("ar5A7");

var $7pE6f = parcelRequire("7pE6f");
var $4sbrV = parcelRequire("4sbrV");

var $3j1mV = parcelRequire("3j1mV");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $hq2Sz = parcelRequire("hq2Sz");

var $26Yin = parcelRequire("26Yin");
const $47620fd954fbb053$export$cc0e93306dc05b9d = (isConvoAIMigrationEnabled)=>{
    const [{ bulkIssuesList: bulkIssuesList }, { setBulkIssuesList: setBulkIssuesList }] = (0, $hq2Sz.useBulkCreateContext)();
    const [markdownPlusContent, setMarkdownPlusContent] = (0, $gwFzn.useState)('');
    const [pageIdMap, setPageIdMap] = (0, $gwFzn.useState)(undefined);
    const [currentAiState, setCurrentAiState] = (0, $gwFzn.useState)((0, $hq2Sz.AiStates).LOADING);
    const { logAiStreamingBackendFailed: logAiStreamingBackendFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { logAiNoResultsGenerated: logAiNoResultsGenerated } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const pageId = contentId ?? '';
    const pageType = contentType ?? '';
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, pageId, pageType);
    // Used to keep track of the issues that have been added to the list and give a unique id
    const issueIndex = (0, $gwFzn.useRef)(0);
    // Needed to convert confluence content into MD+ format for the ai request
    (0, $diswb.useQuery)((0, $d2LG0.default)`query useAIAgentIssuesStreamingDataBulkIssueADFQuery($contentId:ID!){singleContent(id:$contentId){id body{atlas_doc_format{value}}}}`, {
        variables: {
            contentId: pageId
        },
        onError: (_adfError)=>{
            setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
        },
        fetchPolicy: 'network-only',
        onCompleted: (adfData)=>{
            const adf = adfData?.singleContent?.body?.atlas_doc_format?.value;
            if (adf) try {
                const parsedAdf = JSON.parse(adf);
                const { markdown: markdownPlus, idMap: idMap } = (0, $7pE6f.adfToMarkdownPlus)(parsedAdf);
                // Handle pages that don't have any content
                if (!markdownPlus) {
                    setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    return;
                }
                setMarkdownPlusContent(markdownPlus);
                setPageIdMap(idMap);
            } catch (err) {
                setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
            }
        },
        skip: currentAiState !== (0, $hq2Sz.AiStates).LOADING || isConvoAIMigrationEnabled
    });
    const request = {
        recipient_agent_named_id: 'ai_issue_create_agent',
        agent_input_context: {
            application: 'Confluence',
            context: {
                confluence_page_markdown_plus: markdownPlusContent,
                highlighted_text: null,
                source_ari: pageAri
            },
            suggested_issues_config: {
                max_issues: 10,
                suggested_issue_field_types: [
                    {
                        issue_type: 'Task',
                        fields: [
                            {
                                field_name: 'Summary',
                                field_type: 'Short-Text'
                            },
                            {
                                field_name: 'Description',
                                field_type: 'Paragraph'
                            }
                        ]
                    }
                ]
            }
        }
    };
    const [{ content: content, responseState: responseState, error: error }] = (0, $ar5A7.useAIAgentStreaming)(request, {
        enablePartialJson: true,
        skip: !markdownPlusContent || isConvoAIMigrationEnabled,
        headers: {
            'x-experience-id': 'ai-issue-create-confluence-bulk',
            'x-product': 'confluence'
        }
    });
    (0, $gwFzn.useEffect)(()=>{
        const getIssueDetails = ()=>{
            return {
                iconUrl: '',
                name: '',
                id: ''
            };
        };
        // Temp add issues until we can handle partial responses
        const addIssues = (issues)=>{
            const newIssues = issues.map((issue)=>({
                    id: String(issueIndex.current++),
                    summary: issue.field_values.Summary,
                    description: (0, $4sbrV.markdownPlusToAdf)({
                        markdown: issue.field_values.Description,
                        idMap: pageIdMap
                    }),
                    issueType: getIssueDetails()
                }));
            setBulkIssuesList(newIssues);
        };
        // Switch statement to handle the different response states
        switch(responseState){
            case (0, $ioNzo.AIAgentResponseState).Initialization:
                // Not needed really just want to track all the states
                setBulkIssuesList([]);
                break;
            case (0, $ioNzo.AIAgentResponseState).AnswerPart:
                break;
            case (0, $ioNzo.AIAgentResponseState).FinalResponse:
                const issues = content.suggested_issues;
                try {
                    if (issues.length === 0) {
                        logAiNoResultsGenerated();
                        setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    } else {
                        // Setting list when all issues are returned for now, will update to handle partial responses
                        addIssues(issues);
                        setCurrentAiState((0, $hq2Sz.AiStates).IDLE);
                    }
                } catch (e) {
                    setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    logAiStreamingBackendFailed(e);
                }
                break;
            case (0, $ioNzo.AIAgentResponseState).Error:
                setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                logAiStreamingBackendFailed(error);
                break;
            default:
                break;
        }
    }, [
        content,
        pageIdMap,
        responseState,
        issueIndex,
        error,
        logAiStreamingBackendFailed,
        logAiNoResultsGenerated,
        setBulkIssuesList
    ]);
    return {
        aiAgentContent: bulkIssuesList,
        aiAgentCurrentAiState: currentAiState,
        aiAgentResponseState: responseState
    };
};

});
parcelRegister("ioNzo", function(module, exports) {

$parcel$export(module.exports, "AIAgentResponseState", () => $28532a1dd8dc1259$export$8dac07e05677d855);
$parcel$export(module.exports, "getDefaultAIAgentStreamingState", () => $28532a1dd8dc1259$export$25aa85b7d3899cd7);
var $28532a1dd8dc1259$export$8dac07e05677d855 = /*#__PURE__*/ function(AIAgentResponseState) {
    AIAgentResponseState["Initialization"] = "Initialization";
    AIAgentResponseState["AnswerPart"] = "AnswerPart";
    AIAgentResponseState["FinalResponse"] = "FinalResponse";
    AIAgentResponseState["FollowUp"] = "FollowUp";
    AIAgentResponseState["Error"] = "Error";
    return AIAgentResponseState;
}({});
function $28532a1dd8dc1259$export$25aa85b7d3899cd7() {
    return {
        content: null,
        responseState: "Initialization"
    };
}

});

parcelRegister("ar5A7", function(module, exports) {

$parcel$export(module.exports, "useAIAgentStreaming", () => $cfdd8e22dec1006f$export$3983045c2bc05499);

var $gwFzn = parcelRequire("gwFzn");

var $6yCLg = parcelRequire("6yCLg");

var $kSYCF = parcelRequire("kSYCF");

var $ioNzo = parcelRequire("ioNzo");
function $cfdd8e22dec1006f$export$3983045c2bc05499(request, config, onStateChange) {
    const refetchId = (0, $gwFzn.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $kSYCF.aiAgentStreamingEffect), (0, $ioNzo.getDefaultAIAgentStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $gwFzn.useEffect)(()=>{
        onStateChange?.(state);
    }, [
        state,
        onStateChange
    ]);
    const refetch = (0, $gwFzn.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $ioNzo.getDefaultAIAgentStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}

});
parcelRegister("kSYCF", function(module, exports) {

$parcel$export(module.exports, "aiAgentStreamingEffect", () => $e34978cfff846cdd$export$127df341c69343cc);

var $eH9u1 = parcelRequire("eH9u1");

var $guQFZ = parcelRequire("guQFZ");

var $eJ5lO = parcelRequire("eJ5lO");

var $4iZtC = parcelRequire("4iZtC");

var $7CiAC = parcelRequire("7CiAC");

var $2HUA6 = parcelRequire("2HUA6");

var $eByKY = parcelRequire("eByKY");

var $69nRD = parcelRequire("69nRD");

var $kkxph = parcelRequire("kkxph");

var $8EEqM = parcelRequire("8EEqM");

var $1PXvI = parcelRequire("1PXvI");

var $d4WWA = parcelRequire("d4WWA");

var $6PagU = parcelRequire("6PagU");

var $fPwFv = parcelRequire("fPwFv");

var $1yL2P = parcelRequire("1yL2P");

var $ioNzo = parcelRequire("ioNzo");
function $e34978cfff846cdd$export$127df341c69343cc(input$) {
    return input$.pipe((0, $69nRD.skipWhile)(({ inputs: [_, { skip: skip }] })=>!!skip), (0, $7CiAC.distinctUntilChanged)(({ inputs: [prevRequest, prevConfig, prevRefetchId] }, { inputs: [nextRequest, nextConfig, nextRefetchId] })=>(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(prevRequest, nextRequest) && (0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(prevConfig, nextConfig) && prevRefetchId === nextRefetchId), (0, $eByKY.map)(({ inputs: [request, config] })=>({
            config: (0, $d4WWA.getDefaultConfigWithUserSettings)(config),
            request: request
        })), (0, $eByKY.map)(({ request: request, config: config })=>({
            requestConfig: (0, $1PXvI.createAIAgentRequestConfig)(request, config),
            config: config
        })), (0, $kkxph.switchMap)(({ requestConfig: requestConfig, config: config })=>{
        (0, $1yL2P.logInfo)('pre request data', config, requestConfig);
        return (0, $6PagU.makeAIAgentStreamRequest)(requestConfig).pipe((0, $eByKY.map)((state)=>({
                config: config,
                state: state
            })));
    }), (0, $2HUA6.filter)(({ config: config, state: state })=>{
        if (!config.enableFollowUp && state.responseState === (0, $ioNzo.AIAgentResponseState).FollowUp) return false;
        return true;
    }), (0, $eByKY.map)(({ config: config, state: state })=>{
        (0, $1yL2P.logInfo)('response data', config, state);
        const nextState = (0, $fPwFv.parsePartialJsonIfNeeded)(state, config);
        (0, $1yL2P.logInfo)('post json parsing content', config, state);
        return {
            state: nextState,
            config: config
        };
    }), (0, $8EEqM.timeInterval)(), (0, $eJ5lO.concatMap)(({ value: { state: state, config: config }, interval: interval })=>{
        if (!config.delayChunkUpdate) return (0, $guQFZ.of)(state);
        const { time: time, gap: gap } = config.delayChunkUpdate;
        if (interval < gap) return (0, $guQFZ.of)(state).pipe((0, $4iZtC.delay)(time));
        return (0, $guQFZ.of)(state);
    }));
}

});
parcelRegister("1PXvI", function(module, exports) {

$parcel$export(module.exports, "createAIAgentRequestConfig", () => $7ac5ed2e1fc30856$export$7e0f2b55f5aef001);
const $7ac5ed2e1fc30856$export$7e0f2b55f5aef001 = (request, config)=>{
    const requestInitParams = {
        method: 'POST',
        headers: new Headers({
            ...config.headers
        }),
        body: JSON.stringify(request)
    };
    return {
        requestInitParams: requestInitParams,
        url: `${config.baseUrl}/${config.chatPath}`
    };
};

});

parcelRegister("d4WWA", function(module, exports) {

$parcel$export(module.exports, "getDefaultConfigWithUserSettings", () => $ab2f13c932b77d60$export$f6c7760a1a99679e);

var $iQFRZ = parcelRequire("iQFRZ");

var $iXcwu = parcelRequire("iXcwu");
const $ab2f13c932b77d60$var$baseUrl = (0, $iQFRZ.Lens).fromNullableProp()('baseUrl', (0, $iXcwu.BASE_STREAM_URL));
const $ab2f13c932b77d60$var$chatPath = (0, $iQFRZ.Lens).fromNullableProp()('chatPath', (0, $iXcwu.CHAT_STREAM_PATH));
const $ab2f13c932b77d60$var$enablePartialJson = (0, $iQFRZ.Lens).fromNullableProp()('enablePartialJson', false);
const $ab2f13c932b77d60$var$enableFollowUp = (0, $iQFRZ.Lens).fromNullableProp()('enableFollowUp', false);
const $ab2f13c932b77d60$var$enableLocalVerboseLogs = (0, $iQFRZ.Lens).fromNullableProp()('enableLocalVerboseLogs', false);
const $ab2f13c932b77d60$var$skip = (0, $iQFRZ.Lens).fromNullableProp()('skip', false);
const $ab2f13c932b77d60$var$contentType = (0, $iQFRZ.Lens).fromNullableProp()('content-type', 'application/json;charset=UTF-8');
const $ab2f13c932b77d60$export$f6c7760a1a99679e = (config)=>({
        baseUrl: $ab2f13c932b77d60$var$baseUrl.get(config),
        chatPath: $ab2f13c932b77d60$var$chatPath.get(config),
        enablePartialJson: $ab2f13c932b77d60$var$enablePartialJson.get(config),
        enableFollowUp: $ab2f13c932b77d60$var$enableFollowUp.get(config),
        enableLocalVerboseLogs: $ab2f13c932b77d60$var$enableLocalVerboseLogs.get(config),
        skip: $ab2f13c932b77d60$var$skip.get(config),
        headers: {
            'content-type': $ab2f13c932b77d60$var$contentType.get(config.headers),
            'x-product': config.headers['x-product'],
            'x-experience-id': config.headers['x-experience-id'],
            'x-issynthetic-traffic': config.headers['x-issynthetic-traffic'] ?? 'false'
        }
    });

});
parcelRegister("iXcwu", function(module, exports) {

$parcel$export(module.exports, "CHAT_STREAM_PATH", () => $5b661c5b454cb9d6$export$82796cc300bdfa9d);
$parcel$export(module.exports, "BASE_STREAM_URL", () => $5b661c5b454cb9d6$export$7c03f5942efb8a41);
const $5b661c5b454cb9d6$export$82796cc300bdfa9d = 'chat/v1/invoke_agent/stream';
const $5b661c5b454cb9d6$export$7c03f5942efb8a41 = '/gateway/api/assist';

});


parcelRegister("6PagU", function(module, exports) {

$parcel$export(module.exports, "makeAIAgentStreamRequest", () => $42226743f0d31b04$export$f08c4fd1705b0192);

var $iX7e9 = parcelRequire("iX7e9");

var $ioNzo = parcelRequire("ioNzo");

var $1z3D5 = parcelRequire("1z3D5");
function $42226743f0d31b04$export$f08c4fd1705b0192(requestConfig) {
    const behaviorSubject = new (0, $iX7e9.BehaviorSubject)({
        content: null,
        responseState: (0, $ioNzo.AIAgentResponseState).Initialization
    });
    fetch(requestConfig.url, {
        credentials: 'include',
        ...requestConfig.requestInitParams
    }).then((response)=>(0, $1z3D5.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $ioNzo.AIAgentResponseState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.message.content;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $ioNzo.AIAgentResponseState).FinalResponse,
                        content: bufferContent,
                        metadata: {
                            tokenData: chunk.message.usage_data
                        }
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? [],
                        responseState: (0, $ioNzo.AIAgentResponseState).FollowUp
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $ioNzo.AIAgentResponseState).Error,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
}

});
parcelRegister("1z3D5", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $cf4ed817163e53de$export$e45226161c660403);

var $bddW2 = parcelRequire("bddW2");

var $5DpVa = parcelRequire("5DpVa");
async function* $cf4ed817163e53de$export$e45226161c660403(response) {
    // covered HTTP errors only from this doc
    // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
    const possibleHTTPError = await (0, $bddW2.match)(response).returnType().with({
        status: 201
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).NO_ANSWER,
                status_code: response.status
            }
        };
    }).with({
        status: 400
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).NO_AGENT,
                status_code: response.status
            }
        };
    }).with({
        status: 403
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).AI_DISABLED,
                status_code: response.status
            }
        };
    }).with({
        status: 429
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).RATE_LIMIT,
                status_code: response.status
            }
        };
    }).with({
        status: 500
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).with({
        status: (0, $bddW2.P).not(200)
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).otherwise(()=>Promise.resolve(null));
    if (possibleHTTPError) {
        yield possibleHTTPError;
        return;
    }
    if (!response.body) {
        const responseText = await response.text();
        yield {
            type: 'ERROR',
            message: {
                content: `[Error]: response.body is missing. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).NETWORK_ERROR,
                status_code: response.status
            }
        };
        return;
    }
    try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $5DpVa.ErrorMessage).UNEXPECTED
            }
        };
        return;
    }
}

});
parcelRegister("5DpVa", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $b56344e668682954$export$915e9e7bd4f0f96d);
/**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-29941 Internal documentation for deprecation (no external access)}. Please use `ConvoAIStreamingHeaders` instead.
 * more info: https://hello.atlassian.net/wiki/spaces/CONVAI/pages/4886462722/Sunsetting+assistance-service+timeline
 */ var $b56344e668682954$export$915e9e7bd4f0f96d = /*#__PURE__*/ function(ErrorMessage) {
    ErrorMessage["NETWORK_ERROR"] = "NETWORK_ERROR";
    ErrorMessage["NO_ANSWER"] = "NO_ANSWER";
    ErrorMessage["RATE_LIMIT"] = "RATE_LIMIT";
    // typo comes from the backend
    // https://bitbucket.org/atlassian/assistance-service/src/02087c3b6569f042ec338e08e8e0e152c4563dad/src/schema/message_publisher.py#lines-74
    ErrorMessage["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "ASWER_UNAVAILABLE_FOR_CONTENT";
    ErrorMessage["NO_AGENT"] = "NO_AGENT";
    ErrorMessage["PLUGIN_ERRORED"] = "PLUGIN_ERRORED";
    ErrorMessage["OPENAI_RATE_LIMIT_USER_ABUSE"] = "OPENAI_RATE_LIMIT";
    ErrorMessage["ACCEPTABLE_USE_VIOLATIONS"] = "ACCEPTABLE_USE_VIOLATIONS";
    ErrorMessage["AI_DISABLED"] = "AI_DISABLED";
    ErrorMessage["UNEXPECTED"] = "UNEXPECTED";
    ErrorMessage["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    return ErrorMessage;
}({});

});



parcelRegister("fPwFv", function(module, exports) {

$parcel$export(module.exports, "parsePartialJsonIfNeeded", () => $e1721d84517230b5$export$1a589176614a95f1);

var $aGU6X = parcelRequire("aGU6X");

var $ioNzo = parcelRequire("ioNzo");
function $e1721d84517230b5$export$1a589176614a95f1(state, config) {
    if (state.responseState !== (0, $ioNzo.AIAgentResponseState).Initialization && config.enablePartialJson && state.content) try {
        const parsedContent = (0, $aGU6X.parse)(state.content);
        return {
            ...state,
            content: parsedContent
        };
    } catch (error) {}
    return state;
}

});

parcelRegister("1yL2P", function(module, exports) {

$parcel$export(module.exports, "logInfo", () => $499c3fbfbea69a7f$export$89c0607256d35f0a);
const $499c3fbfbea69a7f$export$89c0607256d35f0a = (message, config, data)=>{
    if (config.enableLocalVerboseLogs) // eslint-disable-next-line no-console
    console.info(`[@atlassian/ai-agent-streaming] [${message}]:`, data);
};

});



parcelRegister("3j1mV", function(module, exports) {

$parcel$export(module.exports, "useConfluencePageAri", () => $4fb0a6929b7f9ec7$export$baf23e7d4a1078c1);

var $gwFzn = parcelRequire("gwFzn");

var $ayhth = parcelRequire("ayhth");
var $ixUm0 = parcelRequire("ixUm0");
var $iILKK = parcelRequire("iILKK");
const $4fb0a6929b7f9ec7$export$baf23e7d4a1078c1 = (siteId, contentId, contentType)=>{
    const pageAri = (0, $gwFzn.useMemo)(()=>{
        try {
            switch(contentType){
                case 'page':
                    return (0, $ixUm0.ConfluencePageAri).create({
                        siteId: siteId,
                        pageId: contentId
                    }).toString();
                case 'blogpost':
                    return (0, $ayhth.ConfluenceBlogpostAri).create({
                        siteId: siteId,
                        blogpostId: contentId
                    }).toString();
                case 'whiteboard':
                    return (0, $iILKK.ConfluenceWhiteboardAri).create({
                        siteId: siteId,
                        whiteboardId: contentId
                    }).toString();
            }
        } catch  {
            return null;
        }
    }, [
        contentType,
        siteId,
        contentId
    ]);
    return {
        pageAri: pageAri
    };
};

});


parcelRegister("4cFF0", function(module, exports) {

$parcel$export(module.exports, "useConvoAIIssuesStreaming", () => $201fdba6e4f87137$export$a7634ad0f889de42);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $kAaxz = parcelRequire("kAaxz");
var $d3UlG = parcelRequire("d3UlG");

var $7pE6f = parcelRequire("7pE6f");
var $4sbrV = parcelRequire("4sbrV");

var $3j1mV = parcelRequire("3j1mV");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $jjbUz = parcelRequire("jjbUz");

var $hq2Sz = parcelRequire("hq2Sz");

var $26Yin = parcelRequire("26Yin");
const $201fdba6e4f87137$export$a7634ad0f889de42 = (isConvoAIMigrationEnabled)=>{
    const [{ bulkIssuesList: bulkIssuesList }, { setBulkIssuesList: setBulkIssuesList }] = (0, $hq2Sz.useBulkCreateContext)();
    const [markdownPlusContent, setMarkdownPlusContent] = (0, $gwFzn.useState)('');
    const [pageIdMap, setPageIdMap] = (0, $gwFzn.useState)(undefined);
    const [currentAiState, setCurrentAiState] = (0, $gwFzn.useState)((0, $hq2Sz.AiStates).LOADING);
    const { logAiStreamingBackendFailed: logAiStreamingBackendFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { logAiNoResultsGenerated: logAiNoResultsGenerated } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageId = contentId ?? '';
    const pageType = contentType ?? '';
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, pageId, pageType);
    // Used to keep track of the issues that have been added to the list and give a unique id
    const issueIndex = (0, $gwFzn.useRef)(0);
    const isRefetched = (0, $gwFzn.useRef)(false);
    // Needed to convert confluence content into MD+ format for the ai request
    (0, $diswb.useQuery)((0, $d2LG0.default)`query useConvoAIIssuesStreamingDataBulkIssueADFQuery($contentId:ID!){singleContent(id:$contentId){id body{atlas_doc_format{value}}}}`, {
        variables: {
            contentId: pageId
        },
        onError: (_adfError)=>{
            setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
        },
        fetchPolicy: 'network-only',
        onCompleted: (adfData)=>{
            const adf = adfData?.singleContent?.body?.atlas_doc_format?.value;
            if (adf) try {
                const parsedAdf = JSON.parse(adf);
                const { markdown: markdownPlus, idMap: idMap } = (0, $7pE6f.adfToMarkdownPlus)(parsedAdf);
                // Handle pages that don't have any content
                if (!markdownPlus) {
                    setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    return;
                }
                setMarkdownPlusContent(markdownPlus);
                setPageIdMap(idMap);
            } catch (err) {
                setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
            }
        },
        skip: currentAiState !== (0, $hq2Sz.AiStates).LOADING || !isConvoAIMigrationEnabled
    });
    const [request, config] = (0, $gwFzn.useMemo)(()=>(0, $jjbUz.buildIssueSuggestionsRequest)(markdownPlusContent, pageAri ?? '', isConvoAIMigrationEnabled), [
        markdownPlusContent,
        pageAri,
        isConvoAIMigrationEnabled
    ]);
    const [{ content: content, responseState: responseState, error: error }, refetch] = (0, $d3UlG.useConvoAIStreaming)(request, config);
    (0, $gwFzn.useEffect)(()=>{
        if (markdownPlusContent && responseState !== (0, $kAaxz.ConvoAIResponseState).FinalResponse && !isRefetched.current) {
            refetch();
            isRefetched.current = true;
        }
    }, [
        markdownPlusContent,
        responseState,
        refetch
    ]);
    const issues = (0, $gwFzn.useMemo)(()=>{
        try {
            return content ? JSON.parse(content) : {
                suggested_issues: []
            };
        } catch  {
            return {
                suggested_issues: []
            };
        }
    }, [
        content
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const getIssueDetails = ()=>{
            return {
                iconUrl: '',
                name: '',
                id: ''
            };
        };
        // Temp add issues until we can handle partial responses
        const addIssues = (issueList)=>{
            const newIssues = issueList.map((issue)=>({
                    id: String(issueIndex.current++),
                    summary: issue.field_values.Summary,
                    description: (0, $4sbrV.markdownPlusToAdf)({
                        markdown: issue.field_values.Description,
                        idMap: pageIdMap
                    }),
                    issueType: getIssueDetails()
                }));
            setBulkIssuesList(newIssues);
        };
        // Switch statement to handle the different response states
        switch(responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                // Not needed really just want to track all the states
                setBulkIssuesList([]);
                break;
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                try {
                    if (issues?.suggested_issues?.length === 0) {
                        logAiNoResultsGenerated();
                        setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    } else {
                        // Setting list when all issues are returned for now, will update to handle partial responses
                        addIssues(issues?.suggested_issues);
                        setCurrentAiState((0, $hq2Sz.AiStates).IDLE);
                    }
                } catch (e) {
                    setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    logAiStreamingBackendFailed(e);
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                logAiStreamingBackendFailed(error);
                break;
            default:
                break;
        }
    }, [
        issues,
        pageIdMap,
        responseState,
        issueIndex,
        error,
        content,
        logAiStreamingBackendFailed,
        logAiNoResultsGenerated,
        setBulkIssuesList
    ]);
    return {
        convoAIContent: bulkIssuesList,
        convoAICurrentAiState: currentAiState,
        convoAIResponseState: responseState
    };
};

});
parcelRegister("jjbUz", function(module, exports) {

$parcel$export(module.exports, "buildIssueSuggestionsRequest", () => $5070b96505b9e572$export$61d8a22303c46a7e);
const $5070b96505b9e572$export$61d8a22303c46a7e = (markdownPlusContent, pageAri, isConvoAIMigrationEnabled)=>{
    return [
        {
            ai_feature_input: {
                context: {
                    primary_text: markdownPlusContent,
                    input_mime_type: 'text/markdown',
                    source_ari: pageAri
                },
                source: 'CONFLUENCE',
                suggested_issues_config: {
                    max_issues: 10,
                    suggested_issue_field_types: [
                        {
                            issue_type: 'Task',
                            fields: [
                                {
                                    field_name: 'Summary',
                                    field_type: 'Short-Text'
                                },
                                {
                                    field_name: 'Description',
                                    field_type: 'Paragraph'
                                }
                            ]
                        }
                    ]
                },
                sourceType: 'string'
            }
        },
        {
            apiPath: 'v2/ai-feature/jira/issue/source-type/documentation/suggestions/stream',
            enablePartialJson: false,
            skip: !markdownPlusContent || !isConvoAIMigrationEnabled,
            headers: {
                'x-experience-id': 'ai-issue-create-confluence-bulk',
                'x-product': 'confluence'
            }
        }
    ];
};

});




parcelRegister("b7nPG", function(module, exports) {

$parcel$export(module.exports, "BulkCreateFlagsContainer", () => $394c97495ccb97e6$export$faba4facebe8b231);

var $gwFzn = parcelRequire("gwFzn");

var $7aRa9 = parcelRequire("7aRa9");

var $aMxFD = parcelRequire("aMxFD");
const $394c97495ccb97e6$var$BulkCreateFlagsContainerComponent = ({ flags: flags })=>{
    const setFlags = (0, $aMxFD.useSetBulkCreateFlagsContainer)();
    (0, $gwFzn.useEffect)(()=>{
        setFlags(flags);
    }, [
        flags,
        setFlags
    ]);
    return null;
};
const $394c97495ccb97e6$export$faba4facebe8b231 = (0, $7aRa9.withFlags)($394c97495ccb97e6$var$BulkCreateFlagsContainerComponent);

});

parcelRegister("bHOLm", function(module, exports) {

$parcel$export(module.exports, "AiBulkDefaultView", () => $e31d70bedca4a367$export$94a6c19356438095);

var $gwFzn = parcelRequire("gwFzn");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $lOlzk = parcelRequire("lOlzk");

var $23FOO = parcelRequire("23FOO");

var $3ecIt = parcelRequire("3ecIt");

var $5Ew1A = parcelRequire("5Ew1A");

var $26Yin = parcelRequire("26Yin");

var $hq2Sz = parcelRequire("hq2Sz");

var $qMR2B = parcelRequire("qMR2B");

var $aXkRG = parcelRequire("aXkRG");

var $5FJ5W = parcelRequire("5FJ5W");

var $1uJpg = parcelRequire("1uJpg");
const $e31d70bedca4a367$var$contentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap'
});
const $e31d70bedca4a367$export$94a6c19356438095 = ({ onClose: onClose })=>{
    const { logCancelAiPanel: logCancelAiPanel } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { addSingleIssuesToPage: addSingleIssuesToPage } = (0, $qMR2B.useGetIssueInsertionActions)();
    const [{ aiState: aiState, error: error }, actions] = (0, $hq2Sz.useBulkCreateContext)();
    const onPanelClose = (0, $gwFzn.useCallback)(()=>{
        logCancelAiPanel();
        addSingleIssuesToPage();
        actions.resetAIBulkCreateState();
        onClose();
    }, [
        logCancelAiPanel,
        onClose,
        addSingleIssuesToPage,
        actions
    ]);
    const isLoading = aiState === (0, $hq2Sz.AiStates).LOADING;
    const isError = error !== (0, $hq2Sz.ErrorStates).EMPTY;
    const isComplete = !isLoading && !isError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1uJpg.RainbowLoadingSidebar), {
        isShown: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $e31d70bedca4a367$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $23FOO.BulkCreateHeader), {
        onClose: onPanelClose
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5FJ5W.IssueCreateAiLoading), {
        loadingType: "bulk"
    }), isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: (0, $26Yin.BULK_ISSUE_CREATE_SOURCE),
        errorMessage: (0, $hq2Sz.ErrorMessageMap)[error],
        isCreatedWithAi: true
    }), isComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lOlzk.BulkCreateBody), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3ecIt.BulkCreateFooter), {
        onClose: onPanelClose,
        onCreateAll: onClose
    })))));
};

});
parcelRegister("lOlzk", function(module, exports) {

$parcel$export(module.exports, "BulkCreateBody", () => $832bf07ce05f7f94$export$a9383f5eed4e0adc);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $2Nwuj = parcelRequire("2Nwuj");

var $aoVih = parcelRequire("aoVih");

var $9wGTI = parcelRequire("9wGTI");

var $aMxFD = parcelRequire("aMxFD");

var $hq2Sz = parcelRequire("hq2Sz");

var $3E5yu = parcelRequire("3E5yu");

var $iQrB5 = parcelRequire("iQrB5");

var $26Yin = parcelRequire("26Yin");

var $hx8EL = parcelRequire("hx8EL");
const $832bf07ce05f7f94$var$bodyStyles = (0, $ecnYn.xcss)({
    flexGrow: 1,
    overflowY: 'auto'
});
const $832bf07ce05f7f94$export$a9383f5eed4e0adc = ()=>{
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const [{ bulkIssuesList: bulkIssuesList, currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, issueTypeHasRequiredFields: issueTypeHasRequiredFields, aiResultViewedFiredOnce: aiResultViewedFiredOnce }, { setAiResultViewedFiredOnce: setAiResultViewedFiredOnce }] = (0, $hq2Sz.useBulkCreateContext)();
    const { logAiResultViewed: logAiResultViewed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const issueType = (0, $hq2Sz.useGetIssueType)();
    const onConfigureClick = (0, $gwFzn.useCallback)((event)=>{
        event.preventDefault();
        goToPage('configure');
    }, [
        goToPage
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // TODO: Change this before rolling out confluence_ai_bulk_issue_creation_handle_chunks.
        if (isCreatedWithAi && bulkIssuesList.length > 0 && !aiResultViewedFiredOnce) {
            logAiResultViewed(bulkIssuesList.length);
            setAiResultViewedFiredOnce(true);
        }
    }, [
        isCreatedWithAi,
        bulkIssuesList,
        logAiResultViewed,
        aiResultViewedFiredOnce,
        setAiResultViewedFiredOnce
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        paddingBlockStart: "space.100",
        xcss: $832bf07ce05f7f94$var$bodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iQrB5.BulkCreateErrorSectionMessage), null), currentJiraSite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        weight: "semibold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).jiraSiteHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, currentJiraSite.displayName)), currentJiraProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        weight: "semibold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).jiraProjectHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, currentJiraProject.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small",
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: "#",
        testId: "bulk-create-configure-button",
        onClick: onConfigureClick
    }, "Configure")), issueTypeHasRequiredFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        title: (0, $3E5yu.messages).requiredFieldsSectionMessageTitle.defaultMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).requiredFieldsSectionMessageDescriptionIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).requiredFieldsSectionMessageDescription))), isCreatedFromTable && bulkIssuesList.length > 50 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        title: (0, $3E5yu.messages).moreThanFiftyWorkItemsSectionMessageTitle.defaultMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).moreThanFiftyWorkItemsSectionMessageDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, bulkIssuesList.map((issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hx8EL.BulkCreateIssueCard), {
            key: issue.id,
            issue: issue,
            issueType: issueType
        })))));
};

});
parcelRegister("iQrB5", function(module, exports) {

$parcel$export(module.exports, "BulkCreateErrorSectionMessage", () => $9cfc11ac0e778c90$export$4cc6cce5c43c90e6);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $aoVih = parcelRequire("aoVih");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $aMxFD = parcelRequire("aMxFD");
const $9cfc11ac0e778c90$export$4cc6cce5c43c90e6 = ()=>{
    const errorMessage = (0, $aMxFD.useErrorMessage)();
    if (!errorMessage) return null;
    const { createdCount: createdCount, failedCount: failedCount } = errorMessage;
    const partialCreateErrorMessageText = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelIssueCreatePartialErrorMessageIssueTermRefresh : (0, $3E5yu.messages).sidePanelIssueCreatePartialErrorMessage;
    const errorMessageText = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelIssueCreateErrorMessageIssueTermRefresh : (0, $3E5yu.messages).sidePanelIssueCreateErrorMessage;
    const formattedMessage = createdCount !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), partialCreateErrorMessageText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...errorMessageText,
        values: {
            issuesCount: failedCount
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "bulkCreateErrorSectionMessage"
    }, formattedMessage);
};

});

parcelRegister("hx8EL", function(module, exports) {

$parcel$export(module.exports, "BulkCreateIssueCard", () => $3477a14ae2c81903$export$56ffef98c4eef3d4);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $6bJyJ = parcelRequire("6bJyJ");

var $esRft = parcelRequire("esRft");

var $aMxFD = parcelRequire("aMxFD");

var $hq2Sz = parcelRequire("hq2Sz");

var $3E5yu = parcelRequire("3E5yu");

var $lykTR = parcelRequire("lykTR");
const $3477a14ae2c81903$var$cardStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    boxShadow: 'elevation.shadow.raised',
    borderRadius: '4px',
    cursor: 'pointer',
    padding: 'space.100',
    margin: 'space.025'
});
const $3477a14ae2c81903$var$stackStyles = (0, $ecnYn.xcss)({
    minHeight: '80px'
});
const $3477a14ae2c81903$var$issueTypeInlineStyles = (0, $ecnYn.xcss)({
    minHeight: '32px'
});
const $3477a14ae2c81903$export$56ffef98c4eef3d4 = ({ issue: { id: issueId, summary: summary, description: description }, issueType: issueType })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const setCurrentIssueId = (0, $hq2Sz.useSetCurrentIssueId)();
    const [showToolBar, setShowToolBar] = (0, $gwFzn.useState)(false);
    const onIssueClick = (0, $gwFzn.useCallback)(()=>{
        goToPage('edit_issue');
        setCurrentIssueId(issueId);
    }, [
        goToPage,
        issueId,
        setCurrentIssueId
    ]);
    const onMouseEnter = (0, $gwFzn.useCallback)(()=>void setShowToolBar(true), [
        setShowToolBar
    ]);
    const onMouseLeave = (0, $gwFzn.useCallback)(()=>void setShowToolBar(false), [
        setShowToolBar
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3477a14ae2c81903$var$cardStyles,
        onClick: onIssueClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $3477a14ae2c81903$var$stackStyles,
        space: "space.200",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        maxLines: 2
    }, summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $3477a14ae2c81903$var$issueTypeInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        appearance: "square",
        size: "xsmall",
        src: issueType.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        weight: "medium",
        size: "small"
    }, issueType.name)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
        label: formatMessage((0, $3E5yu.messages).issueCardDescriptionIconLabel),
        color: "var(--ds-icon, #44546F)",
        testId: "bulk-create-issue-card-description-icon"
    })), showToolBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lykTR.BulkCreateIssueCardToolBar), {
        issueId: issueId
    })))));
};

});
parcelRegister("lykTR", function(module, exports) {

$parcel$export(module.exports, "BulkCreateIssueCardToolBar", () => $32fa0430959c80d0$export$adeb5a38caa83ee3);

var $gwFzn = parcelRequire("gwFzn");

var $u9agA = parcelRequire("u9agA");

var $cvXh8 = parcelRequire("cvXh8");

var $lnqHu = parcelRequire("lnqHu");

var $1Zr9M = parcelRequire("1Zr9M");

var $1qfLF = parcelRequire("1qfLF");

var $hq2Sz = parcelRequire("hq2Sz");

var $9x4yo = parcelRequire("9x4yo");

var $jImJ9 = parcelRequire("jImJ9");

var $aMxFD = parcelRequire("aMxFD");

var $26Yin = parcelRequire("26Yin");
const $32fa0430959c80d0$export$adeb5a38caa83ee3 = ({ issueId: issueId })=>{
    const setCurrentIssueId = (0, $hq2Sz.useSetCurrentIssueId)();
    const [{ issueTypeHasRequiredFields: issueTypeHasRequiredFields }, { removeBulkIssue: removeBulkIssue }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createIssueHandler: createIssueHandler, loading: isCreateLoading } = (0, $9x4yo.useCreateIssue)();
    const { triggerSingleIssueCreatedFlag: triggerSingleIssueCreatedFlag } = (0, $jImJ9.useBulkCreateFlags)();
    const setErrorMessage = (0, $aMxFD.useSetErrorMessage)();
    const { logCreateSingleIssueClick: logCreateSingleIssueClick, logSingleIssueCreateSuccess: logSingleIssueCreateSuccess, logIssueCreationFailed: logIssueCreationFailed, logSidePanelIssueRemoved: logSidePanelIssueRemoved } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const isCreateDisabled = issueTypeHasRequiredFields || isCreateLoading;
    const onAcceptClick = (0, $gwFzn.useCallback)((event)=>{
        event.stopPropagation();
        setErrorMessage(null);
        let createdIssueId;
        createIssueHandler({
            issueId: issueId,
            onComplete: ({ key: issueKey, summary: summary, id: id })=>{
                logSingleIssueCreateSuccess();
                removeBulkIssue(issueId);
                createdIssueId = id;
                triggerSingleIssueCreatedFlag({
                    issueKey: issueKey,
                    summary: summary
                });
            },
            onFailure: (error)=>{
                logIssueCreationFailed(1, error);
                setErrorMessage({
                    createdCount: 0,
                    failedCount: 1
                });
            }
        });
        logCreateSingleIssueClick(createdIssueId);
    }, [
        issueId,
        removeBulkIssue,
        createIssueHandler,
        triggerSingleIssueCreatedFlag,
        setErrorMessage,
        logCreateSingleIssueClick,
        logSingleIssueCreateSuccess,
        logIssueCreationFailed
    ]);
    const onDiscardClick = (0, $gwFzn.useCallback)((event)=>{
        event.stopPropagation();
        logSidePanelIssueRemoved();
        setErrorMessage(null);
        removeBulkIssue(issueId);
    }, [
        issueId,
        removeBulkIssue,
        setErrorMessage,
        logSidePanelIssueRemoved
    ]);
    const onEditClick = (0, $gwFzn.useCallback)(()=>{
        setErrorMessage(null);
        setCurrentIssueId(issueId);
    }, [
        issueId,
        setCurrentIssueId,
        setErrorMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                spacing: "none"
            }),
        isDisabled: isCreateDisabled,
        label: "Accept",
        onClick: onAcceptClick,
        testId: "bulk-create-issue-card-accept-action"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                spacing: "none"
            }),
        isDisabled: isCreateLoading,
        label: "Discard",
        onClick: onDiscardClick,
        testId: "bulk-create-issue-card-discard-action"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                spacing: "none"
            }),
        isDisabled: isCreateLoading,
        label: "Edit",
        onClick: onEditClick,
        testId: "bulk-create-issue-card-edit-action"
    }));
};

});
parcelRegister("9x4yo", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $c2d3778a4a421c09$export$8af2d18142c8506c);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $lLsq0 = parcelRequire("lLsq0");
const $c2d3778a4a421c09$export$8af2d18142c8506c = ()=>{
    const [{ bulkIssuesList: bulkIssuesList, currentJiraProject: currentJiraProject }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createBulkIssuesHandler: createBulkIssuesHandler, loading: loading, response: response } = (0, $lLsq0.useCreateBulkIssues)();
    const issueType = (0, $hq2Sz.useGetIssueType)();
    const setSingleIssuesCreated = (0, $hq2Sz.useSetSingleIssuesCreated)();
    const createIssueHandler = (0, $gwFzn.useCallback)(async ({ issueId: issueId, onComplete: onComplete, onFailure: onFailure })=>{
        const issue = bulkIssuesList.find((item)=>item.id === issueId);
        if (!issue || !currentJiraProject) return;
        createBulkIssuesHandler({
            issueBody: {
                issueUpdates: [
                    {
                        fields: {
                            description: issue.description,
                            issuetype: {
                                id: issueType.id
                            },
                            project: {
                                id: currentJiraProject.id
                            },
                            summary: issue.summary
                        }
                    }
                ]
            },
            onComplete: (bulkCreateResponse)=>{
                const result = bulkCreateResponse.issues?.[0];
                if (result) {
                    const issueCreated = {
                        ...result,
                        summary: issue.summary,
                        rowIndex: issue.rowIndex
                    };
                    setSingleIssuesCreated(issueCreated);
                    onComplete(issueCreated);
                }
            },
            onFailure: onFailure
        });
    }, [
        bulkIssuesList,
        currentJiraProject,
        createBulkIssuesHandler,
        issueType.id,
        setSingleIssuesCreated
    ]);
    return {
        createIssueHandler: createIssueHandler,
        loading: loading,
        response: response
    };
};

});
parcelRegister("lLsq0", function(module, exports) {

$parcel$export(module.exports, "useCreateBulkIssues", () => $301f3e9a767797da$export$57078a0bf3b22549);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $26Yin = parcelRequire("26Yin");

var $euVTc = parcelRequire("euVTc");

var $k9cgj = parcelRequire("k9cgj");
const $301f3e9a767797da$export$c508f13f509a9be = 'create-bulk-issues';
const $301f3e9a767797da$export$57078a0bf3b22549 = ()=>{
    const [{ currentJiraSite: currentJiraSite }] = (0, $hq2Sz.useBulkCreateContext)();
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    const [response, setResponse] = (0, $gwFzn.useState)(null);
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setError = (0, $hq2Sz.useSetError)();
    const createBulkIssuesHandler = (0, $gwFzn.useCallback)(async ({ issueBody: issueBody, onComplete: onComplete, onFailure: onFailure, rowIndices: rowIndices })=>{
        if (!currentJiraSite || !currentJiraSite.cloudId) return;
        setLoading(true);
        setResponse(null);
        try {
            const result = await (0, $k9cgj.createBulkIssues)({
                cloudId: currentJiraSite.cloudId,
                issueBody: issueBody
            });
            if (!result) {
                onFailure('Empty response');
                logRequestFailed({
                    requestName: $301f3e9a767797da$export$c508f13f509a9be,
                    errorMessage: 'Failed to create issue: Empty from response call to bulk create'
                });
                setError((0, $hq2Sz.ErrorStates).BULK_CREATION);
            } else {
                if (rowIndices && rowIndices.length > 0) result.issues = (0, $euVTc.updateIssuesWithRowIndex)(result, rowIndices);
                setResponse(result);
                onComplete(result);
            }
        } catch (err) {
            onFailure(err);
            logRequestFailed({
                requestName: $301f3e9a767797da$export$c508f13f509a9be,
                errorMessage: `Failed to create issue ${err.message}`
            });
            setError((0, $hq2Sz.ErrorStates).BULK_CREATION);
        } finally{
            setLoading(false);
        }
    }, [
        currentJiraSite,
        logRequestFailed,
        setError
    ]);
    return {
        createBulkIssuesHandler: createBulkIssuesHandler,
        loading: loading,
        response: response
    };
};

});
parcelRegister("euVTc", function(module, exports) {

$parcel$export(module.exports, "getValidatedIssueFieldValuesForColumn", () => $39b1e229aed8b0e2$export$dea6de0898ac5b8);
$parcel$export(module.exports, "getClosestTableFromSelection", () => $39b1e229aed8b0e2$export$90fcb8f3c3f5ab4f);
$parcel$export(module.exports, "mapTableToIssues", () => $39b1e229aed8b0e2$export$d050dc64d7b7d275);
$parcel$export(module.exports, "updateIssuesWithRowIndex", () => $39b1e229aed8b0e2$export$fd730ab37ac74696);

var $eqKgz = parcelRequire("eqKgz");

var $2R8mu = parcelRequire("2R8mu");

var $CbMiC = parcelRequire("CbMiC");
const $39b1e229aed8b0e2$var$TEAM_ID_PATTERN = /[0-9A-Za-z]{8}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{12}/;
const $39b1e229aed8b0e2$var$getFieldTypeFromMapping = (mapping)=>{
    if (mapping.field) return $39b1e229aed8b0e2$export$485ff2ccf56b085f(mapping.field);
    return (0, $CbMiC.FieldType).UNSUPPORTED;
};
const $39b1e229aed8b0e2$export$485ff2ccf56b085f = (metadata)=>{
    switch(metadata.schema.type){
        // "SHORT_TEXT" is the least restrictive type, so we can use it for "ANY"
        case (0, $2R8mu.FieldMetadataSchemaType).STRING:
            const customType = metadata.schema.custom;
            return customType == (0, $2R8mu.FieldMetadataSchemaCustom).TEXT_AREA ? (0, $CbMiC.FieldType).PARAGRAPH : (0, $CbMiC.FieldType).SHORT_TEXT;
        case (0, $2R8mu.FieldMetadataSchemaType).NUMBER:
            return (0, $CbMiC.FieldType).NUMBER;
        case (0, $2R8mu.FieldMetadataSchemaType).DATE:
            return (0, $CbMiC.FieldType).DATE;
        case (0, $2R8mu.FieldMetadataSchemaType).USER:
            return (0, $CbMiC.FieldType).USER;
        case (0, $2R8mu.FieldMetadataSchemaType).PRIORITY:
            return (0, $CbMiC.FieldType).PRIORITY;
        case (0, $2R8mu.FieldMetadataSchemaType).DATETIME:
            return (0, $CbMiC.FieldType).TIMESTAMP;
        case (0, $2R8mu.FieldMetadataSchemaType).ARRAY:
            if (metadata.schema.custom == (0, $2R8mu.FieldMetadataSchemaCustom).PEOPLE) return (0, $CbMiC.FieldType).PEOPLE;
            else if (metadata.schema.system == (0, $2R8mu.FieldMetadataSchemaSystem).LABELS) return (0, $CbMiC.FieldType).LABELS;
            return (0, $CbMiC.FieldType).UNSUPPORTED;
        case (0, $2R8mu.FieldMetadataSchemaType).TEAM:
            return (0, $CbMiC.FieldType).TEAM;
        default:
            return (0, $CbMiC.FieldType).UNSUPPORTED;
    }
};
const $39b1e229aed8b0e2$var$getMentionAccountIdFromAdfNode = (adfNode)=>{
    return adfNode.type == 'mention' && adfNode.attrs?.id ? adfNode.attrs.id : null;
};
const $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree = (adf)=>{
    const nodes = [
        adf
    ];
    const accountIds = [];
    let node;
    while((node = nodes.pop()) !== undefined){
        const accountId = $39b1e229aed8b0e2$var$getMentionAccountIdFromAdfNode(node);
        accountId && accountIds.push(node.attrs.id);
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
    }
    return accountIds;
};
const $39b1e229aed8b0e2$var$getTeamIdFromUrl = (urlString)=>{
    if (!urlString) return null;
    let url;
    try {
        url = new URL(urlString);
    } catch  {
        return null;
    }
    const path = url.pathname;
    const pathParts = path.split('/');
    if (path.startsWith('/people/team') && pathParts.length > 3) {
        const teamId = pathParts[3];
        return teamId.match($39b1e229aed8b0e2$var$TEAM_ID_PATTERN) ? teamId : null;
    }
    return null;
};
const $39b1e229aed8b0e2$var$getTeamIdFromAdfNode = (adfNode)=>{
    let urlString;
    if (adfNode.type == 'inlineCard' || adfNode.type == 'blockCard') urlString = adfNode.attrs?.url;
    else if (adfNode.type == 'link') urlString = adfNode.attrs?.href;
    else if (adfNode.type == 'text') urlString = adfNode.text;
    return $39b1e229aed8b0e2$var$getTeamIdFromUrl(urlString);
};
const $39b1e229aed8b0e2$var$getTeamIdFromAdfTree = (adf)=>{
    const nodes = [
        adf
    ];
    let node;
    while((node = nodes.pop()) !== undefined){
        const teamId = $39b1e229aed8b0e2$var$getTeamIdFromAdfNode(node);
        if (teamId) return teamId;
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
        node.marks?.forEach((n)=>{
            nodes.push(n);
        });
    }
    return null;
};
const $39b1e229aed8b0e2$var$getLabelsFromAdfTree = (adf)=>{
    const nodes = [
        adf
    ];
    const labels = [];
    let node;
    while((node = nodes.pop()) !== undefined){
        if (node.type == 'text' && node.text) labels.push(...node.text.split(/\s+/));
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
    }
    return labels;
};
const $39b1e229aed8b0e2$var$getIssueFieldValueFromCellValue = (fieldType, cell)=>{
    if (!cell) return null;
    const textContent = cell.textContent?.trim();
    const adf = (0, $eqKgz.htmlToADF)(cell.innerHTML);
    let accountIds;
    const dateFromTextContent = textContent ? new Date(textContent) : null;
    const validDateOrNull = dateFromTextContent && !isNaN(dateFromTextContent.getTime()) ? dateFromTextContent : null;
    switch(fieldType){
        case (0, $CbMiC.FieldType).SHORT_TEXT:
            return textContent;
        case (0, $CbMiC.FieldType).PARAGRAPH:
            return adf;
        case (0, $CbMiC.FieldType).NUMBER:
            return Number(textContent);
        case (0, $CbMiC.FieldType).DATE:
            return validDateOrNull ? validDateOrNull.toISOString().split('T')[0] : null;
        case (0, $CbMiC.FieldType).USER:
            accountIds = $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree(adf);
            return accountIds.length > 0 ? {
                id: accountIds[0]
            } : null;
        case (0, $CbMiC.FieldType).PRIORITY:
            return textContent && textContent.length > 1 ? {
                name: textContent.charAt(0).toUpperCase() + textContent.toLowerCase().slice(1)
            } : null;
        case (0, $CbMiC.FieldType).TIMESTAMP:
            return validDateOrNull ? validDateOrNull.toISOString() : null;
        case (0, $CbMiC.FieldType).PEOPLE:
            accountIds = $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree(adf);
            return accountIds.map((id)=>({
                    id: id
                }));
        case (0, $CbMiC.FieldType).LABELS:
            return $39b1e229aed8b0e2$var$getLabelsFromAdfTree(adf);
        case (0, $CbMiC.FieldType).TEAM:
            return $39b1e229aed8b0e2$var$getTeamIdFromAdfTree(adf);
        default:
            return textContent;
    }
};
const $39b1e229aed8b0e2$var$getRowFieldValues = (fieldType, column, table)=>{
    const rows = Array.from(table.rows).slice(1);
    const fieldValues = rows.map((row)=>$39b1e229aed8b0e2$var$getIssueFieldValueFromCellValue(fieldType, row.cells[column.index]));
    return fieldValues.filter((value)=>value !== null);
};
const $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType = (fieldType, column, table, validator)=>{
    const fieldValues = $39b1e229aed8b0e2$var$getRowFieldValues(fieldType, column, table);
    const hasValidValue = fieldValues.some(validator);
    if (!hasValidValue) return null;
    return {
        canBeRequired: false,
        fieldValues: // TODO: PR incoming
        fieldValues
    };
};
const $39b1e229aed8b0e2$export$dea6de0898ac5b8 = (column, table)=>{
    const validatedIssueFieldValues = new Map();
    const setIfNotNull = (fieldType, validatedValues)=>{
        if (validatedValues) validatedIssueFieldValues.set(fieldType, validatedValues);
    };
    const dateValidator = (value)=>value != null && !isNaN(new Date(value.toString()).getTime());
    const userValidator = (value)=>value != null && typeof value === 'object' && 'id' in value && value.id != null && value.id.length > 0;
    const tautologicalValidator = ()=>true;
    setIfNotNull((0, $CbMiC.FieldType).SHORT_TEXT, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).PARAGRAPH, column, table, tautologicalValidator));
    setIfNotNull((0, $CbMiC.FieldType).PARAGRAPH, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).PARAGRAPH, column, table, tautologicalValidator));
    setIfNotNull((0, $CbMiC.FieldType).NUMBER, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).NUMBER, column, table, (value)=>!Number.isNaN(Number(value))));
    setIfNotNull((0, $CbMiC.FieldType).DATE, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).DATE, column, table, dateValidator));
    setIfNotNull((0, $CbMiC.FieldType).TIMESTAMP, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).TIMESTAMP, column, table, dateValidator));
    setIfNotNull((0, $CbMiC.FieldType).USER, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).USER, column, table, userValidator));
    setIfNotNull((0, $CbMiC.FieldType).PRIORITY, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).PRIORITY, column, table, (value)=>value != null));
    setIfNotNull((0, $CbMiC.FieldType).PEOPLE, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).PEOPLE, column, table, (values)=>Array.isArray(values) && values.every(userValidator)));
    setIfNotNull((0, $CbMiC.FieldType).TEAM, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).TEAM, column, table, (value)=>!!value?.toString().match($39b1e229aed8b0e2$var$TEAM_ID_PATTERN)));
    setIfNotNull((0, $CbMiC.FieldType).LABELS, $39b1e229aed8b0e2$var$getValidatedIssueFieldValuesForType((0, $CbMiC.FieldType).LABELS, column, table, tautologicalValidator));
    return validatedIssueFieldValues;
};
const $39b1e229aed8b0e2$export$90fcb8f3c3f5ab4f = (activeSelection)=>{
    if (activeSelection && activeSelection.rangeCount > 0) {
        // Get the first range from the selection
        const range = activeSelection.getRangeAt(0);
        // Start from the common ancestor container of the range
        let node = range.commonAncestorContainer;
        // If the node is a text node, move up to its parent element
        if (node?.nodeType === Node.TEXT_NODE) node = node.parentElement;
        // Traverse up the DOM tree to find the closest <table> element
        while(node && node.nodeType === Node.ELEMENT_NODE){
            if (node.tagName === 'TABLE') return node;
            node = node.parentElement;
        }
    }
    return null;
};
const $39b1e229aed8b0e2$export$d050dc64d7b7d275 = (mappings, table)=>{
    let issueIndex = 0;
    const rows = table.rows;
    const issues = [];
    const isFirstRowHeader = rows.length > 0 && Array.from(rows[0].cells).every((cell)=>cell.tagName.toLowerCase() === 'th' || cell.classList.contains('ak-renderer-table-number-column'));
    // Starting from the second row as we will be using the first row as the header even if it is not a HTML header row
    for(let i = 1; i < rows.length; i++){
        const issue = {
            id: '',
            summary: '',
            description: undefined,
            issueType: {
                iconUrl: '',
                name: '',
                id: ''
            },
            // Note: the issue insertion API does not count the HTML header row as the first row so we want to shift the index by 1 if the first row is a HTML header row
            rowIndex: i - (isFirstRowHeader ? 1 : 0)
        };
        let emptySummary = true;
        let emptyDescription = true;
        for (const mapping of mappings){
            const textContent = mapping.column ? rows[i]?.cells[mapping.column.index]?.textContent?.trim() : '';
            if (mapping.field) {
                if (mapping.field.fieldId === 'summary') {
                    issue.summary = textContent || 'Untitled';
                    emptySummary = !textContent;
                } else if (mapping.field.fieldId === 'description') {
                    //The description expects ADF content
                    const cellHTML = mapping.column ? rows[i]?.cells[mapping.column.index]?.innerHTML : '';
                    issue.description = (0, $eqKgz.htmlToADF)(cellHTML);
                    emptyDescription = !textContent;
                } else {
                    const fieldType = $39b1e229aed8b0e2$var$getFieldTypeFromMapping(mapping);
                    const fieldValue = $39b1e229aed8b0e2$var$getIssueFieldValueFromCellValue(fieldType, mapping.column ? rows[i]?.cells[mapping.column.index] : null);
                    if (!issue.additionalFields) issue.additionalFields = [];
                    if (fieldValue !== null) issue.additionalFields.push({
                        field: mapping.field,
                        value: fieldValue
                    });
                }
            }
        }
        if (!emptySummary && !emptyDescription) {
            issue.id = String(issueIndex++);
            issues.push(issue);
        }
    }
    return issues;
};
const $39b1e229aed8b0e2$export$fd730ab37ac74696 = (result, rowIndices)=>{
    const failedElementNumbers = result.errors.map((error)=>error.failedElementNumber);
    const updatedRowIndices = rowIndices.filter((_, elementNumber)=>!failedElementNumbers.includes(elementNumber));
    return result.issues.map((issue, index)=>{
        return {
            ...issue,
            rowIndex: updatedRowIndices[index]
        };
    });
};

});
parcelRegister("eqKgz", function(module, exports) {

$parcel$export(module.exports, "htmlToADF", () => $631da813c6a2d352$export$e83f06e0073cd34f);

var $kviC1 = parcelRequire("kviC1");

var $ODlve = parcelRequire("ODlve");

var $h9yJL = parcelRequire("h9yJL");
const $631da813c6a2d352$var$adfTransformer = new (0, $h9yJL.JSONTransformer)();
const $631da813c6a2d352$export$e83f06e0073cd34f = (html)=>{
    const element = document.createElement('div');
    element.innerHTML = html;
    const doc = (0, $kviC1.DOMParser).fromSchema((0, $ODlve.defaultSchema)).parse(element);
    return $631da813c6a2d352$var$adfTransformer.encode(doc);
};

});







parcelRegister("23FOO", function(module, exports) {

$parcel$export(module.exports, "BulkCreateHeader", () => $ea94463cb9b948e3$export$fe6406b062c20dac);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $lnqHu = parcelRequire("lnqHu");

var $1qfLF = parcelRequire("1qfLF");

var $lAFHW = parcelRequire("lAFHW");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");
const $ea94463cb9b948e3$var$headerStyles = (0, $ecnYn.xcss)({
    flexShrink: 0
});
const $ea94463cb9b948e3$var$headerMessageStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $ea94463cb9b948e3$export$fe6406b062c20dac = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        paddingBlockEnd: "space.100",
        paddingInlineStart: "space.300",
        xcss: $ea94463cb9b948e3$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lAFHW.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ea94463cb9b948e3$var$headerMessageStyle
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkCreateHeaderTextIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkCreateHeaderText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
                label: "close-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: onClose,
        testId: "close-issue-create-panel-button"
    })));
};

});

parcelRegister("3ecIt", function(module, exports) {

$parcel$export(module.exports, "BulkCreateFooter", () => $f2e2bf93bb67f77b$export$68f1231a891ae47c);

var $gwFzn = parcelRequire("gwFzn");

var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $ep3mz = parcelRequire("ep3mz");

var $hiixe = parcelRequire("hiixe");

var $3t3RY = parcelRequire("3t3RY");

var $74xbC = parcelRequire("74xbC");
const $f2e2bf93bb67f77b$var$footerBaseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    flexShrink: 0,
    position: 'relative',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.150',
        right: 'space.150',
        height: '1px',
        backgroundColor: 'elevation.surface',
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width'
    }
});
const $f2e2bf93bb67f77b$var$footerTopStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $f2e2bf93bb67f77b$var$AI_BULK_CREATE_FEEDBACK_ENTRYPOINT_ID = 'bfca508d-e2bb-4436-a060-3fa27bdce78f';
const $f2e2bf93bb67f77b$export$68f1231a891ae47c = ({ onClose: onClose, onCreateAll: onCreateAll })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $f2e2bf93bb67f77b$var$footerBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $f2e2bf93bb67f77b$var$footerTopStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $74xbC.IssueCreateAiFeedback), {
        contentId: contentId ?? '',
        entrypointId: $f2e2bf93bb67f77b$var$AI_BULK_CREATE_FEEDBACK_ENTRYPOINT_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3t3RY.BulkCreateButtonGroup), {
        onClose: onClose,
        onCreateAll: onCreateAll
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hiixe.AiSubFooter), null));
};

});
parcelRegister("3t3RY", function(module, exports) {

$parcel$export(module.exports, "BulkCreateButtonGroup", () => $2fd9480bca9d7e8f$export$1926ccc813f04882);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $ccHMk = parcelRequire("ccHMk");

var $9wGTI = parcelRequire("9wGTI");

var $aMxFD = parcelRequire("aMxFD");

var $kp2re = parcelRequire("kp2re");

var $hq2Sz = parcelRequire("hq2Sz");

var $jImJ9 = parcelRequire("jImJ9");

var $26Yin = parcelRequire("26Yin");

var $3E5yu = parcelRequire("3E5yu");

var $1Q0l6 = parcelRequire("1Q0l6");

var $qMR2B = parcelRequire("qMR2B");

var $1mDVg = parcelRequire("1mDVg");
const $2fd9480bca9d7e8f$var$buttonGroupStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050'
});
const $2fd9480bca9d7e8f$export$1926ccc813f04882 = ({ onClose: onClose, onCreateAll: onCreateAll })=>{
    const { createAllIssuesHandler: createAllIssuesHandler, loading: isCreateAllLoading } = (0, $kp2re.useCreateAllIssues)();
    const [{ bulkIssuesList: bulkIssuesList, issueTypeHasRequiredFields: issueTypeHasRequiredFields, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, singleIssuesCreated: singleIssuesCreated, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable }, { removeBulkIssueList: removeBulkIssueList }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload, pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { triggerMultipleIssuesCreatedFlag: triggerMultipleIssuesCreatedFlag, triggerSingleIssueInsertLinkFailureFlag: triggerSingleIssueInsertLinkFailureFlag, triggerMultipleIssuesInsertLinkFailureFlag: triggerMultipleIssuesInsertLinkFailureFlag } = (0, $jImJ9.useBulkCreateFlags)();
    const setErrorMessage = (0, $aMxFD.useSetErrorMessage)();
    const { logCreateAllClick: logCreateAllClick, logMultipleIssueCreateSuccess: logMultipleIssueCreateSuccess, logIssueCreationFailed: logIssueCreationFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { constructAnchorLinkToHeading: constructAnchorLinkToHeading, constructXmlModification: constructXmlModification, constructCellModifications: constructCellModifications } = (0, $qMR2B.useGetIssueInsertionActions)();
    const reloadOnClick = (0, $gwFzn.useCallback)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = constructAnchorLinkToHeading();
        window.location.reload();
    }, [
        constructAnchorLinkToHeading
    ]);
    const isCreateAllDisabled = bulkIssuesList.length === 0 || issueTypeHasRequiredFields || isCreatedFromTable && bulkIssuesList.length > 50;
    const handleStorageInsertion = (0, $gwFzn.useCallback)((createdIssues, payload)=>{
        let showReloadAction = false;
        (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(payload, pageMode);
        const insertPromise = isCreatedWithAi ? (0, $1Q0l6.insertContentAtSelectionEnd)(payload) : (0, $1Q0l6.insertContentAtColumn)(payload);
        insertPromise.then((data)=>{
            // There is a case where the API response is OK, but the response data is false.
            // When this happens, the backend has trouble inserting the ticket to the page (likely due to a payload error) and we should show an error toast.
            if (data === false) throw new Error('Failed to insert storage');
        }).then(()=>{
            showReloadAction = true;
        }).catch((_error)=>{
            if (createdIssues.length === 1) triggerSingleIssueInsertLinkFailureFlag({
                issueKey: createdIssues[0].key,
                summary: createdIssues[0].summary
            });
            else triggerMultipleIssuesInsertLinkFailureFlag(createdIssues);
        }).finally(()=>{
            triggerMultipleIssuesCreatedFlag(createdIssues, reloadOnClick, showReloadAction);
        });
    }, [
        isCreatedWithAi,
        pageMode,
        reloadOnClick,
        triggerMultipleIssuesCreatedFlag,
        triggerMultipleIssuesInsertLinkFailureFlag,
        triggerSingleIssueInsertLinkFailureFlag
    ]);
    const onCreateAllClick = (0, $gwFzn.useCallback)(()=>{
        logCreateAllClick();
        setErrorMessage(null);
        createAllIssuesHandler({
            onComplete: ({ createdIssues: createdIssues, createdIssueIDs: createdIssueIDs, failedIssueIDs: failedIssueIDs })=>{
                logMultipleIssueCreateSuccess(createdIssueIDs.length);
                const eligibleForInsertion = hasEditPermission || !(0, $9wGTI.fg)('jira-work-create-from-connie-without-edit-perms');
                if (isCreatedWithAi && insertStorageFragmentRequestPayload && eligibleForInsertion) {
                    insertStorageFragmentRequestPayload.xmlModification = constructXmlModification([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ], insertStorageFragmentRequestPayload);
                    handleStorageInsertion(createdIssues, insertStorageFragmentRequestPayload);
                } else if (!isCreatedWithAi && insertStorageColumnTableRequestPayload && eligibleForInsertion) {
                    insertStorageColumnTableRequestPayload.cellModifications = constructCellModifications([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ]);
                    handleStorageInsertion([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ], insertStorageColumnTableRequestPayload);
                } else triggerMultipleIssuesCreatedFlag(createdIssues, reloadOnClick, false);
                removeBulkIssueList(createdIssueIDs);
                if (failedIssueIDs.length !== 0) {
                    logIssueCreationFailed(failedIssueIDs.length);
                    setErrorMessage({
                        createdCount: createdIssueIDs.length,
                        failedCount: failedIssueIDs.length
                    });
                } else onCreateAll();
            },
            onFailure: (error)=>{
                logIssueCreationFailed(bulkIssuesList.length, error);
                setErrorMessage({
                    createdCount: 0,
                    failedCount: bulkIssuesList.length
                });
            }
        });
    }, [
        logCreateAllClick,
        setErrorMessage,
        createAllIssuesHandler,
        logMultipleIssueCreateSuccess,
        insertStorageFragmentRequestPayload,
        insertStorageColumnTableRequestPayload,
        removeBulkIssueList,
        constructXmlModification,
        constructCellModifications,
        singleIssuesCreated,
        triggerMultipleIssuesCreatedFlag,
        reloadOnClick,
        logIssueCreationFailed,
        onCreateAll,
        bulkIssuesList,
        isCreatedWithAi,
        hasEditPermission,
        handleStorageInsertion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        xcss: $2fd9480bca9d7e8f$var$buttonGroupStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "bulk-create-button-group-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkCreateCancelFooterButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        isDisabled: isCreateAllDisabled,
        isLoading: isCreateAllLoading,
        onClick: onCreateAllClick,
        testId: "bulk-create-button-group-create-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $3E5yu.messages).bulkCreateCreateAllFooterButton)));
};

});
parcelRegister("kp2re", function(module, exports) {

$parcel$export(module.exports, "useCreateAllIssues", () => $7387aac0bbb24193$export$e714d12ec594ed0a);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $lLsq0 = parcelRequire("lLsq0");
const $7387aac0bbb24193$export$e714d12ec594ed0a = ()=>{
    const [{ bulkIssuesList: bulkIssuesList, currentJiraProject: currentJiraProject }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createBulkIssuesHandler: createBulkIssuesHandler, loading: loading, response: response } = (0, $lLsq0.useCreateBulkIssues)();
    const issueType = (0, $hq2Sz.useGetIssueType)();
    const createAllIssuesHandler = (0, $gwFzn.useCallback)(async ({ onComplete: onComplete, onFailure: onFailure })=>{
        if (!currentJiraProject || bulkIssuesList.length === 0) return;
        const issueUpdates = bulkIssuesList.map((issue)=>{
            const fields = {
                description: issue.description,
                issuetype: {
                    id: issueType.id
                },
                project: {
                    id: currentJiraProject.id
                },
                summary: issue.summary,
                ...issue.assigneeUserId && {
                    assignee: {
                        id: issue.assigneeUserId
                    }
                },
                ...issue.parentIssueLink && {
                    parent: {
                        key: issue.parentIssueLink
                    }
                },
                ...issue.labels && {
                    labels: issue.labels
                }
            };
            if (issue.additionalFields) issue.additionalFields.forEach((f)=>{
                fields[f.field.fieldId] = f.value;
            });
            return {
                fields: fields
            };
        });
        const rowIndices = bulkIssuesList.filter((issue)=>issue.rowIndex !== undefined).map((issue)=>Number(issue.rowIndex));
        createBulkIssuesHandler({
            issueBody: {
                issueUpdates: issueUpdates
            },
            onComplete: ({ issues: createdIssues, errors: failedIssuesResponse })=>{
                const failedIssueIDs = failedIssuesResponse.map((errorItem)=>bulkIssuesList?.[errorItem.failedElementNumber]?.id);
                const createdIssueIDs = bulkIssuesList.filter((issue)=>!failedIssueIDs.includes(issue.id)).map((issue)=>issue.id);
                onComplete({
                    createdIssueIDs: createdIssueIDs,
                    createdIssues: createdIssues,
                    failedIssueIDs: failedIssueIDs
                });
            },
            onFailure: onFailure,
            rowIndices: rowIndices
        });
    }, [
        currentJiraProject,
        bulkIssuesList,
        createBulkIssuesHandler,
        issueType.id
    ]);
    return {
        createAllIssuesHandler: createAllIssuesHandler,
        loading: loading,
        response: response
    };
};

});

parcelRegister("qMR2B", function(module, exports) {

$parcel$export(module.exports, "useGetIssueInsertionActions", () => $ed2929b91c73486c$export$d58e5870a6e92835);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dPJCf = parcelRequire("dPJCf");

var $9wGTI = parcelRequire("9wGTI");

var $3E5yu = parcelRequire("3E5yu");

var $hq2Sz = parcelRequire("hq2Sz");

var $1mDVg = parcelRequire("1mDVg");

var $26Yin = parcelRequire("26Yin");

var $jImJ9 = parcelRequire("jImJ9");

var $1Q0l6 = parcelRequire("1Q0l6");
const $ed2929b91c73486c$var$JIRA_SINGLE_ISSUE_LINK_INSERTION = 'jiraSingleIssueLinkInsertion';
const $ed2929b91c73486c$var$JIRA_MULTIPLE_ISSUE_LINK_INSERTION = 'jiraMultipleIssueLinkInsertion';
const $ed2929b91c73486c$export$d58e5870a6e92835 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [{ currentJiraSite: currentJiraSite, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, singleIssuesCreated: singleIssuesCreated, isCreatedWithAi: isCreatedWithAi }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload, pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { triggerSingleIssueInsertLinkFailureFlag: triggerSingleIssueInsertLinkFailureFlag, triggerMultipleIssuesInsertLinkFailureFlag: triggerMultipleIssuesInsertLinkFailureFlag, triggerMultipleIssuesCreatedFlag: triggerMultipleIssuesCreatedFlag } = (0, $jImJ9.useBulkCreateFlags)();
    const resetSingleIssuesCreated = (0, $hq2Sz.useResetSingleIssuesCreated)();
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const headingString = formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkCreateIssueInsertionHeadingIssueTermRefresh : (0, $3E5yu.messages).bulkCreateIssueInsertionHeading);
    const currentUrl = (0, $dPJCf.useRouteDataRef)().current?.href;
    const constructXmlModification = (0, $gwFzn.useCallback)((createdIssues, insertStorageFragmentRequestPayload)=>{
        const smartlinkTags = (0, $1Q0l6.bulkConstructSmartlinkTags)(createdIssues.map((issue)=>(0, $1Q0l6.constructJiraIssueUrl)(currentJiraSite?.url, issue.key)));
        return insertStorageFragmentRequestPayload?.selectedText !== headingString ? `${(0, $1Q0l6.constructHeading)(headingString)}<br/>${smartlinkTags}` : `<p>${smartlinkTags}</p>`;
    }, [
        currentJiraSite?.url,
        headingString
    ]);
    const constructCellModifications = (0, $gwFzn.useCallback)((createdIssues)=>{
        return createdIssues.filter((issue)=>issue.rowIndex !== undefined).map((issue)=>{
            const xmlInsertion = (0, $1Q0l6.constructSmartlinkTag)((0, $1Q0l6.constructJiraIssueUrl)(currentJiraSite?.url, issue.key));
            return {
                rowIndex: Number(issue.rowIndex),
                xmlInsertion: xmlInsertion
            };
        });
    }, [
        currentJiraSite?.url
    ]);
    const constructAnchorLinkToHeading = (0, $gwFzn.useCallback)(()=>{
        const formattedHeading = headingString.split(' ').join('-');
        const [baseUrl, existingHash] = (currentUrl ?? '').split('#');
        return existingHash ? `${baseUrl}#${formattedHeading}` : `${currentUrl}#${formattedHeading}`;
    }, [
        currentUrl,
        headingString
    ]);
    const reloadOnClick = (0, $gwFzn.useCallback)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = constructAnchorLinkToHeading();
        window.location.reload();
    }, [
        constructAnchorLinkToHeading
    ]);
    const handleStorageInsertion = (0, $gwFzn.useCallback)((issuesCreated, payload)=>{
        let showReloadAction = false;
        (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(payload, pageMode);
        const insertPromise = isCreatedWithAi ? (0, $1Q0l6.insertContentAtSelectionEnd)(payload) : (0, $1Q0l6.insertContentAtColumn)(payload);
        insertPromise.then((data)=>{
            // There is a case where the API response is OK, but the response data is false.
            // When this happens, the backend has trouble inserting the ticket to the page (likely due to a payload error) and we should show an error toast.
            if (data === false) throw new Error('Failed to insert storage');
        }).then(()=>{
            showReloadAction = true;
            resetSingleIssuesCreated();
        }).catch((_error)=>{
            if (issuesCreated.length === 1) {
                triggerSingleIssueInsertLinkFailureFlag({
                    issueKey: issuesCreated[0].key,
                    summary: issuesCreated[0].summary
                });
                logRequestFailed({
                    requestName: $ed2929b91c73486c$var$JIRA_SINGLE_ISSUE_LINK_INSERTION,
                    errorMessage: _error.message
                });
            } else {
                triggerMultipleIssuesInsertLinkFailureFlag(issuesCreated);
                logRequestFailed({
                    requestName: $ed2929b91c73486c$var$JIRA_MULTIPLE_ISSUE_LINK_INSERTION,
                    errorMessage: _error.message
                });
            }
        }).finally(()=>{
            triggerMultipleIssuesCreatedFlag(issuesCreated, reloadOnClick, showReloadAction);
        });
    }, [
        pageMode,
        isCreatedWithAi,
        resetSingleIssuesCreated,
        triggerSingleIssueInsertLinkFailureFlag,
        logRequestFailed,
        triggerMultipleIssuesInsertLinkFailureFlag,
        triggerMultipleIssuesCreatedFlag,
        reloadOnClick
    ]);
    const addSingleIssuesToPage = (0, $gwFzn.useCallback)(()=>{
        //If the user doesn't have edit permissions on the page, we shouldn't attempt to insert the issues.
        if (singleIssuesCreated.length > 0 && !hasEditPermission && (0, $9wGTI.fg)('jira-work-create-from-connie-without-edit-perms')) {
            triggerMultipleIssuesCreatedFlag(singleIssuesCreated, reloadOnClick, false);
            resetSingleIssuesCreated();
        } else if (insertStorageFragmentRequestPayload && isCreatedWithAi && singleIssuesCreated.length > 0) {
            insertStorageFragmentRequestPayload.xmlModification = constructXmlModification(singleIssuesCreated, insertStorageFragmentRequestPayload);
            handleStorageInsertion(singleIssuesCreated, insertStorageFragmentRequestPayload);
        } else if (insertStorageColumnTableRequestPayload && !isCreatedWithAi && singleIssuesCreated.length > 0) {
            insertStorageColumnTableRequestPayload.cellModifications = constructCellModifications(singleIssuesCreated);
            handleStorageInsertion(singleIssuesCreated, insertStorageColumnTableRequestPayload);
        }
    }, [
        constructXmlModification,
        constructCellModifications,
        insertStorageFragmentRequestPayload,
        insertStorageColumnTableRequestPayload,
        singleIssuesCreated,
        handleStorageInsertion,
        isCreatedWithAi,
        hasEditPermission,
        reloadOnClick,
        triggerMultipleIssuesCreatedFlag,
        resetSingleIssuesCreated
    ]);
    return {
        constructAnchorLinkToHeading: constructAnchorLinkToHeading,
        constructXmlModification: constructXmlModification,
        constructCellModifications: constructCellModifications,
        addSingleIssuesToPage: addSingleIssuesToPage
    };
};

});





parcelRegister("5wb21", function(module, exports) {

$parcel$export(module.exports, "BulkIssueCreateProvidersWrapper", () => $a7c6d6705668316e$export$8415879aba634d17);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $aMxFD = parcelRequire("aMxFD");

var $CbMiC = parcelRequire("CbMiC");
const $a7c6d6705668316e$export$8415879aba634d17 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hq2Sz.BulkCreateContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aMxFD.AiBulkNavigationContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $CbMiC.BulkConfigureContextContainer), null, children)));
};

});

parcelRegister("gq4uD", function(module, exports) {

$parcel$export(module.exports, "useGetInitialDataForBulkIssueCreateForm", () => $fe83b98d34932c56$export$166dc120320861d);

var $gwFzn = parcelRequire("gwFzn");

var $CbMiC = parcelRequire("CbMiC");

var $hq2Sz = parcelRequire("hq2Sz");

var $kMdZo = parcelRequire("kMdZo");

var $bhYqu = parcelRequire("bhYqu");

var $lbX5W = parcelRequire("lbX5W");
const $fe83b98d34932c56$export$166dc120320861d = ()=>{
    (0, $kMdZo.useGetAvailableSites)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const [{ currentJiraSite: currentJiraSite }, { setCurrentJiraSite: setCurrentJiraSite }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (selectedAvailableSite && !currentJiraSite) setCurrentJiraSite(selectedAvailableSite);
    }, [
        selectedAvailableSite,
        currentJiraSite,
        setCurrentJiraSite
    ]);
    (0, $bhYqu.useGetJiraProjects)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const [{ currentJiraProject: currentJiraProject }, { setCurrentJiraProject: setCurrentJiraProject }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (selectedProject && !currentJiraProject) setCurrentJiraProject(selectedProject);
    }, [
        selectedProject,
        currentJiraProject,
        setCurrentJiraProject
    ]);
    (0, $lbX5W.useGetIssueTypes)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const [{ currentDefaultIssueType: currentDefaultIssueType }, { setCurrentDefaultIssueType: setCurrentDefaultIssueType }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (selectedIssueType && !currentDefaultIssueType) setCurrentDefaultIssueType(selectedIssueType);
    }, [
        selectedIssueType,
        currentDefaultIssueType,
        setCurrentDefaultIssueType
    ]);
};

});
parcelRegister("kMdZo", function(module, exports) {

$parcel$export(module.exports, "useGetAvailableSites", () => $5d10bb9dbc732385$export$eb7aae190047eab2);

var $gwFzn = parcelRequire("gwFzn");

var $g5o3i = parcelRequire("g5o3i");

var $bQm3c = parcelRequire("bQm3c");

var $hq2Sz = parcelRequire("hq2Sz");

var $CbMiC = parcelRequire("CbMiC");

var $2ay9q = parcelRequire("2ay9q");

var $26Yin = parcelRequire("26Yin");
const $5d10bb9dbc732385$export$eb7aae190047eab2 = ()=>{
    const { setSelectedAvailableSite: setSelectedAvailableSite, setOptionsAvailableSites: setOptionsAvailableSites } = (0, $CbMiC.useAvailableSitesActions)();
    const { cloudId: sessionCloudId } = (0, $bQm3c.useSessionData)();
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const overrideCloudIdForSitePicker = persistedOverrideCloudId || sessionCloudId;
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setError = (0, $hq2Sz.useSetError)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $g5o3i.useGetFirstAvailableSiteDomain)({
        preferredCloudId: overrideCloudIdForSitePicker,
        onComplete: (0, $gwFzn.useCallback)(({ availableSites: availableSites })=>{
            const firstSite = availableSites[0];
            const preferredSite = availableSites.find((site)=>site.cloudId === overrideCloudIdForSitePicker);
            setSelectedAvailableSite(preferredSite || firstSite);
            setOptionsAvailableSites(availableSites);
        }, [
            setSelectedAvailableSite,
            setOptionsAvailableSites,
            overrideCloudIdForSitePicker
        ]),
        onError: (0, $gwFzn.useCallback)((error)=>{
            logRequestFailed({
                requestName: 'fetch-jira-site',
                errorMessage: error.message
            });
            setError((0, $hq2Sz.ErrorStates).SITE_RETRIEVAL);
            actions.setManualCreateState('error');
        }, [
            logRequestFailed,
            setError,
            actions
        ])
    });
};

});

parcelRegister("bhYqu", function(module, exports) {

$parcel$export(module.exports, "useGetJiraProjects", () => $3fb376e27e7792bc$export$beaf2a819f4720da);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $CbMiC = parcelRequire("CbMiC");

var $26Yin = parcelRequire("26Yin");

var $k9cgj = parcelRequire("k9cgj");
const $3fb376e27e7792bc$export$423c192d1714471e = 'fetch-jira-projects';
const $3fb376e27e7792bc$export$903912d141558556 = 'fetch-recent-jira-projects';
const $3fb376e27e7792bc$export$beaf2a819f4720da = ()=>{
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setError = (0, $hq2Sz.useSetError)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $hq2Sz.useBulkCreateContext)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { setSelectedProjectIfEmpty: setSelectedProjectIfEmpty, setOptionsRecentProjects: setOptionsRecentProjects, setOptionsAllProjects: setOptionsAllProjects, setLoadingProjects: setLoadingProjects, setIsJiraError: setIsJiraError } = (0, $CbMiC.useProjectsActions)();
    const { projectSelectorQuery: query } = (0, $CbMiC.useProjectsState)();
    (0, $gwFzn.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        if (!selectedAvailableSite || query && query.trim().length > 0) return;
        const fetchProjects = async ()=>{
            setLoadingProjects(true);
            const [recentProjectsPromise, allProjectsPromise] = await Promise.allSettled([
                fetchRecentProjects(),
                fetchAllProjects()
            ]);
            const firstProject = getFirstFromPromise(recentProjectsPromise) || getFirstFromPromise(allProjectsPromise);
            if (firstProject) setSelectedProjectIfEmpty(firstProject);
            else setIsJiraError(true);
            setLoadingProjects(false);
        };
        const getFirstFromPromise = (result)=>{
            return result.status === 'fulfilled' ? result.value?.[0] : undefined;
        };
        const fetchAllProjects = async ()=>{
            try {
                const allProjects = await (0, $k9cgj.fetchJiraProjects)({
                    cloudId: cloudId
                });
                if (allProjects) setOptionsAllProjects(allProjects);
                return allProjects;
            } catch (e) {
                logRequestFailed({
                    requestName: $3fb376e27e7792bc$export$423c192d1714471e,
                    errorMessage: `Failed to fetch projects: ${e.message}`
                });
                setError((0, $hq2Sz.ErrorStates).PROJECT_RETRIEVAL);
                actions.setManualCreateState('error');
            }
        };
        const fetchRecentProjects = async ()=>{
            try {
                const recentProjects = await (0, $k9cgj.fetchRecentJiraProjects)({
                    cloudId: cloudId
                });
                const recentProjectIds = recentProjects?.map((project)=>project.id);
                if (!recentProjectIds || recentProjectIds.length === 0) return;
                const recentProjectsWithIssueCreatePermissionData = await (0, $k9cgj.fetchJiraProjects)({
                    cloudId: cloudId,
                    projectIds: recentProjectIds
                });
                if (recentProjectsWithIssueCreatePermissionData) setOptionsRecentProjects(recentProjectsWithIssueCreatePermissionData);
                return recentProjectsWithIssueCreatePermissionData;
            } catch (e) {
                logRequestFailed({
                    requestName: $3fb376e27e7792bc$export$903912d141558556,
                    errorMessage: `Failed to fetch recent projects with issue create permission: ${e.message}`
                });
                setError((0, $hq2Sz.ErrorStates).PROJECT_RETRIEVAL);
                actions.setManualCreateState('error');
            }
        };
        fetchProjects();
    }, [
        selectedAvailableSite,
        setLoadingProjects,
        setOptionsAllProjects,
        logRequestFailed,
        setError,
        setOptionsRecentProjects,
        setSelectedProjectIfEmpty,
        query,
        setIsJiraError,
        actions
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        if (!selectedAvailableSite || !query || query.trim().length === 0) return;
        const fetchProjects = async ()=>{
            try {
                const allProjects = await (0, $k9cgj.fetchJiraProjects)({
                    cloudId: cloudId,
                    query: query
                });
                if (allProjects) {
                    setOptionsRecentProjects([]);
                    setOptionsAllProjects(allProjects);
                }
                return allProjects;
            } catch (e) {
                logRequestFailed({
                    requestName: $3fb376e27e7792bc$export$423c192d1714471e,
                    errorMessage: `Failed to fetch query projects: ${e.message}`
                });
            }
        };
        fetchProjects();
    }, [
        selectedAvailableSite,
        setOptionsAllProjects,
        logRequestFailed,
        setOptionsRecentProjects,
        query
    ]);
};

});

parcelRegister("lbX5W", function(module, exports) {

$parcel$export(module.exports, "useGetIssueTypes", () => $bc7180254427c083$export$76233ca4792d5ed4);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $CbMiC = parcelRequire("CbMiC");

var $26Yin = parcelRequire("26Yin");

var $k9cgj = parcelRequire("k9cgj");
const $bc7180254427c083$export$34eff5686aa81020 = 'fetch-issue-types';
const $bc7180254427c083$export$76233ca4792d5ed4 = ()=>{
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setError = (0, $hq2Sz.useSetError)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $hq2Sz.useBulkCreateContext)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const { setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty, setOptionsIssueTypes: setOptionsIssueTypes, setLoadingIssueType: setLoadingIssueType } = (0, $CbMiC.useIssueTypesActions)();
    (0, $gwFzn.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        const projectId = selectedProject?.id;
        if (!cloudId || !projectId) return;
        const fetchIssues = async ()=>{
            setLoadingIssueType(true);
            try {
                const data = await (0, $k9cgj.fetchIssueTypes)({
                    cloudId: cloudId,
                    projectId: projectId
                });
                const validIssueTypes = data?.filter((issueType)=>!issueType.subtask);
                validIssueTypes && setOptionsIssueTypes(validIssueTypes);
                const firstIssueType = validIssueTypes?.[0];
                firstIssueType && setSelectedIssueTypeIfEmpty(firstIssueType);
            } catch (e) {
                setError((0, $hq2Sz.ErrorStates).ISSUE_TYPE_RETRIEVAL);
                actions.setManualCreateState('error');
                logRequestFailed({
                    requestName: $bc7180254427c083$export$34eff5686aa81020,
                    errorMessage: e.message
                });
            } finally{
                setLoadingIssueType(false);
            }
        };
        fetchIssues();
    }, [
        selectedAvailableSite?.cloudId,
        selectedProject?.id,
        setLoadingIssueType,
        setOptionsIssueTypes,
        setError,
        logRequestFailed,
        setSelectedIssueTypeIfEmpty,
        actions
    ]);
};

});


parcelRegister("fI2qC", function(module, exports) {

$parcel$export(module.exports, "useHasRequiredFields", () => $bcdbe53c991b783f$export$c85ba7cfb56ee08a);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $k9cgj = parcelRequire("k9cgj");
const $bcdbe53c991b783f$export$8704aba2771cf253 = [
    'description',
    'issuetype',
    'project',
    'summary'
];
const $bcdbe53c991b783f$export$c85ba7cfb56ee08a = ()=>{
    const setIssueTypeHasRequiredFields = (0, $hq2Sz.useSetIssueTypeHasRequiredFields)();
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [{ currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, currentDefaultIssueType: currentDefaultIssueType }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $gwFzn.useEffect)(()=>{
        const fetchIssueMetadata = async ()=>{
            if (!currentJiraProject || !currentDefaultIssueType || !currentJiraSite) return;
            setIsLoading(true);
            try {
                const data = await (0, $k9cgj.fetchIssuesMetadata)({
                    cloudId: currentJiraSite.cloudId,
                    projectId: currentJiraProject.id,
                    issueTypeId: currentDefaultIssueType.id
                });
                if (data) {
                    const requiredFieldFound = data.fields.some((field)=>field.required && !$bcdbe53c991b783f$export$8704aba2771cf253.includes(field.key) && !field.hasDefaultValue);
                    setIssueTypeHasRequiredFields(requiredFieldFound);
                }
            } catch (e) {
                if ($bcdbe53c991b783f$var$isError(e)) setError(e.message);
            } finally{
                setIsLoading(false);
            }
        };
        fetchIssueMetadata();
    }, [
        currentJiraSite,
        currentJiraProject,
        currentDefaultIssueType,
        setIssueTypeHasRequiredFields
    ]);
    return {
        isLoading: isLoading,
        error: error
    };
};
const $bcdbe53c991b783f$var$isError = (error)=>{
    return error instanceof Error;
};

});

parcelRegister("cP6qJ", function(module, exports) {

$parcel$export(module.exports, "BulkNavigationContainer", () => $a1e922e86f28467f$export$3e5bfa69be7c6c6c);

var $gwFzn = parcelRequire("gwFzn");

var $5xGzZ = parcelRequire("5xGzZ");

var $yGUhA = parcelRequire("yGUhA");

var $ebLyN = parcelRequire("ebLyN");

var $32b4y = parcelRequire("32b4y");

var $6WgnJ = parcelRequire("6WgnJ");

var $kW3me = parcelRequire("kW3me");

var $dA2Ck = parcelRequire("dA2Ck");

var $jiHhQ = parcelRequire("jiHhQ");

var $b7nPG = parcelRequire("b7nPG");
const $a1e922e86f28467f$export$3e5bfa69be7c6c6c = ({ onClose: onClose })=>{
    (0, $5xGzZ.useGetIssueTypeFields)();
    (0, $yGUhA.useSetOptionsColumns)();
    (0, $ebLyN.useInitMappings)();
    (0, $32b4y.useMapTableToIssues)();
    (0, $6WgnJ.useHandleCloseAndAddIssuesToPage)(onClose);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dA2Ck.BulkCreateDefaultView), {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kW3me.BulkConfigureView), {
        closePanel: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jiHhQ.BulkEditIssueView), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b7nPG.BulkCreateFlagsContainer), null));
};

});
parcelRegister("5xGzZ", function(module, exports) {

$parcel$export(module.exports, "useGetIssueTypeFields", () => $5acf347b59010cba$export$329fec8b4c580586);

var $gwFzn = parcelRequire("gwFzn");

var $hq2Sz = parcelRequire("hq2Sz");

var $CbMiC = parcelRequire("CbMiC");

var $k9cgj = parcelRequire("k9cgj");
const $5acf347b59010cba$export$329fec8b4c580586 = ()=>{
    const setIssueTypeFields = (0, $hq2Sz.useSetIssueTypeFields)();
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const { setOptionsIssueTypeFields: setOptionsIssueTypeFields, setLoadingIssueTypeFields: setLoadingIssueTypeFields } = (0, $CbMiC.useMappingsActions)();
    (0, $gwFzn.useEffect)(()=>{
        const fetchIssueMetadata = async ()=>{
            if (!selectedAvailableSite || !selectedProject || !selectedIssueType) return;
            setIsLoading(true);
            setLoadingIssueTypeFields(true);
            try {
                const data = await (0, $k9cgj.fetchIssuesMetadata)({
                    cloudId: selectedAvailableSite.cloudId,
                    projectId: selectedProject.id,
                    issueTypeId: selectedIssueType.id
                });
                if (data) {
                    const requiredFields = data.fields.filter((field)=>field.required);
                    const optionalFields = data.fields.filter((field)=>!field.required);
                    setIssueTypeFields({
                        requiredFields: requiredFields,
                        optionalFields: optionalFields
                    });
                    setOptionsIssueTypeFields([
                        ...requiredFields,
                        ...optionalFields
                    ]);
                }
            } catch (e) {
                if ($5acf347b59010cba$var$isError(e)) setError(e.message);
            } finally{
                setIsLoading(false);
                setLoadingIssueTypeFields(false);
            }
        };
        fetchIssueMetadata();
    }, [
        selectedAvailableSite,
        selectedProject,
        selectedIssueType,
        setIssueTypeFields,
        setOptionsIssueTypeFields,
        setLoadingIssueTypeFields
    ]);
    return {
        isLoading: isLoading,
        error: error
    };
};
const $5acf347b59010cba$var$isError = (error)=>{
    return error instanceof Error;
};

});

parcelRegister("yGUhA", function(module, exports) {

$parcel$export(module.exports, "useSetOptionsColumns", () => $5734ef8176e1881e$export$eb10de2fe984535);

var $gwFzn = parcelRequire("gwFzn");

var $CbMiC = parcelRequire("CbMiC");

var $1mDVg = parcelRequire("1mDVg");

var $euVTc = parcelRequire("euVTc");
const $5734ef8176e1881e$export$eb10de2fe984535 = ()=>{
    const { setOptionsColumns: setOptionsColumns, setColumnOffset: setColumnOffset } = (0, $CbMiC.useMappingsActions)();
    const [{ selectedTable: selectedTable }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (selectedTable && selectedTable.rows.length > 0) {
            const columns = [];
            // Always use the first row as the header row, even if it is not a HTML header row
            const firstRow = selectedTable?.querySelector('tbody tr:first-child');
            if (firstRow) {
                const firstRowCells = Array.from(firstRow.querySelectorAll('td, th'));
                const hasNumberedCol = firstRowCells[0].classList.contains('ak-renderer-table-number-column') ? 1 : 0;
                const hasHeaderCol = selectedTable.rows.length > 1 && Array.from(selectedTable.rows).every((row)=>row.cells.length > 1 && (row.cells[0].tagName.toLowerCase() === 'th' || row.cells[1].tagName.toLowerCase() === 'th')) ? 1 : 0;
                // The API does not index the header column
                setColumnOffset(hasHeaderCol);
                let columnIndex = hasNumberedCol + hasHeaderCol;
                // Skip the header and numbered column
                firstRowCells.slice(hasNumberedCol + hasHeaderCol).forEach((cell)=>{
                    const column = {
                        index: columnIndex,
                        header: cell.textContent ?? ''
                    };
                    columns.push({
                        ...column,
                        validatedIssueFieldValues: (0, $euVTc.getValidatedIssueFieldValuesForColumn)(column, selectedTable)
                    });
                    columnIndex += 1;
                });
            }
            setOptionsColumns(columns);
        }
    }, [
        selectedTable,
        setColumnOffset,
        setOptionsColumns
    ]);
};

});

parcelRegister("ebLyN", function(module, exports) {

$parcel$export(module.exports, "useInitMappings", () => $baa550ab5fae5345$export$c8ab1378f7db9642);

var $gwFzn = parcelRequire("gwFzn");

var $CbMiC = parcelRequire("CbMiC");
const $baa550ab5fae5345$var$createDefaultMappings = (columns, fields)=>{
    // Map both summary and description if there's only one column
    if (columns.length === 1) return [
        'summary',
        'description'
    ].map((fieldId)=>{
        const field = fields.find((f)=>f.fieldId === fieldId);
        return {
            column: columns[0],
            field: field
        };
    });
    const fieldMap = {
        0: 'summary',
        1: 'description'
    };
    return columns.slice(0, 2).map((column, index)=>{
        const fieldId = fieldMap[index];
        const field = fields.find((f)=>f.fieldId === fieldId);
        return {
            column: column,
            field: field
        };
    });
};
const $baa550ab5fae5345$export$c8ab1378f7db9642 = ()=>{
    const { optionsIssueTypeFields: optionsIssueTypeFields, optionsColumns: optionsColumns } = (0, $CbMiC.useMappingsState)();
    const { setColumnToFieldMappings: setColumnToFieldMappings, initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings } = (0, $CbMiC.useMappingsActions)();
    (0, $gwFzn.useEffect)(()=>{
        if (optionsIssueTypeFields && optionsColumns) {
            const defaultMappings = $baa550ab5fae5345$var$createDefaultMappings(optionsColumns, optionsIssueTypeFields);
            setColumnToFieldMappings(defaultMappings);
            initUnsavedColumnToFieldMappings();
        }
    }, [
        optionsIssueTypeFields,
        optionsColumns,
        setColumnToFieldMappings,
        initUnsavedColumnToFieldMappings
    ]);
};

});

parcelRegister("32b4y", function(module, exports) {

$parcel$export(module.exports, "useMapTableToIssues", () => $2e24543847a65a25$export$70098129974a7e55);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $CbMiC = parcelRequire("CbMiC");

var $hq2Sz = parcelRequire("hq2Sz");

var $1mDVg = parcelRequire("1mDVg");

var $aMxFD = parcelRequire("aMxFD");

var $euVTc = parcelRequire("euVTc");
const $2e24543847a65a25$export$70098129974a7e55 = ()=>{
    const { columnToFieldMappings: columnToFieldMappings, columnOffset: columnOffset } = (0, $CbMiC.useMappingsState)();
    const [{ selectedTable: selectedTable, insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload }, { setInsertStorageColumnTableRequestPayload: setInsertStorageColumnTableRequestPayload }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, { setBulkIssuesList: setBulkIssuesList }] = (0, $hq2Sz.useBulkCreateContext)();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    (0, $gwFzn.useEffect)(()=>{
        if (columnToFieldMappings && columnToFieldMappings.length > 0 && selectedTable) {
            const mappedIssues = (0, $euVTc.mapTableToIssues)(columnToFieldMappings, selectedTable);
            setBulkIssuesList(mappedIssues);
            if (mappedIssues.length === 0 && (0, $9wGTI.fg)('confluence_bulk_issue_creation_loading_fix')) goToPage('configure');
        }
    }, [
        columnToFieldMappings,
        goToPage,
        selectedTable,
        setBulkIssuesList
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (columnToFieldMappings && columnToFieldMappings.length > 0) {
            const summaryMapping = columnToFieldMappings.find((mapping)=>mapping.field?.key === 'summary');
            //The insertion API does not include header columns in indexing
            const unadjustedIndex = summaryMapping?.column?.index ?? 0;
            const tableColumnIndex = columnOffset != null && unadjustedIndex !== 0 ? unadjustedIndex - columnOffset : unadjustedIndex;
            const updatedPayload = {
                ...insertStorageColumnTableRequestPayload,
                tableColumnIndex: tableColumnIndex
            };
            setInsertStorageColumnTableRequestPayload(updatedPayload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        columnToFieldMappings
    ]);
};

});

parcelRegister("6WgnJ", function(module, exports) {

$parcel$export(module.exports, "useHandleCloseAndAddIssuesToPage", () => $b087aae42cea54f5$export$fcc44dd45d1185f8);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $hq2Sz = parcelRequire("hq2Sz");

var $qMR2B = parcelRequire("qMR2B");
const $b087aae42cea54f5$export$fcc44dd45d1185f8 = (onClose)=>{
    const shouldClose = (0, $hq2Sz.useCloseAndAddIssuesToPage)();
    const { addSingleIssuesToPage: addSingleIssuesToPage } = (0, $qMR2B.useGetIssueInsertionActions)();
    const resetCloseAndAddIssuesToPage = (0, $hq2Sz.useResetCloseAndAddIssuesToPage)();
    (0, $gwFzn.useEffect)(()=>{
        if (shouldClose && (0, $9wGTI.fg)('close_side_panel_on_final_single_issue_creation')) {
            addSingleIssuesToPage();
            onClose();
            // Reset the state after closing
            resetCloseAndAddIssuesToPage();
        }
    }, [
        shouldClose,
        onClose,
        addSingleIssuesToPage,
        resetCloseAndAddIssuesToPage
    ]);
};

});

parcelRegister("dA2Ck", function(module, exports) {

$parcel$export(module.exports, "BulkCreateDefaultView", () => $b647e1903fe52db9$export$48c6ac1fbf5f1245);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $9hlns = parcelRequire("9hlns");

var $9wGTI = parcelRequire("9wGTI");

var $23FOO = parcelRequire("23FOO");

var $5Ew1A = parcelRequire("5Ew1A");

var $3E5yu = parcelRequire("3E5yu");

var $grqp1 = parcelRequire("grqp1");

var $hq2Sz = parcelRequire("hq2Sz");

var $qMR2B = parcelRequire("qMR2B");

var $26Yin = parcelRequire("26Yin");

var $aXkRG = parcelRequire("aXkRG");

var $lOlzk = parcelRequire("lOlzk");

var $3t3RY = parcelRequire("3t3RY");
const $b647e1903fe52db9$var$contentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap'
});
const $b647e1903fe52db9$var$footerBaseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    flexShrink: 0,
    position: 'relative',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.150',
        right: 'space.150',
        height: '1px',
        backgroundColor: 'elevation.surface',
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width'
    }
});
const $b647e1903fe52db9$var$footerTopStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $b647e1903fe52db9$var$loadingScreenStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
});
const $b647e1903fe52db9$export$48c6ac1fbf5f1245 = ({ onClose: onClose })=>{
    const { isLoading: isLoading, isError: isError, isIdle: isIdle } = (0, $grqp1.useManualBulkCreateState)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $hq2Sz.useBulkCreateContext)();
    const { addSingleIssuesToPage: addSingleIssuesToPage } = (0, $qMR2B.useGetIssueInsertionActions)();
    // TO-DO need to implement logic to retry fetching Jira site / project / issue type
    // const handleTryAgain = () => {}
    const onPanelClose = (0, $gwFzn.useCallback)(()=>{
        addSingleIssuesToPage();
        //reset manual bulk state, bulk issue list and error state if FG is enabled
        if ((0, $9wGTI.fg)('confluence_bulk_issue_creation_panel_state_bug_fix')) actions.resetManualBulkCreateState();
        onClose();
    }, [
        actions,
        addSingleIssuesToPage,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b647e1903fe52db9$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $23FOO.BulkCreateHeader), {
        onClose: onPanelClose
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b647e1903fe52db9$var$loadingScreenStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "large"
    })), isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: (0, $26Yin.BULK_ISSUE_CREATE_SOURCE),
        errorMessage: (0, $3E5yu.messages).connectJiraProjectErrorDescription
    }), isIdle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lOlzk.BulkCreateBody), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b647e1903fe52db9$var$footerBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $b647e1903fe52db9$var$footerTopStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3t3RY.BulkCreateButtonGroup), {
        onClose: onPanelClose,
        onCreateAll: onClose
    }))))));
};

});
parcelRegister("grqp1", function(module, exports) {

$parcel$export(module.exports, "useManualBulkCreateState", () => $15c1ee332125e9b5$export$61b27cec524a09b0);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $hq2Sz = parcelRequire("hq2Sz");

var $CbMiC = parcelRequire("CbMiC");
const $15c1ee332125e9b5$export$61b27cec524a09b0 = ()=>{
    const [{ currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, currentDefaultIssueType: currentDefaultIssueType, manualCreateState: manualCreateState, error: error, bulkIssuesList: bulkIssuesList }, actions] = (0, $hq2Sz.useBulkCreateContext)();
    const { loadingIssueTypeFields: loadingIssueTypeFields } = (0, $CbMiC.useMappingsState)();
    (0, $gwFzn.useEffect)(()=>{
        const isLoading = !currentJiraSite || !currentJiraProject || !currentDefaultIssueType || loadingIssueTypeFields || bulkIssuesList?.length === 0 && (0, $9wGTI.fg)('confluence_bulk_issue_creation_panel_state_bug_fix');
        if (isLoading) actions.setManualCreateState('loading');
        const isError = error !== (0, $hq2Sz.ErrorStates).EMPTY;
        if (isError && (0, $9wGTI.fg)('confluence_bulk_issue_creation_panel_state_bug_fix')) actions.setManualCreateState('error');
        if (!isLoading && !isError) actions.setManualCreateState('idle');
    }, [
        actions,
        currentDefaultIssueType,
        currentJiraProject,
        currentJiraSite,
        loadingIssueTypeFields,
        error,
        bulkIssuesList
    ]);
    return {
        isLoading: manualCreateState === 'loading',
        isError: manualCreateState === 'error',
        isIdle: manualCreateState === 'idle'
    };
};

});




parcelRegister("frJep", function(module, exports) {

$parcel$export(module.exports, "useIsAIIssueCreationEnabled", () => $ae678835b2293c93$export$58de3335a79e10d3);

var $1mDVg = parcelRequire("1mDVg");

var $2ay9q = parcelRequire("2ay9q");
const $ae678835b2293c93$export$58de3335a79e10d3 = ()=>{
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
    const isCreateIssueWithAiEnabledByUser = (0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)();
    return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};

});

parcelRegister("fz2l1", function(module, exports) {

$parcel$export(module.exports, "getPageMode", () => $9d48445854f70eb8$export$8b02a744327cd19);

var $1mDVg = parcelRequire("1mDVg");
const $9d48445854f70eb8$export$8b02a744327cd19 = (viewMode, isLivePage, hasEditPermission)=>{
    if (isLivePage) {
        if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).LIVE_EDIT;
        return (0, $1mDVg.PageMode).LIVE_VIEW;
    }
    if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).EDIT;
    return (0, $1mDVg.PageMode).VIEW;
};

});



//# sourceMappingURL=FullPageEditorComponent.01b30512.js.map
